webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(238);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(233);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(317));
__export(__webpack_require__(316));
__export(__webpack_require__(211));
__export(__webpack_require__(40));
__export(__webpack_require__(209));
__export(__webpack_require__(39));
__export(__webpack_require__(210));
__export(__webpack_require__(33));
__export(__webpack_require__(318));
__export(__webpack_require__(212));
__export(__webpack_require__(321));
__export(__webpack_require__(322));
__export(__webpack_require__(41));
__export(__webpack_require__(213));
__export(__webpack_require__(214));
__export(__webpack_require__(69));
__export(__webpack_require__(320));
__export(__webpack_require__(326));
__export(__webpack_require__(327));
__export(__webpack_require__(328));
__export(__webpack_require__(324));
__export(__webpack_require__(323));
__export(__webpack_require__(325));
__export(__webpack_require__(319));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(234);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(43);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(9);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var PaginationConfig = (function () {
    function PaginationConfig(config) {
        this.config = config;
        config.boundaryLinks = true;
        config.maxSize = 5;
        config.pageSize = shared_1.ITEMS_PER_PAGE;
        config.size = 'sm';
    }
    return PaginationConfig;
}());
PaginationConfig = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbPaginationConfig])
], PaginationConfig);
exports.PaginationConfig = PaginationConfig;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(133));
__export(__webpack_require__(52));
__export(__webpack_require__(16));
__export(__webpack_require__(131));
__export(__webpack_require__(129));
__export(__webpack_require__(130));
__export(__webpack_require__(132));
__export(__webpack_require__(268));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var tracker_service_1 = __webpack_require__(41);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(92);
var MarketmanagerAdminModule = (function () {
    function MarketmanagerAdminModule() {
    }
    return MarketmanagerAdminModule;
}());
MarketmanagerAdminModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(_1.adminState, { useHash: true })
        ],
        declarations: [
            _1.AuditsComponent,
            _1.UserMgmtComponent,
            _1.UserDialogComponent,
            _1.UserDeleteDialogComponent,
            _1.UserMgmtDetailComponent,
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.LogsComponent,
            _1.JhiConfigurationComponent,
            _1.JhiHealthCheckComponent,
            _1.JhiHealthModalComponent,
            _1.JhiDocsComponent,
            _1.JhiTrackerComponent,
            _1.JhiMetricsMonitoringComponent,
            _1.JhiMetricsMonitoringModalComponent
        ],
        entryComponents: [
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.JhiHealthModalComponent,
            _1.JhiMetricsMonitoringModalComponent,
        ],
        providers: [
            _1.AuditsService,
            _1.JhiConfigurationService,
            _1.JhiHealthService,
            _1.JhiMetricsService,
            _1.LogsService,
            tracker_service_1.JhiTrackerService,
            _1.UserResolvePagingParams,
            _1.UserResolve,
            _1.UserModalService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerAdminModule);
exports.MarketmanagerAdminModule = MarketmanagerAdminModule;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var AdditionalflatService = (function () {
    function AdditionalflatService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/additionalflats';
        this.resourceSearchUrl = 'api/_search/additionalflats';
    }
    AdditionalflatService.prototype.create = function (additionalflat) {
        var copy = Object.assign({}, additionalflat);
        copy.validFrom = this.dateUtils.toDate(additionalflat.validFrom);
        copy.updated = this.dateUtils.toDate(additionalflat.updated);
        copy.created = this.dateUtils.toDate(additionalflat.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    AdditionalflatService.prototype.update = function (additionalflat) {
        var copy = Object.assign({}, additionalflat);
        copy.validFrom = this.dateUtils.toDate(additionalflat.validFrom);
        copy.updated = this.dateUtils.toDate(additionalflat.updated);
        copy.created = this.dateUtils.toDate(additionalflat.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    AdditionalflatService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.validFrom = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.validFrom);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    AdditionalflatService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    AdditionalflatService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    AdditionalflatService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    AdditionalflatService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validFrom = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].validFrom);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    AdditionalflatService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return AdditionalflatService;
}());
AdditionalflatService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], AdditionalflatService);
exports.AdditionalflatService = AdditionalflatService;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var BoothService = (function () {
    function BoothService(http) {
        this.http = http;
        this.resourceUrl = 'api/booths';
        this.resourceSearchUrl = 'api/_search/booths';
    }
    BoothService.prototype.create = function (booth) {
        var copy = Object.assign({}, booth);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BoothService.prototype.update = function (booth) {
        var copy = Object.assign({}, booth);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BoothService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    BoothService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    BoothService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    BoothService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    BoothService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return BoothService;
}());
BoothService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BoothService);
exports.BoothService = BoothService;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var BoothfeeService = (function () {
    function BoothfeeService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/boothfees';
        this.resourceSearchUrl = 'api/_search/boothfees';
    }
    BoothfeeService.prototype.create = function (boothfee) {
        var copy = Object.assign({}, boothfee);
        copy.validFrom = this.dateUtils.toDate(boothfee.validFrom);
        copy.updated = this.dateUtils.toDate(boothfee.updated);
        copy.created = this.dateUtils.toDate(boothfee.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BoothfeeService.prototype.update = function (boothfee) {
        var copy = Object.assign({}, boothfee);
        copy.validFrom = this.dateUtils.toDate(boothfee.validFrom);
        copy.updated = this.dateUtils.toDate(boothfee.updated);
        copy.created = this.dateUtils.toDate(boothfee.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BoothfeeService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.validFrom = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.validFrom);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    BoothfeeService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    BoothfeeService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    BoothfeeService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    BoothfeeService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validFrom = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].validFrom);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    BoothfeeService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return BoothfeeService;
}());
BoothfeeService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], BoothfeeService);
exports.BoothfeeService = BoothfeeService;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var BranchService = (function () {
    function BranchService(http) {
        this.http = http;
        this.resourceUrl = 'api/branches';
        this.resourceSearchUrl = 'api/_search/branches';
    }
    BranchService.prototype.create = function (branch) {
        var copy = Object.assign({}, branch);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BranchService.prototype.update = function (branch) {
        var copy = Object.assign({}, branch);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    BranchService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    BranchService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    BranchService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    BranchService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    BranchService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return BranchService;
}());
BranchService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BranchService);
exports.BranchService = BranchService;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ContactTempService = (function () {
    function ContactTempService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/contact-temps';
        this.resourceSearchUrl = 'api/_search/contact-temps';
    }
    ContactTempService.prototype.create = function (contactTemp) {
        var copy = Object.assign({}, contactTemp);
        copy.updated = this.dateUtils.toDate(contactTemp.updated);
        copy.created = this.dateUtils.toDate(contactTemp.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContactTempService.prototype.update = function (contactTemp) {
        var copy = Object.assign({}, contactTemp);
        copy.updated = this.dateUtils.toDate(contactTemp.updated);
        copy.created = this.dateUtils.toDate(contactTemp.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContactTempService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    ContactTempService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContactTempService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ContactTempService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContactTempService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    ContactTempService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ContactTempService;
}());
ContactTempService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ContactTempService);
exports.ContactTempService = ContactTempService;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ContactService = (function () {
    function ContactService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/contacts';
        this.resourceSearchUrl = 'api/_search/contacts';
    }
    ContactService.prototype.create = function (contact) {
        var copy = Object.assign({}, contact);
        copy.updated = this.dateUtils.toDate(contact.updated);
        copy.created = this.dateUtils.toDate(contact.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContactService.prototype.update = function (contact) {
        var copy = Object.assign({}, contact);
        copy.updated = this.dateUtils.toDate(contact.updated);
        copy.created = this.dateUtils.toDate(contact.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContactService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    ContactService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContactService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ContactService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContactService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    ContactService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ContactService;
}());
ContactService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ContactService);
exports.ContactService = ContactService;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ContractService = (function () {
    function ContractService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/contracts';
        this.resourceSearchUrl = 'api/_search/contracts';
    }
    ContractService.prototype.create = function (contract) {
        var copy = Object.assign({}, contract);
        copy.startDate = this.dateUtils.toDate(contract.startDate);
        copy.endDate = this.dateUtils.toDate(contract.endDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContractService.prototype.update = function (contract) {
        var copy = Object.assign({}, contract);
        copy.startDate = this.dateUtils.toDate(contract.startDate);
        copy.endDate = this.dateUtils.toDate(contract.endDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContractService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.startDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startDate);
            jsonResponse.endDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endDate);
            return jsonResponse;
        });
    };
    ContractService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContractService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ContractService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContractService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].startDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startDate);
            jsonResponse[i].endDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endDate);
        }
        res._body = jsonResponse;
        return res;
    };
    ContractService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ContractService;
}());
ContractService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ContractService);
exports.ContractService = ContractService;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ContractdateService = (function () {
    function ContractdateService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/contractdates';
        this.resourceSearchUrl = 'api/_search/contractdates';
    }
    ContractdateService.prototype.create = function (contractdate) {
        var copy = Object.assign({}, contractdate);
        copy.realDate = this.dateUtils.toDate(contractdate.realDate);
        copy.originalDate = this.dateUtils.toDate(contractdate.originalDate);
        copy.evasiveDate = this.dateUtils.toDate(contractdate.evasiveDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContractdateService.prototype.update = function (contractdate) {
        var copy = Object.assign({}, contractdate);
        copy.realDate = this.dateUtils.toDate(contractdate.realDate);
        copy.originalDate = this.dateUtils.toDate(contractdate.originalDate);
        copy.evasiveDate = this.dateUtils.toDate(contractdate.evasiveDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ContractdateService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.realDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.realDate);
            jsonResponse.originalDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.originalDate);
            jsonResponse.evasiveDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.evasiveDate);
            return jsonResponse;
        });
    };
    ContractdateService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContractdateService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ContractdateService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ContractdateService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].realDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].realDate);
            jsonResponse[i].originalDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].originalDate);
            jsonResponse[i].evasiveDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].evasiveDate);
        }
        res._body = jsonResponse;
        return res;
    };
    ContractdateService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ContractdateService;
}());
ContractdateService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ContractdateService);
exports.ContractdateService = ContractdateService;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ElectricmeterService = (function () {
    function ElectricmeterService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/electricmeters';
        this.resourceSearchUrl = 'api/_search/electricmeters';
    }
    ElectricmeterService.prototype.create = function (electricmeter) {
        var copy = Object.assign({}, electricmeter);
        copy.updated = this.dateUtils.toDate(electricmeter.updated);
        copy.created = this.dateUtils.toDate(electricmeter.created);
        copy.lastValueChanged = this.dateUtils.toDate(electricmeter.lastValueChanged);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ElectricmeterService.prototype.update = function (electricmeter) {
        var copy = Object.assign({}, electricmeter);
        copy.updated = this.dateUtils.toDate(electricmeter.updated);
        copy.created = this.dateUtils.toDate(electricmeter.created);
        copy.lastValueChanged = this.dateUtils.toDate(electricmeter.lastValueChanged);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ElectricmeterService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            jsonResponse.lastValueChanged = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.lastValueChanged);
            return jsonResponse;
        });
    };
    ElectricmeterService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ElectricmeterService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ElectricmeterService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ElectricmeterService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
            jsonResponse[i].lastValueChanged = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].lastValueChanged);
        }
        res._body = jsonResponse;
        return res;
    };
    ElectricmeterService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ElectricmeterService;
}());
ElectricmeterService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ElectricmeterService);
exports.ElectricmeterService = ElectricmeterService;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var EnergyflatService = (function () {
    function EnergyflatService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/energyflats';
        this.resourceSearchUrl = 'api/_search/energyflats';
    }
    EnergyflatService.prototype.create = function (energyflat) {
        var copy = Object.assign({}, energyflat);
        copy.validFrom = this.dateUtils.toDate(energyflat.validFrom);
        copy.updated = this.dateUtils.toDate(energyflat.updated);
        copy.created = this.dateUtils.toDate(energyflat.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    EnergyflatService.prototype.update = function (energyflat) {
        var copy = Object.assign({}, energyflat);
        copy.validFrom = this.dateUtils.toDate(energyflat.validFrom);
        copy.updated = this.dateUtils.toDate(energyflat.updated);
        copy.created = this.dateUtils.toDate(energyflat.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    EnergyflatService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.validFrom = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.validFrom);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    EnergyflatService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    EnergyflatService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    EnergyflatService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    EnergyflatService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validFrom = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].validFrom);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    EnergyflatService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return EnergyflatService;
}());
EnergyflatService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], EnergyflatService);
exports.EnergyflatService = EnergyflatService;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var MarketdateBoothService = (function () {
    function MarketdateBoothService(http) {
        this.http = http;
        this.resourceUrl = 'api/marketdate-booths';
        this.resourceSearchUrl = 'api/_search/marketdate-booths';
    }
    MarketdateBoothService.prototype.create = function (marketdateBooth) {
        var copy = Object.assign({}, marketdateBooth);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateBoothService.prototype.update = function (marketdateBooth) {
        var copy = Object.assign({}, marketdateBooth);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateBoothService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    MarketdateBoothService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    MarketdateBoothService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateBoothService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    MarketdateBoothService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateBoothService;
}());
MarketdateBoothService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], MarketdateBoothService);
exports.MarketdateBoothService = MarketdateBoothService;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdateCommentService = (function () {
    function MarketdateCommentService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdate-comments';
        this.resourceSearchUrl = 'api/_search/marketdate-comments';
    }
    MarketdateCommentService.prototype.create = function (marketdateComment) {
        var copy = Object.assign({}, marketdateComment);
        copy.updated = this.dateUtils.toDate(marketdateComment.updated);
        copy.created = this.dateUtils.toDate(marketdateComment.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateCommentService.prototype.update = function (marketdateComment) {
        var copy = Object.assign({}, marketdateComment);
        copy.updated = this.dateUtils.toDate(marketdateComment.updated);
        copy.created = this.dateUtils.toDate(marketdateComment.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateCommentService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdateCommentService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateCommentService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateCommentService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateCommentService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdateCommentService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateCommentService;
}());
MarketdateCommentService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdateCommentService);
exports.MarketdateCommentService = MarketdateCommentService;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdateExpenseService = (function () {
    function MarketdateExpenseService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdate-expenses';
        this.resourceSearchUrl = 'api/_search/marketdate-expenses';
    }
    MarketdateExpenseService.prototype.create = function (marketdateExpense) {
        var copy = Object.assign({}, marketdateExpense);
        copy.updated = this.dateUtils.toDate(marketdateExpense.updated);
        copy.created = this.dateUtils.toDate(marketdateExpense.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateExpenseService.prototype.update = function (marketdateExpense) {
        var copy = Object.assign({}, marketdateExpense);
        copy.updated = this.dateUtils.toDate(marketdateExpense.updated);
        copy.created = this.dateUtils.toDate(marketdateExpense.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateExpenseService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdateExpenseService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateExpenseService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateExpenseService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateExpenseService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdateExpenseService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateExpenseService;
}());
MarketdateExpenseService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdateExpenseService);
exports.MarketdateExpenseService = MarketdateExpenseService;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdateMeterreadingService = (function () {
    function MarketdateMeterreadingService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdate-meterreadings';
        this.resourceSearchUrl = 'api/_search/marketdate-meterreadings';
    }
    MarketdateMeterreadingService.prototype.create = function (marketdateMeterreading) {
        var copy = Object.assign({}, marketdateMeterreading);
        copy.timestamp = this.dateUtils.toDate(marketdateMeterreading.timestamp);
        copy.updated = this.dateUtils.toDate(marketdateMeterreading.updated);
        copy.created = this.dateUtils.toDate(marketdateMeterreading.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateMeterreadingService.prototype.update = function (marketdateMeterreading) {
        var copy = Object.assign({}, marketdateMeterreading);
        copy.timestamp = this.dateUtils.toDate(marketdateMeterreading.timestamp);
        copy.updated = this.dateUtils.toDate(marketdateMeterreading.updated);
        copy.created = this.dateUtils.toDate(marketdateMeterreading.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateMeterreadingService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.timestamp = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.timestamp);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdateMeterreadingService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateMeterreadingService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateMeterreadingService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateMeterreadingService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].timestamp = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].timestamp);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdateMeterreadingService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateMeterreadingService;
}());
MarketdateMeterreadingService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdateMeterreadingService);
exports.MarketdateMeterreadingService = MarketdateMeterreadingService;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdateStatusService = (function () {
    function MarketdateStatusService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdate-statuses';
        this.resourceSearchUrl = 'api/_search/marketdate-statuses';
    }
    MarketdateStatusService.prototype.create = function (marketdateStatus) {
        var copy = Object.assign({}, marketdateStatus);
        copy.updated = this.dateUtils.toDate(marketdateStatus.updated);
        copy.created = this.dateUtils.toDate(marketdateStatus.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateStatusService.prototype.update = function (marketdateStatus) {
        var copy = Object.assign({}, marketdateStatus);
        copy.updated = this.dateUtils.toDate(marketdateStatus.updated);
        copy.created = this.dateUtils.toDate(marketdateStatus.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateStatusService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdateStatusService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateStatusService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateStatusService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateStatusService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdateStatusService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateStatusService;
}());
MarketdateStatusService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdateStatusService);
exports.MarketdateStatusService = MarketdateStatusService;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(184));
__export(__webpack_require__(62));
__export(__webpack_require__(27));
__export(__webpack_require__(182));
__export(__webpack_require__(180));
__export(__webpack_require__(181));
__export(__webpack_require__(183));
__export(__webpack_require__(296));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdateService = (function () {
    function MarketdateService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdates';
        this.resourceSearchUrl = 'api/_search/marketdates';
    }
    MarketdateService.prototype.create = function (marketdate) {
        var copy = Object.assign({}, marketdate);
        copy.originalDate = this.dateUtils.toDate(marketdate.originalDate);
        copy.evasiveDate = this.dateUtils.toDate(marketdate.evasiveDate);
        copy.updated = this.dateUtils.toDate(marketdate.updated);
        copy.created = this.dateUtils.toDate(marketdate.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateService.prototype.update = function (marketdate) {
        var copy = Object.assign({}, marketdate);
        copy.originalDate = this.dateUtils.toDate(marketdate.originalDate);
        copy.evasiveDate = this.dateUtils.toDate(marketdate.evasiveDate);
        copy.updated = this.dateUtils.toDate(marketdate.updated);
        copy.created = this.dateUtils.toDate(marketdate.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdateService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.originalDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.originalDate);
            jsonResponse.evasiveDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.evasiveDate);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdateService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdateService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdateService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].originalDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].originalDate);
            jsonResponse[i].evasiveDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].evasiveDate);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdateService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdateService;
}());
MarketdateService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdateService);
exports.MarketdateService = MarketdateService;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketdayService = (function () {
    function MarketdayService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketdays';
        this.resourceSearchUrl = 'api/_search/marketdays';
    }
    MarketdayService.prototype.create = function (marketday) {
        var copy = Object.assign({}, marketday);
        copy.startTime = this.dateUtils.toDate(marketday.startTime);
        copy.endTime = this.dateUtils.toDate(marketday.endTime);
        copy.buildingStartTime = this.dateUtils.toDate(marketday.buildingStartTime);
        copy.dismantlingEndTime = this.dateUtils.toDate(marketday.dismantlingEndTime);
        copy.startTimeWinter = this.dateUtils.toDate(marketday.startTimeWinter);
        copy.endTimeWinter = this.dateUtils.toDate(marketday.endTimeWinter);
        copy.buildingStartTimeWinter = this.dateUtils.toDate(marketday.buildingStartTimeWinter);
        copy.dismantlingEndTimeWinter = this.dateUtils.toDate(marketday.dismantlingEndTimeWinter);
        copy.updated = this.dateUtils.toDate(marketday.updated);
        copy.created = this.dateUtils.toDate(marketday.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdayService.prototype.update = function (marketday) {
        var copy = Object.assign({}, marketday);
        copy.startTime = this.dateUtils.toDate(marketday.startTime);
        copy.endTime = this.dateUtils.toDate(marketday.endTime);
        copy.buildingStartTime = this.dateUtils.toDate(marketday.buildingStartTime);
        copy.dismantlingEndTime = this.dateUtils.toDate(marketday.dismantlingEndTime);
        copy.startTimeWinter = this.dateUtils.toDate(marketday.startTimeWinter);
        copy.endTimeWinter = this.dateUtils.toDate(marketday.endTimeWinter);
        copy.buildingStartTimeWinter = this.dateUtils.toDate(marketday.buildingStartTimeWinter);
        copy.dismantlingEndTimeWinter = this.dateUtils.toDate(marketday.dismantlingEndTimeWinter);
        copy.updated = this.dateUtils.toDate(marketday.updated);
        copy.created = this.dateUtils.toDate(marketday.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketdayService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.startTime = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startTime);
            jsonResponse.endTime = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endTime);
            jsonResponse.buildingStartTime = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.buildingStartTime);
            jsonResponse.dismantlingEndTime = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dismantlingEndTime);
            jsonResponse.startTimeWinter = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startTimeWinter);
            jsonResponse.endTimeWinter = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endTimeWinter);
            jsonResponse.buildingStartTimeWinter = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.buildingStartTimeWinter);
            jsonResponse.dismantlingEndTimeWinter = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dismantlingEndTimeWinter);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketdayService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdayService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketdayService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketdayService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].startTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startTime);
            jsonResponse[i].endTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endTime);
            jsonResponse[i].buildingStartTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].buildingStartTime);
            jsonResponse[i].dismantlingEndTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dismantlingEndTime);
            jsonResponse[i].startTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startTimeWinter);
            jsonResponse[i].endTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endTimeWinter);
            jsonResponse[i].buildingStartTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].buildingStartTimeWinter);
            jsonResponse[i].dismantlingEndTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dismantlingEndTimeWinter);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketdayService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketdayService;
}());
MarketdayService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketdayService);
exports.MarketdayService = MarketdayService;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var MarketplaceService = (function () {
    function MarketplaceService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/marketplaces';
        this.resourceSearchUrl = 'api/_search/marketplaces';
    }
    MarketplaceService.prototype.create = function (marketplace) {
        var copy = Object.assign({}, marketplace);
        copy.updated = this.dateUtils.toDate(marketplace.updated);
        copy.created = this.dateUtils.toDate(marketplace.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketplaceService.prototype.update = function (marketplace) {
        var copy = Object.assign({}, marketplace);
        copy.updated = this.dateUtils.toDate(marketplace.updated);
        copy.created = this.dateUtils.toDate(marketplace.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    MarketplaceService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    MarketplaceService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketplaceService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    MarketplaceService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    MarketplaceService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    MarketplaceService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return MarketplaceService;
}());
MarketplaceService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], MarketplaceService);
exports.MarketplaceService = MarketplaceService;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var SalesunitService = (function () {
    function SalesunitService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/salesunits';
        this.resourceSearchUrl = 'api/_search/salesunits';
    }
    SalesunitService.prototype.create = function (salesunit) {
        var copy = Object.assign({}, salesunit);
        copy.winterStart = this.dateUtils.toDate(salesunit.winterStart);
        copy.winterEnd = this.dateUtils.toDate(salesunit.winterEnd);
        copy.updated = this.dateUtils.toDate(salesunit.updated);
        copy.created = this.dateUtils.toDate(salesunit.created);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    SalesunitService.prototype.update = function (salesunit) {
        var copy = Object.assign({}, salesunit);
        copy.winterStart = this.dateUtils.toDate(salesunit.winterStart);
        copy.winterEnd = this.dateUtils.toDate(salesunit.winterEnd);
        copy.updated = this.dateUtils.toDate(salesunit.updated);
        copy.created = this.dateUtils.toDate(salesunit.created);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    SalesunitService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.winterStart = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.winterStart);
            jsonResponse.winterEnd = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.winterEnd);
            jsonResponse.updated = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    };
    SalesunitService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    SalesunitService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    SalesunitService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    SalesunitService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].winterStart = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].winterStart);
            jsonResponse[i].winterEnd = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].winterEnd);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    };
    SalesunitService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return SalesunitService;
}());
SalesunitService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], SalesunitService);
exports.SalesunitService = SalesunitService;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var TestentityService = (function () {
    function TestentityService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/testentities';
        this.resourceSearchUrl = 'api/_search/testentities';
    }
    TestentityService.prototype.create = function (testentity) {
        var copy = Object.assign({}, testentity);
        copy.myZonedDateTime = this.dateUtils.toDate(testentity.myZonedDateTime);
        copy.myLocalDate = this.dateUtils
            .convertLocalDateToServer(testentity.myLocalDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    TestentityService.prototype.update = function (testentity) {
        var copy = Object.assign({}, testentity);
        copy.myZonedDateTime = this.dateUtils.toDate(testentity.myZonedDateTime);
        copy.myLocalDate = this.dateUtils
            .convertLocalDateToServer(testentity.myLocalDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    TestentityService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.myZonedDateTime = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.myZonedDateTime);
            jsonResponse.myLocalDate = _this.dateUtils
                .convertLocalDateFromServer(jsonResponse.myLocalDate);
            return jsonResponse;
        });
    };
    TestentityService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    TestentityService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    TestentityService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    TestentityService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].myZonedDateTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].myZonedDateTime);
            jsonResponse[i].myLocalDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].myLocalDate);
        }
        res._body = jsonResponse;
        return res;
    };
    TestentityService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return TestentityService;
}());
TestentityService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], TestentityService);
exports.TestentityService = TestentityService;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(189));
__export(__webpack_require__(63));
__export(__webpack_require__(28));
__export(__webpack_require__(187));
__export(__webpack_require__(185));
__export(__webpack_require__(186));
__export(__webpack_require__(188));
__export(__webpack_require__(298));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(454);
var account_service_1 = __webpack_require__(209);
var tracker_service_1 = __webpack_require__(41); // Barrel doesn't work here. No idea why!
var Principal = (function () {
    function Principal(account, trackerService) {
        this.account = account;
        this.trackerService = trackerService;
        this.authenticated = false;
        this.authenticationState = new Subject_1.Subject();
    }
    Principal.prototype.authenticate = function (identity) {
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
    };
    Principal.prototype.hasAnyAuthority = function (authorities) {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return Promise.resolve(false);
        }
        for (var i = 0; i < authorities.length; i++) {
            if (this.userIdentity.authorities.indexOf(authorities[i]) !== -1) {
                return Promise.resolve(true);
            }
        }
        return Promise.resolve(false);
    };
    Principal.prototype.hasAuthority = function (authority) {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }
        return this.identity().then(function (id) {
            return Promise.resolve(id.authorities && id.authorities.indexOf(authority) !== -1);
        }, function () {
            return Promise.resolve(false);
        });
    };
    Principal.prototype.identity = function (force) {
        var _this = this;
        if (force === true) {
            this.userIdentity = undefined;
        }
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.account.get().toPromise().then(function (account) {
            if (account) {
                _this.userIdentity = account;
                _this.authenticated = true;
                _this.trackerService.connect();
            }
            else {
                _this.userIdentity = null;
                _this.authenticated = false;
            }
            _this.authenticationState.next(_this.userIdentity);
            return _this.userIdentity;
        }).catch(function (err) {
            if (_this.trackerService.stompClient && _this.trackerService.stompClient.connected) {
                _this.trackerService.disconnect();
            }
            _this.userIdentity = null;
            _this.authenticated = false;
            _this.authenticationState.next(_this.userIdentity);
            return null;
        });
    };
    Principal.prototype.isAuthenticated = function () {
        return this.authenticated;
    };
    Principal.prototype.isIdentityResolved = function () {
        return this.userIdentity !== undefined;
    };
    Principal.prototype.getAuthenticationState = function () {
        return this.authenticationState.asObservable();
    };
    Principal.prototype.getImageUrl = function () {
        return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
    };
    return Principal;
}());
Principal = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [account_service_1.AccountService,
        tracker_service_1.JhiTrackerService])
], Principal);
exports.Principal = Principal;


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(138));
__export(__webpack_require__(53));
__export(__webpack_require__(17));
__export(__webpack_require__(136));
__export(__webpack_require__(134));
__export(__webpack_require__(135));
__export(__webpack_require__(137));
__export(__webpack_require__(270));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(194));
__export(__webpack_require__(64));
__export(__webpack_require__(29));
__export(__webpack_require__(192));
__export(__webpack_require__(190));
__export(__webpack_require__(191));
__export(__webpack_require__(193));
__export(__webpack_require__(300));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(199));
__export(__webpack_require__(65));
__export(__webpack_require__(30));
__export(__webpack_require__(197));
__export(__webpack_require__(195));
__export(__webpack_require__(196));
__export(__webpack_require__(198));
__export(__webpack_require__(302));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(207));
__export(__webpack_require__(308));
__export(__webpack_require__(311));
__export(__webpack_require__(309));
__export(__webpack_require__(313));
__export(__webpack_require__(312));
__export(__webpack_require__(314));
__export(__webpack_require__(68));
__export(__webpack_require__(208));
__export(__webpack_require__(310));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Rx_1 = __webpack_require__(216);
var ng2_webstorage_1 = __webpack_require__(42);
var ng_jhipster_1 = __webpack_require__(1);
var AuthServerProvider = (function () {
    function AuthServerProvider(http, base64, $localStorage) {
        this.http = http;
        this.base64 = base64;
        this.$localStorage = $localStorage;
    }
    AuthServerProvider.prototype.getToken = function () {
        return this.$localStorage.retrieve('authenticationToken');
    };
    AuthServerProvider.prototype.login = function (credentials) {
        var data = 'username=' + encodeURIComponent(credentials.username) + '&password=' +
            encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
            'client_secret=my-secret-token-to-change-in-production&client_id=marketmanagerapp';
        var headers = new http_1.Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            'Authorization': 'Basic ' + this.base64.encode('marketmanagerapp' + ':' + 'my-secret-token-to-change-in-production')
        });
        return this.http.post('oauth/token', data, {
            headers: headers
        }).map(authSuccess.bind(this));
        function authSuccess(resp) {
            var response = resp.json();
            var expiredAt = new Date();
            expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
            response.expires_at = expiredAt.getTime();
            this.$localStorage.store('authenticationToken', response);
            return response;
        }
    };
    AuthServerProvider.prototype.logout = function () {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            _this.http.post('api/logout', {});
            _this.$localStorage.clear('authenticationToken');
            observer.complete();
        });
    };
    return AuthServerProvider;
}());
AuthServerProvider = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        ng_jhipster_1.Base64,
        ng2_webstorage_1.LocalStorageService])
], AuthServerProvider);
exports.AuthServerProvider = AuthServerProvider;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng2_webstorage_1 = __webpack_require__(42);
var StateStorageService = (function () {
    function StateStorageService($sessionStorage) {
        this.$sessionStorage = $sessionStorage;
    }
    StateStorageService.prototype.getPreviousState = function () {
        return this.$sessionStorage.retrieve('previousState');
    };
    StateStorageService.prototype.resetPreviousState = function () {
        this.$sessionStorage.clear('previousState');
    };
    StateStorageService.prototype.storePreviousState = function (previousStateName, previousStateParams) {
        var previousState = { 'name': previousStateName, 'params': previousStateParams };
        this.$sessionStorage.store('previousState', previousState);
    };
    StateStorageService.prototype.getDestinationState = function () {
        return this.$sessionStorage.retrieve('destinationState');
    };
    StateStorageService.prototype.storeUrl = function (url) {
        this.$sessionStorage.store('previousUrl', url);
    };
    StateStorageService.prototype.getUrl = function () {
        return this.$sessionStorage.retrieve('previousUrl');
    };
    StateStorageService.prototype.storeDestinationState = function (destinationState, destinationStateParams, fromState) {
        var destinationInfo = {
            'destination': {
                'name': destinationState.name,
                'data': destinationState.data,
            },
            'params': destinationStateParams,
            'from': {
                'name': fromState.name,
            }
        };
        this.$sessionStorage.store('destinationState', destinationInfo);
    };
    return StateStorageService;
}());
StateStorageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_webstorage_1.SessionStorageService])
], StateStorageService);
exports.StateStorageService = StateStorageService;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var Rx_1 = __webpack_require__(216);
var csrf_service_1 = __webpack_require__(211);
var window_service_1 = __webpack_require__(215);
var auth_oauth2_service_1 = __webpack_require__(39);
var SockJS = __webpack_require__(450);
var Stomp = __webpack_require__(451);
var JhiTrackerService = (function () {
    function JhiTrackerService(router, authServerProvider, $window, csrfService) {
        this.router = router;
        this.authServerProvider = authServerProvider;
        this.$window = $window;
        this.csrfService = csrfService;
        this.stompClient = null;
        this.subscriber = null;
        this.alreadyConnectedOnce = false;
        this.connection = this.createConnection();
        this.listener = this.createListener();
    }
    JhiTrackerService.prototype.connect = function () {
        var _this = this;
        if (this.connectedPromise === null) {
            this.connection = this.createConnection();
        }
        // building absolute path so that websocket doesn't fail when deploying with a context path
        var loc = this.$window.nativeWindow.location;
        var url;
        url = '//' + loc.host + loc.pathname + 'websocket/tracker';
        var authToken = this.authServerProvider.getToken().access_token;
        if (authToken) {
            url += '?access_token=' + authToken;
        }
        var socket = new SockJS(url);
        this.stompClient = Stomp.over(socket);
        var headers = {};
        this.stompClient.connect(headers, function () {
            _this.connectedPromise('success');
            _this.connectedPromise = null;
            _this.sendActivity();
            if (!_this.alreadyConnectedOnce) {
                _this.subscription = _this.router.events.subscribe(function (event) {
                    if (event instanceof router_1.NavigationEnd) {
                        _this.sendActivity();
                    }
                });
                _this.alreadyConnectedOnce = true;
            }
        });
    };
    JhiTrackerService.prototype.disconnect = function () {
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
            this.stompClient = null;
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        this.alreadyConnectedOnce = false;
    };
    JhiTrackerService.prototype.receive = function () {
        return this.listener;
    };
    JhiTrackerService.prototype.sendActivity = function () {
        if (this.stompClient !== null && this.stompClient.connected) {
            this.stompClient.send('/topic/activity', // destination
            JSON.stringify({ 'page': this.router.routerState.snapshot.url }), // body
            {} // header
            );
        }
    };
    JhiTrackerService.prototype.subscribe = function () {
        var _this = this;
        this.connection.then(function () {
            _this.subscriber = _this.stompClient.subscribe('/topic/tracker', function (data) {
                _this.listenerObserver.next(JSON.parse(data.body));
            });
        });
    };
    JhiTrackerService.prototype.unsubscribe = function () {
        if (this.subscriber !== null) {
            this.subscriber.unsubscribe();
        }
        this.listener = this.createListener();
    };
    JhiTrackerService.prototype.createListener = function () {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            _this.listenerObserver = observer;
        });
    };
    JhiTrackerService.prototype.createConnection = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return _this.connectedPromise = resolve; });
    };
    return JhiTrackerService;
}());
JhiTrackerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        auth_oauth2_service_1.AuthServerProvider,
        window_service_1.WindowRef,
        csrf_service_1.CSRFService])
], JhiTrackerService);
exports.JhiTrackerService = JhiTrackerService;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(239);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(81);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var JhiHealthService = (function () {
    function JhiHealthService(http) {
        this.http = http;
        this.separator = '.';
    }
    JhiHealthService.prototype.checkHealth = function () {
        return this.http.get('management/health').map(function (res) { return res.json(); });
    };
    JhiHealthService.prototype.transformHealthData = function (data) {
        var response = [];
        this.flattenHealthData(response, null, data);
        return response;
    };
    JhiHealthService.prototype.getBaseName = function (name) {
        if (name) {
            var split = name.split('.');
            return split[0];
        }
    };
    JhiHealthService.prototype.getSubSystemName = function (name) {
        if (name) {
            var split = name.split('.');
            split.splice(0, 1);
            var remainder = split.join('.');
            return remainder ? ' - ' + remainder : '';
        }
    };
    /* private methods */
    JhiHealthService.prototype.addHealthObject = function (result, isLeaf, healthObject, name) {
        var healthData = {
            name: name
        };
        var details = {};
        var hasDetails = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                }
                else {
                    if (!this.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            }
        }
        // Add the details
        if (hasDetails) {
            healthData.details = details;
        }
        // Only add nodes if they provide additional information
        if (isLeaf || hasDetails || healthData.error) {
            result.push(healthData);
        }
        return healthData;
    };
    JhiHealthService.prototype.flattenHealthData = function (result, path, data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var value = data[key];
                if (this.isHealthObject(value)) {
                    if (this.hasSubSystem(value)) {
                        this.addHealthObject(result, false, value, this.getModuleName(path, key));
                        this.flattenHealthData(result, this.getModuleName(path, key), value);
                    }
                    else {
                        this.addHealthObject(result, true, value, this.getModuleName(path, key));
                    }
                }
            }
        }
        return result;
    };
    JhiHealthService.prototype.getModuleName = function (path, name) {
        var result;
        if (path && name) {
            result = path + this.separator + name;
        }
        else if (path) {
            result = path;
        }
        else if (name) {
            result = name;
        }
        else {
            result = '';
        }
        return result;
    };
    JhiHealthService.prototype.hasSubSystem = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (value && value.status) {
                    result = true;
                }
            }
        }
        return result;
    };
    JhiHealthService.prototype.isHealthObject = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                if (key === 'status') {
                    result = true;
                }
            }
        }
        return result;
    };
    return JhiHealthService;
}());
JhiHealthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiHealthService);
exports.JhiHealthService = JhiHealthService;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var shared_1 = __webpack_require__(3);
var UserModalService = (function () {
    function UserModalService(modalService, router, userService) {
        this.modalService = modalService;
        this.router = router;
        this.userService = userService;
        this.isOpen = false;
    }
    UserModalService.prototype.open = function (component, login) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (login) {
            this.userService.find(login).subscribe(function (user) { return _this.userModalRef(component, user); });
        }
        else {
            return this.userModalRef(component, new shared_1.User());
        }
    };
    UserModalService.prototype.userModalRef = function (component, user) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.user = user;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return UserModalService;
}());
UserModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        shared_1.UserService])
], UserModalService);
exports.UserModalService = UserModalService;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var additionalflat_model_1 = __webpack_require__(108);
var additionalflat_service_1 = __webpack_require__(11);
var AdditionalflatPopupService = (function () {
    function AdditionalflatPopupService(datePipe, modalService, router, additionalflatService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.additionalflatService = additionalflatService;
        this.isOpen = false;
    }
    AdditionalflatPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.additionalflatService.find(id).subscribe(function (additionalflat) {
                additionalflat.validFrom = _this.datePipe
                    .transform(additionalflat.validFrom, 'yyyy-MM-ddThh:mm');
                additionalflat.updated = _this.datePipe
                    .transform(additionalflat.updated, 'yyyy-MM-ddThh:mm');
                additionalflat.created = _this.datePipe
                    .transform(additionalflat.created, 'yyyy-MM-ddThh:mm');
                _this.additionalflatModalRef(component, additionalflat);
            });
        }
        else {
            return this.additionalflatModalRef(component, new additionalflat_model_1.Additionalflat());
        }
    };
    AdditionalflatPopupService.prototype.additionalflatModalRef = function (component, additionalflat) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.additionalflat = additionalflat;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return AdditionalflatPopupService;
}());
AdditionalflatPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        additionalflat_service_1.AdditionalflatService])
], AdditionalflatPopupService);
exports.AdditionalflatPopupService = AdditionalflatPopupService;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var booth_model_1 = __webpack_require__(113);
var booth_service_1 = __webpack_require__(12);
var BoothPopupService = (function () {
    function BoothPopupService(modalService, router, boothService) {
        this.modalService = modalService;
        this.router = router;
        this.boothService = boothService;
        this.isOpen = false;
    }
    BoothPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.boothService.find(id).subscribe(function (booth) {
                _this.boothModalRef(component, booth);
            });
        }
        else {
            return this.boothModalRef(component, new booth_model_1.Booth());
        }
    };
    BoothPopupService.prototype.boothModalRef = function (component, booth) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.booth = booth;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return BoothPopupService;
}());
BoothPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        booth_service_1.BoothService])
], BoothPopupService);
exports.BoothPopupService = BoothPopupService;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var boothfee_model_1 = __webpack_require__(118);
var boothfee_service_1 = __webpack_require__(13);
var BoothfeePopupService = (function () {
    function BoothfeePopupService(datePipe, modalService, router, boothfeeService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.boothfeeService = boothfeeService;
        this.isOpen = false;
    }
    BoothfeePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.boothfeeService.find(id).subscribe(function (boothfee) {
                boothfee.validFrom = _this.datePipe
                    .transform(boothfee.validFrom, 'yyyy-MM-ddThh:mm');
                boothfee.updated = _this.datePipe
                    .transform(boothfee.updated, 'yyyy-MM-ddThh:mm');
                boothfee.created = _this.datePipe
                    .transform(boothfee.created, 'yyyy-MM-ddThh:mm');
                _this.boothfeeModalRef(component, boothfee);
            });
        }
        else {
            return this.boothfeeModalRef(component, new boothfee_model_1.Boothfee());
        }
    };
    BoothfeePopupService.prototype.boothfeeModalRef = function (component, boothfee) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.boothfee = boothfee;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return BoothfeePopupService;
}());
BoothfeePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        boothfee_service_1.BoothfeeService])
], BoothfeePopupService);
exports.BoothfeePopupService = BoothfeePopupService;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var branch_model_1 = __webpack_require__(123);
var branch_service_1 = __webpack_require__(14);
var BranchPopupService = (function () {
    function BranchPopupService(modalService, router, branchService) {
        this.modalService = modalService;
        this.router = router;
        this.branchService = branchService;
        this.isOpen = false;
    }
    BranchPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.branchService.find(id).subscribe(function (branch) {
                _this.branchModalRef(component, branch);
            });
        }
        else {
            return this.branchModalRef(component, new branch_model_1.Branch());
        }
    };
    BranchPopupService.prototype.branchModalRef = function (component, branch) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.branch = branch;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return BranchPopupService;
}());
BranchPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        branch_service_1.BranchService])
], BranchPopupService);
exports.BranchPopupService = BranchPopupService;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(123));
__export(__webpack_require__(49));
__export(__webpack_require__(14));
__export(__webpack_require__(121));
__export(__webpack_require__(119));
__export(__webpack_require__(120));
__export(__webpack_require__(122));
__export(__webpack_require__(263));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var contact_temp_model_1 = __webpack_require__(128);
var contact_temp_service_1 = __webpack_require__(15);
var ContactTempPopupService = (function () {
    function ContactTempPopupService(datePipe, modalService, router, contactTempService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.contactTempService = contactTempService;
        this.isOpen = false;
    }
    ContactTempPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.contactTempService.find(id).subscribe(function (contactTemp) {
                contactTemp.updated = _this.datePipe
                    .transform(contactTemp.updated, 'yyyy-MM-ddThh:mm');
                contactTemp.created = _this.datePipe
                    .transform(contactTemp.created, 'yyyy-MM-ddThh:mm');
                _this.contactTempModalRef(component, contactTemp);
            });
        }
        else {
            return this.contactTempModalRef(component, new contact_temp_model_1.ContactTemp());
        }
    };
    ContactTempPopupService.prototype.contactTempModalRef = function (component, contactTemp) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.contactTemp = contactTemp;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ContactTempPopupService;
}());
ContactTempPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        contact_temp_service_1.ContactTempService])
], ContactTempPopupService);
exports.ContactTempPopupService = ContactTempPopupService;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var contact_model_1 = __webpack_require__(133);
var contact_service_1 = __webpack_require__(16);
var ContactPopupService = (function () {
    function ContactPopupService(datePipe, modalService, router, contactService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.contactService = contactService;
        this.isOpen = false;
    }
    ContactPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.contactService.find(id).subscribe(function (contact) {
                contact.updated = _this.datePipe
                    .transform(contact.updated, 'yyyy-MM-ddThh:mm');
                contact.created = _this.datePipe
                    .transform(contact.created, 'yyyy-MM-ddThh:mm');
                _this.contactModalRef(component, contact);
            });
        }
        else {
            return this.contactModalRef(component, new contact_model_1.Contact());
        }
    };
    ContactPopupService.prototype.contactModalRef = function (component, contact) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.contact = contact;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ContactPopupService;
}());
ContactPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        contact_service_1.ContactService])
], ContactPopupService);
exports.ContactPopupService = ContactPopupService;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var contract_model_1 = __webpack_require__(138);
var contract_service_1 = __webpack_require__(17);
var ContractPopupService = (function () {
    function ContractPopupService(datePipe, modalService, router, contractService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.contractService = contractService;
        this.isOpen = false;
    }
    ContractPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.contractService.find(id).subscribe(function (contract) {
                contract.startDate = _this.datePipe
                    .transform(contract.startDate, 'yyyy-MM-ddThh:mm');
                contract.endDate = _this.datePipe
                    .transform(contract.endDate, 'yyyy-MM-ddThh:mm');
                _this.contractModalRef(component, contract);
            });
        }
        else {
            return this.contractModalRef(component, new contract_model_1.Contract());
        }
    };
    ContractPopupService.prototype.contractModalRef = function (component, contract) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.contract = contract;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ContractPopupService;
}());
ContractPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        contract_service_1.ContractService])
], ContractPopupService);
exports.ContractPopupService = ContractPopupService;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var contractdate_model_1 = __webpack_require__(143);
var contractdate_service_1 = __webpack_require__(18);
var ContractdatePopupService = (function () {
    function ContractdatePopupService(datePipe, modalService, router, contractdateService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.contractdateService = contractdateService;
        this.isOpen = false;
    }
    ContractdatePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.contractdateService.find(id).subscribe(function (contractdate) {
                contractdate.realDate = _this.datePipe
                    .transform(contractdate.realDate, 'yyyy-MM-ddThh:mm');
                contractdate.originalDate = _this.datePipe
                    .transform(contractdate.originalDate, 'yyyy-MM-ddThh:mm');
                contractdate.evasiveDate = _this.datePipe
                    .transform(contractdate.evasiveDate, 'yyyy-MM-ddThh:mm');
                _this.contractdateModalRef(component, contractdate);
            });
        }
        else {
            return this.contractdateModalRef(component, new contractdate_model_1.Contractdate());
        }
    };
    ContractdatePopupService.prototype.contractdateModalRef = function (component, contractdate) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.contractdate = contractdate;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ContractdatePopupService;
}());
ContractdatePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        contractdate_service_1.ContractdateService])
], ContractdatePopupService);
exports.ContractdatePopupService = ContractdatePopupService;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var electricmeter_model_1 = __webpack_require__(148);
var electricmeter_service_1 = __webpack_require__(19);
var ElectricmeterPopupService = (function () {
    function ElectricmeterPopupService(datePipe, modalService, router, electricmeterService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.electricmeterService = electricmeterService;
        this.isOpen = false;
    }
    ElectricmeterPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.electricmeterService.find(id).subscribe(function (electricmeter) {
                electricmeter.updated = _this.datePipe
                    .transform(electricmeter.updated, 'yyyy-MM-ddThh:mm');
                electricmeter.created = _this.datePipe
                    .transform(electricmeter.created, 'yyyy-MM-ddThh:mm');
                electricmeter.lastValueChanged = _this.datePipe
                    .transform(electricmeter.lastValueChanged, 'yyyy-MM-ddThh:mm');
                _this.electricmeterModalRef(component, electricmeter);
            });
        }
        else {
            return this.electricmeterModalRef(component, new electricmeter_model_1.Electricmeter());
        }
    };
    ElectricmeterPopupService.prototype.electricmeterModalRef = function (component, electricmeter) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.electricmeter = electricmeter;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ElectricmeterPopupService;
}());
ElectricmeterPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        electricmeter_service_1.ElectricmeterService])
], ElectricmeterPopupService);
exports.ElectricmeterPopupService = ElectricmeterPopupService;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var energyflat_model_1 = __webpack_require__(154);
var energyflat_service_1 = __webpack_require__(20);
var EnergyflatPopupService = (function () {
    function EnergyflatPopupService(datePipe, modalService, router, energyflatService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.energyflatService = energyflatService;
        this.isOpen = false;
    }
    EnergyflatPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.energyflatService.find(id).subscribe(function (energyflat) {
                energyflat.validFrom = _this.datePipe
                    .transform(energyflat.validFrom, 'yyyy-MM-ddThh:mm');
                energyflat.updated = _this.datePipe
                    .transform(energyflat.updated, 'yyyy-MM-ddThh:mm');
                energyflat.created = _this.datePipe
                    .transform(energyflat.created, 'yyyy-MM-ddThh:mm');
                _this.energyflatModalRef(component, energyflat);
            });
        }
        else {
            return this.energyflatModalRef(component, new energyflat_model_1.Energyflat());
        }
    };
    EnergyflatPopupService.prototype.energyflatModalRef = function (component, energyflat) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.energyflat = energyflat;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return EnergyflatPopupService;
}());
EnergyflatPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        energyflat_service_1.EnergyflatService])
], EnergyflatPopupService);
exports.EnergyflatPopupService = EnergyflatPopupService;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var marketdate_booth_model_1 = __webpack_require__(159);
var marketdate_booth_service_1 = __webpack_require__(21);
var MarketdateBoothPopupService = (function () {
    function MarketdateBoothPopupService(modalService, router, marketdateBoothService) {
        this.modalService = modalService;
        this.router = router;
        this.marketdateBoothService = marketdateBoothService;
        this.isOpen = false;
    }
    MarketdateBoothPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateBoothService.find(id).subscribe(function (marketdateBooth) {
                _this.marketdateBoothModalRef(component, marketdateBooth);
            });
        }
        else {
            return this.marketdateBoothModalRef(component, new marketdate_booth_model_1.MarketdateBooth());
        }
    };
    MarketdateBoothPopupService.prototype.marketdateBoothModalRef = function (component, marketdateBooth) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdateBooth = marketdateBooth;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdateBoothPopupService;
}());
MarketdateBoothPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_booth_service_1.MarketdateBoothService])
], MarketdateBoothPopupService);
exports.MarketdateBoothPopupService = MarketdateBoothPopupService;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketdate_comment_model_1 = __webpack_require__(164);
var marketdate_comment_service_1 = __webpack_require__(22);
var MarketdateCommentPopupService = (function () {
    function MarketdateCommentPopupService(datePipe, modalService, router, marketdateCommentService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdateCommentService = marketdateCommentService;
        this.isOpen = false;
    }
    MarketdateCommentPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateCommentService.find(id).subscribe(function (marketdateComment) {
                marketdateComment.updated = _this.datePipe
                    .transform(marketdateComment.updated, 'yyyy-MM-ddThh:mm');
                marketdateComment.created = _this.datePipe
                    .transform(marketdateComment.created, 'yyyy-MM-ddThh:mm');
                _this.marketdateCommentModalRef(component, marketdateComment);
            });
        }
        else {
            return this.marketdateCommentModalRef(component, new marketdate_comment_model_1.MarketdateComment());
        }
    };
    MarketdateCommentPopupService.prototype.marketdateCommentModalRef = function (component, marketdateComment) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdateComment = marketdateComment;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdateCommentPopupService;
}());
MarketdateCommentPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_comment_service_1.MarketdateCommentService])
], MarketdateCommentPopupService);
exports.MarketdateCommentPopupService = MarketdateCommentPopupService;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketdate_expense_model_1 = __webpack_require__(169);
var marketdate_expense_service_1 = __webpack_require__(23);
var MarketdateExpensePopupService = (function () {
    function MarketdateExpensePopupService(datePipe, modalService, router, marketdateExpenseService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdateExpenseService = marketdateExpenseService;
        this.isOpen = false;
    }
    MarketdateExpensePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateExpenseService.find(id).subscribe(function (marketdateExpense) {
                marketdateExpense.updated = _this.datePipe
                    .transform(marketdateExpense.updated, 'yyyy-MM-ddThh:mm');
                marketdateExpense.created = _this.datePipe
                    .transform(marketdateExpense.created, 'yyyy-MM-ddThh:mm');
                _this.marketdateExpenseModalRef(component, marketdateExpense);
            });
        }
        else {
            return this.marketdateExpenseModalRef(component, new marketdate_expense_model_1.MarketdateExpense());
        }
    };
    MarketdateExpensePopupService.prototype.marketdateExpenseModalRef = function (component, marketdateExpense) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdateExpense = marketdateExpense;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdateExpensePopupService;
}());
MarketdateExpensePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_expense_service_1.MarketdateExpenseService])
], MarketdateExpensePopupService);
exports.MarketdateExpensePopupService = MarketdateExpensePopupService;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketdate_meterreading_model_1 = __webpack_require__(174);
var marketdate_meterreading_service_1 = __webpack_require__(24);
var MarketdateMeterreadingPopupService = (function () {
    function MarketdateMeterreadingPopupService(datePipe, modalService, router, marketdateMeterreadingService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdateMeterreadingService = marketdateMeterreadingService;
        this.isOpen = false;
    }
    MarketdateMeterreadingPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateMeterreadingService.find(id).subscribe(function (marketdateMeterreading) {
                marketdateMeterreading.timestamp = _this.datePipe
                    .transform(marketdateMeterreading.timestamp, 'yyyy-MM-ddThh:mm');
                marketdateMeterreading.updated = _this.datePipe
                    .transform(marketdateMeterreading.updated, 'yyyy-MM-ddThh:mm');
                marketdateMeterreading.created = _this.datePipe
                    .transform(marketdateMeterreading.created, 'yyyy-MM-ddThh:mm');
                _this.marketdateMeterreadingModalRef(component, marketdateMeterreading);
            });
        }
        else {
            return this.marketdateMeterreadingModalRef(component, new marketdate_meterreading_model_1.MarketdateMeterreading());
        }
    };
    MarketdateMeterreadingPopupService.prototype.marketdateMeterreadingModalRef = function (component, marketdateMeterreading) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdateMeterreading = marketdateMeterreading;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdateMeterreadingPopupService;
}());
MarketdateMeterreadingPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_meterreading_service_1.MarketdateMeterreadingService])
], MarketdateMeterreadingPopupService);
exports.MarketdateMeterreadingPopupService = MarketdateMeterreadingPopupService;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketdate_status_model_1 = __webpack_require__(179);
var marketdate_status_service_1 = __webpack_require__(25);
var MarketdateStatusPopupService = (function () {
    function MarketdateStatusPopupService(datePipe, modalService, router, marketdateStatusService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdateStatusService = marketdateStatusService;
        this.isOpen = false;
    }
    MarketdateStatusPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateStatusService.find(id).subscribe(function (marketdateStatus) {
                marketdateStatus.updated = _this.datePipe
                    .transform(marketdateStatus.updated, 'yyyy-MM-ddThh:mm');
                marketdateStatus.created = _this.datePipe
                    .transform(marketdateStatus.created, 'yyyy-MM-ddThh:mm');
                _this.marketdateStatusModalRef(component, marketdateStatus);
            });
        }
        else {
            return this.marketdateStatusModalRef(component, new marketdate_status_model_1.MarketdateStatus());
        }
    };
    MarketdateStatusPopupService.prototype.marketdateStatusModalRef = function (component, marketdateStatus) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdateStatus = marketdateStatus;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdateStatusPopupService;
}());
MarketdateStatusPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_status_service_1.MarketdateStatusService])
], MarketdateStatusPopupService);
exports.MarketdateStatusPopupService = MarketdateStatusPopupService;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketdate_model_1 = __webpack_require__(184);
var marketdate_service_1 = __webpack_require__(27);
var MarketdatePopupService = (function () {
    function MarketdatePopupService(datePipe, modalService, router, marketdateService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdateService = marketdateService;
        this.isOpen = false;
    }
    MarketdatePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdateService.find(id).subscribe(function (marketdate) {
                marketdate.originalDate = _this.datePipe
                    .transform(marketdate.originalDate, 'yyyy-MM-ddThh:mm');
                marketdate.evasiveDate = _this.datePipe
                    .transform(marketdate.evasiveDate, 'yyyy-MM-ddThh:mm');
                marketdate.updated = _this.datePipe
                    .transform(marketdate.updated, 'yyyy-MM-ddThh:mm');
                marketdate.created = _this.datePipe
                    .transform(marketdate.created, 'yyyy-MM-ddThh:mm');
                _this.marketdateModalRef(component, marketdate);
            });
        }
        else {
            return this.marketdateModalRef(component, new marketdate_model_1.Marketdate());
        }
    };
    MarketdatePopupService.prototype.marketdateModalRef = function (component, marketdate) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketdate = marketdate;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdatePopupService;
}());
MarketdatePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketdate_service_1.MarketdateService])
], MarketdatePopupService);
exports.MarketdatePopupService = MarketdatePopupService;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketday_model_1 = __webpack_require__(189);
var marketday_service_1 = __webpack_require__(28);
var MarketdayPopupService = (function () {
    function MarketdayPopupService(datePipe, modalService, router, marketdayService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketdayService = marketdayService;
        this.isOpen = false;
    }
    MarketdayPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketdayService.find(id).subscribe(function (marketday) {
                marketday.startTime = _this.datePipe
                    .transform(marketday.startTime, 'yyyy-MM-ddThh:mm');
                marketday.endTime = _this.datePipe
                    .transform(marketday.endTime, 'yyyy-MM-ddThh:mm');
                marketday.buildingStartTime = _this.datePipe
                    .transform(marketday.buildingStartTime, 'yyyy-MM-ddThh:mm');
                marketday.dismantlingEndTime = _this.datePipe
                    .transform(marketday.dismantlingEndTime, 'yyyy-MM-ddThh:mm');
                marketday.startTimeWinter = _this.datePipe
                    .transform(marketday.startTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.endTimeWinter = _this.datePipe
                    .transform(marketday.endTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.buildingStartTimeWinter = _this.datePipe
                    .transform(marketday.buildingStartTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.dismantlingEndTimeWinter = _this.datePipe
                    .transform(marketday.dismantlingEndTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.updated = _this.datePipe
                    .transform(marketday.updated, 'yyyy-MM-ddThh:mm');
                marketday.created = _this.datePipe
                    .transform(marketday.created, 'yyyy-MM-ddThh:mm');
                _this.marketdayModalRef(component, marketday);
            });
        }
        else {
            return this.marketdayModalRef(component, new marketday_model_1.Marketday());
        }
    };
    MarketdayPopupService.prototype.marketdayModalRef = function (component, marketday) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketday = marketday;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketdayPopupService;
}());
MarketdayPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketday_service_1.MarketdayService])
], MarketdayPopupService);
exports.MarketdayPopupService = MarketdayPopupService;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var marketplace_model_1 = __webpack_require__(194);
var marketplace_service_1 = __webpack_require__(29);
var MarketplacePopupService = (function () {
    function MarketplacePopupService(datePipe, modalService, router, marketplaceService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.marketplaceService = marketplaceService;
        this.isOpen = false;
    }
    MarketplacePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.marketplaceService.find(id).subscribe(function (marketplace) {
                marketplace.updated = _this.datePipe
                    .transform(marketplace.updated, 'yyyy-MM-ddThh:mm');
                marketplace.created = _this.datePipe
                    .transform(marketplace.created, 'yyyy-MM-ddThh:mm');
                _this.marketplaceModalRef(component, marketplace);
            });
        }
        else {
            return this.marketplaceModalRef(component, new marketplace_model_1.Marketplace());
        }
    };
    MarketplacePopupService.prototype.marketplaceModalRef = function (component, marketplace) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.marketplace = marketplace;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return MarketplacePopupService;
}());
MarketplacePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        marketplace_service_1.MarketplaceService])
], MarketplacePopupService);
exports.MarketplacePopupService = MarketplacePopupService;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var salesunit_model_1 = __webpack_require__(199);
var salesunit_service_1 = __webpack_require__(30);
var SalesunitPopupService = (function () {
    function SalesunitPopupService(datePipe, modalService, router, salesunitService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.salesunitService = salesunitService;
        this.isOpen = false;
    }
    SalesunitPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.salesunitService.find(id).subscribe(function (salesunit) {
                salesunit.winterStart = _this.datePipe
                    .transform(salesunit.winterStart, 'yyyy-MM-ddThh:mm');
                salesunit.winterEnd = _this.datePipe
                    .transform(salesunit.winterEnd, 'yyyy-MM-ddThh:mm');
                salesunit.updated = _this.datePipe
                    .transform(salesunit.updated, 'yyyy-MM-ddThh:mm');
                salesunit.created = _this.datePipe
                    .transform(salesunit.created, 'yyyy-MM-ddThh:mm');
                _this.salesunitModalRef(component, salesunit);
            });
        }
        else {
            return this.salesunitModalRef(component, new salesunit_model_1.Salesunit());
        }
    };
    SalesunitPopupService.prototype.salesunitModalRef = function (component, salesunit) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.salesunit = salesunit;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return SalesunitPopupService;
}());
SalesunitPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        salesunit_service_1.SalesunitService])
], SalesunitPopupService);
exports.SalesunitPopupService = SalesunitPopupService;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(7);
var testentity_model_1 = __webpack_require__(204);
var testentity_service_1 = __webpack_require__(31);
var TestentityPopupService = (function () {
    function TestentityPopupService(datePipe, modalService, router, testentityService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.testentityService = testentityService;
        this.isOpen = false;
    }
    TestentityPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.testentityService.find(id).subscribe(function (testentity) {
                testentity.myZonedDateTime = _this.datePipe
                    .transform(testentity.myZonedDateTime, 'yyyy-MM-ddThh:mm');
                if (testentity.myLocalDate) {
                    testentity.myLocalDate = {
                        year: testentity.myLocalDate.getFullYear(),
                        month: testentity.myLocalDate.getMonth() + 1,
                        day: testentity.myLocalDate.getDate()
                    };
                }
                _this.testentityModalRef(component, testentity);
            });
        }
        else {
            return this.testentityModalRef(component, new testentity_model_1.Testentity());
        }
    };
    TestentityPopupService.prototype.testentityModalRef = function (component, testentity) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.testentity = testentity;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return TestentityPopupService;
}());
TestentityPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        testentity_service_1.TestentityService])
], TestentityPopupService);
exports.TestentityPopupService = TestentityPopupService;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var NavbarService = (function () {
    function NavbarService() {
        this.visible = true;
        this.visible = true;
    }
    NavbarService.prototype.hide = function () { this.visible = false; };
    NavbarService.prototype.show = function () { this.visible = true; };
    NavbarService.prototype.toggle = function () { this.visible = !this.visible; };
    return NavbarService;
}());
NavbarService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], NavbarService);
exports.NavbarService = NavbarService;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var profile_info_model_1 = __webpack_require__(208);
var ProfileService = (function () {
    function ProfileService(http) {
        this.http = http;
        this.profileInfoUrl = 'api/profile-info';
    }
    ProfileService.prototype.getProfileInfo = function () {
        return this.http.get(this.profileInfoUrl)
            .map(function (res) {
            var data = res.json();
            var pi = new profile_info_model_1.ProfileInfo();
            pi.activeProfiles = data.activeProfiles;
            pi.ribbonEnv = data.ribbonEnv;
            pi.inProduction = data.activeProfiles.indexOf('prod') !== -1;
            pi.swaggerEnabled = data.activeProfiles.indexOf('swagger') !== -1;
            return pi;
        });
    };
    return ProfileService;
}());
ProfileService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ProfileService);
exports.ProfileService = ProfileService;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var login_component_1 = __webpack_require__(213);
var LoginModalService = (function () {
    function LoginModalService(modalService) {
        this.modalService = modalService;
        this.isOpen = false;
    }
    LoginModalService.prototype.open = function () {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        var modalRef = this.modalService.open(login_component_1.JhiLoginModalComponent, {
            container: 'nav'
        });
        modalRef.result.then(function (result) {
            _this.isOpen = false;
        }, function (reason) {
            _this.isOpen = false;
        });
        return modalRef;
    };
    return LoginModalService;
}());
LoginModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal])
], LoginModalService);
exports.LoginModalService = LoginModalService;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(0);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(31);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
var _VERSION = '0.0.0'; // This value will be overwritten by webpack
var _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "0.0.0";
_DEBUG_INFO_ENABLED = false;
exports.VERSION = _VERSION;
exports.DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var activate_service_1 = __webpack_require__(74);
var shared_1 = __webpack_require__(3);
var ActivateComponent = (function () {
    function ActivateComponent(jhiLanguageService, activate, loginModalService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.activate = activate;
        this.loginModalService = loginModalService;
        this.route = route;
        this.jhiLanguageService.setLocations(['activate']);
    }
    ActivateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.activate.get(params['key']).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        });
    };
    ActivateComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return ActivateComponent;
}());
ActivateComponent = __decorate([
    core_1.Component({
        selector: 'jhi-activate',
        template: __webpack_require__(336)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        activate_service_1.Activate,
        shared_1.LoginModalService,
        router_1.ActivatedRoute])
], ActivateComponent);
exports.ActivateComponent = ActivateComponent;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Activate = (function () {
    function Activate(http) {
        this.http = http;
    }
    Activate.prototype.get = function (key) {
        var params = new http_1.URLSearchParams();
        params.set('key', key);
        return this.http.get('api/activate', {
            search: params
        }).map(function (res) { return res; });
    };
    return Activate;
}());
Activate = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Activate);
exports.Activate = Activate;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(73));
__export(__webpack_require__(74));
__export(__webpack_require__(228));
__export(__webpack_require__(80));
__export(__webpack_require__(231));
__export(__webpack_require__(81));
__export(__webpack_require__(232));
__export(__webpack_require__(76));
__export(__webpack_require__(77));
__export(__webpack_require__(229));
__export(__webpack_require__(78));
__export(__webpack_require__(79));
__export(__webpack_require__(230));
__export(__webpack_require__(82));
__export(__webpack_require__(83));
__export(__webpack_require__(233));
__export(__webpack_require__(84));
__export(__webpack_require__(234));
__export(__webpack_require__(227));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_finish_service_1 = __webpack_require__(77);
var shared_1 = __webpack_require__(3);
var navbar_service_1 = __webpack_require__(67);
var PasswordResetFinishComponent = (function () {
    function PasswordResetFinishComponent(jhiLanguageService, passwordResetFinish, loginModalService, route, elementRef, renderer, navbarService) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetFinish = passwordResetFinish;
        this.loginModalService = loginModalService;
        this.route = route;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.navbarService = navbarService;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetFinishComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.navbarService.hide();
        this.route.queryParams.subscribe(function (params) {
            _this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    };
    PasswordResetFinishComponent.prototype.ngAfterViewInit = function () {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    };
    PasswordResetFinishComponent.prototype.finishReset = function () {
        var _this = this;
        this.doNotMatch = null;
        this.error = null;
        if (this.resetAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.passwordResetFinish.save({ key: this.key, newPassword: this.resetAccount.password }).subscribe(function () {
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    PasswordResetFinishComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return PasswordResetFinishComponent;
}());
PasswordResetFinishComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-reset-finish',
        template: __webpack_require__(337)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_finish_service_1.PasswordResetFinish,
        shared_1.LoginModalService,
        router_1.ActivatedRoute,
        core_1.ElementRef,
        core_1.Renderer,
        navbar_service_1.NavbarService])
], PasswordResetFinishComponent);
exports.PasswordResetFinishComponent = PasswordResetFinishComponent;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var PasswordResetFinish = (function () {
    function PasswordResetFinish(http) {
        this.http = http;
    }
    PasswordResetFinish.prototype.save = function (keyAndPassword) {
        return this.http.post('api/v5/account/reset_password/finish', keyAndPassword);
    };
    return PasswordResetFinish;
}());
PasswordResetFinish = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetFinish);
exports.PasswordResetFinish = PasswordResetFinish;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_init_service_1 = __webpack_require__(79);
var PasswordResetInitComponent = (function () {
    function PasswordResetInitComponent(jhiLanguageService, passwordResetInit, elementRef, renderer) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetInit = passwordResetInit;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetInitComponent.prototype.ngOnInit = function () {
        this.resetAccount = {};
    };
    PasswordResetInitComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    PasswordResetInitComponent.prototype.requestReset = function () {
        var _this = this;
        this.error = null;
        this.errorEmailNotExists = null;
        this.passwordResetInit.save(this.resetAccount.email).subscribe(function () {
            _this.success = 'OK';
        }, function (response) {
            _this.success = null;
            if (response.status === 400 && response.data === 'email address not registered') {
                _this.errorEmailNotExists = 'ERROR';
            }
            else {
                _this.error = 'ERROR';
            }
        });
    };
    return PasswordResetInitComponent;
}());
PasswordResetInitComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-reset-init',
        template: __webpack_require__(338)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_init_service_1.PasswordResetInit,
        core_1.ElementRef,
        core_1.Renderer])
], PasswordResetInitComponent);
exports.PasswordResetInitComponent = PasswordResetInitComponent;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var PasswordResetInit = (function () {
    function PasswordResetInit(http) {
        this.http = http;
    }
    PasswordResetInit.prototype.save = function (mail) {
        return this.http.post('api/v5/account/reset_password/init', mail);
    };
    return PasswordResetInit;
}());
PasswordResetInit = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetInit);
exports.PasswordResetInit = PasswordResetInit;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var password_service_1 = __webpack_require__(81);
var PasswordComponent = (function () {
    function PasswordComponent(jhiLanguageService, passwordService, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordService = passwordService;
        this.principal = principal;
        this.jhiLanguageService.setLocations(['password']);
    }
    PasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
    };
    PasswordComponent.prototype.changePassword = function () {
        var _this = this;
        if (this.password !== this.confirmPassword) {
            this.error = null;
            this.success = null;
            this.doNotMatch = 'ERROR';
        }
        else {
            this.doNotMatch = null;
            this.passwordService.save(this.password).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    return PasswordComponent;
}());
PasswordComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password',
        template: __webpack_require__(339)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_service_1.Password,
        shared_1.Principal])
], PasswordComponent);
exports.PasswordComponent = PasswordComponent;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Password = (function () {
    function Password(http) {
        this.http = http;
    }
    Password.prototype.save = function (newPassword) {
        return this.http.post('api/account/change_password', newPassword);
    };
    return Password;
}());
Password = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Password);
exports.Password = Password;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var register_service_1 = __webpack_require__(83);
var shared_1 = __webpack_require__(3);
var RegisterComponent = (function () {
    function RegisterComponent(languageService, loginModalService, registerService, elementRef, renderer) {
        this.languageService = languageService;
        this.loginModalService = loginModalService;
        this.registerService = registerService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.languageService.setLocations(['register']);
    }
    RegisterComponent.prototype.ngOnInit = function () {
        this.success = false;
        this.registerAccount = {};
    };
    RegisterComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#login'), 'focus', []);
    };
    RegisterComponent.prototype.register = function () {
        var _this = this;
        if (this.registerAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.doNotMatch = null;
            this.error = null;
            this.errorUserExists = null;
            this.errorEmailExists = null;
            this.languageService.getCurrent().then(function (key) {
                _this.registerAccount.langKey = key;
                _this.registerService.save(_this.registerAccount).subscribe(function () {
                    _this.success = true;
                }, function (response) { return _this.processError(response); });
            });
        }
    };
    RegisterComponent.prototype.openLogin = function () {
        this.modalRef = this.loginModalService.open();
    };
    RegisterComponent.prototype.processError = function (response) {
        this.success = null;
        if (response.status === 400 && response._body === 'login already in use') {
            this.errorUserExists = 'ERROR';
        }
        else if (response.status === 400 && response._body === 'email address already in use') {
            this.errorEmailExists = 'ERROR';
        }
        else {
            this.error = 'ERROR';
        }
    };
    return RegisterComponent;
}());
RegisterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-register',
        template: __webpack_require__(340)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.LoginModalService,
        register_service_1.Register,
        core_1.ElementRef,
        core_1.Renderer])
], RegisterComponent);
exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Register = (function () {
    function Register(http) {
        this.http = http;
    }
    Register.prototype.save = function (account) {
        return this.http.post('api/register', account);
    };
    return Register;
}());
Register = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Register);
exports.Register = Register;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var SettingsComponent = (function () {
    function SettingsComponent(account, principal, languageService, languageHelper) {
        this.account = account;
        this.principal = principal;
        this.languageService = languageService;
        this.languageHelper = languageHelper;
        this.languageService.setLocations(['settings']);
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.settingsAccount = _this.copyAccount(account);
        });
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
    };
    SettingsComponent.prototype.save = function () {
        var _this = this;
        this.account.save(this.settingsAccount).subscribe(function () {
            _this.error = null;
            _this.success = 'OK';
            _this.principal.identity(true).then(function (account) {
                _this.settingsAccount = _this.copyAccount(account);
            });
            _this.languageService.getCurrent().then(function (current) {
                if (_this.settingsAccount.langKey !== current) {
                    _this.languageService.changeLanguage(_this.settingsAccount.langKey);
                }
            });
        }, function () {
            _this.success = null;
            _this.error = 'ERROR';
        });
    };
    SettingsComponent.prototype.copyAccount = function (account) {
        return {
            activated: account.activated,
            email: account.email,
            firstName: account.firstName,
            langKey: account.langKey,
            lastName: account.lastName,
            login: account.login,
            imageUrl: account.imageUrl
        };
    };
    return SettingsComponent;
}());
SettingsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-settings',
        template: __webpack_require__(341)
    }),
    __metadata("design:paramtypes", [shared_1.AccountService,
        shared_1.Principal,
        ng_jhipster_1.JhiLanguageService,
        shared_1.JhiLanguageHelper])
], SettingsComponent);
exports.SettingsComponent = SettingsComponent;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(1);
var audits_service_1 = __webpack_require__(86);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var AuditsComponent = (function () {
    function AuditsComponent(jhiLanguageService, auditsService, parseLinks, paginationConfig, datePipe) {
        this.jhiLanguageService = jhiLanguageService;
        this.auditsService = auditsService;
        this.parseLinks = parseLinks;
        this.paginationConfig = paginationConfig;
        this.datePipe = datePipe;
        this.jhiLanguageService.setLocations(['audits']);
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 1;
        this.reverse = false;
        this.orderProp = 'timestamp';
    }
    AuditsComponent.prototype.getAudits = function () {
        return this.sortAudits(this.audits);
    };
    AuditsComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.onChangeDate();
    };
    AuditsComponent.prototype.ngOnInit = function () {
        this.today();
        this.previousMonth();
        this.onChangeDate();
    };
    AuditsComponent.prototype.onChangeDate = function () {
        var _this = this;
        this.auditsService.query({ page: this.page - 1, size: this.itemsPerPage,
            fromDate: this.fromDate, toDate: this.toDate }).subscribe(function (res) {
            _this.audits = res.json();
            _this.links = _this.parseLinks.parse(res.headers.get('link'));
            _this.totalItems = +res.headers.get('X-Total-Count');
        });
    };
    AuditsComponent.prototype.previousMonth = function () {
        var dateFormat = 'yyyy-MM-dd';
        var fromDate = new Date();
        if (fromDate.getMonth() === 0) {
            fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
        }
        else {
            fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
        }
        this.fromDate = this.datePipe.transform(fromDate, dateFormat);
    };
    AuditsComponent.prototype.today = function () {
        var dateFormat = 'yyyy-MM-dd';
        // Today + 1 day - needed if the current day must be included
        var today = new Date();
        today.setDate(today.getDate() + 1);
        var date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.toDate = this.datePipe.transform(date, dateFormat);
    };
    AuditsComponent.prototype.sortAudits = function (audits) {
        var _this = this;
        audits = audits.slice(0).sort(function (a, b) {
            if (a[_this.orderProp] < b[_this.orderProp]) {
                return -1;
            }
            else if (true) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return this.reverse ? audits.reverse() : audits;
    };
    return AuditsComponent;
}());
AuditsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-audit',
        template: __webpack_require__(342)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        audits_service_1.AuditsService,
        ng_jhipster_1.ParseLinks,
        uib_pagination_config_1.PaginationConfig,
        common_1.DatePipe])
], AuditsComponent);
exports.AuditsComponent = AuditsComponent;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var AuditsService = (function () {
    function AuditsService(http) {
        this.http = http;
    }
    AuditsService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        params.set('fromDate', req.fromDate);
        params.set('toDate', req.toDate);
        params.set('page', req.page);
        params.set('size', req.size);
        params.set('sort', req.sort);
        var options = {
            search: params
        };
        return this.http.get('management/audits', options);
    };
    return AuditsService;
}());
AuditsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuditsService);
exports.AuditsService = AuditsService;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var configuration_service_1 = __webpack_require__(88);
var JhiConfigurationComponent = (function () {
    function JhiConfigurationComponent(jhiLanguageService, configurationService) {
        this.jhiLanguageService = jhiLanguageService;
        this.configurationService = configurationService;
        this.allConfiguration = null;
        this.configuration = null;
        this.jhiLanguageService.setLocations(['configuration']);
        this.configKeys = [];
        this.filter = '';
        this.orderProp = 'prefix';
        this.reverse = false;
    }
    JhiConfigurationComponent.prototype.keys = function (dict) {
        return (dict === undefined) ? [] : Object.keys(dict);
    };
    JhiConfigurationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configurationService.get().subscribe(function (configuration) {
            _this.configuration = configuration;
            for (var _i = 0, configuration_1 = configuration; _i < configuration_1.length; _i++) {
                var config = configuration_1[_i];
                if (config.properties !== undefined) {
                    _this.configKeys.push(Object.keys(config.properties));
                }
            }
        });
        this.configurationService.getEnv().subscribe(function (configuration) {
            _this.allConfiguration = configuration;
        });
    };
    return JhiConfigurationComponent;
}());
JhiConfigurationComponent = __decorate([
    core_1.Component({
        selector: 'jhi-configuration',
        template: __webpack_require__(343)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        configuration_service_1.JhiConfigurationService])
], JhiConfigurationComponent);
exports.JhiConfigurationComponent = JhiConfigurationComponent;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var JhiConfigurationService = (function () {
    function JhiConfigurationService(http) {
        this.http = http;
    }
    JhiConfigurationService.prototype.get = function () {
        return this.http.get('management/configprops').map(function (res) {
            var properties = [];
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    properties.push(propertiesObject[key]);
                }
            }
            return properties.sort(function (propertyA, propertyB) {
                return (propertyA.prefix === propertyB.prefix) ? 0 :
                    (propertyA.prefix < propertyB.prefix) ? -1 : 1;
            });
        });
    };
    JhiConfigurationService.prototype.getEnv = function () {
        return this.http.get('management/env').map(function (res) {
            var properties = {};
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    var valsObject = propertiesObject[key];
                    var vals = [];
                    for (var valKey in valsObject) {
                        if (valsObject.hasOwnProperty(valKey)) {
                            vals.push({ key: valKey, val: valsObject[valKey] });
                        }
                    }
                    properties[key] = vals;
                }
            }
            return properties;
        });
    };
    return JhiConfigurationService;
}());
JhiConfigurationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiConfigurationService);
exports.JhiConfigurationService = JhiConfigurationService;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var JhiDocsComponent = (function () {
    function JhiDocsComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['global']);
    }
    return JhiDocsComponent;
}());
JhiDocsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-docs',
        template: __webpack_require__(344)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], JhiDocsComponent);
exports.JhiDocsComponent = JhiDocsComponent;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var health_service_1 = __webpack_require__(44);
var JhiHealthModalComponent = (function () {
    function JhiHealthModalComponent(healthService, activeModal) {
        this.healthService = healthService;
        this.activeModal = activeModal;
    }
    JhiHealthModalComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    JhiHealthModalComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    JhiHealthModalComponent.prototype.readableValue = function (value) {
        if (this.currentHealth.name !== 'diskSpace') {
            return value.toString();
        }
        // Should display storage space in an human readable unit
        var val = value / 1073741824;
        if (val > 1) {
            return val.toFixed(2) + ' GB';
        }
        else {
            return (value / 1048576).toFixed(2) + ' MB';
        }
    };
    return JhiHealthModalComponent;
}());
JhiHealthModalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-health-modal',
        template: __webpack_require__(345)
    }),
    __metadata("design:paramtypes", [health_service_1.JhiHealthService, ng_bootstrap_1.NgbActiveModal])
], JhiHealthModalComponent);
exports.JhiHealthModalComponent = JhiHealthModalComponent;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var health_service_1 = __webpack_require__(44);
var health_modal_component_1 = __webpack_require__(90);
var JhiHealthCheckComponent = (function () {
    function JhiHealthCheckComponent(jhiLanguageService, modalService, healthService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.healthService = healthService;
        this.jhiLanguageService.setLocations(['health']);
    }
    JhiHealthCheckComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    JhiHealthCheckComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    JhiHealthCheckComponent.prototype.getBadgeClass = function (statusState) {
        if (statusState === 'UP') {
            return 'badge-success';
        }
        else {
            return 'badge-danger';
        }
    };
    JhiHealthCheckComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingHealth = true;
        this.healthService.checkHealth().subscribe(function (health) {
            _this.healthData = _this.healthService.transformHealthData(health);
            _this.updatingHealth = false;
        }, function (error) {
            if (error.status === 503) {
                _this.healthData = _this.healthService.transformHealthData(error.json());
                _this.updatingHealth = false;
            }
        });
    };
    JhiHealthCheckComponent.prototype.showHealth = function (health) {
        var modalRef = this.modalService.open(health_modal_component_1.JhiHealthModalComponent);
        modalRef.componentInstance.currentHealth = health;
        modalRef.result.then(function (result) {
            // Left blank intentionally, nothing to do here
        }, function (reason) {
            // Left blank intentionally, nothing to do here
        });
    };
    JhiHealthCheckComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    return JhiHealthCheckComponent;
}());
JhiHealthCheckComponent = __decorate([
    core_1.Component({
        selector: 'jhi-health',
        template: __webpack_require__(346),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        health_service_1.JhiHealthService])
], JhiHealthCheckComponent);
exports.JhiHealthCheckComponent = JhiHealthCheckComponent;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(85));
__export(__webpack_require__(86));
__export(__webpack_require__(238));
__export(__webpack_require__(237));
__export(__webpack_require__(236));
__export(__webpack_require__(87));
__export(__webpack_require__(88));
__export(__webpack_require__(239));
__export(__webpack_require__(89));
__export(__webpack_require__(240));
__export(__webpack_require__(91));
__export(__webpack_require__(90));
__export(__webpack_require__(44));
__export(__webpack_require__(241));
__export(__webpack_require__(94));
__export(__webpack_require__(95));
__export(__webpack_require__(242));
__export(__webpack_require__(93));
__export(__webpack_require__(99));
__export(__webpack_require__(244));
__export(__webpack_require__(97));
__export(__webpack_require__(96));
__export(__webpack_require__(98));
__export(__webpack_require__(243));
__export(__webpack_require__(102));
__export(__webpack_require__(100));
__export(__webpack_require__(101));
__export(__webpack_require__(103));
__export(__webpack_require__(245));
__export(__webpack_require__(45));
__export(__webpack_require__(235));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Log = (function () {
    function Log(name, level) {
        this.name = name;
        this.level = level;
    }
    return Log;
}());
exports.Log = Log;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var log_model_1 = __webpack_require__(93);
var logs_service_1 = __webpack_require__(95);
var LogsComponent = (function () {
    function LogsComponent(jhiLanguageService, logsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.logsService = logsService;
        this.filter = '';
        this.orderProp = 'name';
        this.reverse = false;
        this.jhiLanguageService.setLocations(['logs']);
    }
    LogsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
    };
    LogsComponent.prototype.changeLevel = function (name, level) {
        var _this = this;
        var log = new log_model_1.Log(name, level);
        this.logsService.changeLevel(log).subscribe(function () {
            _this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
        });
    };
    return LogsComponent;
}());
LogsComponent = __decorate([
    core_1.Component({
        selector: 'jhi-logs',
        template: __webpack_require__(347),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        logs_service_1.LogsService])
], LogsComponent);
exports.LogsComponent = LogsComponent;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var LogsService = (function () {
    function LogsService(http) {
        this.http = http;
    }
    LogsService.prototype.changeLevel = function (log) {
        return this.http.put('management/logs', log);
    };
    LogsService.prototype.findAll = function () {
        return this.http.get('management/logs').map(function (res) { return res.json(); });
    };
    return LogsService;
}());
LogsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], LogsService);
exports.LogsService = LogsService;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var JhiMetricsMonitoringModalComponent = (function () {
    function JhiMetricsMonitoringModalComponent(activeModal) {
        this.activeModal = activeModal;
        this.threadDumpAll = 0;
        this.threadDumpBlocked = 0;
        this.threadDumpRunnable = 0;
        this.threadDumpTimedWaiting = 0;
        this.threadDumpWaiting = 0;
    }
    JhiMetricsMonitoringModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.threadDump.forEach(function (value) {
            if (value.threadState === 'RUNNABLE') {
                _this.threadDumpRunnable += 1;
            }
            else if (value.threadState === 'WAITING') {
                _this.threadDumpWaiting += 1;
            }
            else if (value.threadState === 'TIMED_WAITING') {
                _this.threadDumpTimedWaiting += 1;
            }
            else if (value.threadState === 'BLOCKED') {
                _this.threadDumpBlocked += 1;
            }
        });
        this.threadDumpAll = this.threadDumpRunnable + this.threadDumpWaiting +
            this.threadDumpTimedWaiting + this.threadDumpBlocked;
    };
    JhiMetricsMonitoringModalComponent.prototype.getBadgeClass = function (threadState) {
        if (threadState === 'RUNNABLE') {
            return 'badge-success';
        }
        else if (threadState === 'WAITING') {
            return 'badge-info';
        }
        else if (threadState === 'TIMED_WAITING') {
            return 'badge-warning';
        }
        else if (threadState === 'BLOCKED') {
            return 'badge-danger';
        }
    };
    return JhiMetricsMonitoringModalComponent;
}());
JhiMetricsMonitoringModalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-metrics-modal',
        template: __webpack_require__(348)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])
], JhiMetricsMonitoringModalComponent);
exports.JhiMetricsMonitoringModalComponent = JhiMetricsMonitoringModalComponent;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var metrics_modal_component_1 = __webpack_require__(96);
var metrics_service_1 = __webpack_require__(98);
var JhiMetricsMonitoringComponent = (function () {
    function JhiMetricsMonitoringComponent(jhiLanguageService, modalService, metricsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.metricsService = metricsService;
        this.metrics = {};
        this.cachesStats = {};
        this.servicesStats = {};
        this.updatingMetrics = true;
        this.JCACHE_KEY = 'jcache.statistics';
        this.jhiLanguageService.setLocations(['metrics']);
    }
    JhiMetricsMonitoringComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    JhiMetricsMonitoringComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingMetrics = true;
        this.metricsService.getMetrics().subscribe(function (metrics) {
            _this.metrics = metrics;
            _this.updatingMetrics = false;
            _this.servicesStats = {};
            _this.cachesStats = {};
            Object.keys(metrics.timers).forEach(function (key) {
                var value = metrics.timers[key];
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    _this.servicesStats[key] = value;
                }
            });
            Object.keys(metrics.gauges).forEach(function (key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    var value = metrics.gauges[key].value;
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);
                    // Keep the name of the domain
                    _this.cachesStats[newKey] = {
                        'name': _this.JCACHE_KEY.length,
                        'value': value
                    };
                }
            });
        });
    };
    JhiMetricsMonitoringComponent.prototype.refreshThreadDumpData = function () {
        var _this = this;
        this.metricsService.threadDump().subscribe(function (data) {
            var modalRef = _this.modalService.open(metrics_modal_component_1.JhiMetricsMonitoringModalComponent, { size: 'lg' });
            modalRef.componentInstance.threadDump = data;
            modalRef.result.then(function (result) {
                // Left blank intentionally, nothing to do here
            }, function (reason) {
                // Left blank intentionally, nothing to do here
            });
        });
    };
    return JhiMetricsMonitoringComponent;
}());
JhiMetricsMonitoringComponent = __decorate([
    core_1.Component({
        selector: 'jhi-metrics',
        template: __webpack_require__(349),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        metrics_service_1.JhiMetricsService])
], JhiMetricsMonitoringComponent);
exports.JhiMetricsMonitoringComponent = JhiMetricsMonitoringComponent;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var JhiMetricsService = (function () {
    function JhiMetricsService(http) {
        this.http = http;
    }
    JhiMetricsService.prototype.getMetrics = function () {
        return this.http.get('management/metrics').map(function (res) { return res.json(); });
    };
    JhiMetricsService.prototype.threadDump = function () {
        return this.http.get('management/dump').map(function (res) { return res.json(); });
    };
    return JhiMetricsService;
}());
JhiMetricsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], JhiMetricsService);
exports.JhiMetricsService = JhiMetricsService;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var JhiTrackerComponent = (function () {
    function JhiTrackerComponent(jhiLanguageService, trackerService) {
        this.jhiLanguageService = jhiLanguageService;
        this.trackerService = trackerService;
        this.activities = [];
        this.jhiLanguageService.setLocations(['tracker']);
    }
    JhiTrackerComponent.prototype.showActivity = function (activity) {
        var existingActivity = false;
        for (var index = 0; index < this.activities.length; index++) {
            if (this.activities[index].sessionId === activity.sessionId) {
                existingActivity = true;
                if (activity.page === 'logout') {
                    this.activities.splice(index, 1);
                }
                else {
                    this.activities[index] = activity;
                }
            }
        }
        if (!existingActivity && (activity.page !== 'logout')) {
            this.activities.push(activity);
        }
    };
    JhiTrackerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.trackerService.subscribe();
        this.trackerService.receive().subscribe(function (activity) {
            _this.showActivity(activity);
        });
    };
    JhiTrackerComponent.prototype.ngOnDestroy = function () {
        this.trackerService.unsubscribe();
    };
    return JhiTrackerComponent;
}());
JhiTrackerComponent = __decorate([
    core_1.Component({
        selector: 'jhi-tracker',
        template: __webpack_require__(350)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.JhiTrackerService])
], JhiTrackerComponent);
exports.JhiTrackerComponent = JhiTrackerComponent;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var user_modal_service_1 = __webpack_require__(45);
var UserMgmtDeleteDialogComponent = (function () {
    function UserMgmtDeleteDialogComponent(jhiLanguageService, userService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDeleteDialogComponent.prototype.confirmDelete = function (login) {
        var _this = this;
        this.userService.delete(login).subscribe(function (response) {
            _this.eventManager.broadcast({ name: 'userListModification',
                content: 'Deleted a user' });
            _this.activeModal.dismiss(true);
        });
    };
    return UserMgmtDeleteDialogComponent;
}());
UserMgmtDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-delete-dialog',
        template: __webpack_require__(351)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], UserMgmtDeleteDialogComponent);
exports.UserMgmtDeleteDialogComponent = UserMgmtDeleteDialogComponent;
var UserDeleteDialogComponent = (function () {
    function UserDeleteDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDeleteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.userModalService.open(UserMgmtDeleteDialogComponent, params['login']);
        });
    };
    UserDeleteDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDeleteDialogComponent;
}());
UserDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-delete-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDeleteDialogComponent);
exports.UserDeleteDialogComponent = UserDeleteDialogComponent;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var UserMgmtDetailComponent = (function () {
    function UserMgmtDetailComponent(jhiLanguageService, userService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.route = route;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['login']);
        });
    };
    UserMgmtDetailComponent.prototype.load = function (login) {
        var _this = this;
        this.userService.find(login).subscribe(function (user) {
            _this.user = user;
        });
    };
    UserMgmtDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return UserMgmtDetailComponent;
}());
UserMgmtDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-detail',
        template: __webpack_require__(352)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        router_1.ActivatedRoute])
], UserMgmtDetailComponent);
exports.UserMgmtDetailComponent = UserMgmtDetailComponent;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var user_modal_service_1 = __webpack_require__(45);
var shared_1 = __webpack_require__(3);
var UserMgmtDialogComponent = (function () {
    function UserMgmtDialogComponent(activeModal, languageHelper, jhiLanguageService, userService, eventManager) {
        this.activeModal = activeModal;
        this.languageHelper = languageHelper;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.eventManager = eventManager;
    }
    UserMgmtDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['user-management']);
    };
    UserMgmtDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.user.id !== null) {
            this.userService.update(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
        else {
            this.userService.create(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
    };
    UserMgmtDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'userListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    UserMgmtDialogComponent.prototype.onSaveError = function () {
        this.isSaving = false;
    };
    return UserMgmtDialogComponent;
}());
UserMgmtDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt-dialog',
        template: __webpack_require__(353)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], UserMgmtDialogComponent);
exports.UserMgmtDialogComponent = UserMgmtDialogComponent;
var UserDialogComponent = (function () {
    function UserDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['login']) {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent, params['login']);
            }
            else {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent);
            }
        });
    };
    UserDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDialogComponent;
}());
UserDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDialogComponent);
exports.UserDialogComponent = UserDialogComponent;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var UserMgmtComponent = (function () {
    function UserMgmtComponent(jhiLanguageService, userService, parseLinks, alertService, principal, eventManager, paginationUtil, paginationConfig, activatedRoute, router) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.loadAll();
            _this.registerChangeInUsers();
        });
    };
    UserMgmtComponent.prototype.ngOnDestroy = function () {
        this.routeData.unsubscribe();
    };
    UserMgmtComponent.prototype.registerChangeInUsers = function () {
        var _this = this;
        this.eventManager.subscribe('userListModification', function (response) { return _this.loadAll(); });
    };
    UserMgmtComponent.prototype.setActive = function (user, isActivated) {
        var _this = this;
        user.activated = isActivated;
        this.userService.update(user).subscribe(function (response) {
            if (response.status === 200) {
                _this.error = null;
                _this.success = 'OK';
                _this.loadAll();
            }
            else {
                _this.success = null;
                _this.error = 'ERROR';
            }
        });
    };
    UserMgmtComponent.prototype.loadAll = function () {
        var _this = this;
        this.userService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    UserMgmtComponent.prototype.trackIdentity = function (index, item) {
        return item.id;
    };
    UserMgmtComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    UserMgmtComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    UserMgmtComponent.prototype.transition = function () {
        this.router.navigate(['/user-management'], { queryParams: {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    UserMgmtComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.users = data;
    };
    UserMgmtComponent.prototype.onError = function (error) {
        this.alertService.error(error.error, error.message, null);
    };
    return UserMgmtComponent;
}());
UserMgmtComponent = __decorate([
    core_1.Component({
        selector: 'jhi-user-mgmt',
        template: __webpack_require__(354)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig,
        router_1.ActivatedRoute,
        router_1.Router])
], UserMgmtComponent);
exports.UserMgmtComponent = UserMgmtComponent;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var additionalflat_popup_service_1 = __webpack_require__(46);
var additionalflat_service_1 = __webpack_require__(11);
var AdditionalflatDeleteDialogComponent = (function () {
    function AdditionalflatDeleteDialogComponent(jhiLanguageService, additionalflatService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.additionalflatService = additionalflatService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['additionalflat']);
    }
    AdditionalflatDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    AdditionalflatDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.additionalflatService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'additionalflatListModification',
                content: 'Deleted an additionalflat'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return AdditionalflatDeleteDialogComponent;
}());
AdditionalflatDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat-delete-dialog',
        template: __webpack_require__(355)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        additionalflat_service_1.AdditionalflatService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], AdditionalflatDeleteDialogComponent);
exports.AdditionalflatDeleteDialogComponent = AdditionalflatDeleteDialogComponent;
var AdditionalflatDeletePopupComponent = (function () {
    function AdditionalflatDeletePopupComponent(route, additionalflatPopupService) {
        this.route = route;
        this.additionalflatPopupService = additionalflatPopupService;
    }
    AdditionalflatDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.additionalflatPopupService
                .open(AdditionalflatDeleteDialogComponent, params['id']);
        });
    };
    AdditionalflatDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return AdditionalflatDeletePopupComponent;
}());
AdditionalflatDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        additionalflat_popup_service_1.AdditionalflatPopupService])
], AdditionalflatDeletePopupComponent);
exports.AdditionalflatDeletePopupComponent = AdditionalflatDeletePopupComponent;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var additionalflat_service_1 = __webpack_require__(11);
var AdditionalflatDetailComponent = (function () {
    function AdditionalflatDetailComponent(eventManager, jhiLanguageService, additionalflatService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.additionalflatService = additionalflatService;
        this.route = route;
        this.jhiLanguageService.setLocations(['additionalflat']);
    }
    AdditionalflatDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInAdditionalflats();
    };
    AdditionalflatDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.additionalflatService.find(id).subscribe(function (additionalflat) {
            _this.additionalflat = additionalflat;
        });
    };
    AdditionalflatDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    AdditionalflatDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    AdditionalflatDetailComponent.prototype.registerChangeInAdditionalflats = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('additionalflatListModification', function (response) { return _this.load(_this.additionalflat.id); });
    };
    return AdditionalflatDetailComponent;
}());
AdditionalflatDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat-detail',
        template: __webpack_require__(356)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        additionalflat_service_1.AdditionalflatService,
        router_1.ActivatedRoute])
], AdditionalflatDetailComponent);
exports.AdditionalflatDetailComponent = AdditionalflatDetailComponent;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var additionalflat_popup_service_1 = __webpack_require__(46);
var additionalflat_service_1 = __webpack_require__(11);
var marketplace_1 = __webpack_require__(36);
var AdditionalflatDialogComponent = (function () {
    function AdditionalflatDialogComponent(activeModal, jhiLanguageService, alertService, additionalflatService, marketplaceService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.additionalflatService = additionalflatService;
        this.marketplaceService = marketplaceService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['additionalflat']);
    }
    AdditionalflatDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(function (res) { _this.marketplaces = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    AdditionalflatDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    AdditionalflatDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.additionalflat.id !== undefined) {
            this.additionalflatService.update(this.additionalflat)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.additionalflatService.create(this.additionalflat)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    AdditionalflatDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'additionalflatListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    AdditionalflatDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    AdditionalflatDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    AdditionalflatDialogComponent.prototype.trackMarketplaceById = function (index, item) {
        return item.id;
    };
    return AdditionalflatDialogComponent;
}());
AdditionalflatDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat-dialog',
        template: __webpack_require__(357)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        additionalflat_service_1.AdditionalflatService,
        marketplace_1.MarketplaceService,
        ng_jhipster_1.EventManager])
], AdditionalflatDialogComponent);
exports.AdditionalflatDialogComponent = AdditionalflatDialogComponent;
var AdditionalflatPopupComponent = (function () {
    function AdditionalflatPopupComponent(route, additionalflatPopupService) {
        this.route = route;
        this.additionalflatPopupService = additionalflatPopupService;
    }
    AdditionalflatPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.additionalflatPopupService
                    .open(AdditionalflatDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.additionalflatPopupService
                    .open(AdditionalflatDialogComponent);
            }
        });
    };
    AdditionalflatPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return AdditionalflatPopupComponent;
}());
AdditionalflatPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        additionalflat_popup_service_1.AdditionalflatPopupService])
], AdditionalflatPopupComponent);
exports.AdditionalflatPopupComponent = AdditionalflatPopupComponent;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var additionalflat_service_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var AdditionalflatComponent = (function () {
    function AdditionalflatComponent(jhiLanguageService, additionalflatService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.additionalflatService = additionalflatService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['additionalflat']);
    }
    AdditionalflatComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.additionalflatService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.additionalflatService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    AdditionalflatComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    AdditionalflatComponent.prototype.transition = function () {
        this.router.navigate(['/additionalflat'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    AdditionalflatComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/additionalflat', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    AdditionalflatComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/additionalflat', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    AdditionalflatComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInAdditionalflats();
    };
    AdditionalflatComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    AdditionalflatComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    AdditionalflatComponent.prototype.registerChangeInAdditionalflats = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('additionalflatListModification', function (response) { return _this.loadAll(); });
    };
    AdditionalflatComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    AdditionalflatComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.additionalflats = data;
    };
    AdditionalflatComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return AdditionalflatComponent;
}());
AdditionalflatComponent = __decorate([
    core_1.Component({
        selector: 'jhi-additionalflat',
        template: __webpack_require__(358)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        additionalflat_service_1.AdditionalflatService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], AdditionalflatComponent);
exports.AdditionalflatComponent = AdditionalflatComponent;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Additionalflat = (function () {
    function Additionalflat(id, marketplaceNumber, validFrom, priceType, priceSanitary, priceCleaning, priceParking, priceAdministration, priceDebit, priceModification, updated, created, gguid, marketplace) {
        this.id = id;
        this.marketplaceNumber = marketplaceNumber;
        this.validFrom = validFrom;
        this.priceType = priceType;
        this.priceSanitary = priceSanitary;
        this.priceCleaning = priceCleaning;
        this.priceParking = priceParking;
        this.priceAdministration = priceAdministration;
        this.priceDebit = priceDebit;
        this.priceModification = priceModification;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.marketplace = marketplace;
    }
    return Additionalflat;
}());
exports.Additionalflat = Additionalflat;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var booth_popup_service_1 = __webpack_require__(47);
var booth_service_1 = __webpack_require__(12);
var BoothDeleteDialogComponent = (function () {
    function BoothDeleteDialogComponent(jhiLanguageService, boothService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.boothService = boothService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }
    BoothDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BoothDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.boothService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'boothListModification',
                content: 'Deleted an booth'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return BoothDeleteDialogComponent;
}());
BoothDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth-delete-dialog',
        template: __webpack_require__(359)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        booth_service_1.BoothService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], BoothDeleteDialogComponent);
exports.BoothDeleteDialogComponent = BoothDeleteDialogComponent;
var BoothDeletePopupComponent = (function () {
    function BoothDeletePopupComponent(route, boothPopupService) {
        this.route = route;
        this.boothPopupService = boothPopupService;
    }
    BoothDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.boothPopupService
                .open(BoothDeleteDialogComponent, params['id']);
        });
    };
    BoothDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BoothDeletePopupComponent;
}());
BoothDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        booth_popup_service_1.BoothPopupService])
], BoothDeletePopupComponent);
exports.BoothDeletePopupComponent = BoothDeletePopupComponent;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var booth_service_1 = __webpack_require__(12);
var BoothDetailComponent = (function () {
    function BoothDetailComponent(eventManager, jhiLanguageService, boothService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.boothService = boothService;
        this.route = route;
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }
    BoothDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInBooths();
    };
    BoothDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.boothService.find(id).subscribe(function (booth) {
            _this.booth = booth;
        });
    };
    BoothDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    BoothDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    BoothDetailComponent.prototype.registerChangeInBooths = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('boothListModification', function (response) { return _this.load(_this.booth.id); });
    };
    return BoothDetailComponent;
}());
BoothDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth-detail',
        template: __webpack_require__(360)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        booth_service_1.BoothService,
        router_1.ActivatedRoute])
], BoothDetailComponent);
exports.BoothDetailComponent = BoothDetailComponent;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var booth_popup_service_1 = __webpack_require__(47);
var booth_service_1 = __webpack_require__(12);
var salesunit_1 = __webpack_require__(37);
var contact_1 = __webpack_require__(9);
var contract_1 = __webpack_require__(35);
var BoothDialogComponent = (function () {
    function BoothDialogComponent(activeModal, jhiLanguageService, alertService, boothService, salesunitService, contactService, contractService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.boothService = boothService;
        this.salesunitService = salesunitService;
        this.contactService = contactService;
        this.contractService = contractService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }
    BoothDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.salesunitService.query().subscribe(function (res) { _this.salesunits = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contractService.query().subscribe(function (res) { _this.contracts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    BoothDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BoothDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.booth.id !== undefined) {
            this.boothService.update(this.booth)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.boothService.create(this.booth)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    BoothDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'boothListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    BoothDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    BoothDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    BoothDialogComponent.prototype.trackSalesunitById = function (index, item) {
        return item.id;
    };
    BoothDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    BoothDialogComponent.prototype.trackContractById = function (index, item) {
        return item.id;
    };
    return BoothDialogComponent;
}());
BoothDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth-dialog',
        template: __webpack_require__(361)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        booth_service_1.BoothService,
        salesunit_1.SalesunitService,
        contact_1.ContactService,
        contract_1.ContractService,
        ng_jhipster_1.EventManager])
], BoothDialogComponent);
exports.BoothDialogComponent = BoothDialogComponent;
var BoothPopupComponent = (function () {
    function BoothPopupComponent(route, boothPopupService) {
        this.route = route;
        this.boothPopupService = boothPopupService;
    }
    BoothPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.boothPopupService
                    .open(BoothDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.boothPopupService
                    .open(BoothDialogComponent);
            }
        });
    };
    BoothPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BoothPopupComponent;
}());
BoothPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        booth_popup_service_1.BoothPopupService])
], BoothPopupComponent);
exports.BoothPopupComponent = BoothPopupComponent;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var booth_service_1 = __webpack_require__(12);
var shared_1 = __webpack_require__(3);
var BoothComponent = (function () {
    function BoothComponent(jhiLanguageService, boothService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.boothService = boothService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }
    BoothComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.boothService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.booths = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.boothService.query().subscribe(function (res) {
            _this.booths = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    BoothComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    BoothComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    BoothComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInBooths();
    };
    BoothComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    BoothComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    BoothComponent.prototype.registerChangeInBooths = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('boothListModification', function (response) { return _this.loadAll(); });
    };
    BoothComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return BoothComponent;
}());
BoothComponent = __decorate([
    core_1.Component({
        selector: 'jhi-booth',
        template: __webpack_require__(362)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        booth_service_1.BoothService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], BoothComponent);
exports.BoothComponent = BoothComponent;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var Booth = (function () {
    function Booth(id, contractType, order, salesunit, contactPerson, contract) {
        this.id = id;
        this.contractType = contractType;
        this.order = order;
        this.salesunit = salesunit;
        this.contactPerson = contactPerson;
        this.contract = contract;
    }
    return Booth;
}());
exports.Booth = Booth;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var boothfee_popup_service_1 = __webpack_require__(48);
var boothfee_service_1 = __webpack_require__(13);
var BoothfeeDeleteDialogComponent = (function () {
    function BoothfeeDeleteDialogComponent(jhiLanguageService, boothfeeService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.boothfeeService = boothfeeService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['boothfee']);
    }
    BoothfeeDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BoothfeeDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.boothfeeService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'boothfeeListModification',
                content: 'Deleted an boothfee'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return BoothfeeDeleteDialogComponent;
}());
BoothfeeDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee-delete-dialog',
        template: __webpack_require__(363)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        boothfee_service_1.BoothfeeService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], BoothfeeDeleteDialogComponent);
exports.BoothfeeDeleteDialogComponent = BoothfeeDeleteDialogComponent;
var BoothfeeDeletePopupComponent = (function () {
    function BoothfeeDeletePopupComponent(route, boothfeePopupService) {
        this.route = route;
        this.boothfeePopupService = boothfeePopupService;
    }
    BoothfeeDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.boothfeePopupService
                .open(BoothfeeDeleteDialogComponent, params['id']);
        });
    };
    BoothfeeDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BoothfeeDeletePopupComponent;
}());
BoothfeeDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        boothfee_popup_service_1.BoothfeePopupService])
], BoothfeeDeletePopupComponent);
exports.BoothfeeDeletePopupComponent = BoothfeeDeletePopupComponent;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var boothfee_service_1 = __webpack_require__(13);
var BoothfeeDetailComponent = (function () {
    function BoothfeeDetailComponent(eventManager, jhiLanguageService, boothfeeService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.boothfeeService = boothfeeService;
        this.route = route;
        this.jhiLanguageService.setLocations(['boothfee']);
    }
    BoothfeeDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInBoothfees();
    };
    BoothfeeDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.boothfeeService.find(id).subscribe(function (boothfee) {
            _this.boothfee = boothfee;
        });
    };
    BoothfeeDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    BoothfeeDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    BoothfeeDetailComponent.prototype.registerChangeInBoothfees = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('boothfeeListModification', function (response) { return _this.load(_this.boothfee.id); });
    };
    return BoothfeeDetailComponent;
}());
BoothfeeDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee-detail',
        template: __webpack_require__(364)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        boothfee_service_1.BoothfeeService,
        router_1.ActivatedRoute])
], BoothfeeDetailComponent);
exports.BoothfeeDetailComponent = BoothfeeDetailComponent;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var boothfee_popup_service_1 = __webpack_require__(48);
var boothfee_service_1 = __webpack_require__(13);
var marketday_1 = __webpack_require__(32);
var BoothfeeDialogComponent = (function () {
    function BoothfeeDialogComponent(activeModal, jhiLanguageService, alertService, boothfeeService, marketdayService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.boothfeeService = boothfeeService;
        this.marketdayService = marketdayService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['boothfee']);
    }
    BoothfeeDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(function (res) { _this.marketdays = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    BoothfeeDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BoothfeeDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.boothfee.id !== undefined) {
            this.boothfeeService.update(this.boothfee)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.boothfeeService.create(this.boothfee)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    BoothfeeDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'boothfeeListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    BoothfeeDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    BoothfeeDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    BoothfeeDialogComponent.prototype.trackMarketdayById = function (index, item) {
        return item.id;
    };
    return BoothfeeDialogComponent;
}());
BoothfeeDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee-dialog',
        template: __webpack_require__(365)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        boothfee_service_1.BoothfeeService,
        marketday_1.MarketdayService,
        ng_jhipster_1.EventManager])
], BoothfeeDialogComponent);
exports.BoothfeeDialogComponent = BoothfeeDialogComponent;
var BoothfeePopupComponent = (function () {
    function BoothfeePopupComponent(route, boothfeePopupService) {
        this.route = route;
        this.boothfeePopupService = boothfeePopupService;
    }
    BoothfeePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.boothfeePopupService
                    .open(BoothfeeDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.boothfeePopupService
                    .open(BoothfeeDialogComponent);
            }
        });
    };
    BoothfeePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BoothfeePopupComponent;
}());
BoothfeePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        boothfee_popup_service_1.BoothfeePopupService])
], BoothfeePopupComponent);
exports.BoothfeePopupComponent = BoothfeePopupComponent;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var boothfee_service_1 = __webpack_require__(13);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var BoothfeeComponent = (function () {
    function BoothfeeComponent(jhiLanguageService, boothfeeService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.boothfeeService = boothfeeService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['boothfee']);
    }
    BoothfeeComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.boothfeeService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.boothfeeService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    BoothfeeComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    BoothfeeComponent.prototype.transition = function () {
        this.router.navigate(['/boothfee'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    BoothfeeComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/boothfee', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    BoothfeeComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/boothfee', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    BoothfeeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInBoothfees();
    };
    BoothfeeComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    BoothfeeComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    BoothfeeComponent.prototype.registerChangeInBoothfees = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('boothfeeListModification', function (response) { return _this.loadAll(); });
    };
    BoothfeeComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    BoothfeeComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.boothfees = data;
    };
    BoothfeeComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return BoothfeeComponent;
}());
BoothfeeComponent = __decorate([
    core_1.Component({
        selector: 'jhi-boothfee',
        template: __webpack_require__(366)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        boothfee_service_1.BoothfeeService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], BoothfeeComponent);
exports.BoothfeeComponent = BoothfeeComponent;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Boothfee = (function () {
    function Boothfee(id, marketdayNumber, validFrom, validMonth, priceType, priceCategoryA, priceCategoryB, priceCategoryC, priceCategoryD, minBoothFee, basicCharges, unit, updated, created, gguid, marketday) {
        this.id = id;
        this.marketdayNumber = marketdayNumber;
        this.validFrom = validFrom;
        this.validMonth = validMonth;
        this.priceType = priceType;
        this.priceCategoryA = priceCategoryA;
        this.priceCategoryB = priceCategoryB;
        this.priceCategoryC = priceCategoryC;
        this.priceCategoryD = priceCategoryD;
        this.minBoothFee = minBoothFee;
        this.basicCharges = basicCharges;
        this.unit = unit;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.marketday = marketday;
    }
    return Boothfee;
}());
exports.Boothfee = Boothfee;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var branch_popup_service_1 = __webpack_require__(49);
var branch_service_1 = __webpack_require__(14);
var BranchDeleteDialogComponent = (function () {
    function BranchDeleteDialogComponent(jhiLanguageService, branchService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.branchService = branchService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['branch']);
    }
    BranchDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BranchDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.branchService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'branchListModification',
                content: 'Deleted an branch'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return BranchDeleteDialogComponent;
}());
BranchDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch-delete-dialog',
        template: __webpack_require__(367)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        branch_service_1.BranchService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], BranchDeleteDialogComponent);
exports.BranchDeleteDialogComponent = BranchDeleteDialogComponent;
var BranchDeletePopupComponent = (function () {
    function BranchDeletePopupComponent(route, branchPopupService) {
        this.route = route;
        this.branchPopupService = branchPopupService;
    }
    BranchDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.branchPopupService
                .open(BranchDeleteDialogComponent, params['id']);
        });
    };
    BranchDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BranchDeletePopupComponent;
}());
BranchDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        branch_popup_service_1.BranchPopupService])
], BranchDeletePopupComponent);
exports.BranchDeletePopupComponent = BranchDeletePopupComponent;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var branch_service_1 = __webpack_require__(14);
var BranchDetailComponent = (function () {
    function BranchDetailComponent(eventManager, jhiLanguageService, branchService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.branchService = branchService;
        this.route = route;
        this.jhiLanguageService.setLocations(['branch']);
    }
    BranchDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInBranches();
    };
    BranchDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.branchService.find(id).subscribe(function (branch) {
            _this.branch = branch;
        });
    };
    BranchDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    BranchDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    BranchDetailComponent.prototype.registerChangeInBranches = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('branchListModification', function (response) { return _this.load(_this.branch.id); });
    };
    return BranchDetailComponent;
}());
BranchDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch-detail',
        template: __webpack_require__(368)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        branch_service_1.BranchService,
        router_1.ActivatedRoute])
], BranchDetailComponent);
exports.BranchDetailComponent = BranchDetailComponent;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var branch_popup_service_1 = __webpack_require__(49);
var branch_service_1 = __webpack_require__(14);
var contact_1 = __webpack_require__(9);
var BranchDialogComponent = (function () {
    function BranchDialogComponent(activeModal, jhiLanguageService, alertService, branchService, contactService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.branchService = branchService;
        this.contactService = contactService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['branch']);
    }
    BranchDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    BranchDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    BranchDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.branch.id !== undefined) {
            this.branchService.update(this.branch)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.branchService.create(this.branch)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    BranchDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'branchListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    BranchDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    BranchDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    BranchDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    return BranchDialogComponent;
}());
BranchDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch-dialog',
        template: __webpack_require__(369)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        branch_service_1.BranchService,
        contact_1.ContactService,
        ng_jhipster_1.EventManager])
], BranchDialogComponent);
exports.BranchDialogComponent = BranchDialogComponent;
var BranchPopupComponent = (function () {
    function BranchPopupComponent(route, branchPopupService) {
        this.route = route;
        this.branchPopupService = branchPopupService;
    }
    BranchPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.branchPopupService
                    .open(BranchDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.branchPopupService
                    .open(BranchDialogComponent);
            }
        });
    };
    BranchPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return BranchPopupComponent;
}());
BranchPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        branch_popup_service_1.BranchPopupService])
], BranchPopupComponent);
exports.BranchPopupComponent = BranchPopupComponent;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var branch_service_1 = __webpack_require__(14);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var BranchComponent = (function () {
    function BranchComponent(jhiLanguageService, branchService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.branchService = branchService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['branch']);
    }
    BranchComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.branchService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.branchService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    BranchComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    BranchComponent.prototype.transition = function () {
        this.router.navigate(['/branch'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    BranchComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/branch', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    BranchComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/branch', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    BranchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInBranches();
    };
    BranchComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    BranchComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    BranchComponent.prototype.registerChangeInBranches = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('branchListModification', function (response) { return _this.loadAll(); });
    };
    BranchComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    BranchComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.branches = data;
    };
    BranchComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return BranchComponent;
}());
BranchComponent = __decorate([
    core_1.Component({
        selector: 'jhi-branch',
        template: __webpack_require__(370)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        branch_service_1.BranchService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], BranchComponent);
exports.BranchComponent = BranchComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Branch = (function () {
    function Branch(id, name, description, branchNumber, city, branchMaster) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.branchNumber = branchNumber;
        this.city = city;
        this.branchMaster = branchMaster;
    }
    return Branch;
}());
exports.Branch = Branch;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contact_temp_popup_service_1 = __webpack_require__(51);
var contact_temp_service_1 = __webpack_require__(15);
var ContactTempDeleteDialogComponent = (function () {
    function ContactTempDeleteDialogComponent(jhiLanguageService, contactTempService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.contactTempService = contactTempService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }
    ContactTempDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContactTempDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.contactTempService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'contactTempListModification',
                content: 'Deleted an contactTemp'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ContactTempDeleteDialogComponent;
}());
ContactTempDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp-delete-dialog',
        template: __webpack_require__(371)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contact_temp_service_1.ContactTempService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ContactTempDeleteDialogComponent);
exports.ContactTempDeleteDialogComponent = ContactTempDeleteDialogComponent;
var ContactTempDeletePopupComponent = (function () {
    function ContactTempDeletePopupComponent(route, contactTempPopupService) {
        this.route = route;
        this.contactTempPopupService = contactTempPopupService;
    }
    ContactTempDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.contactTempPopupService
                .open(ContactTempDeleteDialogComponent, params['id']);
        });
    };
    ContactTempDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContactTempDeletePopupComponent;
}());
ContactTempDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contact_temp_popup_service_1.ContactTempPopupService])
], ContactTempDeletePopupComponent);
exports.ContactTempDeletePopupComponent = ContactTempDeletePopupComponent;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contact_temp_service_1 = __webpack_require__(15);
var ContactTempDetailComponent = (function () {
    function ContactTempDetailComponent(eventManager, jhiLanguageService, contactTempService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.contactTempService = contactTempService;
        this.route = route;
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }
    ContactTempDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInContactTemps();
    };
    ContactTempDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.contactTempService.find(id).subscribe(function (contactTemp) {
            _this.contactTemp = contactTemp;
        });
    };
    ContactTempDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ContactTempDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContactTempDetailComponent.prototype.registerChangeInContactTemps = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contactTempListModification', function (response) { return _this.load(_this.contactTemp.id); });
    };
    return ContactTempDetailComponent;
}());
ContactTempDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp-detail',
        template: __webpack_require__(372)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        contact_temp_service_1.ContactTempService,
        router_1.ActivatedRoute])
], ContactTempDetailComponent);
exports.ContactTempDetailComponent = ContactTempDetailComponent;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contact_temp_popup_service_1 = __webpack_require__(51);
var contact_temp_service_1 = __webpack_require__(15);
var contact_1 = __webpack_require__(9);
var ContactTempDialogComponent = (function () {
    function ContactTempDialogComponent(activeModal, jhiLanguageService, alertService, contactTempService, contactService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.contactTempService = contactTempService;
        this.contactService = contactService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }
    ContactTempDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ContactTempDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContactTempDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.contactTemp.id !== undefined) {
            this.contactTempService.update(this.contactTemp)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.contactTempService.create(this.contactTemp)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    ContactTempDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'contactTempListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ContactTempDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    ContactTempDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ContactTempDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    return ContactTempDialogComponent;
}());
ContactTempDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp-dialog',
        template: __webpack_require__(373)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        contact_temp_service_1.ContactTempService,
        contact_1.ContactService,
        ng_jhipster_1.EventManager])
], ContactTempDialogComponent);
exports.ContactTempDialogComponent = ContactTempDialogComponent;
var ContactTempPopupComponent = (function () {
    function ContactTempPopupComponent(route, contactTempPopupService) {
        this.route = route;
        this.contactTempPopupService = contactTempPopupService;
    }
    ContactTempPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.contactTempPopupService
                    .open(ContactTempDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.contactTempPopupService
                    .open(ContactTempDialogComponent);
            }
        });
    };
    ContactTempPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContactTempPopupComponent;
}());
ContactTempPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contact_temp_popup_service_1.ContactTempPopupService])
], ContactTempPopupComponent);
exports.ContactTempPopupComponent = ContactTempPopupComponent;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contact_temp_service_1 = __webpack_require__(15);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var ContactTempComponent = (function () {
    function ContactTempComponent(jhiLanguageService, contactTempService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.contactTempService = contactTempService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }
    ContactTempComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.contactTempService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.contactTempService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ContactTempComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ContactTempComponent.prototype.transition = function () {
        this.router.navigate(['/contact-temp'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ContactTempComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/contact-temp', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ContactTempComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/contact-temp', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ContactTempComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInContactTemps();
    };
    ContactTempComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContactTempComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ContactTempComponent.prototype.registerChangeInContactTemps = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contactTempListModification', function (response) { return _this.loadAll(); });
    };
    ContactTempComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ContactTempComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.contactTemps = data;
    };
    ContactTempComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ContactTempComponent;
}());
ContactTempComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-temp',
        template: __webpack_require__(374)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contact_temp_service_1.ContactTempService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ContactTempComponent);
exports.ContactTempComponent = ContactTempComponent;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
;
var ContactTemp = (function () {
    function ContactTemp(id, type, salutation, title, firstname, lastname, displayname, company, companyAdditional, street, streetAdditional, zipcode, city, suburb, state, country, phone, phoneAdditional, fax, mobile, email, emailAdditional, web, comment, companyGguid, casIsCompany, casIsContact, latitude, longitude, boothUnit, boothType, radius, boothWidth, boothDepth, assortment, assortmentAdditional, activeMerchant, updated, created, gguid, status, superordinateContact, originalContact) {
        this.id = id;
        this.type = type;
        this.salutation = salutation;
        this.title = title;
        this.firstname = firstname;
        this.lastname = lastname;
        this.displayname = displayname;
        this.company = company;
        this.companyAdditional = companyAdditional;
        this.street = street;
        this.streetAdditional = streetAdditional;
        this.zipcode = zipcode;
        this.city = city;
        this.suburb = suburb;
        this.state = state;
        this.country = country;
        this.phone = phone;
        this.phoneAdditional = phoneAdditional;
        this.fax = fax;
        this.mobile = mobile;
        this.email = email;
        this.emailAdditional = emailAdditional;
        this.web = web;
        this.comment = comment;
        this.companyGguid = companyGguid;
        this.casIsCompany = casIsCompany;
        this.casIsContact = casIsContact;
        this.latitude = latitude;
        this.longitude = longitude;
        this.boothUnit = boothUnit;
        this.boothType = boothType;
        this.radius = radius;
        this.boothWidth = boothWidth;
        this.boothDepth = boothDepth;
        this.assortment = assortment;
        this.assortmentAdditional = assortmentAdditional;
        this.activeMerchant = activeMerchant;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.status = status;
        this.superordinateContact = superordinateContact;
        this.originalContact = originalContact;
        this.casIsCompany = false;
        this.casIsContact = false;
        this.activeMerchant = false;
    }
    return ContactTemp;
}());
exports.ContactTemp = ContactTemp;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contact_popup_service_1 = __webpack_require__(52);
var contact_service_1 = __webpack_require__(16);
var ContactDeleteDialogComponent = (function () {
    function ContactDeleteDialogComponent(jhiLanguageService, contactService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.contactService = contactService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contact', 'contactType', 'contactStatus']);
    }
    ContactDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContactDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.contactService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'contactListModification',
                content: 'Deleted an contact'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ContactDeleteDialogComponent;
}());
ContactDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-delete-dialog',
        template: __webpack_require__(375)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contact_service_1.ContactService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ContactDeleteDialogComponent);
exports.ContactDeleteDialogComponent = ContactDeleteDialogComponent;
var ContactDeletePopupComponent = (function () {
    function ContactDeletePopupComponent(route, contactPopupService) {
        this.route = route;
        this.contactPopupService = contactPopupService;
    }
    ContactDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.contactPopupService
                .open(ContactDeleteDialogComponent, params['id']);
        });
    };
    ContactDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContactDeletePopupComponent;
}());
ContactDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contact_popup_service_1.ContactPopupService])
], ContactDeletePopupComponent);
exports.ContactDeletePopupComponent = ContactDeletePopupComponent;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contact_service_1 = __webpack_require__(16);
var ContactDetailComponent = (function () {
    function ContactDetailComponent(eventManager, jhiLanguageService, contactService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.contactService = contactService;
        this.route = route;
        this.jhiLanguageService.setLocations(['contact', 'contactType', 'contactStatus']);
    }
    ContactDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInContacts();
    };
    ContactDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.contactService.find(id).subscribe(function (contact) {
            _this.contact = contact;
        });
    };
    ContactDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ContactDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContactDetailComponent.prototype.registerChangeInContacts = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contactListModification', function (response) { return _this.load(_this.contact.id); });
    };
    return ContactDetailComponent;
}());
ContactDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-detail',
        template: __webpack_require__(376)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        contact_service_1.ContactService,
        router_1.ActivatedRoute])
], ContactDetailComponent);
exports.ContactDetailComponent = ContactDetailComponent;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contact_popup_service_1 = __webpack_require__(52);
var contact_service_1 = __webpack_require__(16);
var shared_1 = __webpack_require__(3);
var ContactDialogComponent = (function () {
    function ContactDialogComponent(activeModal, jhiLanguageService, alertService, contactService, userService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.contactService = contactService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contact', 'contactType', 'contactStatus']);
    }
    ContactDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ContactDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContactDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.contact.id !== undefined) {
            this.contactService.update(this.contact)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.contactService.create(this.contact)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    ContactDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'contactListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ContactDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    ContactDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ContactDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    ContactDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    return ContactDialogComponent;
}());
ContactDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-dialog',
        template: __webpack_require__(377)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        contact_service_1.ContactService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], ContactDialogComponent);
exports.ContactDialogComponent = ContactDialogComponent;
var ContactPopupComponent = (function () {
    function ContactPopupComponent(route, contactPopupService) {
        this.route = route;
        this.contactPopupService = contactPopupService;
    }
    ContactPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.contactPopupService
                    .open(ContactDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.contactPopupService
                    .open(ContactDialogComponent);
            }
        });
    };
    ContactPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContactPopupComponent;
}());
ContactPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contact_popup_service_1.ContactPopupService])
], ContactPopupComponent);
exports.ContactPopupComponent = ContactPopupComponent;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contact_service_1 = __webpack_require__(16);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var ContactComponent = (function () {
    function ContactComponent(jhiLanguageService, contactService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.contactService = contactService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contact', 'contactType', 'contactStatus']);
    }
    ContactComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.contactService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.contactService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ContactComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ContactComponent.prototype.transition = function () {
        this.router.navigate(['/contact'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ContactComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/contact', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ContactComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/contact', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInContacts();
    };
    ContactComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContactComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ContactComponent.prototype.registerChangeInContacts = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contactListModification', function (response) { return _this.loadAll(); });
    };
    ContactComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ContactComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.contacts = data;
    };
    ContactComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ContactComponent;
}());
ContactComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contact',
        template: __webpack_require__(378)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contact_service_1.ContactService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ContactComponent);
exports.ContactComponent = ContactComponent;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
;
var Contact = (function () {
    function Contact(id, type, salutation, title, firstname, lastname, displayname, company, companyAdditional, street, streetAdditional, zipcode, city, suburb, state, country, phone, phoneAdditional, fax, mobile, email, emailAdditional, web, comment, companyGguid, casIsCompany, casIsContact, latitude, longitude, boothUnit, boothType, radius, boothWidth, boothDepth, assortment, assortmentAdditional, activeMerchant, updated, created, gguid, status, user, salesunits, superordinateContact, subordinateContacts) {
        this.id = id;
        this.type = type;
        this.salutation = salutation;
        this.title = title;
        this.firstname = firstname;
        this.lastname = lastname;
        this.displayname = displayname;
        this.company = company;
        this.companyAdditional = companyAdditional;
        this.street = street;
        this.streetAdditional = streetAdditional;
        this.zipcode = zipcode;
        this.city = city;
        this.suburb = suburb;
        this.state = state;
        this.country = country;
        this.phone = phone;
        this.phoneAdditional = phoneAdditional;
        this.fax = fax;
        this.mobile = mobile;
        this.email = email;
        this.emailAdditional = emailAdditional;
        this.web = web;
        this.comment = comment;
        this.companyGguid = companyGguid;
        this.casIsCompany = casIsCompany;
        this.casIsContact = casIsContact;
        this.latitude = latitude;
        this.longitude = longitude;
        this.boothUnit = boothUnit;
        this.boothType = boothType;
        this.radius = radius;
        this.boothWidth = boothWidth;
        this.boothDepth = boothDepth;
        this.assortment = assortment;
        this.assortmentAdditional = assortmentAdditional;
        this.activeMerchant = activeMerchant;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.status = status;
        this.user = user;
        this.salesunits = salesunits;
        this.superordinateContact = superordinateContact;
        this.subordinateContacts = subordinateContacts;
        this.casIsCompany = false;
        this.casIsContact = false;
        this.activeMerchant = false;
    }
    return Contact;
}());
exports.Contact = Contact;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contract_popup_service_1 = __webpack_require__(53);
var contract_service_1 = __webpack_require__(17);
var ContractDeleteDialogComponent = (function () {
    function ContractDeleteDialogComponent(jhiLanguageService, contractService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.contractService = contractService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contract']);
    }
    ContractDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContractDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.contractService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'contractListModification',
                content: 'Deleted an contract'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ContractDeleteDialogComponent;
}());
ContractDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract-delete-dialog',
        template: __webpack_require__(379)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contract_service_1.ContractService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ContractDeleteDialogComponent);
exports.ContractDeleteDialogComponent = ContractDeleteDialogComponent;
var ContractDeletePopupComponent = (function () {
    function ContractDeletePopupComponent(route, contractPopupService) {
        this.route = route;
        this.contractPopupService = contractPopupService;
    }
    ContractDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.contractPopupService
                .open(ContractDeleteDialogComponent, params['id']);
        });
    };
    ContractDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContractDeletePopupComponent;
}());
ContractDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contract_popup_service_1.ContractPopupService])
], ContractDeletePopupComponent);
exports.ContractDeletePopupComponent = ContractDeletePopupComponent;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contract_service_1 = __webpack_require__(17);
var ContractDetailComponent = (function () {
    function ContractDetailComponent(eventManager, jhiLanguageService, contractService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.contractService = contractService;
        this.route = route;
        this.jhiLanguageService.setLocations(['contract']);
    }
    ContractDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInContracts();
    };
    ContractDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.contractService.find(id).subscribe(function (contract) {
            _this.contract = contract;
        });
    };
    ContractDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ContractDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContractDetailComponent.prototype.registerChangeInContracts = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contractListModification', function (response) { return _this.load(_this.contract.id); });
    };
    return ContractDetailComponent;
}());
ContractDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract-detail',
        template: __webpack_require__(380)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        contract_service_1.ContractService,
        router_1.ActivatedRoute])
], ContractDetailComponent);
exports.ContractDetailComponent = ContractDetailComponent;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contract_popup_service_1 = __webpack_require__(53);
var contract_service_1 = __webpack_require__(17);
var marketday_1 = __webpack_require__(32);
var contact_1 = __webpack_require__(9);
var salesunit_1 = __webpack_require__(37);
var ContractDialogComponent = (function () {
    function ContractDialogComponent(activeModal, jhiLanguageService, alertService, contractService, marketdayService, contactService, salesunitService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.contractService = contractService;
        this.marketdayService = marketdayService;
        this.contactService = contactService;
        this.salesunitService = salesunitService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contract']);
    }
    ContractDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(function (res) { _this.marketdays = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.salesunitService.query().subscribe(function (res) { _this.salesunits = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ContractDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContractDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.contract.id !== undefined) {
            this.contractService.update(this.contract)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.contractService.create(this.contract)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    ContractDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'contractListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ContractDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    ContractDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ContractDialogComponent.prototype.trackMarketdayById = function (index, item) {
        return item.id;
    };
    ContractDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    ContractDialogComponent.prototype.trackSalesunitById = function (index, item) {
        return item.id;
    };
    return ContractDialogComponent;
}());
ContractDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract-dialog',
        template: __webpack_require__(381)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        contract_service_1.ContractService,
        marketday_1.MarketdayService,
        contact_1.ContactService,
        salesunit_1.SalesunitService,
        ng_jhipster_1.EventManager])
], ContractDialogComponent);
exports.ContractDialogComponent = ContractDialogComponent;
var ContractPopupComponent = (function () {
    function ContractPopupComponent(route, contractPopupService) {
        this.route = route;
        this.contractPopupService = contractPopupService;
    }
    ContractPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.contractPopupService
                    .open(ContractDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.contractPopupService
                    .open(ContractDialogComponent);
            }
        });
    };
    ContractPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContractPopupComponent;
}());
ContractPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contract_popup_service_1.ContractPopupService])
], ContractPopupComponent);
exports.ContractPopupComponent = ContractPopupComponent;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contract_service_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(3);
var ContractComponent = (function () {
    function ContractComponent(jhiLanguageService, contractService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.contractService = contractService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contract']);
    }
    ContractComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.contractService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.contracts = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.contractService.query().subscribe(function (res) {
            _this.contracts = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    ContractComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    ContractComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    ContractComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInContracts();
    };
    ContractComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContractComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ContractComponent.prototype.registerChangeInContracts = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contractListModification', function (response) { return _this.loadAll(); });
    };
    ContractComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ContractComponent;
}());
ContractComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contract',
        template: __webpack_require__(382)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contract_service_1.ContractService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], ContractComponent);
exports.ContractComponent = ContractComponent;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Contract = (function () {
    function Contract(id, startDate, merchantNumber, marketdayNumber, marketdateNumber, endDate, boothWidth, boothDepth, contractNumber, boothWidthAdditional, boothDepthAdditional, specialPrice, divergentEnergy, energyAdvancedPayment, isSpecial, boothWidthWinter, boothDepthWinter, boothWidthWinterAdditional, boothDepthWinterAdditional, energyType, energyTypeWinter, gguid, marketday, merchant, salesunit) {
        this.id = id;
        this.startDate = startDate;
        this.merchantNumber = merchantNumber;
        this.marketdayNumber = marketdayNumber;
        this.marketdateNumber = marketdateNumber;
        this.endDate = endDate;
        this.boothWidth = boothWidth;
        this.boothDepth = boothDepth;
        this.contractNumber = contractNumber;
        this.boothWidthAdditional = boothWidthAdditional;
        this.boothDepthAdditional = boothDepthAdditional;
        this.specialPrice = specialPrice;
        this.divergentEnergy = divergentEnergy;
        this.energyAdvancedPayment = energyAdvancedPayment;
        this.isSpecial = isSpecial;
        this.boothWidthWinter = boothWidthWinter;
        this.boothDepthWinter = boothDepthWinter;
        this.boothWidthWinterAdditional = boothWidthWinterAdditional;
        this.boothDepthWinterAdditional = boothDepthWinterAdditional;
        this.energyType = energyType;
        this.energyTypeWinter = energyTypeWinter;
        this.gguid = gguid;
        this.marketday = marketday;
        this.merchant = merchant;
        this.salesunit = salesunit;
        this.divergentEnergy = false;
        this.isSpecial = false;
    }
    return Contract;
}());
exports.Contract = Contract;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contractdate_popup_service_1 = __webpack_require__(54);
var contractdate_service_1 = __webpack_require__(18);
var ContractdateDeleteDialogComponent = (function () {
    function ContractdateDeleteDialogComponent(jhiLanguageService, contractdateService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.contractdateService = contractdateService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contractdate']);
    }
    ContractdateDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContractdateDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.contractdateService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'contractdateListModification',
                content: 'Deleted an contractdate'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ContractdateDeleteDialogComponent;
}());
ContractdateDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate-delete-dialog',
        template: __webpack_require__(383)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contractdate_service_1.ContractdateService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ContractdateDeleteDialogComponent);
exports.ContractdateDeleteDialogComponent = ContractdateDeleteDialogComponent;
var ContractdateDeletePopupComponent = (function () {
    function ContractdateDeletePopupComponent(route, contractdatePopupService) {
        this.route = route;
        this.contractdatePopupService = contractdatePopupService;
    }
    ContractdateDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.contractdatePopupService
                .open(ContractdateDeleteDialogComponent, params['id']);
        });
    };
    ContractdateDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContractdateDeletePopupComponent;
}());
ContractdateDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contractdate_popup_service_1.ContractdatePopupService])
], ContractdateDeletePopupComponent);
exports.ContractdateDeletePopupComponent = ContractdateDeletePopupComponent;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contractdate_service_1 = __webpack_require__(18);
var ContractdateDetailComponent = (function () {
    function ContractdateDetailComponent(eventManager, jhiLanguageService, contractdateService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.contractdateService = contractdateService;
        this.route = route;
        this.jhiLanguageService.setLocations(['contractdate']);
    }
    ContractdateDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInContractdates();
    };
    ContractdateDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.contractdateService.find(id).subscribe(function (contractdate) {
            _this.contractdate = contractdate;
        });
    };
    ContractdateDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ContractdateDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContractdateDetailComponent.prototype.registerChangeInContractdates = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contractdateListModification', function (response) { return _this.load(_this.contractdate.id); });
    };
    return ContractdateDetailComponent;
}());
ContractdateDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate-detail',
        template: __webpack_require__(384)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        contractdate_service_1.ContractdateService,
        router_1.ActivatedRoute])
], ContractdateDetailComponent);
exports.ContractdateDetailComponent = ContractdateDetailComponent;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var contractdate_popup_service_1 = __webpack_require__(54);
var contractdate_service_1 = __webpack_require__(18);
var contract_1 = __webpack_require__(35);
var ContractdateDialogComponent = (function () {
    function ContractdateDialogComponent(activeModal, jhiLanguageService, alertService, contractdateService, contractService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.contractdateService = contractdateService;
        this.contractService = contractService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['contractdate']);
    }
    ContractdateDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contractService.query().subscribe(function (res) { _this.contracts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ContractdateDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ContractdateDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.contractdate.id !== undefined) {
            this.contractdateService.update(this.contractdate)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.contractdateService.create(this.contractdate)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    ContractdateDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'contractdateListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ContractdateDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    ContractdateDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ContractdateDialogComponent.prototype.trackContractById = function (index, item) {
        return item.id;
    };
    return ContractdateDialogComponent;
}());
ContractdateDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate-dialog',
        template: __webpack_require__(385)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        contractdate_service_1.ContractdateService,
        contract_1.ContractService,
        ng_jhipster_1.EventManager])
], ContractdateDialogComponent);
exports.ContractdateDialogComponent = ContractdateDialogComponent;
var ContractdatePopupComponent = (function () {
    function ContractdatePopupComponent(route, contractdatePopupService) {
        this.route = route;
        this.contractdatePopupService = contractdatePopupService;
    }
    ContractdatePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.contractdatePopupService
                    .open(ContractdateDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.contractdatePopupService
                    .open(ContractdateDialogComponent);
            }
        });
    };
    ContractdatePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ContractdatePopupComponent;
}());
ContractdatePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        contractdate_popup_service_1.ContractdatePopupService])
], ContractdatePopupComponent);
exports.ContractdatePopupComponent = ContractdatePopupComponent;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var contractdate_service_1 = __webpack_require__(18);
var shared_1 = __webpack_require__(3);
var ContractdateComponent = (function () {
    function ContractdateComponent(jhiLanguageService, contractdateService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.contractdateService = contractdateService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contractdate']);
    }
    ContractdateComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.contractdateService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.contractdates = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.contractdateService.query().subscribe(function (res) {
            _this.contractdates = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    ContractdateComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    ContractdateComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    ContractdateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInContractdates();
    };
    ContractdateComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ContractdateComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ContractdateComponent.prototype.registerChangeInContractdates = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('contractdateListModification', function (response) { return _this.loadAll(); });
    };
    ContractdateComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ContractdateComponent;
}());
ContractdateComponent = __decorate([
    core_1.Component({
        selector: 'jhi-contractdate',
        template: __webpack_require__(386)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        contractdate_service_1.ContractdateService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], ContractdateComponent);
exports.ContractdateComponent = ContractdateComponent;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Contractdate = (function () {
    function Contractdate(id, realDate, originalDate, evasiveDate, gguid, contract) {
        this.id = id;
        this.realDate = realDate;
        this.originalDate = originalDate;
        this.evasiveDate = evasiveDate;
        this.gguid = gguid;
        this.contract = contract;
    }
    return Contractdate;
}());
exports.Contractdate = Contractdate;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var electricmeter_popup_service_1 = __webpack_require__(55);
var electricmeter_service_1 = __webpack_require__(19);
var ElectricmeterDeleteDialogComponent = (function () {
    function ElectricmeterDeleteDialogComponent(jhiLanguageService, electricmeterService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.electricmeterService = electricmeterService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['electricmeter']);
    }
    ElectricmeterDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ElectricmeterDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.electricmeterService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'electricmeterListModification',
                content: 'Deleted an electricmeter'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ElectricmeterDeleteDialogComponent;
}());
ElectricmeterDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter-delete-dialog',
        template: __webpack_require__(387)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        electricmeter_service_1.ElectricmeterService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ElectricmeterDeleteDialogComponent);
exports.ElectricmeterDeleteDialogComponent = ElectricmeterDeleteDialogComponent;
var ElectricmeterDeletePopupComponent = (function () {
    function ElectricmeterDeletePopupComponent(route, electricmeterPopupService) {
        this.route = route;
        this.electricmeterPopupService = electricmeterPopupService;
    }
    ElectricmeterDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.electricmeterPopupService
                .open(ElectricmeterDeleteDialogComponent, params['id']);
        });
    };
    ElectricmeterDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ElectricmeterDeletePopupComponent;
}());
ElectricmeterDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        electricmeter_popup_service_1.ElectricmeterPopupService])
], ElectricmeterDeletePopupComponent);
exports.ElectricmeterDeletePopupComponent = ElectricmeterDeletePopupComponent;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var electricmeter_service_1 = __webpack_require__(19);
var ElectricmeterDetailComponent = (function () {
    function ElectricmeterDetailComponent(eventManager, jhiLanguageService, electricmeterService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.electricmeterService = electricmeterService;
        this.route = route;
        this.jhiLanguageService.setLocations(['electricmeter']);
    }
    ElectricmeterDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInElectricmeters();
    };
    ElectricmeterDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.electricmeterService.find(id).subscribe(function (electricmeter) {
            _this.electricmeter = electricmeter;
        });
    };
    ElectricmeterDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ElectricmeterDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    ElectricmeterDetailComponent.prototype.registerChangeInElectricmeters = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('electricmeterListModification', function (response) { return _this.load(_this.electricmeter.id); });
    };
    return ElectricmeterDetailComponent;
}());
ElectricmeterDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter-detail',
        template: __webpack_require__(388)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        electricmeter_service_1.ElectricmeterService,
        router_1.ActivatedRoute])
], ElectricmeterDetailComponent);
exports.ElectricmeterDetailComponent = ElectricmeterDetailComponent;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var electricmeter_popup_service_1 = __webpack_require__(55);
var electricmeter_service_1 = __webpack_require__(19);
var marketplace_1 = __webpack_require__(36);
var ElectricmeterDialogComponent = (function () {
    function ElectricmeterDialogComponent(activeModal, jhiLanguageService, alertService, electricmeterService, marketplaceService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.electricmeterService = electricmeterService;
        this.marketplaceService = marketplaceService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['electricmeter']);
    }
    ElectricmeterDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(function (res) { _this.marketplaces = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ElectricmeterDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ElectricmeterDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.electricmeter.id !== undefined) {
            this.electricmeterService.update(this.electricmeter)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.electricmeterService.create(this.electricmeter)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    ElectricmeterDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'electricmeterListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ElectricmeterDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    ElectricmeterDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ElectricmeterDialogComponent.prototype.trackMarketplaceById = function (index, item) {
        return item.id;
    };
    return ElectricmeterDialogComponent;
}());
ElectricmeterDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter-dialog',
        template: __webpack_require__(389)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        electricmeter_service_1.ElectricmeterService,
        marketplace_1.MarketplaceService,
        ng_jhipster_1.EventManager])
], ElectricmeterDialogComponent);
exports.ElectricmeterDialogComponent = ElectricmeterDialogComponent;
var ElectricmeterPopupComponent = (function () {
    function ElectricmeterPopupComponent(route, electricmeterPopupService) {
        this.route = route;
        this.electricmeterPopupService = electricmeterPopupService;
    }
    ElectricmeterPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.electricmeterPopupService
                    .open(ElectricmeterDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.electricmeterPopupService
                    .open(ElectricmeterDialogComponent);
            }
        });
    };
    ElectricmeterPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ElectricmeterPopupComponent;
}());
ElectricmeterPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        electricmeter_popup_service_1.ElectricmeterPopupService])
], ElectricmeterPopupComponent);
exports.ElectricmeterPopupComponent = ElectricmeterPopupComponent;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var electricmeter_service_1 = __webpack_require__(19);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var ElectricmeterComponent = (function () {
    function ElectricmeterComponent(jhiLanguageService, electricmeterService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.electricmeterService = electricmeterService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['electricmeter']);
    }
    ElectricmeterComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.electricmeterService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.electricmeterService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ElectricmeterComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ElectricmeterComponent.prototype.transition = function () {
        this.router.navigate(['/electricmeter'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ElectricmeterComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/electricmeter', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ElectricmeterComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/electricmeter', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ElectricmeterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInElectricmeters();
    };
    ElectricmeterComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ElectricmeterComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ElectricmeterComponent.prototype.registerChangeInElectricmeters = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('electricmeterListModification', function (response) { return _this.loadAll(); });
    };
    ElectricmeterComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ElectricmeterComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.electricmeters = data;
    };
    ElectricmeterComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ElectricmeterComponent;
}());
ElectricmeterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-electricmeter',
        template: __webpack_require__(390)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        electricmeter_service_1.ElectricmeterService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ElectricmeterComponent);
exports.ElectricmeterComponent = ElectricmeterComponent;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Electricmeter = (function () {
    function Electricmeter(id, marketplaceNumber, provider, count230V, count380V, owner, electricmeterNumber, location, updated, created, gguid, lastValue, lastValueChanged, marketplace) {
        this.id = id;
        this.marketplaceNumber = marketplaceNumber;
        this.provider = provider;
        this.count230V = count230V;
        this.count380V = count380V;
        this.owner = owner;
        this.electricmeterNumber = electricmeterNumber;
        this.location = location;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.lastValue = lastValue;
        this.lastValueChanged = lastValueChanged;
        this.marketplace = marketplace;
    }
    return Electricmeter;
}());
exports.Electricmeter = Electricmeter;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(148));
__export(__webpack_require__(55));
__export(__webpack_require__(19));
__export(__webpack_require__(146));
__export(__webpack_require__(144));
__export(__webpack_require__(145));
__export(__webpack_require__(147));
__export(__webpack_require__(275));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var energyflat_popup_service_1 = __webpack_require__(56);
var energyflat_service_1 = __webpack_require__(20);
var EnergyflatDeleteDialogComponent = (function () {
    function EnergyflatDeleteDialogComponent(jhiLanguageService, energyflatService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.energyflatService = energyflatService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['energyflat']);
    }
    EnergyflatDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    EnergyflatDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.energyflatService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'energyflatListModification',
                content: 'Deleted an energyflat'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return EnergyflatDeleteDialogComponent;
}());
EnergyflatDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat-delete-dialog',
        template: __webpack_require__(391)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        energyflat_service_1.EnergyflatService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], EnergyflatDeleteDialogComponent);
exports.EnergyflatDeleteDialogComponent = EnergyflatDeleteDialogComponent;
var EnergyflatDeletePopupComponent = (function () {
    function EnergyflatDeletePopupComponent(route, energyflatPopupService) {
        this.route = route;
        this.energyflatPopupService = energyflatPopupService;
    }
    EnergyflatDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.energyflatPopupService
                .open(EnergyflatDeleteDialogComponent, params['id']);
        });
    };
    EnergyflatDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return EnergyflatDeletePopupComponent;
}());
EnergyflatDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        energyflat_popup_service_1.EnergyflatPopupService])
], EnergyflatDeletePopupComponent);
exports.EnergyflatDeletePopupComponent = EnergyflatDeletePopupComponent;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var energyflat_service_1 = __webpack_require__(20);
var EnergyflatDetailComponent = (function () {
    function EnergyflatDetailComponent(eventManager, jhiLanguageService, energyflatService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.energyflatService = energyflatService;
        this.route = route;
        this.jhiLanguageService.setLocations(['energyflat']);
    }
    EnergyflatDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInEnergyflats();
    };
    EnergyflatDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.energyflatService.find(id).subscribe(function (energyflat) {
            _this.energyflat = energyflat;
        });
    };
    EnergyflatDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    EnergyflatDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    EnergyflatDetailComponent.prototype.registerChangeInEnergyflats = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('energyflatListModification', function (response) { return _this.load(_this.energyflat.id); });
    };
    return EnergyflatDetailComponent;
}());
EnergyflatDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat-detail',
        template: __webpack_require__(392)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        energyflat_service_1.EnergyflatService,
        router_1.ActivatedRoute])
], EnergyflatDetailComponent);
exports.EnergyflatDetailComponent = EnergyflatDetailComponent;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var energyflat_popup_service_1 = __webpack_require__(56);
var energyflat_service_1 = __webpack_require__(20);
var marketday_1 = __webpack_require__(32);
var EnergyflatDialogComponent = (function () {
    function EnergyflatDialogComponent(activeModal, jhiLanguageService, alertService, energyflatService, marketdayService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.energyflatService = energyflatService;
        this.marketdayService = marketdayService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['energyflat']);
    }
    EnergyflatDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(function (res) { _this.marketdays = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    EnergyflatDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    EnergyflatDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.energyflat.id !== undefined) {
            this.energyflatService.update(this.energyflat)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.energyflatService.create(this.energyflat)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    EnergyflatDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'energyflatListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    EnergyflatDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    EnergyflatDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    EnergyflatDialogComponent.prototype.trackMarketdayById = function (index, item) {
        return item.id;
    };
    return EnergyflatDialogComponent;
}());
EnergyflatDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat-dialog',
        template: __webpack_require__(393)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        energyflat_service_1.EnergyflatService,
        marketday_1.MarketdayService,
        ng_jhipster_1.EventManager])
], EnergyflatDialogComponent);
exports.EnergyflatDialogComponent = EnergyflatDialogComponent;
var EnergyflatPopupComponent = (function () {
    function EnergyflatPopupComponent(route, energyflatPopupService) {
        this.route = route;
        this.energyflatPopupService = energyflatPopupService;
    }
    EnergyflatPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.energyflatPopupService
                    .open(EnergyflatDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.energyflatPopupService
                    .open(EnergyflatDialogComponent);
            }
        });
    };
    EnergyflatPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return EnergyflatPopupComponent;
}());
EnergyflatPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        energyflat_popup_service_1.EnergyflatPopupService])
], EnergyflatPopupComponent);
exports.EnergyflatPopupComponent = EnergyflatPopupComponent;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var energyflat_service_1 = __webpack_require__(20);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var EnergyflatComponent = (function () {
    function EnergyflatComponent(jhiLanguageService, energyflatService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.energyflatService = energyflatService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['energyflat']);
    }
    EnergyflatComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.energyflatService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.energyflatService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    EnergyflatComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    EnergyflatComponent.prototype.transition = function () {
        this.router.navigate(['/energyflat'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    EnergyflatComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/energyflat', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    EnergyflatComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/energyflat', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    EnergyflatComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInEnergyflats();
    };
    EnergyflatComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    EnergyflatComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    EnergyflatComponent.prototype.registerChangeInEnergyflats = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('energyflatListModification', function (response) { return _this.loadAll(); });
    };
    EnergyflatComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    EnergyflatComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.energyflats = data;
    };
    EnergyflatComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return EnergyflatComponent;
}());
EnergyflatComponent = __decorate([
    core_1.Component({
        selector: 'jhi-energyflat',
        template: __webpack_require__(394)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        energyflat_service_1.EnergyflatService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], EnergyflatComponent);
exports.EnergyflatComponent = EnergyflatComponent;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Energyflat = (function () {
    function Energyflat(id, marketdayNumber, validFrom, priceType, priceLow, priceNormal, priceSpecial, updated, created, gguid, marketday) {
        this.id = id;
        this.marketdayNumber = marketdayNumber;
        this.validFrom = validFrom;
        this.priceType = priceType;
        this.priceLow = priceLow;
        this.priceNormal = priceNormal;
        this.priceSpecial = priceSpecial;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.marketday = marketday;
    }
    return Energyflat;
}());
exports.Energyflat = Energyflat;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_booth_popup_service_1 = __webpack_require__(57);
var marketdate_booth_service_1 = __webpack_require__(21);
var MarketdateBoothDeleteDialogComponent = (function () {
    function MarketdateBoothDeleteDialogComponent(jhiLanguageService, marketdateBoothService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateBoothService = marketdateBoothService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }
    MarketdateBoothDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateBoothDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateBoothService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateBoothListModification',
                content: 'Deleted an marketdateBooth'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateBoothDeleteDialogComponent;
}());
MarketdateBoothDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth-delete-dialog',
        template: __webpack_require__(395)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_booth_service_1.MarketdateBoothService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateBoothDeleteDialogComponent);
exports.MarketdateBoothDeleteDialogComponent = MarketdateBoothDeleteDialogComponent;
var MarketdateBoothDeletePopupComponent = (function () {
    function MarketdateBoothDeletePopupComponent(route, marketdateBoothPopupService) {
        this.route = route;
        this.marketdateBoothPopupService = marketdateBoothPopupService;
    }
    MarketdateBoothDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdateBoothPopupService
                .open(MarketdateBoothDeleteDialogComponent, params['id']);
        });
    };
    MarketdateBoothDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateBoothDeletePopupComponent;
}());
MarketdateBoothDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_booth_popup_service_1.MarketdateBoothPopupService])
], MarketdateBoothDeletePopupComponent);
exports.MarketdateBoothDeletePopupComponent = MarketdateBoothDeletePopupComponent;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_booth_service_1 = __webpack_require__(21);
var MarketdateBoothDetailComponent = (function () {
    function MarketdateBoothDetailComponent(eventManager, jhiLanguageService, marketdateBoothService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateBoothService = marketdateBoothService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }
    MarketdateBoothDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdateBooths();
    };
    MarketdateBoothDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateBoothService.find(id).subscribe(function (marketdateBooth) {
            _this.marketdateBooth = marketdateBooth;
        });
    };
    MarketdateBoothDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateBoothDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateBoothDetailComponent.prototype.registerChangeInMarketdateBooths = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateBoothListModification', function (response) { return _this.load(_this.marketdateBooth.id); });
    };
    return MarketdateBoothDetailComponent;
}());
MarketdateBoothDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth-detail',
        template: __webpack_require__(396)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketdate_booth_service_1.MarketdateBoothService,
        router_1.ActivatedRoute])
], MarketdateBoothDetailComponent);
exports.MarketdateBoothDetailComponent = MarketdateBoothDetailComponent;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_booth_popup_service_1 = __webpack_require__(57);
var marketdate_booth_service_1 = __webpack_require__(21);
var salesunit_1 = __webpack_require__(37);
var contact_1 = __webpack_require__(9);
var contract_1 = __webpack_require__(35);
var marketdate_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(3);
var MarketdateBoothDialogComponent = (function () {
    function MarketdateBoothDialogComponent(activeModal, jhiLanguageService, alertService, marketdateBoothService, salesunitService, contactService, contractService, marketdateService, userService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdateBoothService = marketdateBoothService;
        this.salesunitService = salesunitService;
        this.contactService = contactService;
        this.contractService = contractService;
        this.marketdateService = marketdateService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }
    MarketdateBoothDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.salesunitService.query().subscribe(function (res) { _this.salesunits = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contractService.query().subscribe(function (res) { _this.contracts = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.marketdateService.query().subscribe(function (res) { _this.marketdates = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateBoothDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateBoothDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdateBooth.id !== undefined) {
            this.marketdateBoothService.update(this.marketdateBooth)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateBoothService.create(this.marketdateBooth)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateBoothDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateBoothListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateBoothDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateBoothDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateBoothDialogComponent.prototype.trackSalesunitById = function (index, item) {
        return item.id;
    };
    MarketdateBoothDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    MarketdateBoothDialogComponent.prototype.trackContractById = function (index, item) {
        return item.id;
    };
    MarketdateBoothDialogComponent.prototype.trackMarketdateById = function (index, item) {
        return item.id;
    };
    MarketdateBoothDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    return MarketdateBoothDialogComponent;
}());
MarketdateBoothDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth-dialog',
        template: __webpack_require__(397)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketdate_booth_service_1.MarketdateBoothService,
        salesunit_1.SalesunitService,
        contact_1.ContactService,
        contract_1.ContractService,
        marketdate_1.MarketdateService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], MarketdateBoothDialogComponent);
exports.MarketdateBoothDialogComponent = MarketdateBoothDialogComponent;
var MarketdateBoothPopupComponent = (function () {
    function MarketdateBoothPopupComponent(route, marketdateBoothPopupService) {
        this.route = route;
        this.marketdateBoothPopupService = marketdateBoothPopupService;
    }
    MarketdateBoothPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdateBoothPopupService
                    .open(MarketdateBoothDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdateBoothPopupService
                    .open(MarketdateBoothDialogComponent);
            }
        });
    };
    MarketdateBoothPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateBoothPopupComponent;
}());
MarketdateBoothPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_booth_popup_service_1.MarketdateBoothPopupService])
], MarketdateBoothPopupComponent);
exports.MarketdateBoothPopupComponent = MarketdateBoothPopupComponent;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_booth_service_1 = __webpack_require__(21);
var shared_1 = __webpack_require__(3);
var MarketdateBoothComponent = (function () {
    function MarketdateBoothComponent(jhiLanguageService, marketdateBoothService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateBoothService = marketdateBoothService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }
    MarketdateBoothComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateBoothService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.marketdateBooths = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateBoothService.query().subscribe(function (res) {
            _this.marketdateBooths = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateBoothComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    MarketdateBoothComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    MarketdateBoothComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdateBooths();
    };
    MarketdateBoothComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateBoothComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateBoothComponent.prototype.registerChangeInMarketdateBooths = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateBoothListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateBoothComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateBoothComponent;
}());
MarketdateBoothComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-booth',
        template: __webpack_require__(398)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_booth_service_1.MarketdateBoothService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], MarketdateBoothComponent);
exports.MarketdateBoothComponent = MarketdateBoothComponent;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
;
;
var MarketdateBooth = (function () {
    function MarketdateBooth(id, contractType, order, width, depth, sqmCost, sqmCostIncludingBase, energyPriceType, priceSanitary, priceCleaning, priceParking, marketingFee, priceTotal, status, correctionNotice, salesunit, contactPerson, contract, marketdate, updatedBy, merchant) {
        this.id = id;
        this.contractType = contractType;
        this.order = order;
        this.width = width;
        this.depth = depth;
        this.sqmCost = sqmCost;
        this.sqmCostIncludingBase = sqmCostIncludingBase;
        this.energyPriceType = energyPriceType;
        this.priceSanitary = priceSanitary;
        this.priceCleaning = priceCleaning;
        this.priceParking = priceParking;
        this.marketingFee = marketingFee;
        this.priceTotal = priceTotal;
        this.status = status;
        this.correctionNotice = correctionNotice;
        this.salesunit = salesunit;
        this.contactPerson = contactPerson;
        this.contract = contract;
        this.marketdate = marketdate;
        this.updatedBy = updatedBy;
        this.merchant = merchant;
    }
    return MarketdateBooth;
}());
exports.MarketdateBooth = MarketdateBooth;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_comment_popup_service_1 = __webpack_require__(58);
var marketdate_comment_service_1 = __webpack_require__(22);
var MarketdateCommentDeleteDialogComponent = (function () {
    function MarketdateCommentDeleteDialogComponent(jhiLanguageService, marketdateCommentService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateCommentService = marketdateCommentService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }
    MarketdateCommentDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateCommentDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateCommentService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateCommentListModification',
                content: 'Deleted an marketdateComment'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateCommentDeleteDialogComponent;
}());
MarketdateCommentDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment-delete-dialog',
        template: __webpack_require__(399)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_comment_service_1.MarketdateCommentService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateCommentDeleteDialogComponent);
exports.MarketdateCommentDeleteDialogComponent = MarketdateCommentDeleteDialogComponent;
var MarketdateCommentDeletePopupComponent = (function () {
    function MarketdateCommentDeletePopupComponent(route, marketdateCommentPopupService) {
        this.route = route;
        this.marketdateCommentPopupService = marketdateCommentPopupService;
    }
    MarketdateCommentDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdateCommentPopupService
                .open(MarketdateCommentDeleteDialogComponent, params['id']);
        });
    };
    MarketdateCommentDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateCommentDeletePopupComponent;
}());
MarketdateCommentDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_comment_popup_service_1.MarketdateCommentPopupService])
], MarketdateCommentDeletePopupComponent);
exports.MarketdateCommentDeletePopupComponent = MarketdateCommentDeletePopupComponent;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_comment_service_1 = __webpack_require__(22);
var MarketdateCommentDetailComponent = (function () {
    function MarketdateCommentDetailComponent(eventManager, jhiLanguageService, marketdateCommentService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateCommentService = marketdateCommentService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }
    MarketdateCommentDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdateComments();
    };
    MarketdateCommentDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateCommentService.find(id).subscribe(function (marketdateComment) {
            _this.marketdateComment = marketdateComment;
        });
    };
    MarketdateCommentDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateCommentDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateCommentDetailComponent.prototype.registerChangeInMarketdateComments = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateCommentListModification', function (response) { return _this.load(_this.marketdateComment.id); });
    };
    return MarketdateCommentDetailComponent;
}());
MarketdateCommentDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment-detail',
        template: __webpack_require__(400)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketdate_comment_service_1.MarketdateCommentService,
        router_1.ActivatedRoute])
], MarketdateCommentDetailComponent);
exports.MarketdateCommentDetailComponent = MarketdateCommentDetailComponent;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_comment_popup_service_1 = __webpack_require__(58);
var marketdate_comment_service_1 = __webpack_require__(22);
var marketdate_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(3);
var MarketdateCommentDialogComponent = (function () {
    function MarketdateCommentDialogComponent(activeModal, jhiLanguageService, alertService, marketdateCommentService, marketdateService, userService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdateCommentService = marketdateCommentService;
        this.marketdateService = marketdateService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }
    MarketdateCommentDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(function (res) { _this.marketdates = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateCommentDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateCommentDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdateComment.id !== undefined) {
            this.marketdateCommentService.update(this.marketdateComment)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateCommentService.create(this.marketdateComment)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateCommentDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateCommentListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateCommentDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateCommentDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateCommentDialogComponent.prototype.trackMarketdateById = function (index, item) {
        return item.id;
    };
    MarketdateCommentDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    return MarketdateCommentDialogComponent;
}());
MarketdateCommentDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment-dialog',
        template: __webpack_require__(401)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketdate_comment_service_1.MarketdateCommentService,
        marketdate_1.MarketdateService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], MarketdateCommentDialogComponent);
exports.MarketdateCommentDialogComponent = MarketdateCommentDialogComponent;
var MarketdateCommentPopupComponent = (function () {
    function MarketdateCommentPopupComponent(route, marketdateCommentPopupService) {
        this.route = route;
        this.marketdateCommentPopupService = marketdateCommentPopupService;
    }
    MarketdateCommentPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdateCommentPopupService
                    .open(MarketdateCommentDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdateCommentPopupService
                    .open(MarketdateCommentDialogComponent);
            }
        });
    };
    MarketdateCommentPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateCommentPopupComponent;
}());
MarketdateCommentPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_comment_popup_service_1.MarketdateCommentPopupService])
], MarketdateCommentPopupComponent);
exports.MarketdateCommentPopupComponent = MarketdateCommentPopupComponent;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_comment_service_1 = __webpack_require__(22);
var shared_1 = __webpack_require__(3);
var MarketdateCommentComponent = (function () {
    function MarketdateCommentComponent(jhiLanguageService, marketdateCommentService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateCommentService = marketdateCommentService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }
    MarketdateCommentComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateCommentService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.marketdateComments = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateCommentService.query().subscribe(function (res) {
            _this.marketdateComments = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateCommentComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    MarketdateCommentComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    MarketdateCommentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdateComments();
    };
    MarketdateCommentComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateCommentComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateCommentComponent.prototype.registerChangeInMarketdateComments = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateCommentListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateCommentComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateCommentComponent;
}());
MarketdateCommentComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-comment',
        template: __webpack_require__(402)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_comment_service_1.MarketdateCommentService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], MarketdateCommentComponent);
exports.MarketdateCommentComponent = MarketdateCommentComponent;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var MarketdateComment = (function () {
    function MarketdateComment(id, comment, commentType, updated, created, marketdate, updatedBy) {
        this.id = id;
        this.comment = comment;
        this.commentType = commentType;
        this.updated = updated;
        this.created = created;
        this.marketdate = marketdate;
        this.updatedBy = updatedBy;
    }
    return MarketdateComment;
}());
exports.MarketdateComment = MarketdateComment;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_expense_popup_service_1 = __webpack_require__(59);
var marketdate_expense_service_1 = __webpack_require__(23);
var MarketdateExpenseDeleteDialogComponent = (function () {
    function MarketdateExpenseDeleteDialogComponent(jhiLanguageService, marketdateExpenseService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateExpenseService = marketdateExpenseService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }
    MarketdateExpenseDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateExpenseDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateExpenseService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateExpenseListModification',
                content: 'Deleted an marketdateExpense'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateExpenseDeleteDialogComponent;
}());
MarketdateExpenseDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense-delete-dialog',
        template: __webpack_require__(403)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_expense_service_1.MarketdateExpenseService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateExpenseDeleteDialogComponent);
exports.MarketdateExpenseDeleteDialogComponent = MarketdateExpenseDeleteDialogComponent;
var MarketdateExpenseDeletePopupComponent = (function () {
    function MarketdateExpenseDeletePopupComponent(route, marketdateExpensePopupService) {
        this.route = route;
        this.marketdateExpensePopupService = marketdateExpensePopupService;
    }
    MarketdateExpenseDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdateExpensePopupService
                .open(MarketdateExpenseDeleteDialogComponent, params['id']);
        });
    };
    MarketdateExpenseDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateExpenseDeletePopupComponent;
}());
MarketdateExpenseDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_expense_popup_service_1.MarketdateExpensePopupService])
], MarketdateExpenseDeletePopupComponent);
exports.MarketdateExpenseDeletePopupComponent = MarketdateExpenseDeletePopupComponent;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_expense_service_1 = __webpack_require__(23);
var MarketdateExpenseDetailComponent = (function () {
    function MarketdateExpenseDetailComponent(eventManager, jhiLanguageService, dataUtils, marketdateExpenseService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.marketdateExpenseService = marketdateExpenseService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }
    MarketdateExpenseDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdateExpenses();
    };
    MarketdateExpenseDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateExpenseService.find(id).subscribe(function (marketdateExpense) {
            _this.marketdateExpense = marketdateExpense;
        });
    };
    MarketdateExpenseDetailComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    MarketdateExpenseDetailComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    MarketdateExpenseDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateExpenseDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateExpenseDetailComponent.prototype.registerChangeInMarketdateExpenses = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateExpenseListModification', function (response) { return _this.load(_this.marketdateExpense.id); });
    };
    return MarketdateExpenseDetailComponent;
}());
MarketdateExpenseDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense-detail',
        template: __webpack_require__(404)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        marketdate_expense_service_1.MarketdateExpenseService,
        router_1.ActivatedRoute])
], MarketdateExpenseDetailComponent);
exports.MarketdateExpenseDetailComponent = MarketdateExpenseDetailComponent;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_expense_popup_service_1 = __webpack_require__(59);
var marketdate_expense_service_1 = __webpack_require__(23);
var marketdate_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(3);
var MarketdateExpenseDialogComponent = (function () {
    function MarketdateExpenseDialogComponent(activeModal, jhiLanguageService, dataUtils, alertService, marketdateExpenseService, marketdateService, userService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.alertService = alertService;
        this.marketdateExpenseService = marketdateExpenseService;
        this.marketdateService = marketdateService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }
    MarketdateExpenseDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(function (res) { _this.marketdates = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateExpenseDialogComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    MarketdateExpenseDialogComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    MarketdateExpenseDialogComponent.prototype.setFileData = function (event, marketdateExpense, field, isImage) {
        if (event.target.files && event.target.files[0]) {
            var file_1 = event.target.files[0];
            if (isImage && !/^image\//.test(file_1.type)) {
                return;
            }
            this.dataUtils.toBase64(file_1, function (base64Data) {
                marketdateExpense[field] = base64Data;
                marketdateExpense[field + "ContentType"] = file_1.type;
            });
        }
    };
    MarketdateExpenseDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateExpenseDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdateExpense.id !== undefined) {
            this.marketdateExpenseService.update(this.marketdateExpense)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateExpenseService.create(this.marketdateExpense)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateExpenseDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateExpenseListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateExpenseDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateExpenseDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateExpenseDialogComponent.prototype.trackMarketdateById = function (index, item) {
        return item.id;
    };
    MarketdateExpenseDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    return MarketdateExpenseDialogComponent;
}());
MarketdateExpenseDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense-dialog',
        template: __webpack_require__(405)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        ng_jhipster_1.AlertService,
        marketdate_expense_service_1.MarketdateExpenseService,
        marketdate_1.MarketdateService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], MarketdateExpenseDialogComponent);
exports.MarketdateExpenseDialogComponent = MarketdateExpenseDialogComponent;
var MarketdateExpensePopupComponent = (function () {
    function MarketdateExpensePopupComponent(route, marketdateExpensePopupService) {
        this.route = route;
        this.marketdateExpensePopupService = marketdateExpensePopupService;
    }
    MarketdateExpensePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdateExpensePopupService
                    .open(MarketdateExpenseDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdateExpensePopupService
                    .open(MarketdateExpenseDialogComponent);
            }
        });
    };
    MarketdateExpensePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateExpensePopupComponent;
}());
MarketdateExpensePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_expense_popup_service_1.MarketdateExpensePopupService])
], MarketdateExpensePopupComponent);
exports.MarketdateExpensePopupComponent = MarketdateExpensePopupComponent;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_expense_service_1 = __webpack_require__(23);
var shared_1 = __webpack_require__(3);
var MarketdateExpenseComponent = (function () {
    function MarketdateExpenseComponent(jhiLanguageService, marketdateExpenseService, alertService, dataUtils, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateExpenseService = marketdateExpenseService;
        this.alertService = alertService;
        this.dataUtils = dataUtils;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }
    MarketdateExpenseComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateExpenseService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.marketdateExpenses = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateExpenseService.query().subscribe(function (res) {
            _this.marketdateExpenses = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateExpenseComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    MarketdateExpenseComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    MarketdateExpenseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdateExpenses();
    };
    MarketdateExpenseComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateExpenseComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateExpenseComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    MarketdateExpenseComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    MarketdateExpenseComponent.prototype.registerChangeInMarketdateExpenses = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateExpenseListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateExpenseComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateExpenseComponent;
}());
MarketdateExpenseComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-expense',
        template: __webpack_require__(406)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_expense_service_1.MarketdateExpenseService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.DataUtils,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], MarketdateExpenseComponent);
exports.MarketdateExpenseComponent = MarketdateExpenseComponent;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var MarketdateExpense = (function () {
    function MarketdateExpense(id, description, value, expenseType, updated, created, image, marketdate, updatedBy) {
        this.id = id;
        this.description = description;
        this.value = value;
        this.expenseType = expenseType;
        this.updated = updated;
        this.created = created;
        this.image = image;
        this.marketdate = marketdate;
        this.updatedBy = updatedBy;
    }
    return MarketdateExpense;
}());
exports.MarketdateExpense = MarketdateExpense;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_meterreading_popup_service_1 = __webpack_require__(60);
var marketdate_meterreading_service_1 = __webpack_require__(24);
var MarketdateMeterreadingDeleteDialogComponent = (function () {
    function MarketdateMeterreadingDeleteDialogComponent(jhiLanguageService, marketdateMeterreadingService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateMeterreadingService = marketdateMeterreadingService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }
    MarketdateMeterreadingDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateMeterreadingDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateMeterreadingService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateMeterreadingListModification',
                content: 'Deleted an marketdateMeterreading'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateMeterreadingDeleteDialogComponent;
}());
MarketdateMeterreadingDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading-delete-dialog',
        template: __webpack_require__(407)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_meterreading_service_1.MarketdateMeterreadingService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateMeterreadingDeleteDialogComponent);
exports.MarketdateMeterreadingDeleteDialogComponent = MarketdateMeterreadingDeleteDialogComponent;
var MarketdateMeterreadingDeletePopupComponent = (function () {
    function MarketdateMeterreadingDeletePopupComponent(route, marketdateMeterreadingPopupService) {
        this.route = route;
        this.marketdateMeterreadingPopupService = marketdateMeterreadingPopupService;
    }
    MarketdateMeterreadingDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdateMeterreadingPopupService
                .open(MarketdateMeterreadingDeleteDialogComponent, params['id']);
        });
    };
    MarketdateMeterreadingDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateMeterreadingDeletePopupComponent;
}());
MarketdateMeterreadingDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_meterreading_popup_service_1.MarketdateMeterreadingPopupService])
], MarketdateMeterreadingDeletePopupComponent);
exports.MarketdateMeterreadingDeletePopupComponent = MarketdateMeterreadingDeletePopupComponent;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_meterreading_service_1 = __webpack_require__(24);
var MarketdateMeterreadingDetailComponent = (function () {
    function MarketdateMeterreadingDetailComponent(eventManager, jhiLanguageService, marketdateMeterreadingService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateMeterreadingService = marketdateMeterreadingService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }
    MarketdateMeterreadingDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdateMeterreadings();
    };
    MarketdateMeterreadingDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateMeterreadingService.find(id).subscribe(function (marketdateMeterreading) {
            _this.marketdateMeterreading = marketdateMeterreading;
        });
    };
    MarketdateMeterreadingDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateMeterreadingDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateMeterreadingDetailComponent.prototype.registerChangeInMarketdateMeterreadings = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateMeterreadingListModification', function (response) { return _this.load(_this.marketdateMeterreading.id); });
    };
    return MarketdateMeterreadingDetailComponent;
}());
MarketdateMeterreadingDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading-detail',
        template: __webpack_require__(408)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketdate_meterreading_service_1.MarketdateMeterreadingService,
        router_1.ActivatedRoute])
], MarketdateMeterreadingDetailComponent);
exports.MarketdateMeterreadingDetailComponent = MarketdateMeterreadingDetailComponent;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_meterreading_popup_service_1 = __webpack_require__(60);
var marketdate_meterreading_service_1 = __webpack_require__(24);
var marketdate_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(3);
var electricmeter_1 = __webpack_require__(149);
var MarketdateMeterreadingDialogComponent = (function () {
    function MarketdateMeterreadingDialogComponent(activeModal, jhiLanguageService, alertService, marketdateMeterreadingService, marketdateService, userService, electricmeterService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdateMeterreadingService = marketdateMeterreadingService;
        this.marketdateService = marketdateService;
        this.userService = userService;
        this.electricmeterService = electricmeterService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }
    MarketdateMeterreadingDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(function (res) { _this.marketdates = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.electricmeterService.query().subscribe(function (res) { _this.electricmeters = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateMeterreadingDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateMeterreadingDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdateMeterreading.id !== undefined) {
            this.marketdateMeterreadingService.update(this.marketdateMeterreading)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateMeterreadingService.create(this.marketdateMeterreading)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateMeterreadingDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateMeterreadingListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateMeterreadingDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateMeterreadingDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateMeterreadingDialogComponent.prototype.trackMarketdateById = function (index, item) {
        return item.id;
    };
    MarketdateMeterreadingDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    MarketdateMeterreadingDialogComponent.prototype.trackElectricmeterById = function (index, item) {
        return item.id;
    };
    return MarketdateMeterreadingDialogComponent;
}());
MarketdateMeterreadingDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading-dialog',
        template: __webpack_require__(409)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketdate_meterreading_service_1.MarketdateMeterreadingService,
        marketdate_1.MarketdateService,
        shared_1.UserService,
        electricmeter_1.ElectricmeterService,
        ng_jhipster_1.EventManager])
], MarketdateMeterreadingDialogComponent);
exports.MarketdateMeterreadingDialogComponent = MarketdateMeterreadingDialogComponent;
var MarketdateMeterreadingPopupComponent = (function () {
    function MarketdateMeterreadingPopupComponent(route, marketdateMeterreadingPopupService) {
        this.route = route;
        this.marketdateMeterreadingPopupService = marketdateMeterreadingPopupService;
    }
    MarketdateMeterreadingPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdateMeterreadingPopupService
                    .open(MarketdateMeterreadingDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdateMeterreadingPopupService
                    .open(MarketdateMeterreadingDialogComponent);
            }
        });
    };
    MarketdateMeterreadingPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateMeterreadingPopupComponent;
}());
MarketdateMeterreadingPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_meterreading_popup_service_1.MarketdateMeterreadingPopupService])
], MarketdateMeterreadingPopupComponent);
exports.MarketdateMeterreadingPopupComponent = MarketdateMeterreadingPopupComponent;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_meterreading_service_1 = __webpack_require__(24);
var shared_1 = __webpack_require__(3);
var MarketdateMeterreadingComponent = (function () {
    function MarketdateMeterreadingComponent(jhiLanguageService, marketdateMeterreadingService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateMeterreadingService = marketdateMeterreadingService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }
    MarketdateMeterreadingComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateMeterreadingService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.marketdateMeterreadings = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateMeterreadingService.query().subscribe(function (res) {
            _this.marketdateMeterreadings = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateMeterreadingComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    MarketdateMeterreadingComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    MarketdateMeterreadingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdateMeterreadings();
    };
    MarketdateMeterreadingComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateMeterreadingComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateMeterreadingComponent.prototype.registerChangeInMarketdateMeterreadings = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateMeterreadingListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateMeterreadingComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateMeterreadingComponent;
}());
MarketdateMeterreadingComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-meterreading',
        template: __webpack_require__(410)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_meterreading_service_1.MarketdateMeterreadingService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], MarketdateMeterreadingComponent);
exports.MarketdateMeterreadingComponent = MarketdateMeterreadingComponent;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var MarketdateMeterreading = (function () {
    function MarketdateMeterreading(id, value, timestampType, timestamp, updated, created, marketdate, updatedBy, electricmeter) {
        this.id = id;
        this.value = value;
        this.timestampType = timestampType;
        this.timestamp = timestamp;
        this.updated = updated;
        this.created = created;
        this.marketdate = marketdate;
        this.updatedBy = updatedBy;
        this.electricmeter = electricmeter;
    }
    return MarketdateMeterreading;
}());
exports.MarketdateMeterreading = MarketdateMeterreading;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_status_popup_service_1 = __webpack_require__(61);
var marketdate_status_service_1 = __webpack_require__(25);
var MarketdateStatusDeleteDialogComponent = (function () {
    function MarketdateStatusDeleteDialogComponent(jhiLanguageService, marketdateStatusService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateStatusService = marketdateStatusService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }
    MarketdateStatusDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateStatusDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateStatusService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateStatusListModification',
                content: 'Deleted an marketdateStatus'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateStatusDeleteDialogComponent;
}());
MarketdateStatusDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status-delete-dialog',
        template: __webpack_require__(411)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_status_service_1.MarketdateStatusService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateStatusDeleteDialogComponent);
exports.MarketdateStatusDeleteDialogComponent = MarketdateStatusDeleteDialogComponent;
var MarketdateStatusDeletePopupComponent = (function () {
    function MarketdateStatusDeletePopupComponent(route, marketdateStatusPopupService) {
        this.route = route;
        this.marketdateStatusPopupService = marketdateStatusPopupService;
    }
    MarketdateStatusDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdateStatusPopupService
                .open(MarketdateStatusDeleteDialogComponent, params['id']);
        });
    };
    MarketdateStatusDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateStatusDeletePopupComponent;
}());
MarketdateStatusDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_status_popup_service_1.MarketdateStatusPopupService])
], MarketdateStatusDeletePopupComponent);
exports.MarketdateStatusDeletePopupComponent = MarketdateStatusDeletePopupComponent;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_status_service_1 = __webpack_require__(25);
var MarketdateStatusDetailComponent = (function () {
    function MarketdateStatusDetailComponent(eventManager, jhiLanguageService, marketdateStatusService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateStatusService = marketdateStatusService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }
    MarketdateStatusDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdateStatuses();
    };
    MarketdateStatusDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateStatusService.find(id).subscribe(function (marketdateStatus) {
            _this.marketdateStatus = marketdateStatus;
        });
    };
    MarketdateStatusDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateStatusDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateStatusDetailComponent.prototype.registerChangeInMarketdateStatuses = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateStatusListModification', function (response) { return _this.load(_this.marketdateStatus.id); });
    };
    return MarketdateStatusDetailComponent;
}());
MarketdateStatusDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status-detail',
        template: __webpack_require__(412)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketdate_status_service_1.MarketdateStatusService,
        router_1.ActivatedRoute])
], MarketdateStatusDetailComponent);
exports.MarketdateStatusDetailComponent = MarketdateStatusDetailComponent;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_status_popup_service_1 = __webpack_require__(61);
var marketdate_status_service_1 = __webpack_require__(25);
var marketdate_1 = __webpack_require__(26);
var shared_1 = __webpack_require__(3);
var MarketdateStatusDialogComponent = (function () {
    function MarketdateStatusDialogComponent(activeModal, jhiLanguageService, alertService, marketdateStatusService, marketdateService, userService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdateStatusService = marketdateStatusService;
        this.marketdateService = marketdateService;
        this.userService = userService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }
    MarketdateStatusDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(function (res) { _this.marketdates = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) { _this.users = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateStatusDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateStatusDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdateStatus.id !== undefined) {
            this.marketdateStatusService.update(this.marketdateStatus)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateStatusService.create(this.marketdateStatus)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateStatusDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateStatusListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateStatusDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateStatusDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateStatusDialogComponent.prototype.trackMarketdateById = function (index, item) {
        return item.id;
    };
    MarketdateStatusDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    return MarketdateStatusDialogComponent;
}());
MarketdateStatusDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status-dialog',
        template: __webpack_require__(413)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketdate_status_service_1.MarketdateStatusService,
        marketdate_1.MarketdateService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], MarketdateStatusDialogComponent);
exports.MarketdateStatusDialogComponent = MarketdateStatusDialogComponent;
var MarketdateStatusPopupComponent = (function () {
    function MarketdateStatusPopupComponent(route, marketdateStatusPopupService) {
        this.route = route;
        this.marketdateStatusPopupService = marketdateStatusPopupService;
    }
    MarketdateStatusPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdateStatusPopupService
                    .open(MarketdateStatusDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdateStatusPopupService
                    .open(MarketdateStatusDialogComponent);
            }
        });
    };
    MarketdateStatusPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateStatusPopupComponent;
}());
MarketdateStatusPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_status_popup_service_1.MarketdateStatusPopupService])
], MarketdateStatusPopupComponent);
exports.MarketdateStatusPopupComponent = MarketdateStatusPopupComponent;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_status_service_1 = __webpack_require__(25);
var shared_1 = __webpack_require__(3);
var MarketdateStatusComponent = (function () {
    function MarketdateStatusComponent(jhiLanguageService, marketdateStatusService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateStatusService = marketdateStatusService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }
    MarketdateStatusComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateStatusService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.marketdateStatuses = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateStatusService.query().subscribe(function (res) {
            _this.marketdateStatuses = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateStatusComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    MarketdateStatusComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    MarketdateStatusComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdateStatuses();
    };
    MarketdateStatusComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateStatusComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateStatusComponent.prototype.registerChangeInMarketdateStatuses = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateStatusListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateStatusComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateStatusComponent;
}());
MarketdateStatusComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-status',
        template: __webpack_require__(414)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_status_service_1.MarketdateStatusService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], MarketdateStatusComponent);
exports.MarketdateStatusComponent = MarketdateStatusComponent;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var MarketdateStatus = (function () {
    function MarketdateStatus(id, marketdayNumber, status, updated, created, marketdate, updatedBy) {
        this.id = id;
        this.marketdayNumber = marketdayNumber;
        this.status = status;
        this.updated = updated;
        this.created = created;
        this.marketdate = marketdate;
        this.updatedBy = updatedBy;
    }
    return MarketdateStatus;
}());
exports.MarketdateStatus = MarketdateStatus;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_popup_service_1 = __webpack_require__(62);
var marketdate_service_1 = __webpack_require__(27);
var MarketdateDeleteDialogComponent = (function () {
    function MarketdateDeleteDialogComponent(jhiLanguageService, marketdateService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateService = marketdateService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }
    MarketdateDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdateService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdateListModification',
                content: 'Deleted an marketdate'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdateDeleteDialogComponent;
}());
MarketdateDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-delete-dialog',
        template: __webpack_require__(415)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_service_1.MarketdateService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdateDeleteDialogComponent);
exports.MarketdateDeleteDialogComponent = MarketdateDeleteDialogComponent;
var MarketdateDeletePopupComponent = (function () {
    function MarketdateDeletePopupComponent(route, marketdatePopupService) {
        this.route = route;
        this.marketdatePopupService = marketdatePopupService;
    }
    MarketdateDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdatePopupService
                .open(MarketdateDeleteDialogComponent, params['id']);
        });
    };
    MarketdateDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdateDeletePopupComponent;
}());
MarketdateDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_popup_service_1.MarketdatePopupService])
], MarketdateDeletePopupComponent);
exports.MarketdateDeletePopupComponent = MarketdateDeletePopupComponent;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_service_1 = __webpack_require__(27);
var MarketdateDetailComponent = (function () {
    function MarketdateDetailComponent(eventManager, jhiLanguageService, marketdateService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateService = marketdateService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }
    MarketdateDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdates();
    };
    MarketdateDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdateService.find(id).subscribe(function (marketdate) {
            _this.marketdate = marketdate;
        });
    };
    MarketdateDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdateDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateDetailComponent.prototype.registerChangeInMarketdates = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateListModification', function (response) { return _this.load(_this.marketdate.id); });
    };
    return MarketdateDetailComponent;
}());
MarketdateDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-detail',
        template: __webpack_require__(416)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketdate_service_1.MarketdateService,
        router_1.ActivatedRoute])
], MarketdateDetailComponent);
exports.MarketdateDetailComponent = MarketdateDetailComponent;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_popup_service_1 = __webpack_require__(62);
var marketdate_service_1 = __webpack_require__(27);
var marketday_1 = __webpack_require__(32);
var MarketdateDialogComponent = (function () {
    function MarketdateDialogComponent(activeModal, jhiLanguageService, alertService, marketdateService, marketdayService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdateService = marketdateService;
        this.marketdayService = marketdayService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }
    MarketdateDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(function (res) { _this.marketdays = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdateDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketdate.id !== undefined) {
            this.marketdateService.update(this.marketdate)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdateService.create(this.marketdate)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdateDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdateListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdateDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdateDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdateDialogComponent.prototype.trackMarketdayById = function (index, item) {
        return item.id;
    };
    return MarketdateDialogComponent;
}());
MarketdateDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-dialog',
        template: __webpack_require__(417)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketdate_service_1.MarketdateService,
        marketday_1.MarketdayService,
        ng_jhipster_1.EventManager])
], MarketdateDialogComponent);
exports.MarketdateDialogComponent = MarketdateDialogComponent;
var MarketdatePopupComponent = (function () {
    function MarketdatePopupComponent(route, marketdatePopupService) {
        this.route = route;
        this.marketdatePopupService = marketdatePopupService;
    }
    MarketdatePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdatePopupService
                    .open(MarketdateDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdatePopupService
                    .open(MarketdateDialogComponent);
            }
        });
    };
    MarketdatePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdatePopupComponent;
}());
MarketdatePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketdate_popup_service_1.MarketdatePopupService])
], MarketdatePopupComponent);
exports.MarketdatePopupComponent = MarketdatePopupComponent;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_service_1 = __webpack_require__(27);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var MarketdateComponent = (function () {
    function MarketdateComponent(jhiLanguageService, marketdateService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdateService = marketdateService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }
    MarketdateComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdateService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdateService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdateComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    MarketdateComponent.prototype.transition = function () {
        this.router.navigate(['/marketdate'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    MarketdateComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/marketdate', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketdateComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/marketdate', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketdateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdates();
    };
    MarketdateComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdateComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdateComponent.prototype.registerChangeInMarketdates = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdateListModification', function (response) { return _this.loadAll(); });
    };
    MarketdateComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    MarketdateComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.marketdates = data;
    };
    MarketdateComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdateComponent;
}());
MarketdateComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketdate',
        template: __webpack_require__(418)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketdate_service_1.MarketdateService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], MarketdateComponent);
exports.MarketdateComponent = MarketdateComponent;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
var Marketdate = (function () {
    function Marketdate(id, marketdayNumber, originalDate, evasiveDate, holiday, canceled, comment, updated, created, gguid, status, marketday, marketdateBooths, marketdateComments, marketdateExpenses, marketdateMeterreadings, marketdateStatuses) {
        this.id = id;
        this.marketdayNumber = marketdayNumber;
        this.originalDate = originalDate;
        this.evasiveDate = evasiveDate;
        this.holiday = holiday;
        this.canceled = canceled;
        this.comment = comment;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.status = status;
        this.marketday = marketday;
        this.marketdateBooths = marketdateBooths;
        this.marketdateComments = marketdateComments;
        this.marketdateExpenses = marketdateExpenses;
        this.marketdateMeterreadings = marketdateMeterreadings;
        this.marketdateStatuses = marketdateStatuses;
        this.holiday = false;
        this.canceled = false;
    }
    return Marketdate;
}());
exports.Marketdate = Marketdate;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketday_popup_service_1 = __webpack_require__(63);
var marketday_service_1 = __webpack_require__(28);
var MarketdayDeleteDialogComponent = (function () {
    function MarketdayDeleteDialogComponent(jhiLanguageService, marketdayService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketdayService = marketdayService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }
    MarketdayDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdayDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketdayService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketdayListModification',
                content: 'Deleted an marketday'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketdayDeleteDialogComponent;
}());
MarketdayDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday-delete-dialog',
        template: __webpack_require__(419)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketday_service_1.MarketdayService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketdayDeleteDialogComponent);
exports.MarketdayDeleteDialogComponent = MarketdayDeleteDialogComponent;
var MarketdayDeletePopupComponent = (function () {
    function MarketdayDeletePopupComponent(route, marketdayPopupService) {
        this.route = route;
        this.marketdayPopupService = marketdayPopupService;
    }
    MarketdayDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketdayPopupService
                .open(MarketdayDeleteDialogComponent, params['id']);
        });
    };
    MarketdayDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdayDeletePopupComponent;
}());
MarketdayDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketday_popup_service_1.MarketdayPopupService])
], MarketdayDeletePopupComponent);
exports.MarketdayDeletePopupComponent = MarketdayDeletePopupComponent;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketday_service_1 = __webpack_require__(28);
var MarketdayDetailComponent = (function () {
    function MarketdayDetailComponent(eventManager, jhiLanguageService, marketdayService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdayService = marketdayService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }
    MarketdayDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketdays();
    };
    MarketdayDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketdayService.find(id).subscribe(function (marketday) {
            _this.marketday = marketday;
        });
    };
    MarketdayDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketdayDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdayDetailComponent.prototype.registerChangeInMarketdays = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdayListModification', function (response) { return _this.load(_this.marketday.id); });
    };
    return MarketdayDetailComponent;
}());
MarketdayDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday-detail',
        template: __webpack_require__(420)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketday_service_1.MarketdayService,
        router_1.ActivatedRoute])
], MarketdayDetailComponent);
exports.MarketdayDetailComponent = MarketdayDetailComponent;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketday_popup_service_1 = __webpack_require__(63);
var marketday_service_1 = __webpack_require__(28);
var marketplace_1 = __webpack_require__(36);
var contact_1 = __webpack_require__(9);
var branch_1 = __webpack_require__(50);
var MarketdayDialogComponent = (function () {
    function MarketdayDialogComponent(activeModal, jhiLanguageService, alertService, marketdayService, marketplaceService, contactService, branchService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketdayService = marketdayService;
        this.marketplaceService = marketplaceService;
        this.contactService = contactService;
        this.branchService = branchService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }
    MarketdayDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(function (res) { _this.marketplaces = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.branchService.query().subscribe(function (res) { _this.branches = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdayDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketdayDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketday.id !== undefined) {
            this.marketdayService.update(this.marketday)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketdayService.create(this.marketday)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketdayDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketdayListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketdayDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketdayDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketdayDialogComponent.prototype.trackMarketplaceById = function (index, item) {
        return item.id;
    };
    MarketdayDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    MarketdayDialogComponent.prototype.trackBranchById = function (index, item) {
        return item.id;
    };
    return MarketdayDialogComponent;
}());
MarketdayDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday-dialog',
        template: __webpack_require__(421)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketday_service_1.MarketdayService,
        marketplace_1.MarketplaceService,
        contact_1.ContactService,
        branch_1.BranchService,
        ng_jhipster_1.EventManager])
], MarketdayDialogComponent);
exports.MarketdayDialogComponent = MarketdayDialogComponent;
var MarketdayPopupComponent = (function () {
    function MarketdayPopupComponent(route, marketdayPopupService) {
        this.route = route;
        this.marketdayPopupService = marketdayPopupService;
    }
    MarketdayPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketdayPopupService
                    .open(MarketdayDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketdayPopupService
                    .open(MarketdayDialogComponent);
            }
        });
    };
    MarketdayPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketdayPopupComponent;
}());
MarketdayPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketday_popup_service_1.MarketdayPopupService])
], MarketdayPopupComponent);
exports.MarketdayPopupComponent = MarketdayPopupComponent;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketday_service_1 = __webpack_require__(28);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var MarketdayComponent = (function () {
    function MarketdayComponent(jhiLanguageService, marketdayService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.marketdayService = marketdayService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }
    MarketdayComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketdayService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketdayService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    MarketdayComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    MarketdayComponent.prototype.transition = function () {
        this.router.navigate(['/marketday'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    MarketdayComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/marketday', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketdayComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/marketday', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketdayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketdays();
    };
    MarketdayComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketdayComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketdayComponent.prototype.registerChangeInMarketdays = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketdayListModification', function (response) { return _this.loadAll(); });
    };
    MarketdayComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    MarketdayComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.marketdays = data;
    };
    MarketdayComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketdayComponent;
}());
MarketdayComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketday',
        template: __webpack_require__(422)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketday_service_1.MarketdayService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], MarketdayComponent);
exports.MarketdayComponent = MarketdayComponent;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
;
var Marketday = (function () {
    function Marketday(id, marketdayNumber, active, name, keyword, marketType, assortment, vatType, unit, classification, onHolidayString, onHoliday, dayString, day, startTime, endTime, buildingStartTime, dismantlingEndTime, startTimeWinter, endTimeWinter, buildingStartTimeWinter, dismantlingEndTimeWinter, marketplaceNumber, branchString, updated, created, gguid, marketplace, marketMaster1, marketMaster2, marketMaster3, branch) {
        this.id = id;
        this.marketdayNumber = marketdayNumber;
        this.active = active;
        this.name = name;
        this.keyword = keyword;
        this.marketType = marketType;
        this.assortment = assortment;
        this.vatType = vatType;
        this.unit = unit;
        this.classification = classification;
        this.onHolidayString = onHolidayString;
        this.onHoliday = onHoliday;
        this.dayString = dayString;
        this.day = day;
        this.startTime = startTime;
        this.endTime = endTime;
        this.buildingStartTime = buildingStartTime;
        this.dismantlingEndTime = dismantlingEndTime;
        this.startTimeWinter = startTimeWinter;
        this.endTimeWinter = endTimeWinter;
        this.buildingStartTimeWinter = buildingStartTimeWinter;
        this.dismantlingEndTimeWinter = dismantlingEndTimeWinter;
        this.marketplaceNumber = marketplaceNumber;
        this.branchString = branchString;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.marketplace = marketplace;
        this.marketMaster1 = marketMaster1;
        this.marketMaster2 = marketMaster2;
        this.marketMaster3 = marketMaster3;
        this.branch = branch;
        this.active = false;
    }
    return Marketday;
}());
exports.Marketday = Marketday;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketplace_popup_service_1 = __webpack_require__(64);
var marketplace_service_1 = __webpack_require__(29);
var MarketplaceDeleteDialogComponent = (function () {
    function MarketplaceDeleteDialogComponent(jhiLanguageService, marketplaceService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.marketplaceService = marketplaceService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketplace']);
    }
    MarketplaceDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketplaceDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.marketplaceService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'marketplaceListModification',
                content: 'Deleted an marketplace'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return MarketplaceDeleteDialogComponent;
}());
MarketplaceDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace-delete-dialog',
        template: __webpack_require__(423)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketplace_service_1.MarketplaceService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], MarketplaceDeleteDialogComponent);
exports.MarketplaceDeleteDialogComponent = MarketplaceDeleteDialogComponent;
var MarketplaceDeletePopupComponent = (function () {
    function MarketplaceDeletePopupComponent(route, marketplacePopupService) {
        this.route = route;
        this.marketplacePopupService = marketplacePopupService;
    }
    MarketplaceDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.marketplacePopupService
                .open(MarketplaceDeleteDialogComponent, params['id']);
        });
    };
    MarketplaceDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketplaceDeletePopupComponent;
}());
MarketplaceDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketplace_popup_service_1.MarketplacePopupService])
], MarketplaceDeletePopupComponent);
exports.MarketplaceDeletePopupComponent = MarketplaceDeletePopupComponent;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketplace_service_1 = __webpack_require__(29);
var MarketplaceDetailComponent = (function () {
    function MarketplaceDetailComponent(eventManager, jhiLanguageService, marketplaceService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.marketplaceService = marketplaceService;
        this.route = route;
        this.jhiLanguageService.setLocations(['marketplace']);
    }
    MarketplaceDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInMarketplaces();
    };
    MarketplaceDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.marketplaceService.find(id).subscribe(function (marketplace) {
            _this.marketplace = marketplace;
        });
    };
    MarketplaceDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    MarketplaceDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketplaceDetailComponent.prototype.registerChangeInMarketplaces = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketplaceListModification', function (response) { return _this.load(_this.marketplace.id); });
    };
    return MarketplaceDetailComponent;
}());
MarketplaceDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace-detail',
        template: __webpack_require__(424)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        marketplace_service_1.MarketplaceService,
        router_1.ActivatedRoute])
], MarketplaceDetailComponent);
exports.MarketplaceDetailComponent = MarketplaceDetailComponent;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var marketplace_popup_service_1 = __webpack_require__(64);
var marketplace_service_1 = __webpack_require__(29);
var branch_1 = __webpack_require__(50);
var MarketplaceDialogComponent = (function () {
    function MarketplaceDialogComponent(activeModal, jhiLanguageService, alertService, marketplaceService, branchService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.marketplaceService = marketplaceService;
        this.branchService = branchService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['marketplace']);
    }
    MarketplaceDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.branchService.query().subscribe(function (res) { _this.branches = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    MarketplaceDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    MarketplaceDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.marketplace.id !== undefined) {
            this.marketplaceService.update(this.marketplace)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.marketplaceService.create(this.marketplace)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    MarketplaceDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'marketplaceListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    MarketplaceDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    MarketplaceDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    MarketplaceDialogComponent.prototype.trackBranchById = function (index, item) {
        return item.id;
    };
    return MarketplaceDialogComponent;
}());
MarketplaceDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace-dialog',
        template: __webpack_require__(425)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        marketplace_service_1.MarketplaceService,
        branch_1.BranchService,
        ng_jhipster_1.EventManager])
], MarketplaceDialogComponent);
exports.MarketplaceDialogComponent = MarketplaceDialogComponent;
var MarketplacePopupComponent = (function () {
    function MarketplacePopupComponent(route, marketplacePopupService) {
        this.route = route;
        this.marketplacePopupService = marketplacePopupService;
    }
    MarketplacePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.marketplacePopupService
                    .open(MarketplaceDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.marketplacePopupService
                    .open(MarketplaceDialogComponent);
            }
        });
    };
    MarketplacePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return MarketplacePopupComponent;
}());
MarketplacePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        marketplace_popup_service_1.MarketplacePopupService])
], MarketplacePopupComponent);
exports.MarketplacePopupComponent = MarketplacePopupComponent;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var marketplace_service_1 = __webpack_require__(29);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var MarketplaceComponent = (function () {
    function MarketplaceComponent(jhiLanguageService, marketplaceService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.marketplaceService = marketplaceService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketplace']);
    }
    MarketplaceComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.marketplaceService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.marketplaceService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    MarketplaceComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    MarketplaceComponent.prototype.transition = function () {
        this.router.navigate(['/marketplace'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    MarketplaceComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/marketplace', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketplaceComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/marketplace', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    MarketplaceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInMarketplaces();
    };
    MarketplaceComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    MarketplaceComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    MarketplaceComponent.prototype.registerChangeInMarketplaces = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('marketplaceListModification', function (response) { return _this.loadAll(); });
    };
    MarketplaceComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    MarketplaceComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.marketplaces = data;
    };
    MarketplaceComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return MarketplaceComponent;
}());
MarketplaceComponent = __decorate([
    core_1.Component({
        selector: 'jhi-marketplace',
        template: __webpack_require__(426)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        marketplace_service_1.MarketplaceService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], MarketplaceComponent);
exports.MarketplaceComponent = MarketplaceComponent;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Marketplace = (function () {
    function Marketplace(id, marketplaceNumber, name, keyword, description, particularities, street, zipcode, city, place, placeDescription, alternativePlace, sanitaryLocation, latitude, longitude, branchString, updated, created, gguid, branch, electricmeters, additionalflats) {
        this.id = id;
        this.marketplaceNumber = marketplaceNumber;
        this.name = name;
        this.keyword = keyword;
        this.description = description;
        this.particularities = particularities;
        this.street = street;
        this.zipcode = zipcode;
        this.city = city;
        this.place = place;
        this.placeDescription = placeDescription;
        this.alternativePlace = alternativePlace;
        this.sanitaryLocation = sanitaryLocation;
        this.latitude = latitude;
        this.longitude = longitude;
        this.branchString = branchString;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.branch = branch;
        this.electricmeters = electricmeters;
        this.additionalflats = additionalflats;
    }
    return Marketplace;
}());
exports.Marketplace = Marketplace;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var salesunit_popup_service_1 = __webpack_require__(65);
var salesunit_service_1 = __webpack_require__(30);
var SalesunitDeleteDialogComponent = (function () {
    function SalesunitDeleteDialogComponent(jhiLanguageService, salesunitService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.salesunitService = salesunitService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['salesunit']);
    }
    SalesunitDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    SalesunitDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.salesunitService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'salesunitListModification',
                content: 'Deleted an salesunit'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return SalesunitDeleteDialogComponent;
}());
SalesunitDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit-delete-dialog',
        template: __webpack_require__(427)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        salesunit_service_1.SalesunitService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], SalesunitDeleteDialogComponent);
exports.SalesunitDeleteDialogComponent = SalesunitDeleteDialogComponent;
var SalesunitDeletePopupComponent = (function () {
    function SalesunitDeletePopupComponent(route, salesunitPopupService) {
        this.route = route;
        this.salesunitPopupService = salesunitPopupService;
    }
    SalesunitDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.salesunitPopupService
                .open(SalesunitDeleteDialogComponent, params['id']);
        });
    };
    SalesunitDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return SalesunitDeletePopupComponent;
}());
SalesunitDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        salesunit_popup_service_1.SalesunitPopupService])
], SalesunitDeletePopupComponent);
exports.SalesunitDeletePopupComponent = SalesunitDeletePopupComponent;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var salesunit_service_1 = __webpack_require__(30);
var SalesunitDetailComponent = (function () {
    function SalesunitDetailComponent(eventManager, jhiLanguageService, salesunitService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.salesunitService = salesunitService;
        this.route = route;
        this.jhiLanguageService.setLocations(['salesunit']);
    }
    SalesunitDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInSalesunits();
    };
    SalesunitDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.salesunitService.find(id).subscribe(function (salesunit) {
            _this.salesunit = salesunit;
        });
    };
    SalesunitDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    SalesunitDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    SalesunitDetailComponent.prototype.registerChangeInSalesunits = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('salesunitListModification', function (response) { return _this.load(_this.salesunit.id); });
    };
    return SalesunitDetailComponent;
}());
SalesunitDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit-detail',
        template: __webpack_require__(428)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        salesunit_service_1.SalesunitService,
        router_1.ActivatedRoute])
], SalesunitDetailComponent);
exports.SalesunitDetailComponent = SalesunitDetailComponent;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var salesunit_popup_service_1 = __webpack_require__(65);
var salesunit_service_1 = __webpack_require__(30);
var contact_1 = __webpack_require__(9);
var SalesunitDialogComponent = (function () {
    function SalesunitDialogComponent(activeModal, jhiLanguageService, alertService, salesunitService, contactService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.salesunitService = salesunitService;
        this.contactService = contactService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['salesunit']);
    }
    SalesunitDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    SalesunitDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    SalesunitDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.salesunit.id !== undefined) {
            this.salesunitService.update(this.salesunit)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.salesunitService.create(this.salesunit)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    SalesunitDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'salesunitListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    SalesunitDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    SalesunitDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    SalesunitDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    return SalesunitDialogComponent;
}());
SalesunitDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit-dialog',
        template: __webpack_require__(429)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        salesunit_service_1.SalesunitService,
        contact_1.ContactService,
        ng_jhipster_1.EventManager])
], SalesunitDialogComponent);
exports.SalesunitDialogComponent = SalesunitDialogComponent;
var SalesunitPopupComponent = (function () {
    function SalesunitPopupComponent(route, salesunitPopupService) {
        this.route = route;
        this.salesunitPopupService = salesunitPopupService;
    }
    SalesunitPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.salesunitPopupService
                    .open(SalesunitDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.salesunitPopupService
                    .open(SalesunitDialogComponent);
            }
        });
    };
    SalesunitPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return SalesunitPopupComponent;
}());
SalesunitPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        salesunit_popup_service_1.SalesunitPopupService])
], SalesunitPopupComponent);
exports.SalesunitPopupComponent = SalesunitPopupComponent;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var salesunit_service_1 = __webpack_require__(30);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(8);
var SalesunitComponent = (function () {
    function SalesunitComponent(jhiLanguageService, salesunitService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.salesunitService = salesunitService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['salesunit']);
    }
    SalesunitComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.salesunitService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.salesunitService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    SalesunitComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    SalesunitComponent.prototype.transition = function () {
        this.router.navigate(['/salesunit'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    SalesunitComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/salesunit', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    SalesunitComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/salesunit', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    SalesunitComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInSalesunits();
    };
    SalesunitComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    SalesunitComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    SalesunitComponent.prototype.registerChangeInSalesunits = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('salesunitListModification', function (response) { return _this.loadAll(); });
    };
    SalesunitComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    SalesunitComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.salesunits = data;
    };
    SalesunitComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return SalesunitComponent;
}());
SalesunitComponent = __decorate([
    core_1.Component({
        selector: 'jhi-salesunit',
        template: __webpack_require__(430)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        salesunit_service_1.SalesunitService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], SalesunitComponent);
exports.SalesunitComponent = SalesunitComponent;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Salesunit = (function () {
    function Salesunit(id, name, salesunitNumber, boothType, boothWidth, boothDepth, boothSize, energyType, identification, assortment, assortmentAdditional, assortmentExtended, assortmentExtendedAdditional, contactFirstname, contactLastname, contactMobile, boothWidthWinter, boothDepthWinter, boothSizeWinter, energyTypeWinter, winterStart, winterEnd, merchantNumber, merchantGguid, updated, created, gguid, merchant) {
        this.id = id;
        this.name = name;
        this.salesunitNumber = salesunitNumber;
        this.boothType = boothType;
        this.boothWidth = boothWidth;
        this.boothDepth = boothDepth;
        this.boothSize = boothSize;
        this.energyType = energyType;
        this.identification = identification;
        this.assortment = assortment;
        this.assortmentAdditional = assortmentAdditional;
        this.assortmentExtended = assortmentExtended;
        this.assortmentExtendedAdditional = assortmentExtendedAdditional;
        this.contactFirstname = contactFirstname;
        this.contactLastname = contactLastname;
        this.contactMobile = contactMobile;
        this.boothWidthWinter = boothWidthWinter;
        this.boothDepthWinter = boothDepthWinter;
        this.boothSizeWinter = boothSizeWinter;
        this.energyTypeWinter = energyTypeWinter;
        this.winterStart = winterStart;
        this.winterEnd = winterEnd;
        this.merchantNumber = merchantNumber;
        this.merchantGguid = merchantGguid;
        this.updated = updated;
        this.created = created;
        this.gguid = gguid;
        this.merchant = merchant;
    }
    return Salesunit;
}());
exports.Salesunit = Salesunit;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var testentity_popup_service_1 = __webpack_require__(66);
var testentity_service_1 = __webpack_require__(31);
var TestentityDeleteDialogComponent = (function () {
    function TestentityDeleteDialogComponent(jhiLanguageService, testentityService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.testentityService = testentityService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['testentity']);
    }
    TestentityDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    TestentityDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.testentityService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'testentityListModification',
                content: 'Deleted an testentity'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return TestentityDeleteDialogComponent;
}());
TestentityDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity-delete-dialog',
        template: __webpack_require__(431)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        testentity_service_1.TestentityService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], TestentityDeleteDialogComponent);
exports.TestentityDeleteDialogComponent = TestentityDeleteDialogComponent;
var TestentityDeletePopupComponent = (function () {
    function TestentityDeletePopupComponent(route, testentityPopupService) {
        this.route = route;
        this.testentityPopupService = testentityPopupService;
    }
    TestentityDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.testentityPopupService
                .open(TestentityDeleteDialogComponent, params['id']);
        });
    };
    TestentityDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return TestentityDeletePopupComponent;
}());
TestentityDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        testentity_popup_service_1.TestentityPopupService])
], TestentityDeletePopupComponent);
exports.TestentityDeletePopupComponent = TestentityDeletePopupComponent;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var testentity_service_1 = __webpack_require__(31);
var TestentityDetailComponent = (function () {
    function TestentityDetailComponent(eventManager, jhiLanguageService, testentityService, route) {
        this.eventManager = eventManager;
        this.jhiLanguageService = jhiLanguageService;
        this.testentityService = testentityService;
        this.route = route;
        this.jhiLanguageService.setLocations(['testentity']);
    }
    TestentityDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInTestentities();
    };
    TestentityDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.testentityService.find(id).subscribe(function (testentity) {
            _this.testentity = testentity;
        });
    };
    TestentityDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    TestentityDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    TestentityDetailComponent.prototype.registerChangeInTestentities = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('testentityListModification', function (response) { return _this.load(_this.testentity.id); });
    };
    return TestentityDetailComponent;
}());
TestentityDetailComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity-detail',
        template: __webpack_require__(432)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        testentity_service_1.TestentityService,
        router_1.ActivatedRoute])
], TestentityDetailComponent);
exports.TestentityDetailComponent = TestentityDetailComponent;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var testentity_popup_service_1 = __webpack_require__(66);
var testentity_service_1 = __webpack_require__(31);
var contact_1 = __webpack_require__(9);
var TestentityDialogComponent = (function () {
    function TestentityDialogComponent(activeModal, jhiLanguageService, alertService, testentityService, contactService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.testentityService = testentityService;
        this.contactService = contactService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['testentity']);
    }
    TestentityDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(function (res) { _this.contacts = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    TestentityDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    TestentityDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.testentity.id !== undefined) {
            this.testentityService.update(this.testentity)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
        else {
            this.testentityService.create(this.testentity)
                .subscribe(function (res) {
                return _this.onSaveSuccess(res);
            }, function (res) { return _this.onSaveError(res); });
        }
    };
    TestentityDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'testentityListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    TestentityDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    TestentityDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    TestentityDialogComponent.prototype.trackContactById = function (index, item) {
        return item.id;
    };
    return TestentityDialogComponent;
}());
TestentityDialogComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity-dialog',
        template: __webpack_require__(433)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        testentity_service_1.TestentityService,
        contact_1.ContactService,
        ng_jhipster_1.EventManager])
], TestentityDialogComponent);
exports.TestentityDialogComponent = TestentityDialogComponent;
var TestentityPopupComponent = (function () {
    function TestentityPopupComponent(route, testentityPopupService) {
        this.route = route;
        this.testentityPopupService = testentityPopupService;
    }
    TestentityPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.testentityPopupService
                    .open(TestentityDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.testentityPopupService
                    .open(TestentityDialogComponent);
            }
        });
    };
    TestentityPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return TestentityPopupComponent;
}());
TestentityPopupComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        testentity_popup_service_1.TestentityPopupService])
], TestentityPopupComponent);
exports.TestentityPopupComponent = TestentityPopupComponent;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var testentity_service_1 = __webpack_require__(31);
var shared_1 = __webpack_require__(3);
var TestentityComponent = (function () {
    function TestentityComponent(jhiLanguageService, testentityService, alertService, eventManager, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.testentityService = testentityService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['testentity']);
    }
    TestentityComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.testentityService.search({
                query: this.currentSearch,
            }).subscribe(function (res) { return _this.testentities = res.json(); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.testentityService.query().subscribe(function (res) {
            _this.testentities = res.json();
            _this.currentSearch = '';
        }, function (res) { return _this.onError(res.json()); });
    };
    TestentityComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    };
    TestentityComponent.prototype.clear = function () {
        this.currentSearch = '';
        this.loadAll();
    };
    TestentityComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInTestentities();
    };
    TestentityComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    TestentityComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    TestentityComponent.prototype.registerChangeInTestentities = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('testentityListModification', function (response) { return _this.loadAll(); });
    };
    TestentityComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return TestentityComponent;
}());
TestentityComponent = __decorate([
    core_1.Component({
        selector: 'jhi-testentity',
        template: __webpack_require__(434)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        testentity_service_1.TestentityService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute,
        shared_1.Principal])
], TestentityComponent);
exports.TestentityComponent = TestentityComponent;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Testentity = (function () {
    function Testentity(id, name, description, myNumber, myZonedDateTime, myLocalDate, contact) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.myNumber = myNumber;
        this.myZonedDateTime = myZonedDateTime;
        this.myLocalDate = myLocalDate;
        this.contact = contact;
    }
    return Testentity;
}());
exports.Testentity = Testentity;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(206);
var MarketmanagerHomeModule = (function () {
    function MarketmanagerHomeModule() {
    }
    return MarketmanagerHomeModule;
}());
MarketmanagerHomeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot([_1.HOME_ROUTE], { useHash: true })
        ],
        declarations: [
            _1.HomeComponent,
        ],
        entryComponents: [],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerHomeModule);
exports.MarketmanagerHomeModule = MarketmanagerHomeModule;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(306));
__export(__webpack_require__(307));
__export(__webpack_require__(205));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ErrorComponent = (function () {
    function ErrorComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['error']);
    }
    ErrorComponent.prototype.ngOnInit = function () {
    };
    return ErrorComponent;
}());
ErrorComponent = __decorate([
    core_1.Component({
        selector: 'jhi-error',
        template: __webpack_require__(436)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], ErrorComponent);
exports.ErrorComponent = ErrorComponent;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProfileInfo = (function () {
    function ProfileInfo() {
    }
    return ProfileInfo;
}());
exports.ProfileInfo = ProfileInfo;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var AccountService = (function () {
    function AccountService(http) {
        this.http = http;
    }
    AccountService.prototype.get = function () {
        return this.http.get('api/account').map(function (res) { return res.json(); });
    };
    AccountService.prototype.save = function (account) {
        return this.http.post('api/account', account);
    };
    return AccountService;
}());
AccountService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AccountService);
exports.AccountService = AccountService;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var login_modal_service_1 = __webpack_require__(69);
var principal_service_1 = __webpack_require__(33);
var state_storage_service_1 = __webpack_require__(40);
var AuthService = (function () {
    function AuthService(principal, stateStorageService, loginModalService, router) {
        this.principal = principal;
        this.stateStorageService = stateStorageService;
        this.loginModalService = loginModalService;
        this.router = router;
    }
    AuthService.prototype.authorize = function (force) {
        var authReturn = this.principal.identity(force).then(authThen.bind(this));
        return authReturn;
        function authThen() {
            var _this = this;
            var isAuthenticated = this.principal.isAuthenticated();
            var toStateInfo = this.stateStorageService.getDestinationState().destination;
            // an authenticated user can't access to login and register pages
            if (isAuthenticated && (toStateInfo.name === 'register')) {
                this.router.navigate(['']);
                return false;
            }
            // recover and clear previousState after external login redirect (e.g. oauth2)
            var fromStateInfo = this.stateStorageService.getDestinationState().from;
            var previousState = this.stateStorageService.getPreviousState();
            if (isAuthenticated && !fromStateInfo.name && previousState) {
                this.stateStorageService.resetPreviousState();
                this.router.navigate([previousState.name], { queryParams: previousState.params });
                return false;
            }
            if (toStateInfo.data.authorities && toStateInfo.data.authorities.length > 0) {
                return this.principal.hasAnyAuthority(toStateInfo.data.authorities).then(function (hasAnyAuthority) {
                    if (!hasAnyAuthority) {
                        if (isAuthenticated) {
                            // user is signed in but not authorized for desired state
                            _this.router.navigate(['accessdenied']);
                        }
                        else {
                            // user is not authenticated. Show the state they wanted before you
                            // send them to the login service, so you can return them when you're done
                            var toStateParamsInfo = _this.stateStorageService.getDestinationState().params;
                            _this.stateStorageService.storePreviousState(toStateInfo.name, toStateParamsInfo);
                            // now, send them to the signin state so they can log in
                            _this.router.navigate(['accessdenied']).then(function () {
                                _this.loginModalService.open();
                            });
                        }
                    }
                    return hasAnyAuthority;
                });
            }
            return true;
        }
    };
    return AuthService;
}());
AuthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [principal_service_1.Principal,
        state_storage_service_1.StateStorageService,
        login_modal_service_1.LoginModalService,
        router_1.Router])
], AuthService);
exports.AuthService = AuthService;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(448);
var CSRFService = (function () {
    function CSRFService(cookieService) {
        this.cookieService = cookieService;
    }
    CSRFService.prototype.getCSRF = function (name) {
        name = "" + (name ? name : 'XSRF-TOKEN');
        return this.cookieService.get(name);
    };
    return CSRFService;
}());
CSRFService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [core_2.CookieService])
], CSRFService);
exports.CSRFService = CSRFService;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/*
    Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    They are written in English to avoid character encoding issues (not a perfect solution)
*/
exports.LANGUAGES = [
    'de',
    'en'
    // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
];


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var login_service_1 = __webpack_require__(214);
var state_storage_service_1 = __webpack_require__(40);
var JhiLoginModalComponent = (function () {
    function JhiLoginModalComponent(eventManager, languageService, loginService, stateStorageService, elementRef, renderer, router, activeModal) {
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.loginService = loginService;
        this.stateStorageService = stateStorageService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.router = router;
        this.activeModal = activeModal;
        this.credentials = {};
    }
    JhiLoginModalComponent.prototype.ngOnInit = function () {
        this.languageService.addLocation('login');
    };
    JhiLoginModalComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
    };
    JhiLoginModalComponent.prototype.cancel = function () {
        this.credentials = {
            username: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
        this.activeModal.dismiss('cancel');
    };
    JhiLoginModalComponent.prototype.login = function () {
        var _this = this;
        this.loginService.login({
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(function () {
            _this.authenticationError = false;
            _this.activeModal.dismiss('login success');
            if (_this.router.url === '/register' || (/activate/.test(_this.router.url)) ||
                _this.router.url === '/finishReset' || _this.router.url === '/requestReset') {
                _this.router.navigate(['']);
            }
            _this.eventManager.broadcast({
                name: 'authenticationSuccess',
                content: 'Sending Authentication Success'
            });
            // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // // since login is succesful, go to stored previousState and clear previousState
            var redirect = _this.stateStorageService.getUrl();
            if (redirect) {
                _this.router.navigate([redirect]);
            }
        }).catch(function () {
            _this.authenticationError = true;
        });
    };
    JhiLoginModalComponent.prototype.register = function () {
        this.activeModal.dismiss('to state register');
        this.router.navigate(['/register']);
    };
    JhiLoginModalComponent.prototype.requestResetPassword = function () {
        this.activeModal.dismiss('to state requestReset');
        this.router.navigate(['/reset', 'request']);
    };
    return JhiLoginModalComponent;
}());
JhiLoginModalComponent = __decorate([
    core_1.Component({
        selector: 'jhi-login-modal',
        template: __webpack_require__(440)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        login_service_1.LoginService,
        state_storage_service_1.StateStorageService,
        core_1.ElementRef,
        core_1.Renderer,
        router_1.Router,
        ng_bootstrap_1.NgbActiveModal])
], JhiLoginModalComponent);
exports.JhiLoginModalComponent = JhiLoginModalComponent;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var principal_service_1 = __webpack_require__(33);
var auth_oauth2_service_1 = __webpack_require__(39);
var tracker_service_1 = __webpack_require__(41);
var LoginService = (function () {
    function LoginService(languageService, principal, trackerService, authServerProvider) {
        this.languageService = languageService;
        this.principal = principal;
        this.trackerService = trackerService;
        this.authServerProvider = authServerProvider;
    }
    LoginService.prototype.login = function (credentials, callback) {
        var _this = this;
        var cb = callback || function () { };
        return new Promise(function (resolve, reject) {
            _this.authServerProvider.login(credentials).subscribe(function (data) {
                _this.principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        _this.languageService.changeLanguage(account.langKey);
                    }
                    _this.trackerService.sendActivity();
                    resolve(data);
                });
                return cb();
            }, function (err) {
                _this.logout();
                reject(err);
                return cb(err);
            });
        });
    };
    LoginService.prototype.logout = function () {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
    };
    return LoginService;
}());
LoginService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        principal_service_1.Principal,
        tracker_service_1.JhiTrackerService,
        auth_oauth2_service_1.AuthServerProvider])
], LoginService);
exports.LoginService = LoginService;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
function _window() {
    // return the global native browser window object
    return window;
}
var WindowRef = (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    return WindowRef;
}());
WindowRef = __decorate([
    core_1.Injectable()
], WindowRef);
exports.WindowRef = WindowRef;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(102);

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(452);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(71);
var ng2_webstorage_1 = __webpack_require__(42);
var shared_1 = __webpack_require__(3);
var home_module_1 = __webpack_require__(205);
var admin_module_1 = __webpack_require__(10);
var account_module_1 = __webpack_require__(226);
var entity_module_1 = __webpack_require__(279);
var layouts_1 = __webpack_require__(38);
var http_provider_1 = __webpack_require__(251);
var uib_pagination_config_1 = __webpack_require__(8);
var layouts_2 = __webpack_require__(38);
var MarketmanagerAppModule = (function () {
    function MarketmanagerAppModule() {
    }
    return MarketmanagerAppModule;
}());
MarketmanagerAppModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            layouts_1.LayoutRoutingModule,
            ng2_webstorage_1.Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
            shared_1.MarketmanagerSharedModule,
            home_module_1.MarketmanagerHomeModule,
            admin_module_1.MarketmanagerAdminModule,
            account_module_1.MarketmanagerAccountModule,
            entity_module_1.MarketmanagerEntityModule
        ],
        declarations: [
            layouts_2.JhiMainComponent,
            layouts_2.NavbarComponent,
            layouts_2.ErrorComponent,
            layouts_2.PageRibbonComponent,
            layouts_2.ActiveMenuDirective,
            layouts_2.FooterComponent
        ],
        providers: [
            layouts_2.ProfileService,
            http_provider_1.customHttpProvider(),
            uib_pagination_config_1.PaginationConfig,
            shared_1.UserRouteAccessService
        ],
        bootstrap: [layouts_2.JhiMainComponent]
    })
], MarketmanagerAppModule);
exports.MarketmanagerAppModule = MarketmanagerAppModule;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var app_constants_1 = __webpack_require__(72);
function ProdConfig() {
    // disable debug data on prod profile to improve performance
    if (!app_constants_1.DEBUG_INFO_ENABLED) {
        core_1.enableProdMode();
    }
}
exports.ProdConfig = ProdConfig;


/***/ }),
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(232);

/***/ }),
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(75);
var MarketmanagerAccountModule = (function () {
    function MarketmanagerAccountModule() {
    }
    return MarketmanagerAccountModule;
}());
MarketmanagerAccountModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(_1.accountState, { useHash: true })
        ],
        declarations: [
            _1.ActivateComponent,
            _1.RegisterComponent,
            _1.PasswordComponent,
            _1.PasswordStrengthBarComponent,
            _1.PasswordResetInitComponent,
            _1.PasswordResetFinishComponent,
            _1.SettingsComponent
        ],
        providers: [
            _1.Register,
            _1.Activate,
            _1.Password,
            _1.PasswordResetInit,
            _1.PasswordResetFinish
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerAccountModule);
exports.MarketmanagerAccountModule = MarketmanagerAccountModule;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(75);
var ACCOUNT_ROUTES = [
    _1.activateRoute,
    _1.passwordRoute,
    _1.passwordResetFinishRoute,
    _1.passwordResetInitRoute,
    _1.registerRoute,
    _1.settingsRoute
];
exports.accountState = [{
        path: '',
        children: ACCOUNT_ROUTES
    }];


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var activate_component_1 = __webpack_require__(73);
exports.activateRoute = {
    path: 'activate',
    component: activate_component_1.ActivateComponent,
    data: {
        authorities: [],
        pageTitle: 'activate.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var password_reset_finish_component_1 = __webpack_require__(76);
exports.passwordResetFinishRoute = {
    path: 'reset/finish',
    component: password_reset_finish_component_1.PasswordResetFinishComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var password_reset_init_component_1 = __webpack_require__(78);
exports.passwordResetInitRoute = {
    path: 'reset/request',
    component: password_reset_init_component_1.PasswordResetInitComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var PasswordStrengthBarComponent = (function () {
    function PasswordStrengthBarComponent(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];
    }
    PasswordStrengthBarComponent.prototype.measureStrength = function (p) {
        var force = 0;
        var regex = /[$-/:-?{-~!"^_`\[\]]/g; // "
        var lowerLetters = /[a-z]+/.test(p);
        var upperLetters = /[A-Z]+/.test(p);
        var numbers = /[0-9]+/.test(p);
        var symbols = regex.test(p);
        var flags = [lowerLetters, upperLetters, numbers, symbols];
        var passedMatches = flags.filter(function (isMatchedFlag) {
            return isMatchedFlag === true;
        }).length;
        force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
        force += passedMatches * 10;
        // penality (short password)
        force = (p.length <= 6) ? Math.min(force, 10) : force;
        // penality (poor variety of characters)
        force = (passedMatches === 1) ? Math.min(force, 10) : force;
        force = (passedMatches === 2) ? Math.min(force, 20) : force;
        force = (passedMatches === 3) ? Math.min(force, 40) : force;
        return force;
    };
    ;
    PasswordStrengthBarComponent.prototype.getColor = function (s) {
        var idx = 0;
        if (s <= 10) {
            idx = 0;
        }
        else if (s <= 20) {
            idx = 1;
        }
        else if (s <= 30) {
            idx = 2;
        }
        else if (s <= 40) {
            idx = 3;
        }
        else {
            idx = 4;
        }
        return { idx: idx + 1, col: this.colors[idx] };
    };
    ;
    Object.defineProperty(PasswordStrengthBarComponent.prototype, "passwordToCheck", {
        set: function (password) {
            if (password) {
                var c = this.getColor(this.measureStrength(password));
                var element = this.elementRef.nativeElement;
                if (element.className) {
                    this.renderer.setElementClass(element, element.className, false);
                }
                var lis = element.getElementsByTagName('li');
                for (var i = 0; i < lis.length; i++) {
                    if (i < c.idx) {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', c.col);
                    }
                    else {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', '#DDD');
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return PasswordStrengthBarComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PasswordStrengthBarComponent.prototype, "passwordToCheck", null);
PasswordStrengthBarComponent = __decorate([
    core_1.Component({
        selector: 'jhi-password-strength-bar',
        template: "\n        <div id=\"strength\">\n            <small jhiTranslate=\"global.messages.validate.newpassword.strength\">Password strength:</small>\n            <ul id=\"strengthBar\">\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n            </ul>\n        </div>",
        styles: [
            __webpack_require__(443)
        ]
    }),
    __metadata("design:paramtypes", [core_1.Renderer, core_1.ElementRef])
], PasswordStrengthBarComponent);
exports.PasswordStrengthBarComponent = PasswordStrengthBarComponent;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var password_component_1 = __webpack_require__(80);
exports.passwordRoute = {
    path: 'password',
    component: password_component_1.PasswordComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var register_component_1 = __webpack_require__(82);
exports.registerRoute = {
    path: 'register',
    component: register_component_1.RegisterComponent,
    data: {
        authorities: [],
        pageTitle: 'register.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var settings_component_1 = __webpack_require__(84);
exports.settingsRoute = {
    path: 'settings',
    component: settings_component_1.SettingsComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.settings'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(92);
var shared_1 = __webpack_require__(3);
var ADMIN_ROUTES = [
    _1.auditsRoute,
    _1.configurationRoute,
    _1.docsRoute,
    _1.healthRoute,
    _1.logsRoute,
    _1.trackerRoute
].concat(_1.userMgmtRoute, [
    _1.metricsRoute
]);
exports.adminState = [{
        path: '',
        data: {
            authorities: ['ROLE_ADMIN']
        },
        canActivate: [shared_1.UserRouteAccessService],
        children: ADMIN_ROUTES
    }].concat(_1.userDialogRoute);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuditData = (function () {
    function AuditData(remoteAddress, sessionId) {
        this.remoteAddress = remoteAddress;
        this.sessionId = sessionId;
    }
    return AuditData;
}());
exports.AuditData = AuditData;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Audit = (function () {
    function Audit(data, principal, timestamp, type) {
        this.data = data;
        this.principal = principal;
        this.timestamp = timestamp;
        this.type = type;
    }
    return Audit;
}());
exports.Audit = Audit;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var audits_component_1 = __webpack_require__(85);
exports.auditsRoute = {
    path: 'audits',
    component: audits_component_1.AuditsComponent,
    data: {
        pageTitle: 'audits.title'
    }
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var configuration_component_1 = __webpack_require__(87);
exports.configurationRoute = {
    path: 'jhi-configuration',
    component: configuration_component_1.JhiConfigurationComponent,
    data: {
        pageTitle: 'configuration.title'
    }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var docs_component_1 = __webpack_require__(89);
exports.docsRoute = {
    path: 'docs',
    component: docs_component_1.JhiDocsComponent,
    data: {
        pageTitle: 'global.menu.admin.apidocs'
    }
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var health_component_1 = __webpack_require__(91);
exports.healthRoute = {
    path: 'jhi-health',
    component: health_component_1.JhiHealthCheckComponent,
    data: {
        pageTitle: 'health.title'
    }
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logs_component_1 = __webpack_require__(94);
exports.logsRoute = {
    path: 'logs',
    component: logs_component_1.LogsComponent,
    data: {
        pageTitle: 'logs.title'
    }
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metrics_component_1 = __webpack_require__(97);
exports.metricsRoute = {
    path: 'jhi-metrics',
    component: metrics_component_1.JhiMetricsMonitoringComponent,
    data: {
        pageTitle: 'metrics.title'
    }
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tracker_component_1 = __webpack_require__(99);
exports.trackerRoute = {
    path: 'jhi-tracker',
    component: tracker_component_1.JhiTrackerComponent,
    data: {
        pageTitle: 'tracker.title'
    }
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var user_management_component_1 = __webpack_require__(103);
var user_management_detail_component_1 = __webpack_require__(101);
var user_management_dialog_component_1 = __webpack_require__(102);
var user_management_delete_dialog_component_1 = __webpack_require__(100);
var shared_1 = __webpack_require__(3);
var UserResolve = (function () {
    function UserResolve(principal) {
        this.principal = principal;
    }
    UserResolve.prototype.canActivate = function () {
        var _this = this;
        return this.principal.identity().then(function (account) { return _this.principal.hasAnyAuthority(['ROLE_ADMIN']); });
    };
    return UserResolve;
}());
UserResolve = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [shared_1.Principal])
], UserResolve);
exports.UserResolve = UserResolve;
var UserResolvePagingParams = (function () {
    function UserResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    UserResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return UserResolvePagingParams;
}());
UserResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], UserResolvePagingParams);
exports.UserResolvePagingParams = UserResolvePagingParams;
exports.userMgmtRoute = [
    {
        path: 'user-management',
        component: user_management_component_1.UserMgmtComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'userManagement.home.title'
        }
    },
    {
        path: 'user-management/:login',
        component: user_management_detail_component_1.UserMgmtDetailComponent,
        data: {
            pageTitle: 'userManagement.home.title'
        }
    }
];
exports.userDialogRoute = [
    {
        path: 'user-management-new',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/edit',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/delete',
        component: user_management_delete_dialog_component_1.UserDeleteDialogComponent,
        outlet: 'popup'
    }
];


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(224);
var prod_config_1 = __webpack_require__(221);
var app_module_1 = __webpack_require__(220);
prod_config_1.ProdConfig();
if (false) {
    module['hot'].accept();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.MarketmanagerAppModule);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var layouts_1 = __webpack_require__(38);
exports.navbarRoute = {
    path: '',
    component: layouts_1.NavbarComponent,
    outlet: 'navbar'
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(70);
var auth_service_1 = __webpack_require__(210);
var principal_service_1 = __webpack_require__(33);
var auth_oauth2_service_1 = __webpack_require__(39);
var AuthExpiredInterceptor = (function (_super) {
    __extends(AuthExpiredInterceptor, _super);
    function AuthExpiredInterceptor(injector) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        return _this;
    }
    AuthExpiredInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    AuthExpiredInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        return observable.catch(function (error, source) {
            if (error.status === 401) {
                var principal = _this.injector.get(principal_service_1.Principal);
                if (principal.isAuthenticated()) {
                    var auth = _this.injector.get(auth_service_1.AuthService);
                    auth.authorize(true);
                }
                else {
                    var authServerProvider = _this.injector.get(auth_oauth2_service_1.AuthServerProvider);
                    authServerProvider.logout();
                }
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return AuthExpiredInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.AuthExpiredInterceptor = AuthExpiredInterceptor;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(1);
var AuthInterceptor = (function (_super) {
    __extends(AuthInterceptor, _super);
    function AuthInterceptor(localStorage, sessionStorage) {
        var _this = _super.call(this) || this;
        _this.localStorage = localStorage;
        _this.sessionStorage = sessionStorage;
        return _this;
    }
    AuthInterceptor.prototype.requestIntercept = function (options) {
        var token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        if (token && token.expires_at && token.expires_at > new Date().getTime()) {
            options.headers.append('Authorization', 'Bearer ' + token.access_token);
        }
        return options;
    };
    AuthInterceptor.prototype.responseIntercept = function (observable) {
        return observable; // by pass
    };
    return AuthInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.AuthInterceptor = AuthInterceptor;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(70);
var ErrorHandlerInterceptor = (function (_super) {
    __extends(ErrorHandlerInterceptor, _super);
    function ErrorHandlerInterceptor(eventManager) {
        var _this = _super.call(this) || this;
        _this.eventManager = eventManager;
        return _this;
    }
    ErrorHandlerInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    ErrorHandlerInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        return observable.catch(function (error) {
            if (!(error.status === 401 && (error.text() === '' ||
                (error.json().path && error.json().path.indexOf('/api/account') === 0)))) {
                _this.eventManager.broadcast({ name: 'marketmanagerApp.httpError', content: error });
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return ErrorHandlerInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.ErrorHandlerInterceptor = ErrorHandlerInterceptor;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var auth_interceptor_1 = __webpack_require__(249);
var ng2_webstorage_1 = __webpack_require__(42);
var auth_expired_interceptor_1 = __webpack_require__(248);
var errorhandler_interceptor_1 = __webpack_require__(250);
var notification_interceptor_1 = __webpack_require__(252);
function interceptableFactory(backend, defaultOptions, localStorage, sessionStorage, injector, eventManager) {
    return new ng_jhipster_1.InterceptableHttp(backend, defaultOptions, [
        new auth_interceptor_1.AuthInterceptor(localStorage, sessionStorage),
        new auth_expired_interceptor_1.AuthExpiredInterceptor(injector),
        // Other interceptors can be added here
        new errorhandler_interceptor_1.ErrorHandlerInterceptor(eventManager),
        new notification_interceptor_1.NotificationInterceptor()
    ]);
}
exports.interceptableFactory = interceptableFactory;
;
function customHttpProvider() {
    return {
        provide: http_1.Http,
        useFactory: interceptableFactory,
        deps: [
            http_1.XHRBackend,
            http_1.RequestOptions,
            ng2_webstorage_1.LocalStorageService,
            ng2_webstorage_1.SessionStorageService,
            core_1.Injector,
            ng_jhipster_1.EventManager
        ]
    };
}
exports.customHttpProvider = customHttpProvider;
;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(70);
var NotificationInterceptor = (function (_super) {
    __extends(NotificationInterceptor, _super);
    function NotificationInterceptor() {
        return _super.call(this) || this;
    }
    NotificationInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    NotificationInterceptor.prototype.responseIntercept = function (observable) {
        return observable.catch(function (error) {
            var arr = Array.from(error.headers._headers);
            var headers = [];
            var i;
            for (i = 0; i < arr.length; i++) {
                if (arr[i][0].endsWith('app-alert') || arr[i][0].endsWith('app-params')) {
                    headers.push(arr[i][0]);
                }
            }
            headers.sort();
            var alertKey = headers.length >= 1 ? error.headers.get(headers[0]) : null;
            if (typeof alertKey === 'string') {
                // AlertService.success(alertKey, { param: response.headers(headers[1])});
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return NotificationInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.NotificationInterceptor = NotificationInterceptor;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(255);
var ENTITY_STATES = _1.additionalflatRoute.concat(_1.additionalflatPopupRoute);
var MarketmanagerAdditionalflatModule = (function () {
    function MarketmanagerAdditionalflatModule() {
    }
    return MarketmanagerAdditionalflatModule;
}());
MarketmanagerAdditionalflatModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.AdditionalflatComponent,
            _1.AdditionalflatDetailComponent,
            _1.AdditionalflatDialogComponent,
            _1.AdditionalflatDeleteDialogComponent,
            _1.AdditionalflatPopupComponent,
            _1.AdditionalflatDeletePopupComponent,
        ],
        entryComponents: [
            _1.AdditionalflatComponent,
            _1.AdditionalflatDialogComponent,
            _1.AdditionalflatPopupComponent,
            _1.AdditionalflatDeleteDialogComponent,
            _1.AdditionalflatDeletePopupComponent,
        ],
        providers: [
            _1.AdditionalflatService,
            _1.AdditionalflatPopupService,
            _1.AdditionalflatResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerAdditionalflatModule);
exports.MarketmanagerAdditionalflatModule = MarketmanagerAdditionalflatModule;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var additionalflat_component_1 = __webpack_require__(107);
var additionalflat_detail_component_1 = __webpack_require__(105);
var additionalflat_dialog_component_1 = __webpack_require__(106);
var additionalflat_delete_dialog_component_1 = __webpack_require__(104);
var AdditionalflatResolvePagingParams = (function () {
    function AdditionalflatResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    AdditionalflatResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return AdditionalflatResolvePagingParams;
}());
AdditionalflatResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], AdditionalflatResolvePagingParams);
exports.AdditionalflatResolvePagingParams = AdditionalflatResolvePagingParams;
exports.additionalflatRoute = [
    {
        path: 'additionalflat',
        component: additionalflat_component_1.AdditionalflatComponent,
        resolve: {
            'pagingParams': AdditionalflatResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.additionalflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'additionalflat/:id',
        component: additionalflat_detail_component_1.AdditionalflatDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.additionalflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.additionalflatPopupRoute = [
    {
        path: 'additionalflat-new',
        component: additionalflat_dialog_component_1.AdditionalflatPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.additionalflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'additionalflat/:id/edit',
        component: additionalflat_dialog_component_1.AdditionalflatPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.additionalflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'additionalflat/:id/delete',
        component: additionalflat_delete_dialog_component_1.AdditionalflatDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.additionalflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(108));
__export(__webpack_require__(46));
__export(__webpack_require__(11));
__export(__webpack_require__(106));
__export(__webpack_require__(104));
__export(__webpack_require__(105));
__export(__webpack_require__(107));
__export(__webpack_require__(254));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(258);
var ENTITY_STATES = _1.boothRoute.concat(_1.boothPopupRoute);
var MarketmanagerBoothModule = (function () {
    function MarketmanagerBoothModule() {
    }
    return MarketmanagerBoothModule;
}());
MarketmanagerBoothModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.BoothComponent,
            _1.BoothDetailComponent,
            _1.BoothDialogComponent,
            _1.BoothDeleteDialogComponent,
            _1.BoothPopupComponent,
            _1.BoothDeletePopupComponent,
        ],
        entryComponents: [
            _1.BoothComponent,
            _1.BoothDialogComponent,
            _1.BoothPopupComponent,
            _1.BoothDeleteDialogComponent,
            _1.BoothDeletePopupComponent,
        ],
        providers: [
            _1.BoothService,
            _1.BoothPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerBoothModule);
exports.MarketmanagerBoothModule = MarketmanagerBoothModule;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var booth_component_1 = __webpack_require__(112);
var booth_detail_component_1 = __webpack_require__(110);
var booth_dialog_component_1 = __webpack_require__(111);
var booth_delete_dialog_component_1 = __webpack_require__(109);
exports.boothRoute = [
    {
        path: 'booth',
        component: booth_component_1.BoothComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.booth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'booth/:id',
        component: booth_detail_component_1.BoothDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.booth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.boothPopupRoute = [
    {
        path: 'booth-new',
        component: booth_dialog_component_1.BoothPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.booth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'booth/:id/edit',
        component: booth_dialog_component_1.BoothPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.booth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'booth/:id/delete',
        component: booth_delete_dialog_component_1.BoothDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.booth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(113));
__export(__webpack_require__(47));
__export(__webpack_require__(12));
__export(__webpack_require__(111));
__export(__webpack_require__(109));
__export(__webpack_require__(110));
__export(__webpack_require__(112));
__export(__webpack_require__(257));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(261);
var ENTITY_STATES = _1.boothfeeRoute.concat(_1.boothfeePopupRoute);
var MarketmanagerBoothfeeModule = (function () {
    function MarketmanagerBoothfeeModule() {
    }
    return MarketmanagerBoothfeeModule;
}());
MarketmanagerBoothfeeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.BoothfeeComponent,
            _1.BoothfeeDetailComponent,
            _1.BoothfeeDialogComponent,
            _1.BoothfeeDeleteDialogComponent,
            _1.BoothfeePopupComponent,
            _1.BoothfeeDeletePopupComponent,
        ],
        entryComponents: [
            _1.BoothfeeComponent,
            _1.BoothfeeDialogComponent,
            _1.BoothfeePopupComponent,
            _1.BoothfeeDeleteDialogComponent,
            _1.BoothfeeDeletePopupComponent,
        ],
        providers: [
            _1.BoothfeeService,
            _1.BoothfeePopupService,
            _1.BoothfeeResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerBoothfeeModule);
exports.MarketmanagerBoothfeeModule = MarketmanagerBoothfeeModule;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var boothfee_component_1 = __webpack_require__(117);
var boothfee_detail_component_1 = __webpack_require__(115);
var boothfee_dialog_component_1 = __webpack_require__(116);
var boothfee_delete_dialog_component_1 = __webpack_require__(114);
var BoothfeeResolvePagingParams = (function () {
    function BoothfeeResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    BoothfeeResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return BoothfeeResolvePagingParams;
}());
BoothfeeResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], BoothfeeResolvePagingParams);
exports.BoothfeeResolvePagingParams = BoothfeeResolvePagingParams;
exports.boothfeeRoute = [
    {
        path: 'boothfee',
        component: boothfee_component_1.BoothfeeComponent,
        resolve: {
            'pagingParams': BoothfeeResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.boothfee.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'boothfee/:id',
        component: boothfee_detail_component_1.BoothfeeDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.boothfee.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.boothfeePopupRoute = [
    {
        path: 'boothfee-new',
        component: boothfee_dialog_component_1.BoothfeePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.boothfee.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'boothfee/:id/edit',
        component: boothfee_dialog_component_1.BoothfeePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.boothfee.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'boothfee/:id/delete',
        component: boothfee_delete_dialog_component_1.BoothfeeDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.boothfee.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(118));
__export(__webpack_require__(48));
__export(__webpack_require__(13));
__export(__webpack_require__(116));
__export(__webpack_require__(114));
__export(__webpack_require__(115));
__export(__webpack_require__(117));
__export(__webpack_require__(260));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(50);
var ENTITY_STATES = _1.branchRoute.concat(_1.branchPopupRoute);
var MarketmanagerBranchModule = (function () {
    function MarketmanagerBranchModule() {
    }
    return MarketmanagerBranchModule;
}());
MarketmanagerBranchModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.BranchComponent,
            _1.BranchDetailComponent,
            _1.BranchDialogComponent,
            _1.BranchDeleteDialogComponent,
            _1.BranchPopupComponent,
            _1.BranchDeletePopupComponent,
        ],
        entryComponents: [
            _1.BranchComponent,
            _1.BranchDialogComponent,
            _1.BranchPopupComponent,
            _1.BranchDeleteDialogComponent,
            _1.BranchDeletePopupComponent,
        ],
        providers: [
            _1.BranchService,
            _1.BranchPopupService,
            _1.BranchResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerBranchModule);
exports.MarketmanagerBranchModule = MarketmanagerBranchModule;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var branch_component_1 = __webpack_require__(122);
var branch_detail_component_1 = __webpack_require__(120);
var branch_dialog_component_1 = __webpack_require__(121);
var branch_delete_dialog_component_1 = __webpack_require__(119);
var BranchResolvePagingParams = (function () {
    function BranchResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    BranchResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return BranchResolvePagingParams;
}());
BranchResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], BranchResolvePagingParams);
exports.BranchResolvePagingParams = BranchResolvePagingParams;
exports.branchRoute = [
    {
        path: 'branch',
        component: branch_component_1.BranchComponent,
        resolve: {
            'pagingParams': BranchResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.branch.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'branch/:id',
        component: branch_detail_component_1.BranchDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.branch.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.branchPopupRoute = [
    {
        path: 'branch-new',
        component: branch_dialog_component_1.BranchPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.branch.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'branch/:id/edit',
        component: branch_dialog_component_1.BranchPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.branch.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'branch/:id/delete',
        component: branch_delete_dialog_component_1.BranchDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.branch.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(266);
var ENTITY_STATES = _1.contactTempRoute.concat(_1.contactTempPopupRoute);
var MarketmanagerContactTempModule = (function () {
    function MarketmanagerContactTempModule() {
    }
    return MarketmanagerContactTempModule;
}());
MarketmanagerContactTempModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ContactTempComponent,
            _1.ContactTempDetailComponent,
            _1.ContactTempDialogComponent,
            _1.ContactTempDeleteDialogComponent,
            _1.ContactTempPopupComponent,
            _1.ContactTempDeletePopupComponent,
        ],
        entryComponents: [
            _1.ContactTempComponent,
            _1.ContactTempDialogComponent,
            _1.ContactTempPopupComponent,
            _1.ContactTempDeleteDialogComponent,
            _1.ContactTempDeletePopupComponent,
        ],
        providers: [
            _1.ContactTempService,
            _1.ContactTempPopupService,
            _1.ContactTempResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerContactTempModule);
exports.MarketmanagerContactTempModule = MarketmanagerContactTempModule;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var contact_temp_component_1 = __webpack_require__(127);
var contact_temp_detail_component_1 = __webpack_require__(125);
var contact_temp_dialog_component_1 = __webpack_require__(126);
var contact_temp_delete_dialog_component_1 = __webpack_require__(124);
var ContactTempResolvePagingParams = (function () {
    function ContactTempResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ContactTempResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ContactTempResolvePagingParams;
}());
ContactTempResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ContactTempResolvePagingParams);
exports.ContactTempResolvePagingParams = ContactTempResolvePagingParams;
exports.contactTempRoute = [
    {
        path: 'contact-temp',
        component: contact_temp_component_1.ContactTempComponent,
        resolve: {
            'pagingParams': ContactTempResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contactTemp.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'contact-temp/:id',
        component: contact_temp_detail_component_1.ContactTempDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contactTemp.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.contactTempPopupRoute = [
    {
        path: 'contact-temp-new',
        component: contact_temp_dialog_component_1.ContactTempPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contactTemp.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contact-temp/:id/edit',
        component: contact_temp_dialog_component_1.ContactTempPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contactTemp.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contact-temp/:id/delete',
        component: contact_temp_delete_dialog_component_1.ContactTempDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contactTemp.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(128));
__export(__webpack_require__(51));
__export(__webpack_require__(15));
__export(__webpack_require__(126));
__export(__webpack_require__(124));
__export(__webpack_require__(125));
__export(__webpack_require__(127));
__export(__webpack_require__(265));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(9);
var ENTITY_STATES = _1.contactRoute.concat(_1.contactPopupRoute);
var MarketmanagerContactModule = (function () {
    function MarketmanagerContactModule() {
    }
    return MarketmanagerContactModule;
}());
MarketmanagerContactModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ContactComponent,
            _1.ContactDetailComponent,
            _1.ContactDialogComponent,
            _1.ContactDeleteDialogComponent,
            _1.ContactPopupComponent,
            _1.ContactDeletePopupComponent,
        ],
        entryComponents: [
            _1.ContactComponent,
            _1.ContactDialogComponent,
            _1.ContactPopupComponent,
            _1.ContactDeleteDialogComponent,
            _1.ContactDeletePopupComponent,
        ],
        providers: [
            _1.ContactService,
            _1.ContactPopupService,
            _1.ContactResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerContactModule);
exports.MarketmanagerContactModule = MarketmanagerContactModule;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var contact_component_1 = __webpack_require__(132);
var contact_detail_component_1 = __webpack_require__(130);
var contact_dialog_component_1 = __webpack_require__(131);
var contact_delete_dialog_component_1 = __webpack_require__(129);
var ContactResolvePagingParams = (function () {
    function ContactResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ContactResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ContactResolvePagingParams;
}());
ContactResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ContactResolvePagingParams);
exports.ContactResolvePagingParams = ContactResolvePagingParams;
exports.contactRoute = [
    {
        path: 'contact',
        component: contact_component_1.ContactComponent,
        resolve: {
            'pagingParams': ContactResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contact.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'contact/:id',
        component: contact_detail_component_1.ContactDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contact.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.contactPopupRoute = [
    {
        path: 'contact-new',
        component: contact_dialog_component_1.ContactPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contact.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contact/:id/edit',
        component: contact_dialog_component_1.ContactPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contact.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contact/:id/delete',
        component: contact_delete_dialog_component_1.ContactDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contact.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(35);
var ENTITY_STATES = _1.contractRoute.concat(_1.contractPopupRoute);
var MarketmanagerContractModule = (function () {
    function MarketmanagerContractModule() {
    }
    return MarketmanagerContractModule;
}());
MarketmanagerContractModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ContractComponent,
            _1.ContractDetailComponent,
            _1.ContractDialogComponent,
            _1.ContractDeleteDialogComponent,
            _1.ContractPopupComponent,
            _1.ContractDeletePopupComponent,
        ],
        entryComponents: [
            _1.ContractComponent,
            _1.ContractDialogComponent,
            _1.ContractPopupComponent,
            _1.ContractDeleteDialogComponent,
            _1.ContractDeletePopupComponent,
        ],
        providers: [
            _1.ContractService,
            _1.ContractPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerContractModule);
exports.MarketmanagerContractModule = MarketmanagerContractModule;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var contract_component_1 = __webpack_require__(137);
var contract_detail_component_1 = __webpack_require__(135);
var contract_dialog_component_1 = __webpack_require__(136);
var contract_delete_dialog_component_1 = __webpack_require__(134);
exports.contractRoute = [
    {
        path: 'contract',
        component: contract_component_1.ContractComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contract.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'contract/:id',
        component: contract_detail_component_1.ContractDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contract.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.contractPopupRoute = [
    {
        path: 'contract-new',
        component: contract_dialog_component_1.ContractPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contract.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contract/:id/edit',
        component: contract_dialog_component_1.ContractPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contract.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contract/:id/delete',
        component: contract_delete_dialog_component_1.ContractDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contract.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(273);
var ENTITY_STATES = _1.contractdateRoute.concat(_1.contractdatePopupRoute);
var MarketmanagerContractdateModule = (function () {
    function MarketmanagerContractdateModule() {
    }
    return MarketmanagerContractdateModule;
}());
MarketmanagerContractdateModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ContractdateComponent,
            _1.ContractdateDetailComponent,
            _1.ContractdateDialogComponent,
            _1.ContractdateDeleteDialogComponent,
            _1.ContractdatePopupComponent,
            _1.ContractdateDeletePopupComponent,
        ],
        entryComponents: [
            _1.ContractdateComponent,
            _1.ContractdateDialogComponent,
            _1.ContractdatePopupComponent,
            _1.ContractdateDeleteDialogComponent,
            _1.ContractdateDeletePopupComponent,
        ],
        providers: [
            _1.ContractdateService,
            _1.ContractdatePopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerContractdateModule);
exports.MarketmanagerContractdateModule = MarketmanagerContractdateModule;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var contractdate_component_1 = __webpack_require__(142);
var contractdate_detail_component_1 = __webpack_require__(140);
var contractdate_dialog_component_1 = __webpack_require__(141);
var contractdate_delete_dialog_component_1 = __webpack_require__(139);
exports.contractdateRoute = [
    {
        path: 'contractdate',
        component: contractdate_component_1.ContractdateComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contractdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'contractdate/:id',
        component: contractdate_detail_component_1.ContractdateDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contractdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.contractdatePopupRoute = [
    {
        path: 'contractdate-new',
        component: contractdate_dialog_component_1.ContractdatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contractdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contractdate/:id/edit',
        component: contractdate_dialog_component_1.ContractdatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contractdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'contractdate/:id/delete',
        component: contractdate_delete_dialog_component_1.ContractdateDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.contractdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(143));
__export(__webpack_require__(54));
__export(__webpack_require__(18));
__export(__webpack_require__(141));
__export(__webpack_require__(139));
__export(__webpack_require__(140));
__export(__webpack_require__(142));
__export(__webpack_require__(272));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(149);
var ENTITY_STATES = _1.electricmeterRoute.concat(_1.electricmeterPopupRoute);
var MarketmanagerElectricmeterModule = (function () {
    function MarketmanagerElectricmeterModule() {
    }
    return MarketmanagerElectricmeterModule;
}());
MarketmanagerElectricmeterModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ElectricmeterComponent,
            _1.ElectricmeterDetailComponent,
            _1.ElectricmeterDialogComponent,
            _1.ElectricmeterDeleteDialogComponent,
            _1.ElectricmeterPopupComponent,
            _1.ElectricmeterDeletePopupComponent,
        ],
        entryComponents: [
            _1.ElectricmeterComponent,
            _1.ElectricmeterDialogComponent,
            _1.ElectricmeterPopupComponent,
            _1.ElectricmeterDeleteDialogComponent,
            _1.ElectricmeterDeletePopupComponent,
        ],
        providers: [
            _1.ElectricmeterService,
            _1.ElectricmeterPopupService,
            _1.ElectricmeterResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerElectricmeterModule);
exports.MarketmanagerElectricmeterModule = MarketmanagerElectricmeterModule;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var electricmeter_component_1 = __webpack_require__(147);
var electricmeter_detail_component_1 = __webpack_require__(145);
var electricmeter_dialog_component_1 = __webpack_require__(146);
var electricmeter_delete_dialog_component_1 = __webpack_require__(144);
var ElectricmeterResolvePagingParams = (function () {
    function ElectricmeterResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ElectricmeterResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ElectricmeterResolvePagingParams;
}());
ElectricmeterResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ElectricmeterResolvePagingParams);
exports.ElectricmeterResolvePagingParams = ElectricmeterResolvePagingParams;
exports.electricmeterRoute = [
    {
        path: 'electricmeter',
        component: electricmeter_component_1.ElectricmeterComponent,
        resolve: {
            'pagingParams': ElectricmeterResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.electricmeter.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'electricmeter/:id',
        component: electricmeter_detail_component_1.ElectricmeterDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.electricmeter.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.electricmeterPopupRoute = [
    {
        path: 'electricmeter-new',
        component: electricmeter_dialog_component_1.ElectricmeterPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.electricmeter.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'electricmeter/:id/edit',
        component: electricmeter_dialog_component_1.ElectricmeterPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.electricmeter.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'electricmeter/:id/delete',
        component: electricmeter_delete_dialog_component_1.ElectricmeterDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.electricmeter.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(278);
var ENTITY_STATES = _1.energyflatRoute.concat(_1.energyflatPopupRoute);
var MarketmanagerEnergyflatModule = (function () {
    function MarketmanagerEnergyflatModule() {
    }
    return MarketmanagerEnergyflatModule;
}());
MarketmanagerEnergyflatModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.EnergyflatComponent,
            _1.EnergyflatDetailComponent,
            _1.EnergyflatDialogComponent,
            _1.EnergyflatDeleteDialogComponent,
            _1.EnergyflatPopupComponent,
            _1.EnergyflatDeletePopupComponent,
        ],
        entryComponents: [
            _1.EnergyflatComponent,
            _1.EnergyflatDialogComponent,
            _1.EnergyflatPopupComponent,
            _1.EnergyflatDeleteDialogComponent,
            _1.EnergyflatDeletePopupComponent,
        ],
        providers: [
            _1.EnergyflatService,
            _1.EnergyflatPopupService,
            _1.EnergyflatResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerEnergyflatModule);
exports.MarketmanagerEnergyflatModule = MarketmanagerEnergyflatModule;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var energyflat_component_1 = __webpack_require__(153);
var energyflat_detail_component_1 = __webpack_require__(151);
var energyflat_dialog_component_1 = __webpack_require__(152);
var energyflat_delete_dialog_component_1 = __webpack_require__(150);
var EnergyflatResolvePagingParams = (function () {
    function EnergyflatResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    EnergyflatResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return EnergyflatResolvePagingParams;
}());
EnergyflatResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], EnergyflatResolvePagingParams);
exports.EnergyflatResolvePagingParams = EnergyflatResolvePagingParams;
exports.energyflatRoute = [
    {
        path: 'energyflat',
        component: energyflat_component_1.EnergyflatComponent,
        resolve: {
            'pagingParams': EnergyflatResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.energyflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'energyflat/:id',
        component: energyflat_detail_component_1.EnergyflatDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.energyflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.energyflatPopupRoute = [
    {
        path: 'energyflat-new',
        component: energyflat_dialog_component_1.EnergyflatPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.energyflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'energyflat/:id/edit',
        component: energyflat_dialog_component_1.EnergyflatPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.energyflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'energyflat/:id/delete',
        component: energyflat_delete_dialog_component_1.EnergyflatDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.energyflat.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(154));
__export(__webpack_require__(56));
__export(__webpack_require__(20));
__export(__webpack_require__(152));
__export(__webpack_require__(150));
__export(__webpack_require__(151));
__export(__webpack_require__(153));
__export(__webpack_require__(277));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var contact_module_1 = __webpack_require__(267);
var branch_module_1 = __webpack_require__(262);
var marketplace_module_1 = __webpack_require__(299);
var marketday_module_1 = __webpack_require__(297);
var marketdate_module_1 = __webpack_require__(295);
var electricmeter_module_1 = __webpack_require__(274);
var boothfee_module_1 = __webpack_require__(259);
var energyflat_module_1 = __webpack_require__(276);
var additionalflat_module_1 = __webpack_require__(253);
var salesunit_module_1 = __webpack_require__(301);
var testentity_module_1 = __webpack_require__(304);
var marketdate_status_module_1 = __webpack_require__(293);
var marketdate_comment_module_1 = __webpack_require__(284);
var contact_temp_module_1 = __webpack_require__(264);
var marketdate_meterreading_module_1 = __webpack_require__(290);
var marketdate_expense_module_1 = __webpack_require__(287);
var booth_module_1 = __webpack_require__(256);
var contract_module_1 = __webpack_require__(269);
var marketdate_booth_module_1 = __webpack_require__(281);
var contractdate_module_1 = __webpack_require__(271);
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */
var MarketmanagerEntityModule = (function () {
    function MarketmanagerEntityModule() {
    }
    return MarketmanagerEntityModule;
}());
MarketmanagerEntityModule = __decorate([
    core_1.NgModule({
        imports: [
            contact_module_1.MarketmanagerContactModule,
            branch_module_1.MarketmanagerBranchModule,
            marketplace_module_1.MarketmanagerMarketplaceModule,
            marketday_module_1.MarketmanagerMarketdayModule,
            marketdate_module_1.MarketmanagerMarketdateModule,
            electricmeter_module_1.MarketmanagerElectricmeterModule,
            boothfee_module_1.MarketmanagerBoothfeeModule,
            energyflat_module_1.MarketmanagerEnergyflatModule,
            additionalflat_module_1.MarketmanagerAdditionalflatModule,
            salesunit_module_1.MarketmanagerSalesunitModule,
            testentity_module_1.MarketmanagerTestentityModule,
            marketdate_status_module_1.MarketmanagerMarketdateStatusModule,
            marketdate_comment_module_1.MarketmanagerMarketdateCommentModule,
            contact_temp_module_1.MarketmanagerContactTempModule,
            marketdate_meterreading_module_1.MarketmanagerMarketdateMeterreadingModule,
            marketdate_expense_module_1.MarketmanagerMarketdateExpenseModule,
            booth_module_1.MarketmanagerBoothModule,
            contract_module_1.MarketmanagerContractModule,
            marketdate_booth_module_1.MarketmanagerMarketdateBoothModule,
            contractdate_module_1.MarketmanagerContractdateModule,
        ],
        declarations: [],
        entryComponents: [],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerEntityModule);
exports.MarketmanagerEntityModule = MarketmanagerEntityModule;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(159));
__export(__webpack_require__(57));
__export(__webpack_require__(21));
__export(__webpack_require__(157));
__export(__webpack_require__(155));
__export(__webpack_require__(156));
__export(__webpack_require__(158));
__export(__webpack_require__(282));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(280);
var ENTITY_STATES = _1.marketdateBoothRoute.concat(_1.marketdateBoothPopupRoute);
var MarketmanagerMarketdateBoothModule = (function () {
    function MarketmanagerMarketdateBoothModule() {
    }
    return MarketmanagerMarketdateBoothModule;
}());
MarketmanagerMarketdateBoothModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateBoothComponent,
            _1.MarketdateBoothDetailComponent,
            _1.MarketdateBoothDialogComponent,
            _1.MarketdateBoothDeleteDialogComponent,
            _1.MarketdateBoothPopupComponent,
            _1.MarketdateBoothDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateBoothComponent,
            _1.MarketdateBoothDialogComponent,
            _1.MarketdateBoothPopupComponent,
            _1.MarketdateBoothDeleteDialogComponent,
            _1.MarketdateBoothDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateBoothService,
            _1.MarketdateBoothPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateBoothModule);
exports.MarketmanagerMarketdateBoothModule = MarketmanagerMarketdateBoothModule;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var marketdate_booth_component_1 = __webpack_require__(158);
var marketdate_booth_detail_component_1 = __webpack_require__(156);
var marketdate_booth_dialog_component_1 = __webpack_require__(157);
var marketdate_booth_delete_dialog_component_1 = __webpack_require__(155);
exports.marketdateBoothRoute = [
    {
        path: 'marketdate-booth',
        component: marketdate_booth_component_1.MarketdateBoothComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate-booth/:id',
        component: marketdate_booth_detail_component_1.MarketdateBoothDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdateBoothPopupRoute = [
    {
        path: 'marketdate-booth-new',
        component: marketdate_booth_dialog_component_1.MarketdateBoothPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-booth/:id/edit',
        component: marketdate_booth_dialog_component_1.MarketdateBoothPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-booth/:id/delete',
        component: marketdate_booth_delete_dialog_component_1.MarketdateBoothDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(164));
__export(__webpack_require__(58));
__export(__webpack_require__(22));
__export(__webpack_require__(162));
__export(__webpack_require__(160));
__export(__webpack_require__(161));
__export(__webpack_require__(163));
__export(__webpack_require__(285));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(283);
var ENTITY_STATES = _1.marketdateCommentRoute.concat(_1.marketdateCommentPopupRoute);
var MarketmanagerMarketdateCommentModule = (function () {
    function MarketmanagerMarketdateCommentModule() {
    }
    return MarketmanagerMarketdateCommentModule;
}());
MarketmanagerMarketdateCommentModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateCommentComponent,
            _1.MarketdateCommentDetailComponent,
            _1.MarketdateCommentDialogComponent,
            _1.MarketdateCommentDeleteDialogComponent,
            _1.MarketdateCommentPopupComponent,
            _1.MarketdateCommentDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateCommentComponent,
            _1.MarketdateCommentDialogComponent,
            _1.MarketdateCommentPopupComponent,
            _1.MarketdateCommentDeleteDialogComponent,
            _1.MarketdateCommentDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateCommentService,
            _1.MarketdateCommentPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateCommentModule);
exports.MarketmanagerMarketdateCommentModule = MarketmanagerMarketdateCommentModule;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var marketdate_comment_component_1 = __webpack_require__(163);
var marketdate_comment_detail_component_1 = __webpack_require__(161);
var marketdate_comment_dialog_component_1 = __webpack_require__(162);
var marketdate_comment_delete_dialog_component_1 = __webpack_require__(160);
exports.marketdateCommentRoute = [
    {
        path: 'marketdate-comment',
        component: marketdate_comment_component_1.MarketdateCommentComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateComment.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate-comment/:id',
        component: marketdate_comment_detail_component_1.MarketdateCommentDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateComment.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdateCommentPopupRoute = [
    {
        path: 'marketdate-comment-new',
        component: marketdate_comment_dialog_component_1.MarketdateCommentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateComment.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-comment/:id/edit',
        component: marketdate_comment_dialog_component_1.MarketdateCommentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateComment.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-comment/:id/delete',
        component: marketdate_comment_delete_dialog_component_1.MarketdateCommentDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateComment.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(169));
__export(__webpack_require__(59));
__export(__webpack_require__(23));
__export(__webpack_require__(167));
__export(__webpack_require__(165));
__export(__webpack_require__(166));
__export(__webpack_require__(168));
__export(__webpack_require__(288));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(286);
var ENTITY_STATES = _1.marketdateExpenseRoute.concat(_1.marketdateExpensePopupRoute);
var MarketmanagerMarketdateExpenseModule = (function () {
    function MarketmanagerMarketdateExpenseModule() {
    }
    return MarketmanagerMarketdateExpenseModule;
}());
MarketmanagerMarketdateExpenseModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateExpenseComponent,
            _1.MarketdateExpenseDetailComponent,
            _1.MarketdateExpenseDialogComponent,
            _1.MarketdateExpenseDeleteDialogComponent,
            _1.MarketdateExpensePopupComponent,
            _1.MarketdateExpenseDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateExpenseComponent,
            _1.MarketdateExpenseDialogComponent,
            _1.MarketdateExpensePopupComponent,
            _1.MarketdateExpenseDeleteDialogComponent,
            _1.MarketdateExpenseDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateExpenseService,
            _1.MarketdateExpensePopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateExpenseModule);
exports.MarketmanagerMarketdateExpenseModule = MarketmanagerMarketdateExpenseModule;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var marketdate_expense_component_1 = __webpack_require__(168);
var marketdate_expense_detail_component_1 = __webpack_require__(166);
var marketdate_expense_dialog_component_1 = __webpack_require__(167);
var marketdate_expense_delete_dialog_component_1 = __webpack_require__(165);
exports.marketdateExpenseRoute = [
    {
        path: 'marketdate-expense',
        component: marketdate_expense_component_1.MarketdateExpenseComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate-expense/:id',
        component: marketdate_expense_detail_component_1.MarketdateExpenseDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdateExpensePopupRoute = [
    {
        path: 'marketdate-expense-new',
        component: marketdate_expense_dialog_component_1.MarketdateExpensePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-expense/:id/edit',
        component: marketdate_expense_dialog_component_1.MarketdateExpensePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-expense/:id/delete',
        component: marketdate_expense_delete_dialog_component_1.MarketdateExpenseDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(174));
__export(__webpack_require__(60));
__export(__webpack_require__(24));
__export(__webpack_require__(172));
__export(__webpack_require__(170));
__export(__webpack_require__(171));
__export(__webpack_require__(173));
__export(__webpack_require__(291));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(289);
var ENTITY_STATES = _1.marketdateMeterreadingRoute.concat(_1.marketdateMeterreadingPopupRoute);
var MarketmanagerMarketdateMeterreadingModule = (function () {
    function MarketmanagerMarketdateMeterreadingModule() {
    }
    return MarketmanagerMarketdateMeterreadingModule;
}());
MarketmanagerMarketdateMeterreadingModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateMeterreadingComponent,
            _1.MarketdateMeterreadingDetailComponent,
            _1.MarketdateMeterreadingDialogComponent,
            _1.MarketdateMeterreadingDeleteDialogComponent,
            _1.MarketdateMeterreadingPopupComponent,
            _1.MarketdateMeterreadingDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateMeterreadingComponent,
            _1.MarketdateMeterreadingDialogComponent,
            _1.MarketdateMeterreadingPopupComponent,
            _1.MarketdateMeterreadingDeleteDialogComponent,
            _1.MarketdateMeterreadingDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateMeterreadingService,
            _1.MarketdateMeterreadingPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateMeterreadingModule);
exports.MarketmanagerMarketdateMeterreadingModule = MarketmanagerMarketdateMeterreadingModule;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var marketdate_meterreading_component_1 = __webpack_require__(173);
var marketdate_meterreading_detail_component_1 = __webpack_require__(171);
var marketdate_meterreading_dialog_component_1 = __webpack_require__(172);
var marketdate_meterreading_delete_dialog_component_1 = __webpack_require__(170);
exports.marketdateMeterreadingRoute = [
    {
        path: 'marketdate-meterreading',
        component: marketdate_meterreading_component_1.MarketdateMeterreadingComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate-meterreading/:id',
        component: marketdate_meterreading_detail_component_1.MarketdateMeterreadingDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdateMeterreadingPopupRoute = [
    {
        path: 'marketdate-meterreading-new',
        component: marketdate_meterreading_dialog_component_1.MarketdateMeterreadingPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-meterreading/:id/edit',
        component: marketdate_meterreading_dialog_component_1.MarketdateMeterreadingPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-meterreading/:id/delete',
        component: marketdate_meterreading_delete_dialog_component_1.MarketdateMeterreadingDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(179));
__export(__webpack_require__(61));
__export(__webpack_require__(25));
__export(__webpack_require__(177));
__export(__webpack_require__(175));
__export(__webpack_require__(176));
__export(__webpack_require__(178));
__export(__webpack_require__(294));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(10);
var _1 = __webpack_require__(292);
var ENTITY_STATES = _1.marketdateStatusRoute.concat(_1.marketdateStatusPopupRoute);
var MarketmanagerMarketdateStatusModule = (function () {
    function MarketmanagerMarketdateStatusModule() {
    }
    return MarketmanagerMarketdateStatusModule;
}());
MarketmanagerMarketdateStatusModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            admin_module_1.MarketmanagerAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateStatusComponent,
            _1.MarketdateStatusDetailComponent,
            _1.MarketdateStatusDialogComponent,
            _1.MarketdateStatusDeleteDialogComponent,
            _1.MarketdateStatusPopupComponent,
            _1.MarketdateStatusDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateStatusComponent,
            _1.MarketdateStatusDialogComponent,
            _1.MarketdateStatusPopupComponent,
            _1.MarketdateStatusDeleteDialogComponent,
            _1.MarketdateStatusDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateStatusService,
            _1.MarketdateStatusPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateStatusModule);
exports.MarketmanagerMarketdateStatusModule = MarketmanagerMarketdateStatusModule;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var marketdate_status_component_1 = __webpack_require__(178);
var marketdate_status_detail_component_1 = __webpack_require__(176);
var marketdate_status_dialog_component_1 = __webpack_require__(177);
var marketdate_status_delete_dialog_component_1 = __webpack_require__(175);
exports.marketdateStatusRoute = [
    {
        path: 'marketdate-status',
        component: marketdate_status_component_1.MarketdateStatusComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate-status/:id',
        component: marketdate_status_detail_component_1.MarketdateStatusDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdateStatusPopupRoute = [
    {
        path: 'marketdate-status-new',
        component: marketdate_status_dialog_component_1.MarketdateStatusPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-status/:id/edit',
        component: marketdate_status_dialog_component_1.MarketdateStatusPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate-status/:id/delete',
        component: marketdate_status_delete_dialog_component_1.MarketdateStatusDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(26);
var ENTITY_STATES = _1.marketdateRoute.concat(_1.marketdatePopupRoute);
var MarketmanagerMarketdateModule = (function () {
    function MarketmanagerMarketdateModule() {
    }
    return MarketmanagerMarketdateModule;
}());
MarketmanagerMarketdateModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdateComponent,
            _1.MarketdateDetailComponent,
            _1.MarketdateDialogComponent,
            _1.MarketdateDeleteDialogComponent,
            _1.MarketdatePopupComponent,
            _1.MarketdateDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdateComponent,
            _1.MarketdateDialogComponent,
            _1.MarketdatePopupComponent,
            _1.MarketdateDeleteDialogComponent,
            _1.MarketdateDeletePopupComponent,
        ],
        providers: [
            _1.MarketdateService,
            _1.MarketdatePopupService,
            _1.MarketdateResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdateModule);
exports.MarketmanagerMarketdateModule = MarketmanagerMarketdateModule;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var marketdate_component_1 = __webpack_require__(183);
var marketdate_detail_component_1 = __webpack_require__(181);
var marketdate_dialog_component_1 = __webpack_require__(182);
var marketdate_delete_dialog_component_1 = __webpack_require__(180);
var MarketdateResolvePagingParams = (function () {
    function MarketdateResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    MarketdateResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return MarketdateResolvePagingParams;
}());
MarketdateResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], MarketdateResolvePagingParams);
exports.MarketdateResolvePagingParams = MarketdateResolvePagingParams;
exports.marketdateRoute = [
    {
        path: 'marketdate',
        component: marketdate_component_1.MarketdateComponent,
        resolve: {
            'pagingParams': MarketdateResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketdate/:id',
        component: marketdate_detail_component_1.MarketdateDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdatePopupRoute = [
    {
        path: 'marketdate-new',
        component: marketdate_dialog_component_1.MarketdatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate/:id/edit',
        component: marketdate_dialog_component_1.MarketdatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketdate/:id/delete',
        component: marketdate_delete_dialog_component_1.MarketdateDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketdate.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(32);
var ENTITY_STATES = _1.marketdayRoute.concat(_1.marketdayPopupRoute);
var MarketmanagerMarketdayModule = (function () {
    function MarketmanagerMarketdayModule() {
    }
    return MarketmanagerMarketdayModule;
}());
MarketmanagerMarketdayModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketdayComponent,
            _1.MarketdayDetailComponent,
            _1.MarketdayDialogComponent,
            _1.MarketdayDeleteDialogComponent,
            _1.MarketdayPopupComponent,
            _1.MarketdayDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketdayComponent,
            _1.MarketdayDialogComponent,
            _1.MarketdayPopupComponent,
            _1.MarketdayDeleteDialogComponent,
            _1.MarketdayDeletePopupComponent,
        ],
        providers: [
            _1.MarketdayService,
            _1.MarketdayPopupService,
            _1.MarketdayResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketdayModule);
exports.MarketmanagerMarketdayModule = MarketmanagerMarketdayModule;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var marketday_component_1 = __webpack_require__(188);
var marketday_detail_component_1 = __webpack_require__(186);
var marketday_dialog_component_1 = __webpack_require__(187);
var marketday_delete_dialog_component_1 = __webpack_require__(185);
var MarketdayResolvePagingParams = (function () {
    function MarketdayResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    MarketdayResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return MarketdayResolvePagingParams;
}());
MarketdayResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], MarketdayResolvePagingParams);
exports.MarketdayResolvePagingParams = MarketdayResolvePagingParams;
exports.marketdayRoute = [
    {
        path: 'marketday',
        component: marketday_component_1.MarketdayComponent,
        resolve: {
            'pagingParams': MarketdayResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketday.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketday/:id',
        component: marketday_detail_component_1.MarketdayDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketday.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketdayPopupRoute = [
    {
        path: 'marketday-new',
        component: marketday_dialog_component_1.MarketdayPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketday.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketday/:id/edit',
        component: marketday_dialog_component_1.MarketdayPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketday.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketday/:id/delete',
        component: marketday_delete_dialog_component_1.MarketdayDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketday.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(36);
var ENTITY_STATES = _1.marketplaceRoute.concat(_1.marketplacePopupRoute);
var MarketmanagerMarketplaceModule = (function () {
    function MarketmanagerMarketplaceModule() {
    }
    return MarketmanagerMarketplaceModule;
}());
MarketmanagerMarketplaceModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.MarketplaceComponent,
            _1.MarketplaceDetailComponent,
            _1.MarketplaceDialogComponent,
            _1.MarketplaceDeleteDialogComponent,
            _1.MarketplacePopupComponent,
            _1.MarketplaceDeletePopupComponent,
        ],
        entryComponents: [
            _1.MarketplaceComponent,
            _1.MarketplaceDialogComponent,
            _1.MarketplacePopupComponent,
            _1.MarketplaceDeleteDialogComponent,
            _1.MarketplaceDeletePopupComponent,
        ],
        providers: [
            _1.MarketplaceService,
            _1.MarketplacePopupService,
            _1.MarketplaceResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerMarketplaceModule);
exports.MarketmanagerMarketplaceModule = MarketmanagerMarketplaceModule;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var marketplace_component_1 = __webpack_require__(193);
var marketplace_detail_component_1 = __webpack_require__(191);
var marketplace_dialog_component_1 = __webpack_require__(192);
var marketplace_delete_dialog_component_1 = __webpack_require__(190);
var MarketplaceResolvePagingParams = (function () {
    function MarketplaceResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    MarketplaceResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return MarketplaceResolvePagingParams;
}());
MarketplaceResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], MarketplaceResolvePagingParams);
exports.MarketplaceResolvePagingParams = MarketplaceResolvePagingParams;
exports.marketplaceRoute = [
    {
        path: 'marketplace',
        component: marketplace_component_1.MarketplaceComponent,
        resolve: {
            'pagingParams': MarketplaceResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketplace.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'marketplace/:id',
        component: marketplace_detail_component_1.MarketplaceDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketplace.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.marketplacePopupRoute = [
    {
        path: 'marketplace-new',
        component: marketplace_dialog_component_1.MarketplacePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketplace.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketplace/:id/edit',
        component: marketplace_dialog_component_1.MarketplacePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketplace.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'marketplace/:id/delete',
        component: marketplace_delete_dialog_component_1.MarketplaceDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.marketplace.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(37);
var ENTITY_STATES = _1.salesunitRoute.concat(_1.salesunitPopupRoute);
var MarketmanagerSalesunitModule = (function () {
    function MarketmanagerSalesunitModule() {
    }
    return MarketmanagerSalesunitModule;
}());
MarketmanagerSalesunitModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.SalesunitComponent,
            _1.SalesunitDetailComponent,
            _1.SalesunitDialogComponent,
            _1.SalesunitDeleteDialogComponent,
            _1.SalesunitPopupComponent,
            _1.SalesunitDeletePopupComponent,
        ],
        entryComponents: [
            _1.SalesunitComponent,
            _1.SalesunitDialogComponent,
            _1.SalesunitPopupComponent,
            _1.SalesunitDeleteDialogComponent,
            _1.SalesunitDeletePopupComponent,
        ],
        providers: [
            _1.SalesunitService,
            _1.SalesunitPopupService,
            _1.SalesunitResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerSalesunitModule);
exports.MarketmanagerSalesunitModule = MarketmanagerSalesunitModule;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(3);
var ng_jhipster_1 = __webpack_require__(1);
var salesunit_component_1 = __webpack_require__(198);
var salesunit_detail_component_1 = __webpack_require__(196);
var salesunit_dialog_component_1 = __webpack_require__(197);
var salesunit_delete_dialog_component_1 = __webpack_require__(195);
var SalesunitResolvePagingParams = (function () {
    function SalesunitResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    SalesunitResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return SalesunitResolvePagingParams;
}());
SalesunitResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], SalesunitResolvePagingParams);
exports.SalesunitResolvePagingParams = SalesunitResolvePagingParams;
exports.salesunitRoute = [
    {
        path: 'salesunit',
        component: salesunit_component_1.SalesunitComponent,
        resolve: {
            'pagingParams': SalesunitResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.salesunit.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'salesunit/:id',
        component: salesunit_detail_component_1.SalesunitDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.salesunit.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.salesunitPopupRoute = [
    {
        path: 'salesunit-new',
        component: salesunit_dialog_component_1.SalesunitPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.salesunit.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'salesunit/:id/edit',
        component: salesunit_dialog_component_1.SalesunitPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.salesunit.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'salesunit/:id/delete',
        component: salesunit_delete_dialog_component_1.SalesunitDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.salesunit.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(204));
__export(__webpack_require__(66));
__export(__webpack_require__(31));
__export(__webpack_require__(202));
__export(__webpack_require__(200));
__export(__webpack_require__(201));
__export(__webpack_require__(203));
__export(__webpack_require__(305));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(303);
var ENTITY_STATES = _1.testentityRoute.concat(_1.testentityPopupRoute);
var MarketmanagerTestentityModule = (function () {
    function MarketmanagerTestentityModule() {
    }
    return MarketmanagerTestentityModule;
}());
MarketmanagerTestentityModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.MarketmanagerSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.TestentityComponent,
            _1.TestentityDetailComponent,
            _1.TestentityDialogComponent,
            _1.TestentityDeleteDialogComponent,
            _1.TestentityPopupComponent,
            _1.TestentityDeletePopupComponent,
        ],
        entryComponents: [
            _1.TestentityComponent,
            _1.TestentityDialogComponent,
            _1.TestentityPopupComponent,
            _1.TestentityDeleteDialogComponent,
            _1.TestentityDeletePopupComponent,
        ],
        providers: [
            _1.TestentityService,
            _1.TestentityPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerTestentityModule);
exports.MarketmanagerTestentityModule = MarketmanagerTestentityModule;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(3);
var testentity_component_1 = __webpack_require__(203);
var testentity_detail_component_1 = __webpack_require__(201);
var testentity_dialog_component_1 = __webpack_require__(202);
var testentity_delete_dialog_component_1 = __webpack_require__(200);
exports.testentityRoute = [
    {
        path: 'testentity',
        component: testentity_component_1.TestentityComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.testentity.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'testentity/:id',
        component: testentity_detail_component_1.TestentityDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.testentity.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.testentityPopupRoute = [
    {
        path: 'testentity-new',
        component: testentity_dialog_component_1.TestentityPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.testentity.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'testentity/:id/edit',
        component: testentity_dialog_component_1.TestentityPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.testentity.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'testentity/:id/delete',
        component: testentity_delete_dialog_component_1.TestentityDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'marketmanagerApp.testentity.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var HomeComponent = (function () {
    function HomeComponent(jhiLanguageService, principal, loginModalService, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.principal = principal;
        this.loginModalService = loginModalService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['home']);
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
        this.registerAuthenticationSuccess();
    };
    HomeComponent.prototype.registerAuthenticationSuccess = function () {
        var _this = this;
        this.eventManager.subscribe('authenticationSuccess', function (message) {
            _this.principal.identity().then(function (account) {
                _this.account = account;
            });
        });
    };
    HomeComponent.prototype.isAuthenticated = function () {
        return this.principal.isAuthenticated();
    };
    HomeComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return HomeComponent;
}());
HomeComponent = __decorate([
    core_1.Component({
        selector: 'jhi-home',
        template: __webpack_require__(435),
        styles: [
            __webpack_require__(444)
        ]
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        shared_1.LoginModalService,
        ng_jhipster_1.EventManager])
], HomeComponent);
exports.HomeComponent = HomeComponent;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(206);
exports.HOME_ROUTE = {
    path: '',
    component: _1.HomeComponent,
    data: {
        authorities: [],
        pageTitle: 'home.title'
    }
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var error_component_1 = __webpack_require__(207);
exports.errorRoute = [
    {
        path: 'error',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
    },
    {
        path: 'accessdenied',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
    }
];


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FooterComponent = (function () {
    function FooterComponent() {
    }
    return FooterComponent;
}());
FooterComponent = __decorate([
    core_1.Component({
        selector: 'jhi-footer',
        template: __webpack_require__(437)
    })
], FooterComponent);
exports.FooterComponent = FooterComponent;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var app_route_1 = __webpack_require__(247);
var _1 = __webpack_require__(38);
var LAYOUT_ROUTES = [
    app_route_1.navbarRoute
].concat(_1.errorRoute);
var LayoutRoutingModule = (function () {
    function LayoutRoutingModule() {
    }
    return LayoutRoutingModule;
}());
LayoutRoutingModule = __decorate([
    core_1.NgModule({
        imports: [
            router_1.RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
        ],
        exports: [
            router_1.RouterModule
        ]
    })
], LayoutRoutingModule);
exports.LayoutRoutingModule = LayoutRoutingModule;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var JhiMainComponent = (function () {
    function JhiMainComponent(jhiLanguageHelper, router, $storageService) {
        this.jhiLanguageHelper = jhiLanguageHelper;
        this.router = router;
        this.$storageService = $storageService;
    }
    JhiMainComponent.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'marketmanagerApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    JhiMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.jhiLanguageHelper.updateTitle(_this.getPageTitle(_this.router.routerState.snapshot.root));
            }
        });
    };
    return JhiMainComponent;
}());
JhiMainComponent = __decorate([
    core_1.Component({
        selector: 'jhi-main',
        template: __webpack_require__(438)
    }),
    __metadata("design:paramtypes", [shared_1.JhiLanguageHelper,
        router_1.Router,
        shared_1.StateStorageService])
], JhiMainComponent);
exports.JhiMainComponent = JhiMainComponent;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(43);
var ActiveMenuDirective = (function () {
    function ActiveMenuDirective(el, renderer, translateService) {
        this.el = el;
        this.renderer = renderer;
        this.translateService = translateService;
    }
    ActiveMenuDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateActiveFlag(event.lang);
        });
        this.updateActiveFlag(this.translateService.currentLang);
    };
    ActiveMenuDirective.prototype.updateActiveFlag = function (selectedLanguage) {
        if (this.jhiActiveMenu === selectedLanguage) {
            this.renderer.setElementClass(this.el.nativeElement, 'active', true);
        }
        else {
            this.renderer.setElementClass(this.el.nativeElement, 'active', false);
        }
    };
    return ActiveMenuDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ActiveMenuDirective.prototype, "jhiActiveMenu", void 0);
ActiveMenuDirective = __decorate([
    core_1.Directive({
        selector: '[jhiActiveMenu]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, ng2_translate_1.TranslateService])
], ActiveMenuDirective);
exports.ActiveMenuDirective = ActiveMenuDirective;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var profile_service_1 = __webpack_require__(68); // FIXME barrel doesn't work here
var shared_1 = __webpack_require__(3);
var app_constants_1 = __webpack_require__(72);
var navbar_service_1 = __webpack_require__(67);
var NavbarComponent = (function () {
    function NavbarComponent(loginService, languageHelper, languageService, principal, loginModalService, profileService, router, navbarService) {
        this.loginService = loginService;
        this.languageHelper = languageHelper;
        this.languageService = languageService;
        this.principal = principal;
        this.loginModalService = loginModalService;
        this.profileService = profileService;
        this.router = router;
        this.navbarService = navbarService;
        this.version = app_constants_1.DEBUG_INFO_ENABLED ? 'v' + app_constants_1.VERSION : '';
        this.isNavbarCollapsed = true;
        this.languageService.addLocation('home');
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.inProduction = profileInfo.inProduction;
            _this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
    };
    NavbarComponent.prototype.changeLanguage = function (languageKey) {
        this.languageService.changeLanguage(languageKey);
    };
    NavbarComponent.prototype.collapseNavbar = function () {
        this.isNavbarCollapsed = true;
    };
    NavbarComponent.prototype.isAuthenticated = function () {
        return this.principal.isAuthenticated();
    };
    NavbarComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    NavbarComponent.prototype.logout = function () {
        this.collapseNavbar();
        this.loginService.logout();
        this.router.navigate(['']);
    };
    NavbarComponent.prototype.toggleNavbar = function () {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    };
    NavbarComponent.prototype.getImageUrl = function () {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    };
    return NavbarComponent;
}());
NavbarComponent = __decorate([
    core_1.Component({
        selector: 'jhi-navbar',
        template: __webpack_require__(439),
        styles: [
            __webpack_require__(445)
        ]
    }),
    __metadata("design:paramtypes", [shared_1.LoginService,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        shared_1.LoginModalService,
        profile_service_1.ProfileService,
        router_1.Router,
        navbar_service_1.NavbarService])
], NavbarComponent);
exports.NavbarComponent = NavbarComponent;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var profile_service_1 = __webpack_require__(68);
var PageRibbonComponent = (function () {
    function PageRibbonComponent(profileService) {
        this.profileService = profileService;
    }
    PageRibbonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.profileInfo = profileInfo;
            _this.ribbonEnv = profileInfo.ribbonEnv;
        });
    };
    return PageRibbonComponent;
}());
PageRibbonComponent = __decorate([
    core_1.Component({
        selector: 'jhi-page-ribbon',
        template: "<div class=\"ribbon\" *ngIf=\"ribbonEnv\"><a href=\"\" jhiTranslate=\"global.ribbon.{{ribbonEnv}}\">{{ribbonEnv}}</a></div>",
        styles: [
            __webpack_require__(446)
        ]
    }),
    __metadata("design:paramtypes", [profile_service_1.ProfileService])
], PageRibbonComponent);
exports.PageRibbonComponent = PageRibbonComponent;


/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(43);
var ng_jhipster_1 = __webpack_require__(1);
var JhiAlertErrorComponent = (function () {
    function JhiAlertErrorComponent(alertService, eventManager, translateService) {
        var _this = this;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.translateService = translateService;
        this.alerts = [];
        this.cleanHttpErrorListener = eventManager.subscribe('marketmanagerApp.httpError', function (response) {
            var i;
            var httpResponse = response.content;
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    _this.addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;
                case 400:
                    var arr = Array.from(httpResponse.headers._headers);
                    var headers = [];
                    for (i = 0; i < arr.length; i++) {
                        if (arr[i][0].endsWith('app-error') || arr[i][0].endsWith('app-params')) {
                            headers.push(arr[i][0]);
                        }
                    }
                    headers.sort();
                    var errorHeader = null;
                    var entityKey = null;
                    if (headers.length > 1) {
                        errorHeader = httpResponse.headers.get(headers[0]);
                        entityKey = httpResponse.headers.get(headers[1]);
                    }
                    if (errorHeader) {
                        var entityName = translateService.instant('global.menu.entities.' + entityKey);
                        _this.addErrorAlert(errorHeader, errorHeader, { entityName: entityName });
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().fieldErrors) {
                        var fieldErrors = httpResponse.json().fieldErrors;
                        for (i = 0; i < fieldErrors.length; i++) {
                            var fieldError = fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = translateService.instant('marketmanagerApp.' +
                                fieldError.objectName + '.' + convertedField);
                            _this.addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, { fieldName: fieldName });
                        }
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message, httpResponse.json().message, httpResponse.json().params);
                    }
                    else {
                        _this.addErrorAlert(httpResponse.text());
                    }
                    break;
                case 404:
                    _this.addErrorAlert('Not found', 'error.url.not.found');
                    break;
                default:
                    if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message);
                    }
                    else {
                        _this.addErrorAlert(JSON.stringify(httpResponse)); // Fixme find a way to parse httpResponse
                    }
            }
        });
    }
    JhiAlertErrorComponent.prototype.ngOnDestroy = function () {
        if (this.cleanHttpErrorListener !== undefined && this.cleanHttpErrorListener !== null) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
            this.alerts = [];
        }
    };
    JhiAlertErrorComponent.prototype.addErrorAlert = function (message, key, data) {
        key = key && key !== null ? key : message;
        this.alerts.push(this.alertService.addAlert({
            type: 'danger',
            msg: key,
            params: data,
            timeout: 5000,
            toast: this.alertService.isToast(),
            scoped: true
        }, this.alerts));
    };
    return JhiAlertErrorComponent;
}());
JhiAlertErrorComponent = __decorate([
    core_1.Component({
        selector: 'jhi-alert-error',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\"  [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert type=\"{{alert.type}}\" close=\"alert.close(alerts)\"><pre [innerHTML]=\"alert.msg\"></pre></ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService, ng_jhipster_1.EventManager, ng2_translate_1.TranslateService])
], JhiAlertErrorComponent);
exports.JhiAlertErrorComponent = JhiAlertErrorComponent;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var JhiAlertComponent = (function () {
    function JhiAlertComponent(alertService) {
        this.alertService = alertService;
    }
    JhiAlertComponent.prototype.ngOnInit = function () {
        this.alerts = this.alertService.get();
    };
    JhiAlertComponent.prototype.ngOnDestroy = function () {
        this.alerts = [];
    };
    return JhiAlertComponent;
}());
JhiAlertComponent = __decorate([
    core_1.Component({
        selector: 'jhi-alert',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\" [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert [type]=\"alert.type\" (close)=\"alert.close(alerts)\"><pre [innerHTML]=\"alert.msg\"></pre></ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService])
], JhiAlertComponent);
exports.JhiAlertComponent = JhiAlertComponent;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var principal_service_1 = __webpack_require__(33);
/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiHasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
var HasAnyAuthorityDirective = (function () {
    function HasAnyAuthorityDirective(principal, templateRef, viewContainerRef) {
        this.principal = principal;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    Object.defineProperty(HasAnyAuthorityDirective.prototype, "jhiHasAnyAuthority", {
        set: function (value) {
            var _this = this;
            this.authorities = typeof value === 'string' ? [value] : value;
            this.updateView();
            // Get notified each time authentication state changes.
            this.principal.getAuthenticationState().subscribe(function (identity) { return _this.updateView(); });
        },
        enumerable: true,
        configurable: true
    });
    HasAnyAuthorityDirective.prototype.updateView = function () {
        var _this = this;
        this.principal.hasAnyAuthority(this.authorities).then(function (result) {
            _this.viewContainerRef.clear();
            if (result) {
                _this.viewContainerRef.createEmbeddedView(_this.templateRef);
            }
        });
    };
    return HasAnyAuthorityDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], HasAnyAuthorityDirective.prototype, "jhiHasAnyAuthority", null);
HasAnyAuthorityDirective = __decorate([
    core_1.Directive({
        selector: '[jhiHasAnyAuthority]'
    }),
    __metadata("design:paramtypes", [principal_service_1.Principal, core_1.TemplateRef, core_1.ViewContainerRef])
], HasAnyAuthorityDirective);
exports.HasAnyAuthorityDirective = HasAnyAuthorityDirective;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var _1 = __webpack_require__(3);
var login_modal_service_1 = __webpack_require__(69);
var state_storage_service_1 = __webpack_require__(40);
var UserRouteAccessService = (function () {
    function UserRouteAccessService(router, loginModalService, principal, stateStorageService) {
        this.router = router;
        this.loginModalService = loginModalService;
        this.principal = principal;
        this.stateStorageService = stateStorageService;
    }
    UserRouteAccessService.prototype.canActivate = function (route, state) {
        var authorities = route.data['authorities'];
        if (!authorities || authorities.length === 0) {
            return true;
        }
        return this.checkLogin(authorities, state.url);
    };
    UserRouteAccessService.prototype.checkLogin = function (authorities, url) {
        var _this = this;
        var principal = this.principal;
        return Promise.resolve(principal.identity().then(function (account) {
            if (account && principal.hasAnyAuthority(authorities)) {
                return true;
            }
            _this.stateStorageService.storeUrl(url);
            _this.router.navigate(['accessdenied']).then(function () {
                _this.loginModalService.open();
            });
            return false;
        }));
    };
    return UserRouteAccessService;
}());
UserRouteAccessService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        login_modal_service_1.LoginModalService,
        _1.Principal,
        state_storage_service_1.StateStorageService])
], UserRouteAccessService);
exports.UserRouteAccessService = UserRouteAccessService;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS_PER_PAGE = 20;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(71);
var router_1 = __webpack_require__(2);
var ng2_translate_1 = __webpack_require__(441);
var language_constants_1 = __webpack_require__(212);
var JhiLanguageHelper = (function () {
    function JhiLanguageHelper(translateService, titleService, router) {
        this.translateService = translateService;
        this.titleService = titleService;
        this.router = router;
        this.init();
    }
    JhiLanguageHelper.prototype.getAll = function () {
        return Promise.resolve(language_constants_1.LANGUAGES);
    };
    /**
     * Update the window title using params in the following
     * order:
     * 1. titleKey parameter
     * 2. $state.$current.data.pageTitle (current state page title)
     * 3. 'global.title'
     */
    JhiLanguageHelper.prototype.updateTitle = function (titleKey) {
        var _this = this;
        if (!titleKey) {
            titleKey = this.getPageTitle(this.router.routerState.snapshot.root);
        }
        this.translateService.get(titleKey).subscribe(function (title) {
            _this.titleService.setTitle(title);
        });
    };
    JhiLanguageHelper.prototype.init = function () {
        var _this = this;
        this.translateService.onTranslationChange.subscribe(function (event) {
            _this.updateTitle();
        });
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateTitle();
        });
    };
    JhiLanguageHelper.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'marketmanagerApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    return JhiLanguageHelper;
}());
JhiLanguageHelper = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_translate_1.TranslateService, platform_browser_1.Title, router_1.Router])
], JhiLanguageHelper);
exports.JhiLanguageHelper = JhiLanguageHelper;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FindLanguageFromKeyPipe = (function () {
    function FindLanguageFromKeyPipe() {
        this.languages = {
            'ca': 'Català',
            'cs': 'Český',
            'da': 'Dansk',
            'de': 'Deutsch',
            'el': 'Ελληνικά',
            'en': 'English',
            'es': 'Español',
            'et': 'Eesti',
            'fr': 'Français',
            'gl': 'Galego',
            'hu': 'Magyar',
            'hi': 'हिंदी',
            'hy': 'Հայերեն',
            'it': 'Italiano',
            'ja': '日本語',
            'ko': '한국어',
            'mr': 'मराठी',
            'nl': 'Nederlands',
            'pl': 'Polski',
            'pt-br': 'Português (Brasil)',
            'pt-pt': 'Português',
            'ro': 'Română',
            'ru': 'Русский',
            'sk': 'Slovenský',
            'sr': 'Srpski',
            'sv': 'Svenska',
            'ta': 'தமிழ்',
            'th': 'ไทย',
            'tr': 'Türkçe',
            'vi': 'Tiếng Việt',
            'zh-cn': '中文（简体）',
            'zh-tw': '繁體中文'
        };
    }
    FindLanguageFromKeyPipe.prototype.transform = function (lang) {
        return this.languages[lang];
    };
    return FindLanguageFromKeyPipe;
}());
FindLanguageFromKeyPipe = __decorate([
    core_1.Pipe({ name: 'findLanguageFromKey' })
], FindLanguageFromKeyPipe);
exports.FindLanguageFromKeyPipe = FindLanguageFromKeyPipe;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(71);
var ng2_translate_1 = __webpack_require__(43);
var ng_jhipster_1 = __webpack_require__(1);
var window_service_1 = __webpack_require__(215);
var _1 = __webpack_require__(3);
function alertServiceProvider(sanitizer, translateService) {
    // set below to true to make alerts look like toast
    var isToast = false;
    return new ng_jhipster_1.AlertService(sanitizer, isToast, translateService);
}
exports.alertServiceProvider = alertServiceProvider;
var MarketmanagerSharedCommonModule = (function () {
    function MarketmanagerSharedCommonModule() {
    }
    return MarketmanagerSharedCommonModule;
}());
MarketmanagerSharedCommonModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.MarketmanagerSharedLibsModule
        ],
        declarations: [
            _1.FindLanguageFromKeyPipe,
            _1.JhiAlertComponent,
            _1.JhiAlertErrorComponent
        ],
        providers: [
            _1.JhiLanguageHelper,
            window_service_1.WindowRef,
            {
                provide: ng_jhipster_1.AlertService,
                useFactory: alertServiceProvider,
                deps: [core_1.Sanitizer, ng2_translate_1.TranslateService]
            },
            platform_browser_1.Title
        ],
        exports: [
            _1.MarketmanagerSharedLibsModule,
            _1.FindLanguageFromKeyPipe,
            _1.JhiAlertComponent,
            _1.JhiAlertErrorComponent
        ]
    })
], MarketmanagerSharedCommonModule);
exports.MarketmanagerSharedCommonModule = MarketmanagerSharedCommonModule;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(447);
var http_1 = __webpack_require__(5);
var common_1 = __webpack_require__(7);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var angular2_infinite_scroll_1 = __webpack_require__(449);
var MarketmanagerSharedLibsModule = (function () {
    function MarketmanagerSharedLibsModule() {
    }
    return MarketmanagerSharedLibsModule;
}());
MarketmanagerSharedLibsModule = __decorate([
    core_1.NgModule({
        imports: [
            ng_bootstrap_1.NgbModule.forRoot(),
            ng_jhipster_1.NgJhipsterModule.forRoot({
                i18nEnabled: true,
                defaultI18nLang: 'de'
            }),
            angular2_infinite_scroll_1.InfiniteScrollModule
        ],
        exports: [
            forms_1.FormsModule,
            http_1.HttpModule,
            common_1.CommonModule,
            ng_bootstrap_1.NgbModule,
            ng_jhipster_1.NgJhipsterModule,
            angular2_infinite_scroll_1.InfiniteScrollModule
        ]
    })
], MarketmanagerSharedLibsModule);
exports.MarketmanagerSharedLibsModule = MarketmanagerSharedLibsModule;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(7);
var cookies_service_1 = __webpack_require__(453);
var _1 = __webpack_require__(3);
var navbar_service_1 = __webpack_require__(67);
var MarketmanagerSharedModule = (function () {
    function MarketmanagerSharedModule() {
    }
    return MarketmanagerSharedModule;
}());
MarketmanagerSharedModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.MarketmanagerSharedLibsModule,
            _1.MarketmanagerSharedCommonModule
        ],
        declarations: [
            _1.JhiLoginModalComponent,
            _1.HasAnyAuthorityDirective
        ],
        providers: [
            cookies_service_1.CookieService,
            _1.LoginService,
            _1.LoginModalService,
            _1.AccountService,
            _1.StateStorageService,
            _1.Principal,
            _1.CSRFService,
            _1.JhiTrackerService,
            _1.AuthServerProvider,
            _1.AuthService,
            _1.UserService,
            common_1.DatePipe,
            navbar_service_1.NavbarService
        ],
        entryComponents: [_1.JhiLoginModalComponent],
        exports: [
            _1.MarketmanagerSharedCommonModule,
            _1.JhiLoginModalComponent,
            _1.HasAnyAuthorityDirective,
            common_1.DatePipe
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], MarketmanagerSharedModule);
exports.MarketmanagerSharedModule = MarketmanagerSharedModule;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Account = (function () {
    function Account(activated, authorities, email, firstName, langKey, lastName, login, imageUrl) {
        this.activated = activated;
        this.authorities = authorities;
        this.email = email;
        this.firstName = firstName;
        this.langKey = langKey;
        this.lastName = lastName;
        this.login = login;
        this.imageUrl = imageUrl;
    }
    return Account;
}());
exports.Account = Account;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var User = (function () {
    function User(id, login, firstName, lastName, email, activated, langKey, authorities, createdBy, createdDate, lastModifiedBy, lastModifiedDate, password) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
    }
    return User;
}());
exports.User = User;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var UserService = (function () {
    function UserService(http) {
        this.http = http;
        this.resourceUrl = 'api/users';
    }
    UserService.prototype.create = function (user) {
        return this.http.post(this.resourceUrl, user);
    };
    UserService.prototype.update = function (user) {
        return this.http.put(this.resourceUrl, user);
    };
    UserService.prototype.find = function (login) {
        return this.http.get(this.resourceUrl + "/" + login).map(function (res) { return res.json(); });
    };
    UserService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        var options = {
            search: params
        };
        return this.http.get(this.resourceUrl, options);
    };
    UserService.prototype.delete = function (login) {
        return this.http.delete(this.resourceUrl + "/" + login);
    };
    return UserService;
}());
UserService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], UserService);
exports.UserService = UserService;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, "ul#strength{display:inline;list-style:none;margin:0;margin-left:15px;padding:0;vertical-align:2px}.point{background:#ddd;border-radius:2px;display:inline-block;height:5px;margin-right:1px;width:20px}.point:last{margin:0!important}", ""]);

// exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".hipster{display:inline-block;width:347px;height:497px;background:url(" + __webpack_require__(333) + ") no-repeat top;background-size:contain}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.hipster{background:url(" + __webpack_require__(334) + ") no-repeat top;background-size:contain}}", ""]);

// exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".navbar-version{font-size:10px;color:#ccc}.jh-navbar{background-color:#353d47;padding:.2em 1em}.jh-navbar .profile-image{margin:-10px 0;height:40px;width:40px;border-radius:50%}.jh-navbar .dropdown-item.active,.jh-navbar .dropdown-item.active:focus,.jh-navbar .dropdown-item.active:hover{background-color:#353d47}.jh-navbar .dropdown-toggle:after{margin-left:.15em}.jh-navbar ul.navbar-nav{padding:.5em}.jh-navbar ul.navbar-nav .nav-item{margin-left:1.5rem}.jh-navbar a.nav-link{font-weight:400}.jh-navbar .jh-navbar-toggler{color:#ccc;font-size:1.5em;padding:10px}.jh-navbar .jh-navbar-toggler:hover{color:#fff}@media screen and (max-width:992px){.jh-logo-container{width:100%}}.navbar-title{display:inline-block;vertical-align:middle}.navbar-brand.logo{padding:5px 15px}.navbar-brand.logo .logo-img{height:45px;width:70px;display:inline-block;vertical-align:middle;background:url(" + __webpack_require__(335) + ") no-repeat 50%;background-size:contain}", ""]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(34)(undefined);
// imports


// module
exports.push([module.i, ".ribbon{background-color:rgba(170,0,0,.5);left:-3.5em;moz-transform:rotate(-45deg);ms-transform:rotate(-45deg);o-transform:rotate(-45deg);webkit-transform:rotate(-45deg);transform:rotate(-45deg);overflow:hidden;position:absolute;top:40px;white-space:nowrap;width:15em;z-index:9999;opacity:.75}.ribbon,.ribbon a{pointer-events:none}.ribbon a{color:#fff;display:block;font-weight:400;margin:1px 0;padding:10px 50px;text-align:center;text-decoration:none;text-shadow:0 0 5px #444}", ""]);

// exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca854e6d0785ba4b9d715049c0bdbcb3.png";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1cd3a1d782e85ba37677c1a2099bc002.png";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a30deb26b4eb1521433021e326cbcc2c.png";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-8 offset-md-2\"> <h1 jhiTranslate=\"activate.title\">Activation</h1> <div class=\"alert alert-success\" *ngIf=\"success\"> <span jhiTranslate=\"activate.messages.success\"> <strong>Your user has been activated.</strong> Please <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign in</a>. </span> </div> <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"activate.messages.error\"> <strong>Your user could not be activated.</strong> Please use the registration form to sign up. </div> </div> </div> </div> ";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-4 col-md-offset-4\"> <h1 jhiTranslate=\"reset.finish.title\">Reset password</h1> <div class=\"alert alert-danger\" jhiTranslate=\"reset.finish.messages.keymissing\" *ngIf=\"keyMissing\"> <strong>The password reset key is missing.</strong> </div> <div class=\"alert alert-warning\" *ngIf=\"!success && !keyMissing\"> <p jhiTranslate=\"reset.finish.messages.info\">Choose a new password</p> </div> <div class=\"alert alert-danger\" *ngIf=\"error\"> <p jhiTranslate=\"reset.finish.messages.error\">Your password couldn't be reset. Remember a password request is only valid for 24 hours.</p> </div> <p class=\"alert alert-success\" *ngIf=\"success\"> <span jhiTranslate=\"reset.finish.messages.success\"><strong>Your password has been reset.</strong></span> </p> <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\"> The password and its confirmation do not match! </div> <div *ngIf=\"!keyMissing\"> <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"finishReset()\" #passwordForm=\"ngForm\"> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #passwordInput=\"ngModel\" placeholder=\"{{'global.form.newpassword.placeholder' | translate}}\" [(ngModel)]=\"resetAccount.password\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.required\" jhiTranslate=\"global.messages.validate.newpassword.required\"> Your password is required. </small> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.newpassword.minlength\"> Your password is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.newpassword.maxlength\"> Your password cannot be longer than 50 characters. </small> </div> <jhi-password-strength-bar [passwordToCheck]=\"resetAccount.password\"></jhi-password-strength-bar> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" #confirmPasswordInput=\"ngModel\" placeholder=\"{{'global.form.confirmpassword.placeholder' | translate}}\" [(ngModel)]=\"confirmPassword\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.required\" jhiTranslate=\"global.messages.validate.confirmpassword.required\"> Your password confirmation is required. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.confirmpassword.minlength\"> Your password confirmation is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\"> Your password confirmation cannot be longer than 50 characters. </small> </div> </div> <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"reset.finish.form.button\">Reset Password</button> </form> </div> </div> </div> </div> ";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-8 offset-md-2\"> <h1 jhiTranslate=\"reset.request.title\">Reset your password</h1> <div class=\"alert alert-danger\" jhiTranslate=\"reset.request.messages.notfound\" *ngIf=\"errorEmailNotExists\"> <strong>Email address isn't registered!</strong> Please check and try again. </div> <div class=\"alert alert-warning\" *ngIf=\"!success\"> <p jhiTranslate=\"reset.request.messages.info\">Enter the email address you used to register.</p> </div> <div class=\"alert alert-success\" *ngIf=\"success == 'OK'\"> <p jhiTranslate=\"reset.request.messages.success\">Check your emails for details on how to reset your password.</p> </div> <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"requestReset()\" #resetRequestForm=\"ngForm\"> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{'global.form.email.placeholder' | translate}}\" [(ngModel)]=\"resetAccount.email\" minlength=\"5\" maxlength=\"100\" #emailInput=\"ngModel\" required> <div *ngIf=\"emailInput.dirty && emailInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.required\" jhiTranslate=\"global.messages.validate.email.required\"> Your email is required. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\"> Your email is invalid. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.minlength\" jhiTranslate=\"global.messages.validate.email.minlength\"> Your email is required to be at least 5 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.email.maxlength\"> Your email cannot be longer than 100 characters. </small> </div> </div> <button type=\"submit\" [disabled]=\"resetRequestForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"reset.request.form.button\">Reset</button> </form> </div> </div> </div> ";

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-8 offset-md-2\"> <h2 jhiTranslate=\"password.title\" translateValues=\"{username: '{{account.login}}'}\" *ngIf=\"account\">Password for [<b>{{account.login}}</b>]</h2> <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"password.messages.success\"> <strong>Password changed!</strong> </div> <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"password.messages.error\"> <strong>An error has occurred!</strong> The password could not be changed. </div> <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\"> The password and its confirmation do not match! </div> <form name=\"form\" role=\"form\" (ngSubmit)=\"changePassword()\" #passwordForm=\"ngForm\"> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #passwordInput=\"ngModel\" placeholder=\"{{'global.form.newpassword.placeholder' | translate}}\" [(ngModel)]=\"password\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.required\" jhiTranslate=\"global.messages.validate.newpassword.required\"> Your password is required. </small> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.newpassword.minlength\"> Your password is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"passwordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.newpassword.maxlength\"> Your password cannot be longer than 50 characters. </small> </div> <jhi-password-strength-bar [passwordToCheck]=\"password\"></jhi-password-strength-bar> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" #confirmPasswordInput=\"ngModel\" placeholder=\"{{'global.form.confirmpassword.placeholder' | translate}}\" [(ngModel)]=\"confirmPassword\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.required\" jhiTranslate=\"global.messages.validate.confirmpassword.required\"> Your confirmation password is required. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.confirmpassword.minlength\"> Your confirmation password is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\"> Your confirmation password cannot be longer than 50 characters. </small> </div> </div> <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"password.form.button\">Save</button> </form> </div> </div> </div> ";

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-8 offset-md-2\"> <h1 jhiTranslate=\"register.title\">Registration</h1> <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"register.messages.success\"> <strong>Registration saved!</strong> Please check your email for confirmation. </div> <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"register.messages.error.fail\"> <strong>Registration failed!</strong> Please try again later. </div> <div class=\"alert alert-danger\" *ngIf=\"errorUserExists\" jhiTranslate=\"register.messages.error.userexists\"> <strong>Login name already registered!</strong> Please choose another one. </div> <div class=\"alert alert-danger\" *ngIf=\"errorEmailExists\" jhiTranslate=\"register.messages.error.emailexists\"> <strong>Email is already in use!</strong> Please choose another one. </div> <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\"> The password and its confirmation do not match! </div> </div> <div class=\"col-md-8 offset-md-2\"> <form name=\"form\" role=\"form\" (ngSubmit)=\"register()\" #registerForm=\"ngForm\"> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"login\" jhiTranslate=\"global.form.username\">Username</label> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"registerAccount.login\" id=\"login\" name=\"login\" #login=\"ngModel\" placeholder=\"{{'global.form.username.placeholder' | translate}}\" required minlength=\"1\" maxlength=\"50\" pattern=\"^[_'.@A-Za-z0-9-]*$\"> <div *ngIf=\"login.dirty && login.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"login.errors.required\" jhiTranslate=\"register.messages.validate.login.required\"> Your username is required. </small> <small class=\"form-text text-danger\" *ngIf=\"login.errors.minlength\" jhiTranslate=\"register.messages.validate.login.minlength\"> Your username is required to be at least 1 character. </small> <small class=\"form-text text-danger\" *ngIf=\"login.errors.maxlength\" jhiTranslate=\"register.messages.validate.login.maxlength\"> Your username cannot be longer than 50 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"login.errors.pattern\" jhiTranslate=\"register.messages.validate.login.pattern\"> Your username can only contain lower-case letters and digits. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" #email=\"ngModel\" placeholder=\"{{'global.form.email.placeholder' | translate}}\" [(ngModel)]=\"registerAccount.email\" minlength=\"5\" maxlength=\"100\" required> <div *ngIf=\"email.dirty && email.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"email.errors.required\" jhiTranslate=\"global.messages.validate.email.required\"> Your email is required. </small> <small class=\"form-text text-danger\" *ngIf=\"email.errors.invalid\" jhiTranslate=\"global.messages.validate.email.invalid\"> Your email is invalid. </small> <small class=\"form-text text-danger\" *ngIf=\"email.errors.minlength\" jhiTranslate=\"global.messages.validate.email.minlength\"> Your email is required to be at least 5 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"email.errors.maxlength\" jhiTranslate=\"global.messages.validate.email.maxlength\"> Your email cannot be longer than 100 characters. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #password=\"ngModel\" placeholder=\"{{'global.form.newpassword.placeholder' | translate}}\" [(ngModel)]=\"registerAccount.password\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"password.dirty && password.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"password.errors.required\" jhiTranslate=\"global.messages.validate.newpassword.required\"> Your password is required. </small> <small class=\"form-text text-danger\" *ngIf=\"password.errors.minlength\" jhiTranslate=\"global.messages.validate.newpassword.minlength\"> Your password is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"password.errors.maxlength\" jhiTranslate=\"global.messages.validate.newpassword.maxlength\"> Your password cannot be longer than 50 characters. </small> </div> <jhi-password-strength-bar [passwordToCheck]=\"registerAccount.password\"></jhi-password-strength-bar> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" #confirmPasswordInput=\"ngModel\" placeholder=\"{{'global.form.confirmpassword.placeholder' | translate}}\" [(ngModel)]=\"confirmPassword\" minlength=\"4\" maxlength=\"50\" required> <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.required\" jhiTranslate=\"global.messages.validate.confirmpassword.required\"> Your confirmation password is required. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.minlength\" jhiTranslate=\"global.messages.validate.confirmpassword.minlength\"> Your confirmation password is required to be at least 4 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"confirmPasswordInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\"> Your confirmation password cannot be longer than 50 characters. </small> </div> </div> <button type=\"submit\" [disabled]=\"registerForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"register.form.button\">Register</button> </form> <p></p> <div class=\"alert alert-warning\"> <span jhiTranslate=\"global.messages.info.authenticated.prefix\">If you want to </span> <a class=\"alert-link\" (click)=\"openLogin()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign in</a><span jhiTranslate=\"global.messages.info.authenticated.suffix\">, you can try the default accounts:<br/>- Administrator (login=\"admin\" and password=\"admin\") <br/>- User (login=\"user\" and password=\"user\").</span> </div> </div> </div> </div> ";

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-8 offset-md-2\"> <h2 jhiTranslate=\"settings.title\" translateValues=\"{username: '{{settingsAccount.login}}'}\" *ngIf=\"settingsAccount\">User settings for [<b>{{settingsAccount.login}}</b>]</h2> <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"settings.messages.success\"> <strong>Settings saved!</strong> </div> <jhi-alert-error></jhi-alert-error> <form name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #settingsForm=\"ngForm\" *ngIf=\"settingsAccount\" novalidate> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"firstName\" jhiTranslate=\"settings.form.firstname\">First Name</label> <input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{'settings.form.firstname.placeholder' | translate}}\" [(ngModel)]=\"settingsAccount.firstName\" minlength=\"1\" maxlength=\"50\" #firstNameInput=\"ngModel\" required> <div *ngIf=\"firstNameInput.dirty && firstNameInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"firstNameInput.errors.required\" jhiTranslate=\"settings.messages.validate.firstname.required\"> Your first name is required. </small> <small class=\"form-text text-danger\" *ngIf=\"firstNameInput.errors.minlength\" jhiTranslate=\"settings.messages.validate.firstname.minlength\"> Your first name is required to be at least 1 character. </small> <small class=\"form-text text-danger\" *ngIf=\"firstNameInput.errors.maxlength\" jhiTranslate=\"settings.messages.validate.firstname.maxlength\"> Your first name cannot be longer than 50 characters. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"lastName\" jhiTranslate=\"settings.form.lastname\">Last Name</label> <input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{'settings.form.lastname.placeholder' | translate}}\" [(ngModel)]=\"settingsAccount.lastName\" minlength=\"1\" maxlength=\"50\" #lastNameInput=\"ngModel\" required> <div *ngIf=\"lastNameInput.dirty && lastNameInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"lastNameInput.errors.required\" jhiTranslate=\"settings.messages.validate.lastname.required\"> Your last name is required. </small> <small class=\"form-text text-danger\" *ngIf=\"lastNameInput.errors.minlength\" jhiTranslate=\"settings.messages.validate.lastname.minlength\"> Your last name is required to be at least 1 character. </small> <small class=\"form-text text-danger\" *ngIf=\"lastNameInput.errors.maxlength\" jhiTranslate=\"settings.messages.validate.lastname.maxlength\"> Your last name cannot be longer than 50 characters. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{'global.form.email.placeholder' | translate}}\" [(ngModel)]=\"settingsAccount.email\" minlength=\"5\" maxlength=\"100\" #emailInput=\"ngModel\" required> <div *ngIf=\"emailInput.dirty && emailInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.required\" jhiTranslate=\"global.messages.validate.email.required\"> Your email is required. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\"> Your email is invalid. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.minlength\" jhiTranslate=\"global.messages.validate.email.minlength\"> Your email is required to be at least 5 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"global.messages.validate.email.maxlength\"> Your email cannot be longer than 100 characters. </small> </div> </div> <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\"> <label for=\"langKey\" jhiTranslate=\"settings.form.language\">Language</label> <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"settingsAccount.langKey\"> <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}</option> </select> </div> <button type=\"submit\" [disabled]=\"settingsForm.form.invalid\" class=\"btn btn-primary\" jhiTranslate=\"settings.form.button\">Save</button> </form> </div> </div> </div> ";

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"audits\"> <h2 jhiTranslate=\"audits.title\">Audits</h2> <div class=\"row\"> <div class=\"col-md-5\"> <h4 jhiTranslate=\"audits.filter.title\">Filter by date</h4> <p class=\"d-flex\"> <span jhiTranslate=\"audits.filter.from\" class=\"input-group-addon\">from</span> <input type=\"date\" class=\"form-control\" name=\"start\" [(ngModel)]=\"fromDate\" (ngModelChange)=\"onChangeDate($event)\" required/> <span jhiTranslate=\"audits.filter.to\" class=\"input-group-addon\">to</span> <input type=\"date\" class=\"form-control\" name=\"end\" [(ngModel)]=\"toDate\" (ngModelChange)=\"onChangeDate($event)\" required/> </p> </div> </div> <div class=\"table-responsive\"> <table class=\"table table-condensed table-striped table-bordered\"> <thead> <tr> <th (click)=\"orderProp = 'timestamp'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.date\">Date</span></th> <th (click)=\"orderProp = 'principal'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.principal\">User</span></th> <th (click)=\"orderProp = 'type'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.status\">State</span></th> <th (click)=\"orderProp = 'data.message'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.data\">Extra data</span></th> </tr> </thead> <tr *ngFor=\"let audit of getAudits()\"> <td><span>{{audit.timestamp| date:'medium'}}</span></td> <td><small>{{audit.principal}}</small></td> <td>{{audit.type}}</td> <td> <span *ngIf=\"audit.data\" ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span *ngIf=\"audit.data\" ng-show=\"audit.data.remoteAddress\"><span jhiTranslate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span> </td> </tr> </table> </div> <div *ngIf=\"audits\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"totalItems\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"allConfiguration && configuration\"> <h2 jhiTranslate=\"configuration.title\">Configuration</h2> <span jhiTranslate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\"> <label>Spring configuration</label> <table class=\"table table-striped table-bordered table-responsive d-table\"> <thead> <tr> <th class=\"w-40\" (click)=\"orderProp = 'prefix'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.prefix\">Prefix</span></th> <th class=\"w-60\" (click)=\"orderProp = 'properties'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.properties\">Properties</span></th> </tr> </thead> <tbody> <tr *ngFor=\"let entry of (configuration | pureFilter:filter:'prefix' | orderBy:orderProp:reverse)\"> <td><span>{{entry.prefix}}</span></td> <td> <div class=\"row\" *ngFor=\"let key of keys(entry.properties)\"> <div class=\"col-md-4\">{{key}}</div> <div class=\"col-md-8\"> <span class=\"float-right badge badge-default break\">{{entry.properties[key] | json}}</span> </div> </div> </td> </tr> </tbody> </table> <div *ngFor=\"let key of keys(allConfiguration)\"> <label><span>{{key}}</span></label> <table class=\"table table-sm table-striped table-bordered table-responsive d-table\"> <thead> <tr> <th class=\"w-40\">Property</th> <th class=\"w-60\">Value</th> </tr> </thead> <tbody> <tr *ngFor=\"let item of allConfiguration[key]\"> <td class=\"break\">{{item.key}}</td> <td class=\"break\"> <span class=\"float-right badge badge-default break\">{{item.val}}</span> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<iframe src=\"swagger-ui/index.html\" width=\"100%\" height=\"900\" seamless target=\"_top\" title=\"Swagger UI\" class=\"border-0\"></iframe> ";

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"showHealthLabel\"> {{'health.indicator.' + baseName(currentHealth.name) | translate}} {{subSystemName(currentHealth.name)}} </h4> <button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('closed')\"><span aria-hidden=\"true\">&times;</span> </button> </div> <div class=\"modal-body pad\"> <div *ngIf=\"currentHealth.details\"> <h5 jhiTranslate=\"health.details.properties\">Properties</h5> <div class=\"table-responsive\"> <table class=\"table table-striped\"> <thead> <tr> <th class=\"text-left\" jhiTranslate=\"health.details.name\">Name</th> <th class=\"text-left\" jhiTranslate=\"health.details.value\">Value</th> </tr> </thead> <tbody> <tr *ngFor=\"let entry of currentHealth.details | keys\"> <td class=\"text-left\">{{entry.key}}</td> <td class=\"text-left\">{{readableValue(entry.value)}}</td> </tr> </tbody> </table> </div> </div> <div *ngIf=\"currentHealth.error\"> <h4 jhiTranslate=\"health.details.error\">Error</h4> <pre>{{currentHealth.error}}</pre> </div> </div> <div class=\"modal-footer\"> <button data-dismiss=\"modal\" class=\"btn btn-secondary float-left\" type=\"button\" (click)=\"activeModal.dismiss('closed')\">Done</button> </div> ";

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"health.title\">Health Checks</span> <button class=\"btn btn-primary float-right\" (click)=\"refresh()\"> <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"health.refresh.button\">Refresh</span> </button> </h2> <div class=\"table-responsive\"> <table id=\"healthCheck\" class=\"table table-striped\"> <thead> <tr> <th jhiTranslate=\"health.table.service\">Service Name</th> <th class=\"text-center\" jhiTranslate=\"health.table.status\">Status</th> <th class=\"text-center\" jhiTranslate=\"health.details.details\">Details</th> </tr> </thead> <tbody> <tr *ngFor=\"let health of healthData\"> <td>{{'health.indicator.' + baseName(health.name) | translate}} {{subSystemName(health.name)}}</td> <td class=\"text-center\"> <span class=\"badge\" [ngClass]=\"getBadgeClass(health.status)\" jhiTranslate=\"{{'health.status.' + health.status}}\"> {{health.status}} </span> </td> <td class=\"text-center\"> <a class=\"hand\" (click)=\"showHealth(health)\" *ngIf=\"health.details || health.error\"> <i class=\"fa fa-eye\"></i> </a> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\" *ngIf=\"loggers\"> <h2 jhiTranslate=\"logs.title\">Logs</h2> <p jhiTranslate=\"logs.nbloggers\" translateValues=\"{total: '{{ loggers.length }}'}\">There are {{ loggers.length }} loggers.</p> <span jhiTranslate=\"logs.filter\">Filter</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\"> <table class=\"table table-condensed table-striped table-bordered\"> <thead> <tr title=\"click to order\"> <th (click)=\"orderProp = 'name'; reverse=!reverse\"><span jhiTranslate=\"logs.table.name\">Name</span></th> <th (click)=\"orderProp = 'level'; reverse=!reverse\"><span jhiTranslate=\"logs.table.level\">Level</span></th> </tr> </thead> <tr *ngFor=\"let logger of (loggers | pureFilter:filter:'name' | orderBy:orderProp:reverse)\"> <td><small>{{logger.name | slice:0:140}}</small></td> <td> <button (click)=\"changeLevel(logger.name, 'TRACE')\" [ngClass]=\"(logger.level=='TRACE') ? 'btn-danger' : 'btn-secondary'\" class=\"btn btn-sm\">TRACE</button> <button (click)=\"changeLevel(logger.name, 'DEBUG')\" [ngClass]=\"(logger.level=='DEBUG') ? 'btn-warning' : 'btn-secondary'\" class=\"btn btn-sm\">DEBUG</button> <button (click)=\"changeLevel(logger.name, 'INFO')\" [ngClass]=\"(logger.level=='INFO') ? 'btn-info' : 'btn-secondary'\" class=\"btn btn-sm\">INFO</button> <button (click)=\"changeLevel(logger.name, 'WARN')\" [ngClass]=\"(logger.level=='WARN') ? 'btn-success' : 'btn-secondary'\" class=\"btn btn-sm\">WARN</button> <button (click)=\"changeLevel(logger.name, 'ERROR')\" [ngClass]=\"(logger.level=='ERROR') ? 'btn-primary' : 'btn-secondary'\" class=\"btn btn-sm\">ERROR</button> </td> </tr> </table> </div> ";

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = " <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"metrics.jvm.threads.dump.title\">Threads dump</h4> <button type=\"button\" class=\"close\" (click)=\"activeModal.dismiss('closed')\">&times;</button> </div> <div class=\"modal-body\"> <span class=\"badge badge-primary\" (click)=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpAll}}</span></span>&nbsp; <span class=\"badge badge-success\" (click)=\"threadDumpFilter = {threadState: 'RUNNABLE'}\">Runnable&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpRunnable}}</span></span>&nbsp; <span class=\"badge badge-info\" (click)=\"threadDumpFilter = {threadState: 'WAITING'}\">Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpWaiting}}</span></span>&nbsp; <span class=\"badge badge-warning\" (click)=\"threadDumpFilter = {threadState: 'TIMED_WAITING'}\">Timed Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"badge badge-danger\" (click)=\"threadDumpFilter = {threadState: 'BLOCKED'}\">Blocked&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpBlocked}}</span></span>&nbsp; <div class=\"mt-2\">&nbsp;</div> Filter <input type=\"text\" [(ngModel)]=\"threadDumpFilter\" class=\"form-control\"> <div class=\"pad\" *ngFor=\"let entry of threadDump | pureFilter:threadDumpFilter:'lockName' | keys\"> <h6> <span class=\"badge\" [ngClass]=\"getBadgeClass(entry.value.threadState)\">{{entry.value.threadState}}</span>&nbsp;{{entry.value.threadName}} (ID {{entry.value.threadId}}) <a (click)=\"entry.show = !entry.show\" href=\"javascript:void(0);\"> <span [hidden]=\"entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span [hidden]=\"!entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span> </a> </h6> <div class=\"card\" [hidden]=\"!entry.show\"> <div class=\"card-block\"> <div *ngFor=\"let st of entry.value.stackTrace | keys\" class=\"break\"> <samp>{{st.value.className}}.{{st.value.methodName}}(<code>{{st.value.fileName}}:{{st.value.lineNumber}}</code>)</samp> <span class=\"mt-1\"></span> </div> </div> </div> <table class=\"table table-sm table-responsive\"> <thead> <tr> <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th> <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th> <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th> <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th> <th jhiTranslate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th> </tr> </thead> <tbody> <tr> <td>{{entry.value.blockedTime}}</td> <td>{{entry.value.blockedCount}}</td> <td>{{entry.value.waitedTime}}</td> <td>{{entry.value.waitedCount}}</td> <td><code>{{entry.value.lockName}}</code></td> </tr> </tbody> </table> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary pull-left\" data-dismiss=\"modal\" (click)=\"activeModal.dismiss('closed')\">Done</button> </div> ";

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"metrics.title\">Application Metrics</span> <button class=\"btn btn-primary float-right\" (click)=\"refresh()\"> <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"metrics.refresh.button\">Refresh</span> </button> </h2> <h3 jhiTranslate=\"metrics.jvm.title\">JVM Metrics</h3> <div class=\"row\" *ngIf=\"!updatingMetrics\"> <div class=\"col-md-4\"> <b jhiTranslate=\"metrics.jvm.memory.title\">Memory</b> <p><span jhiTranslate=\"metrics.jvm.memory.total\">Total Memory</span> ({{metrics.gauges['jvm.memory.total.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.total.max'].value / 1000000 | number:'1.0-0'}}M)</p> <ngb-progressbar type=\"success\" [max]=\"metrics.gauges['jvm.memory.total.max'].value\" [value]=\"metrics.gauges['jvm.memory.total.used'].value\" [striped]=\"true\" [animated]=\"true\"> <span>{{metrics.gauges['jvm.memory.total.used'].value * 100 / metrics.gauges['jvm.memory.total.max'].value | number:'1.0-0'}}%</span> </ngb-progressbar> <p><span jhiTranslate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{metrics.gauges['jvm.memory.heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.heap.max'].value / 1000000 | number:'1.0-0'}}M)</p> <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.heap.max'].value\" [value]=\"metrics.gauges['jvm.memory.heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.gauges['jvm.memory.heap.used'].value * 100 / metrics.gauges['jvm.memory.heap.max'].value | number:'1.0-0'}}%</span> </ngb-progressbar> <p><span jhiTranslate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{metrics.gauges['jvm.memory.non-heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.non-heap.committed'].value / 1000000 | number:'1.0-0'}}M)</p> <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.non-heap.committed'].value\" [value]=\"metrics.gauges['jvm.memory.non-heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.gauges['jvm.memory.non-heap.used'].value * 100 / metrics.gauges['jvm.memory.non-heap.committed'].value | number:'1.0-0'}}%</span> </ngb-progressbar> </div> <div class=\"col-md-4\"> <b jhiTranslate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{metrics.gauges['jvm.threads.count'].value}}) <a class=\"hand\" (click)=\"refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"fa fa-eye\"></i></a> <p><span jhiTranslate=\"metrics.jvm.threads.runnable\">Runnable</span> {{metrics.gauges['jvm.threads.runnable.count'].value}}</p> <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.runnable.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.gauges['jvm.threads.runnable.count'].value * 100 / metrics.gauges['jvm.threads.count'].value | number:'1.0-0'}}%</span> </ngb-progressbar> <p><span jhiTranslate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{metrics.gauges['jvm.threads.timed_waiting.count'].value}})</p> <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.timed_waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\"> <span>{{metrics.gauges['jvm.threads.timed_waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value | number:'1.0-0'}}%</span> </ngb-progressbar> <p><span jhiTranslate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{metrics.gauges['jvm.threads.waiting.count'].value}})</p> <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\"> <span>{{metrics.gauges['jvm.threads.waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value | number:'1.0-0'}}%</span> </ngb-progressbar> <p><span jhiTranslate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{metrics.gauges['jvm.threads.blocked.count'].value}})</p> <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.blocked.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.gauges['jvm.threads.blocked.count'].value * 100 / metrics.gauges['jvm.threads.count'].value | number:'1.0-0'}}%</span> </ngb-progressbar> </div> <div class=\"col-md-4\"> <b jhiTranslate=\"metrics.jvm.gc.title\">Garbage collections</b> <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-MarkSweep.count']\"> <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div> <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.count'].value}}</div> </div> <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-MarkSweep.time']\"> <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div> <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.time'].value}}ms</div> </div> <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-Scavenge.count']\"> <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div> <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.count'].value}}</div> </div> <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-Scavenge.time']\"> <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div> <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.time'].value}}ms</div> </div> </div> </div> <div class=\"well well-lg\" *ngIf=\"updatingMetrics\" jhiTranslate=\"metrics.updating\">Updating...</div> <h3 jhiTranslate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3> <p *ngIf=\"metrics.counters\"> <span jhiTranslate=\"metrics.jvm.http.active\">Active requests</span> <b>{{metrics.counters['com.codahale.metrics.servlet.InstrumentedFilter.activeRequests'].count | number:'1.0-0'}}</b> - <span jhiTranslate=\"metrics.jvm.http.total\">Total requests</span> <b>{{metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count | number:'1.0-0'}}</b> </p> <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\"> <table class=\"table table-striped\"> <thead> <tr> <th jhiTranslate=\"metrics.jvm.http.table.code\">Code</th> <th jhiTranslate=\"metrics.jvm.http.table.count\">Count</th> <th class=\"text-right\" jhiTranslate=\"metrics.jvm.http.table.mean\">Mean</th> <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th> <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th> <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th> </tr> </thead> <tbody> <tr> <td jhiTranslate=\"metrics.jvm.http.code.ok\">OK</td> <td> <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count}}</span> </ngb-progressbar> </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].mean_rate | number:'1.0-2'}} </td> <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m1_rate | number:'1.0-2'}} </td> <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m5_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m15_rate | number:'1.0-2'}} </td> </tr> <tr> <td jhiTranslate=\"metrics.jvm.http.code.notfound\">Not Found</td> <td> <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count}}</span> </ngb-progressbar> </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].mean_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m1_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m5_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m15_rate | number:'1.0-2'}} </td> </tr> <tr> <td jhiTranslate=\"metrics.jvm.http.code.servererror\">Server error</td> <td> <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count}}</span> </ngb-progressbar> </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].mean_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m1_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m5_rate | number:'1.0-2'}} </td> <td class=\"text-right\"> {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m15_rate | number:'1.0-2'}} </td> </tr> </tbody> </table> </div> <h3 jhiTranslate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3> <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\"> <table class=\"table table-striped\"> <thead> <tr> <th jhiTranslate=\"metrics.servicesstats.table.name\">Service name</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.count\">Count</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.mean\">Mean</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.min\">Min</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p50\">p50</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p75\">p75</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p95\">p95</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p99\">p99</th> <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.max\">Max</th> </tr> </thead> <tbody> <tr *ngFor=\"let entry of servicesStats | keys\"> <td>{{entry.key}}</td> <td class=\"text-right\">{{entry.value.count}}</td> <td class=\"text-right\">{{entry.value.mean * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.min * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.p50 * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.p75 * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.p95 * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.p99 * 1000 | number:'1.0-0'}}</td> <td class=\"text-right\">{{entry.value.max * 1000 | number:'1.0-0'}}</td> </tr> </tbody> </table> </div> <h3 jhiTranslate=\"metrics.cache.title\">Cache statistics</h3> <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\"> <table class=\"table table-striped\"> <thead> <tr> <th jhiTranslate=\"metrics.cache.cachename\">Cache name</th> <th class=\"text-right\" data-translate=\"metrics.cache.hits\">Cache Hits</th> <th class=\"text-right\" data-translate=\"metrics.cache.misses\">Cache Misses</th> <th class=\"text-right\" data-translate=\"metrics.cache.gets\">Cache Gets</th> <th class=\"text-right\" data-translate=\"metrics.cache.puts\">Cache Puts</th> <th class=\"text-right\" data-translate=\"metrics.cache.removals\">Cache Removals</th> <th class=\"text-right\" data-translate=\"metrics.cache.evictions\">Cache Evictions</th> <th class=\"text-right\" data-translate=\"metrics.cache.hitPercent\">Cache Hit %</th> <th class=\"text-right\" data-translate=\"metrics.cache.missPercent\">Cache Miss %</th> <th class=\"text-right\" data-translate=\"metrics.cache.averageGetTime\">Average get time (µs)</th> <th class=\"text-right\" data-translate=\"metrics.cache.averagePutTime\">Average put time (µs)</th> <th class=\"text-right\" data-translate=\"metrics.cache.averageRemoveTime\">Average remove time (µs)</th> </tr> </thead> <tbody> <tr *ngFor=\"let entry of cachesStats | keys\"> <td>{{entry.key}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hits'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-misses'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-gets'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-puts'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-removals'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-evictions'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hit-percentage'].value}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-miss-percentage'].value }}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-get-time'].value | number : '1.2-2' }}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-put-time'].value | number : '1.2-2'}}</td> <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-remove-time'].value | number : '1.2-2' }}</td> </tr> </tbody> </table> </div> <h3 jhiTranslate=\"metrics.datasource.title\" *ngIf=\"metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\">DataSource statistics (time in millisecond)</h3> <div class=\"table-responsive\" *ngIf=\"!updatingMetrics && metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"metrics.datasource.usage\">Usage</span> ({{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value}} / {{metrics.gauges['HikariPool-1.pool.TotalConnections'].value}})</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.count\">Count</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.mean\">Mean</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.min\">Min</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p50\">p50</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p75\">p75</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p95\">p95</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p99\">p99</th> <th class=\"text-right\" jhiTranslate=\"metrics.datasource.max\">Max</th> </tr> </thead> <tbody> <tr> <td> <div class=\"progress progress-striped\"> <ngb-progressbar [max]=\"metrics.gauges['HikariPool-1.pool.TotalConnections'].value\" [value]=\"metrics.gauges['HikariPool-1.pool.ActiveConnections'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\"> <span>{{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value * 100 / metrics.gauges['HikariPool-1.pool.TotalConnections'].value | number:'1.0-0'}}%</span> </ngb-progressbar> </div> </td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].count}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].mean | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].min | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p50 | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p75 | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p95 | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p99 | number:'1.0-2'}}</td> <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].max | number:'1.0-2'}}</td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = "<div> <h2 jhiTranslate=\"tracker.title\">Real-time user activities</h2> <div class=\"table-responsive\"> <table class=\"table table-striped\"> <thead> <tr> <th jhiTranslate=\"tracker.table.userlogin\">User</th> <th jhiTranslate=\"tracker.table.ipaddress\">IP Address</th> <th jhiTranslate=\"tracker.table.page\">Current page</th> <th jhiTranslate=\"tracker.table.time\">Time</th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let activity of activities\"> <td>{{activity.userLogin}}</td> <td>{{activity.ipAddress}}</td> <td>{{activity.page}}</td> <td>{{activity.time}}</td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(user.login)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"userManagement.delete.question\" translateValues=\"{login: '{{user.login}}'}\">Are you sure you want to delete this User?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"user\"> <h2> <span jhiTranslate=\"userManagement.detail.title\">User</span> [<b>{{user.login}}</b>] </h2> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"userManagement.login\">Login</span></dt> <dd> <span>{{user.login}}</span> <span class=\"badge badge-danger\" *ngIf=\"!user.activated\" jhiTranslate=\"userManagement.deactivated\">Deactivated</span> <span class=\"badge badge-success\" *ngIf=\"user.activated\" jhiTranslate=\"userManagement.activated\">Activated</span> </dd> <dt><span jhiTranslate=\"userManagement.firstName\">First Name</span></dt> <dd>{{user.firstName}}</dd> <dt><span jhiTranslate=\"userManagement.lastName\">Last Name</span></dt> <dd>{{user.lastName}}</dd> <dt><span jhiTranslate=\"userManagement.email\">Email</span></dt> <dd>{{user.email}}</dd> <dt><span jhiTranslate=\"userManagement.langKey\">Lang Key</span></dt> <dd>{{user.langKey}}</dd> <dt><span jhiTranslate=\"userManagement.createdBy\">Created By</span></dt> <dd>{{user.createdBy}}</dd> <dt><span jhiTranslate=\"userManagement.createdDate\">Created Date</span></dt> <dd>{{user.createdDate | date:'dd/MM/yy HH:mm' }}</dd> <dt><span jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt> <dd>{{user.lastModifiedBy}}</dd> <dt><span jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt> <dd>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</dd> <dt><span jhiTranslate=\"userManagement.profiles\">Profiles</span></dt> <dd> <ul class=\"list-unstyled\"> <li *ngFor=\"let authority of user.authorities\"> <span class=\"badge badge-info\">{{authority}}</span> </li> </ul> </dd> </dl> <button type=\"submit\" routerLink=\"/user-management\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> </div> ";

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myUserLabel\" jhiTranslate=\"userManagement.home.createOrEditLabel\"> Create or edit a User</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\"> <label jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" name=\"id\" [(ngModel)]=\"user.id\" readonly=\"readonly\"> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"userManagement.login\">Login</label> <input type=\"text\" class=\"form-control\" name=\"login\" #loginInput=\"ngModel\" [(ngModel)]=\"user.login\" required minlength=\"1\" maxlength=\"50\" pattern=\"^[_'.@A-Za-z0-9-]*$\"> <div *ngIf=\"loginInput.dirty && loginInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"loginInput.errors.required\" jhiTranslate=\"entity.validation.required\"> This field is required. </small> <small class=\"form-text text-danger\" *ngIf=\"loginInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\" translate-value-max=\"50\"> This field cannot be longer than 50 characters. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"userManagement.firstName\">First Name</label> <input type=\"text\" class=\"form-control\" name=\"firstName\" #firstNameInput=\"ngModel\" [(ngModel)]=\"user.firstName\" maxlength=\"50\"> <div *ngIf=\"firstNameInput.dirty && firstNameInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"firstNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\" translate-value-max=\"50\"> This field cannot be longer than 50 characters. </small> </div> </div> <div class=\"form-group\"> <label jhiTranslate=\"userManagement.lastName\">Last Name</label> <input type=\"text\" class=\"form-control\" name=\"lastName\" #lastNameInput=\"ngModel\" [(ngModel)]=\"user.lastName\" maxlength=\"50\"> <div *ngIf=\"lastNameInput.dirty && lastNameInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"lastNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\" translate-value-max=\"50\"> This field cannot be longer than 50 characters. </small> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"userManagement.email\">Email</label> <input type=\"email\" class=\"form-control\" name=\"email\" #emailInput=\"ngModel\" [(ngModel)]=\"user.email\" required maxlength=\"100\"> <div *ngIf=\"emailInput.dirty && emailInput.invalid\"> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.required\" jhiTranslate=\"entity.validation.required\"> This field is required. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\" translate-value-max=\"100\"> This field cannot be longer than 100 characters. </small> <small class=\"form-text text-danger\" *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\"> Your email is invalid. </small> </div> </div> <div class=\"form-check\"> <label class=\"form-check-label\" for=\"activated\"> <input class=\"form-check-input\" [disabled]=\"user.id === null\" type=\"checkbox\" id=\"activated\" name=\"activated\" [(ngModel)]=\"user.activated\"> <span jhiTranslate=\"userManagement.activated\">Activated</span> </label> </div> <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\"> <label jhiTranslate=\"userManagement.langKey\">Lang Key</label> <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"user.langKey\"> <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"userManagement.profiles\">Profiles</label> <select class=\"form-control\" multiple=\"multiple\" name=\"authority\" [(ngModel)]=\"user.authorities\"> <option *ngFor=\"let authority of authorities\" [value]=\"authority\">{{authority}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-floppy-o\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"userManagement.home.title\">Users</span> <button class=\"btn btn-primary float-right\" [routerLink]=\"['/', { outlets: { popup: ['user-management-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span jhiTranslate=\"userManagement.home.createLabel\">Create a new User</span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"table-responsive\" *ngIf=\"users\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span><span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"login\"><span jhiTranslate=\"userManagement.login\">Login</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"email\"><span jhiTranslate=\"userManagement.email\">Email</span> <span class=\"fa fa-sort\"></span></th> <th></th> <th jhiSortBy=\"langKey\"> <span jhiTranslate=\"userManagement.langKey\">Lang Key</span> <span class=\"fa fa-sort\"></span></th> <th><span jhiTranslate=\"userManagement.profiles\">Profiles</span></th> <th jhiSortBy=\"createdDate\"><span jhiTranslate=\"userManagement.createdDate\">Created Date</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastModifiedBy\"><span jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastModifiedDate\"><span jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody *ngIf=\"users\"> <tr *ngFor=\"let user of users; trackBy: trackIdentity\"> <td><a [routerLink]=\"['../user-management', user.login]\">{{user.id}}</a></td> <td>{{user.login}}</td> <td>{{user.email}}</td> <td> <span class=\"badge badge-danger hand\" (click)=\"setActive(user, true)\" *ngIf=\"!user.activated\" jhiTranslate=\"userManagement.deactivated\">Deactivated</span> <span class=\"badge badge-success hand\" (click)=\"setActive(user, false)\" *ngIf=\"user.activated\" jhiTranslate=\"userManagement.activated\">Activated</span> </td> <td>{{user.langKey}}</td> <td> <div *ngFor=\"let authority of user.authorities\"> <span class=\"tag tag-info\">{{ authority }}</span> </div> </td> <td>{{user.createdDate | date:'dd/MM/yy HH:mm'}}</td> <td>{{user.lastModifiedBy}}</td> <td>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../user-management', user.login]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'user-management/'+ user.login + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'user-management/'+ user.login + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\" [disabled]=\"currentAccount.login==user.login\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"users\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(additionalflat.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.additionalflat.delete.question\" translateValues=\"{id: '{{additionalflat.id}}'}\">Are you sure you want to delete this Additionalflat?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"additionalflat\"> <h2><span jhiTranslate=\"marketmanagerApp.additionalflat.detail.title\">Additionalflat</span> {{additionalflat.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.marketplaceNumber\">Marketplace Number</span></dt> <dd> <span>{{additionalflat.marketplaceNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.validFrom\">Valid From</span></dt> <dd> <span>{{additionalflat.validFrom | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceType\">Price Type</span></dt> <dd> <span>{{additionalflat.priceType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceSanitary\">Price Sanitary</span></dt> <dd> <span>{{additionalflat.priceSanitary}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceCleaning\">Price Cleaning</span></dt> <dd> <span>{{additionalflat.priceCleaning}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceParking\">Price Parking</span></dt> <dd> <span>{{additionalflat.priceParking}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceAdministration\">Price Administration</span></dt> <dd> <span>{{additionalflat.priceAdministration}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceDebit\">Price Debit</span></dt> <dd> <span>{{additionalflat.priceDebit}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.priceModification\">Price Modification</span></dt> <dd> <span>{{additionalflat.priceModification}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.updated\">Updated</span></dt> <dd> <span>{{additionalflat.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.created\">Created</span></dt> <dd> <span>{{additionalflat.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.gguid\">Gguid</span></dt> <dd> <span>{{additionalflat.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.additionalflat.marketplace\">Marketplace</span></dt> <dd> <div *ngIf=\"additionalflat.marketplace\"> <a [routerLink]=\"['/marketplace', additionalflat.marketplace?.id]\">{{additionalflat.marketplace?.marketplaceNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'additionalflat/'+ additionalflat.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myAdditionalflatLabel\" jhiTranslate=\"marketmanagerApp.additionalflat.home.createOrEditLabel\">Create or edit a Additionalflat</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!additionalflat.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"additionalflat.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.marketplaceNumber\" for=\"field_marketplaceNumber\">Marketplace Number</label> <input type=\"text\" class=\"form-control\" name=\"marketplaceNumber\" id=\"field_marketplaceNumber\" [(ngModel)]=\"additionalflat.marketplaceNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.validFrom\" for=\"field_validFrom\">Valid From</label> <div class=\"d-flex\"> <input id=\"field_validFrom\" type=\"datetime-local\" class=\"form-control\" name=\"validFrom\" [(ngModel)]=\"additionalflat.validFrom\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceType\" for=\"field_priceType\">Price Type</label> <input type=\"text\" class=\"form-control\" name=\"priceType\" id=\"field_priceType\" [(ngModel)]=\"additionalflat.priceType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceSanitary\" for=\"field_priceSanitary\">Price Sanitary</label> <input type=\"number\" class=\"form-control\" name=\"priceSanitary\" id=\"field_priceSanitary\" [(ngModel)]=\"additionalflat.priceSanitary\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceCleaning\" for=\"field_priceCleaning\">Price Cleaning</label> <input type=\"number\" class=\"form-control\" name=\"priceCleaning\" id=\"field_priceCleaning\" [(ngModel)]=\"additionalflat.priceCleaning\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceParking\" for=\"field_priceParking\">Price Parking</label> <input type=\"number\" class=\"form-control\" name=\"priceParking\" id=\"field_priceParking\" [(ngModel)]=\"additionalflat.priceParking\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceAdministration\" for=\"field_priceAdministration\">Price Administration</label> <input type=\"number\" class=\"form-control\" name=\"priceAdministration\" id=\"field_priceAdministration\" [(ngModel)]=\"additionalflat.priceAdministration\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceDebit\" for=\"field_priceDebit\">Price Debit</label> <input type=\"number\" class=\"form-control\" name=\"priceDebit\" id=\"field_priceDebit\" [(ngModel)]=\"additionalflat.priceDebit\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.priceModification\" for=\"field_priceModification\">Price Modification</label> <input type=\"number\" class=\"form-control\" name=\"priceModification\" id=\"field_priceModification\" [(ngModel)]=\"additionalflat.priceModification\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"additionalflat.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"additionalflat.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.additionalflat.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"additionalflat.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.additionalflat.marketplace\" for=\"field_marketplace\">Marketplace</label> <select class=\"form-control\" id=\"field_marketplace\" name=\"marketplace\" [(ngModel)]=\"additionalflat.marketplace\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketplaceOption.id === additionalflat.marketplace?.id ? additionalflat.marketplace : marketplaceOption\" *ngFor=\"let marketplaceOption of marketplaces; trackBy: trackMarketplaceById\">{{marketplaceOption.marketplaceNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.additionalflat.home.title\">Additionalflats</span> <button class=\"btn btn-primary float-right create-additionalflat\" [routerLink]=\"['/', { outlets: { popup: ['additionalflat-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.additionalflat.home.createLabel\"> Create new Additionalflat </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.additionalflat.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"additionalflats\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.additionalflat.marketplaceNumber\">Marketplace Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"validFrom\"><span jhiTranslate=\"marketmanagerApp.additionalflat.validFrom\">Valid From</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceType\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceType\">Price Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceSanitary\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceSanitary\">Price Sanitary</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceCleaning\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceCleaning\">Price Cleaning</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceParking\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceParking\">Price Parking</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceAdministration\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceAdministration\">Price Administration</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceDebit\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceDebit\">Price Debit</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceModification\"><span jhiTranslate=\"marketmanagerApp.additionalflat.priceModification\">Price Modification</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.additionalflat.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.additionalflat.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.additionalflat.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplace.marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.additionalflat.marketplace\">Marketplace</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let additionalflat of additionalflats ;trackBy: trackId\"> <td><a [routerLink]=\"['../additionalflat', additionalflat.id ]\">{{additionalflat.id}}</a></td> <td>{{additionalflat.marketplaceNumber}}</td> <td>{{additionalflat.validFrom | date:'medium'}}</td> <td>{{additionalflat.priceType}}</td> <td>{{additionalflat.priceSanitary}}</td> <td>{{additionalflat.priceCleaning}}</td> <td>{{additionalflat.priceParking}}</td> <td>{{additionalflat.priceAdministration}}</td> <td>{{additionalflat.priceDebit}}</td> <td>{{additionalflat.priceModification}}</td> <td>{{additionalflat.updated | date:'medium'}}</td> <td>{{additionalflat.created | date:'medium'}}</td> <td>{{additionalflat.gguid}}</td> <td> <div *ngIf=\"additionalflat.marketplace\"> <a [routerLink]=\"['../marketplace', additionalflat.marketplace?.id ]\">{{additionalflat.marketplace?.marketplaceNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../additionalflat', additionalflat.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'additionalflat/'+ additionalflat.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'additionalflat/'+ additionalflat.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"additionalflats && additionalflats.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(booth.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.booth.delete.question\" translateValues=\"{id: '{{booth.id}}'}\">Are you sure you want to delete this Booth?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"booth\"> <h2><span jhiTranslate=\"marketmanagerApp.booth.detail.title\">Booth</span> {{booth.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.booth.contractType\">Contract Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContractType.' + booth.contractType}}\">{{booth.contractType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.booth.order\">Order</span></dt> <dd> <span>{{booth.order}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.booth.salesunit\">Salesunit</span></dt> <dd> <div *ngIf=\"booth.salesunit\"> <a [routerLink]=\"['/salesunit', booth.salesunit?.id]\">{{booth.salesunit?.salesunitNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.booth.contactPerson\">Contact Person</span></dt> <dd> <div *ngIf=\"booth.contactPerson\"> <a [routerLink]=\"['/contact', booth.contactPerson?.id]\">{{booth.contactPerson?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.booth.contract\">Contract</span></dt> <dd> <div *ngIf=\"booth.contract\"> <a [routerLink]=\"['/contract', booth.contract?.id]\">{{booth.contract?.startDate}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'booth/'+ booth.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myBoothLabel\" jhiTranslate=\"marketmanagerApp.booth.home.createOrEditLabel\">Create or edit a Booth</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!booth.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"booth.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.booth.contractType\" for=\"field_contractType\">Contract Type</label> <select class=\"form-control\" name=\"contractType\" [(ngModel)]=\"booth.contractType\" id=\"field_contractType\"> <option value=\"Standard\" jhiTranslate=\"marketmanagerApp.ContractType.Standard\">Standard</option> <option value=\"None\" jhiTranslate=\"marketmanagerApp.ContractType.None\">None</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.booth.order\" for=\"field_order\">Order</label> <input type=\"number\" class=\"form-control\" name=\"order\" id=\"field_order\" [(ngModel)]=\"booth.order\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.booth.salesunit\" for=\"field_salesunit\">Salesunit</label> <select class=\"form-control\" id=\"field_salesunit\" name=\"salesunit\" [(ngModel)]=\"booth.salesunit\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"salesunitOption.id === booth.salesunit?.id ? booth.salesunit : salesunitOption\" *ngFor=\"let salesunitOption of salesunits; trackBy: trackSalesunitById\">{{salesunitOption.salesunitNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.booth.contactPerson\" for=\"field_contactPerson\">Contact Person</label> <select class=\"form-control\" id=\"field_contactPerson\" name=\"contactPerson\" [(ngModel)]=\"booth.contactPerson\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === booth.contactPerson?.id ? booth.contactPerson : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.booth.contract\" for=\"field_contract\">Contract</label> <select class=\"form-control\" id=\"field_contract\" name=\"contract\" [(ngModel)]=\"booth.contract\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contractOption.id === booth.contract?.id ? booth.contract : contractOption\" *ngFor=\"let contractOption of contracts; trackBy: trackContractById\">{{contractOption.startDate}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.booth.home.title\">Booths</span> <button class=\"btn btn-primary float-right create-booth\" [routerLink]=\"['/', { outlets: { popup: ['booth-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.booth.home.createLabel\"> Create new Booth </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.booth.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"booths\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.booth.contractType\">Contract Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.booth.order\">Order</span></th> <th><span jhiTranslate=\"marketmanagerApp.booth.salesunit\">Salesunit</span></th> <th><span jhiTranslate=\"marketmanagerApp.booth.contactPerson\">Contact Person</span></th> <th><span jhiTranslate=\"marketmanagerApp.booth.contract\">Contract</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let booth of booths ;trackBy: trackId\"> <td><a [routerLink]=\"['../booth', booth.id ]\">{{booth.id}}</a></td> <td jhiTranslate=\"{{'marketmanagerApp.ContractType.' + booth.contractType}}\">{{booth.contractType}}</td> <td>{{booth.order}}</td> <td> <div *ngIf=\"booth.salesunit\"> <a [routerLink]=\"['../salesunit', booth.salesunit?.id ]\">{{booth.salesunit?.salesunitNumber}}</a> </div> </td> <td> <div *ngIf=\"booth.contactPerson\"> <a [routerLink]=\"['../contact', booth.contactPerson?.id ]\">{{booth.contactPerson?.displayname}}</a> </div> </td> <td> <div *ngIf=\"booth.contract\"> <a [routerLink]=\"['../contract', booth.contract?.id ]\">{{booth.contract?.startDate}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../booth', booth.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'booth/'+ booth.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'booth/'+ booth.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(boothfee.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.boothfee.delete.question\" translateValues=\"{id: '{{boothfee.id}}'}\">Are you sure you want to delete this Boothfee?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"boothfee\"> <h2><span jhiTranslate=\"marketmanagerApp.boothfee.detail.title\">Boothfee</span> {{boothfee.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{boothfee.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.validFrom\">Valid From</span></dt> <dd> <span>{{boothfee.validFrom | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.validMonth\">Valid Month</span></dt> <dd> <span>{{boothfee.validMonth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.priceType\">Price Type</span></dt> <dd> <span>{{boothfee.priceType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryA\">Price Category A</span></dt> <dd> <span>{{boothfee.priceCategoryA}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryB\">Price Category B</span></dt> <dd> <span>{{boothfee.priceCategoryB}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryC\">Price Category C</span></dt> <dd> <span>{{boothfee.priceCategoryC}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryD\">Price Category D</span></dt> <dd> <span>{{boothfee.priceCategoryD}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.minBoothFee\">Min Booth Fee</span></dt> <dd> <span>{{boothfee.minBoothFee}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.basicCharges\">Basic Charges</span></dt> <dd> <span>{{boothfee.basicCharges}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.unit\">Unit</span></dt> <dd> <span>{{boothfee.unit}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.updated\">Updated</span></dt> <dd> <span>{{boothfee.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.created\">Created</span></dt> <dd> <span>{{boothfee.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.gguid\">Gguid</span></dt> <dd> <span>{{boothfee.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.boothfee.marketday\">Marketday</span></dt> <dd> <div *ngIf=\"boothfee.marketday\"> <a [routerLink]=\"['/marketday', boothfee.marketday?.id]\">{{boothfee.marketday?.marketdayNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'boothfee/'+ boothfee.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myBoothfeeLabel\" jhiTranslate=\"marketmanagerApp.boothfee.home.createOrEditLabel\">Create or edit a Boothfee</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!boothfee.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"boothfee.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"boothfee.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.validFrom\" for=\"field_validFrom\">Valid From</label> <div class=\"d-flex\"> <input id=\"field_validFrom\" type=\"datetime-local\" class=\"form-control\" name=\"validFrom\" [(ngModel)]=\"boothfee.validFrom\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.validMonth\" for=\"field_validMonth\">Valid Month</label> <input type=\"number\" class=\"form-control\" name=\"validMonth\" id=\"field_validMonth\" [(ngModel)]=\"boothfee.validMonth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.priceType\" for=\"field_priceType\">Price Type</label> <input type=\"text\" class=\"form-control\" name=\"priceType\" id=\"field_priceType\" [(ngModel)]=\"boothfee.priceType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryA\" for=\"field_priceCategoryA\">Price Category A</label> <input type=\"number\" class=\"form-control\" name=\"priceCategoryA\" id=\"field_priceCategoryA\" [(ngModel)]=\"boothfee.priceCategoryA\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryB\" for=\"field_priceCategoryB\">Price Category B</label> <input type=\"number\" class=\"form-control\" name=\"priceCategoryB\" id=\"field_priceCategoryB\" [(ngModel)]=\"boothfee.priceCategoryB\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryC\" for=\"field_priceCategoryC\">Price Category C</label> <input type=\"number\" class=\"form-control\" name=\"priceCategoryC\" id=\"field_priceCategoryC\" [(ngModel)]=\"boothfee.priceCategoryC\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryD\" for=\"field_priceCategoryD\">Price Category D</label> <input type=\"number\" class=\"form-control\" name=\"priceCategoryD\" id=\"field_priceCategoryD\" [(ngModel)]=\"boothfee.priceCategoryD\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.minBoothFee\" for=\"field_minBoothFee\">Min Booth Fee</label> <input type=\"number\" class=\"form-control\" name=\"minBoothFee\" id=\"field_minBoothFee\" [(ngModel)]=\"boothfee.minBoothFee\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.basicCharges\" for=\"field_basicCharges\">Basic Charges</label> <input type=\"number\" class=\"form-control\" name=\"basicCharges\" id=\"field_basicCharges\" [(ngModel)]=\"boothfee.basicCharges\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.unit\" for=\"field_unit\">Unit</label> <input type=\"text\" class=\"form-control\" name=\"unit\" id=\"field_unit\" [(ngModel)]=\"boothfee.unit\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"boothfee.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"boothfee.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.boothfee.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"boothfee.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.boothfee.marketday\" for=\"field_marketday\">Marketday</label> <select class=\"form-control\" id=\"field_marketday\" name=\"marketday\" [(ngModel)]=\"boothfee.marketday\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdayOption.id === boothfee.marketday?.id ? boothfee.marketday : marketdayOption\" *ngFor=\"let marketdayOption of marketdays; trackBy: trackMarketdayById\">{{marketdayOption.marketdayNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.boothfee.home.title\">Boothfees</span> <button class=\"btn btn-primary float-right create-boothfee\" [routerLink]=\"['/', { outlets: { popup: ['boothfee-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.boothfee.home.createLabel\"> Create new Boothfee </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.boothfee.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"boothfees\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.boothfee.marketdayNumber\">Marketday Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"validFrom\"><span jhiTranslate=\"marketmanagerApp.boothfee.validFrom\">Valid From</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"validMonth\"><span jhiTranslate=\"marketmanagerApp.boothfee.validMonth\">Valid Month</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceType\"><span jhiTranslate=\"marketmanagerApp.boothfee.priceType\">Price Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceCategoryA\"><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryA\">Price Category A</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceCategoryB\"><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryB\">Price Category B</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceCategoryC\"><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryC\">Price Category C</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceCategoryD\"><span jhiTranslate=\"marketmanagerApp.boothfee.priceCategoryD\">Price Category D</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"minBoothFee\"><span jhiTranslate=\"marketmanagerApp.boothfee.minBoothFee\">Min Booth Fee</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"basicCharges\"><span jhiTranslate=\"marketmanagerApp.boothfee.basicCharges\">Basic Charges</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"unit\"><span jhiTranslate=\"marketmanagerApp.boothfee.unit\">Unit</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.boothfee.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.boothfee.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.boothfee.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketday.marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.boothfee.marketday\">Marketday</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let boothfee of boothfees ;trackBy: trackId\"> <td><a [routerLink]=\"['../boothfee', boothfee.id ]\">{{boothfee.id}}</a></td> <td>{{boothfee.marketdayNumber}}</td> <td>{{boothfee.validFrom | date:'medium'}}</td> <td>{{boothfee.validMonth}}</td> <td>{{boothfee.priceType}}</td> <td>{{boothfee.priceCategoryA}}</td> <td>{{boothfee.priceCategoryB}}</td> <td>{{boothfee.priceCategoryC}}</td> <td>{{boothfee.priceCategoryD}}</td> <td>{{boothfee.minBoothFee}}</td> <td>{{boothfee.basicCharges}}</td> <td>{{boothfee.unit}}</td> <td>{{boothfee.updated | date:'medium'}}</td> <td>{{boothfee.created | date:'medium'}}</td> <td>{{boothfee.gguid}}</td> <td> <div *ngIf=\"boothfee.marketday\"> <a [routerLink]=\"['../marketday', boothfee.marketday?.id ]\">{{boothfee.marketday?.marketdayNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../boothfee', boothfee.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'boothfee/'+ boothfee.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'boothfee/'+ boothfee.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"boothfees && boothfees.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(branch.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.branch.delete.question\" translateValues=\"{id: '{{branch.id}}'}\">Are you sure you want to delete this Branch?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"branch\"> <h2><span jhiTranslate=\"marketmanagerApp.branch.detail.title\">Branch</span> {{branch.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.branch.name\">Name</span></dt> <dd> <span>{{branch.name}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.branch.description\">Description</span></dt> <dd> <span>{{branch.description}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.branch.branchNumber\">Branch Number</span></dt> <dd> <span>{{branch.branchNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.branch.city\">City</span></dt> <dd> <span>{{branch.city}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.branch.branchMaster\">Branch Master</span></dt> <dd> <div *ngIf=\"branch.branchMaster\"> <a [routerLink]=\"['/contact', branch.branchMaster?.id]\">{{branch.branchMaster?.id}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'branch/'+ branch.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myBranchLabel\" jhiTranslate=\"marketmanagerApp.branch.home.createOrEditLabel\">Create or edit a Branch</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!branch.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"branch.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.branch.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" [(ngModel)]=\"branch.name\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.branch.description\" for=\"field_description\">Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" [(ngModel)]=\"branch.description\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.branch.branchNumber\" for=\"field_branchNumber\">Branch Number</label> <input type=\"number\" class=\"form-control\" name=\"branchNumber\" id=\"field_branchNumber\" [(ngModel)]=\"branch.branchNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.branch.city\" for=\"field_city\">City</label> <input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" [(ngModel)]=\"branch.city\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.branch.branchMaster\" for=\"field_branchMaster\">Branch Master</label> <select class=\"form-control\" id=\"field_branchMaster\" name=\"branchMaster\" [(ngModel)]=\"branch.branchMaster\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === branch.branchMaster?.id ? branch.branchMaster : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.id}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.branch.home.title\">Branches</span> <button class=\"btn btn-primary float-right create-branch\" [routerLink]=\"['/', { outlets: { popup: ['branch-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.branch.home.createLabel\"> Create new Branch </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.branch.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"branches\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"name\"><span jhiTranslate=\"marketmanagerApp.branch.name\">Name</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"description\"><span jhiTranslate=\"marketmanagerApp.branch.description\">Description</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branchNumber\"><span jhiTranslate=\"marketmanagerApp.branch.branchNumber\">Branch Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"city\"><span jhiTranslate=\"marketmanagerApp.branch.city\">City</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branchMaster.id\"><span jhiTranslate=\"marketmanagerApp.branch.branchMaster\">Branch Master</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let branch of branches ;trackBy: trackId\"> <td><a [routerLink]=\"['../branch', branch.id ]\">{{branch.id}}</a></td> <td>{{branch.name}}</td> <td>{{branch.description}}</td> <td>{{branch.branchNumber}}</td> <td>{{branch.city}}</td> <td> <div *ngIf=\"branch.branchMaster\"> <a [routerLink]=\"['../contact', branch.branchMaster?.id ]\">{{branch.branchMaster?.id}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../branch', branch.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'branch/'+ branch.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'branch/'+ branch.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"branches && branches.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(contactTemp.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.contactTemp.delete.question\" translateValues=\"{id: '{{contactTemp.id}}'}\">Are you sure you want to delete this Contact Temp?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"contactTemp\"> <h2><span jhiTranslate=\"marketmanagerApp.contactTemp.detail.title\">Contact Temp</span> {{contactTemp.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.type\">Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContactType.' + contactTemp.type}}\">{{contactTemp.type}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.salutation\">Salutation</span></dt> <dd> <span>{{contactTemp.salutation}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.title\">Title</span></dt> <dd> <span>{{contactTemp.title}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.firstname\">Firstname</span></dt> <dd> <span>{{contactTemp.firstname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.lastname\">Lastname</span></dt> <dd> <span>{{contactTemp.lastname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.displayname\">Displayname</span></dt> <dd> <span>{{contactTemp.displayname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.company\">Company</span></dt> <dd> <span>{{contactTemp.company}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.companyAdditional\">Company Additional</span></dt> <dd> <span>{{contactTemp.companyAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.street\">Street</span></dt> <dd> <span>{{contactTemp.street}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.streetAdditional\">Street Additional</span></dt> <dd> <span>{{contactTemp.streetAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.zipcode\">Zipcode</span></dt> <dd> <span>{{contactTemp.zipcode}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.city\">City</span></dt> <dd> <span>{{contactTemp.city}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.suburb\">Suburb</span></dt> <dd> <span>{{contactTemp.suburb}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.state\">State</span></dt> <dd> <span>{{contactTemp.state}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.country\">Country</span></dt> <dd> <span>{{contactTemp.country}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.phone\">Phone</span></dt> <dd> <span>{{contactTemp.phone}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.phoneAdditional\">Phone Additional</span></dt> <dd> <span>{{contactTemp.phoneAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.fax\">Fax</span></dt> <dd> <span>{{contactTemp.fax}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.mobile\">Mobile</span></dt> <dd> <span>{{contactTemp.mobile}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.email\">Email</span></dt> <dd> <span>{{contactTemp.email}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.emailAdditional\">Email Additional</span></dt> <dd> <span>{{contactTemp.emailAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.web\">Web</span></dt> <dd> <span>{{contactTemp.web}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.comment\">Comment</span></dt> <dd> <span>{{contactTemp.comment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.companyGguid\">Company Gguid</span></dt> <dd> <span>{{contactTemp.companyGguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.casIsCompany\">Cas Is Company</span></dt> <dd> <span>{{contactTemp.casIsCompany}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.casIsContact\">Cas Is Contact</span></dt> <dd> <span>{{contactTemp.casIsContact}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.latitude\">Latitude</span></dt> <dd> <span>{{contactTemp.latitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.longitude\">Longitude</span></dt> <dd> <span>{{contactTemp.longitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.boothUnit\">Booth Unit</span></dt> <dd> <span>{{contactTemp.boothUnit}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.boothType\">Booth Type</span></dt> <dd> <span>{{contactTemp.boothType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.radius\">Radius</span></dt> <dd> <span>{{contactTemp.radius}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.boothWidth\">Booth Width</span></dt> <dd> <span>{{contactTemp.boothWidth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.boothDepth\">Booth Depth</span></dt> <dd> <span>{{contactTemp.boothDepth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.assortment\">Assortment</span></dt> <dd> <span>{{contactTemp.assortment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.assortmentAdditional\">Assortment Additional</span></dt> <dd> <span>{{contactTemp.assortmentAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.activeMerchant\">Active Merchant</span></dt> <dd> <span>{{contactTemp.activeMerchant}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.updated\">Updated</span></dt> <dd> <span>{{contactTemp.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.created\">Created</span></dt> <dd> <span>{{contactTemp.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.gguid\">Gguid</span></dt> <dd> <span>{{contactTemp.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.status\">Status</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContactStatus.' + contactTemp.status}}\">{{contactTemp.status}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.superordinateContact\">Superordinate Contact</span></dt> <dd> <div *ngIf=\"contactTemp.superordinateContact\"> <a [routerLink]=\"['/contact', contactTemp.superordinateContact?.id]\">{{contactTemp.superordinateContact?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contactTemp.originalContact\">Original Contact</span></dt> <dd> <div *ngIf=\"contactTemp.originalContact\"> <a [routerLink]=\"['/contact', contactTemp.originalContact?.id]\">{{contactTemp.originalContact?.displayname}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'contact-temp/'+ contactTemp.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myContactTempLabel\" jhiTranslate=\"marketmanagerApp.contactTemp.home.createOrEditLabel\">Create or edit a Contact Temp</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!contactTemp.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"contactTemp.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.type\" for=\"field_type\">Type</label> <select class=\"form-control\" name=\"type\" [(ngModel)]=\"contactTemp.type\" id=\"field_type\"> <option value=\"Commune\" jhiTranslate=\"marketmanagerApp.ContactType.Commune\">Commune</option> <option value=\"Merchant\" jhiTranslate=\"marketmanagerApp.ContactType.Merchant\">Merchant</option> <option value=\"Person\" jhiTranslate=\"marketmanagerApp.ContactType.Person\">Person</option> <option value=\"Employee\" jhiTranslate=\"marketmanagerApp.ContactType.Employee\">Employee</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.salutation\" for=\"field_salutation\">Salutation</label> <input type=\"text\" class=\"form-control\" name=\"salutation\" id=\"field_salutation\" [(ngModel)]=\"contactTemp.salutation\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.title\" for=\"field_title\">Title</label> <input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" [(ngModel)]=\"contactTemp.title\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.firstname\" for=\"field_firstname\">Firstname</label> <input type=\"text\" class=\"form-control\" name=\"firstname\" id=\"field_firstname\" [(ngModel)]=\"contactTemp.firstname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.lastname\" for=\"field_lastname\">Lastname</label> <input type=\"text\" class=\"form-control\" name=\"lastname\" id=\"field_lastname\" [(ngModel)]=\"contactTemp.lastname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.displayname\" for=\"field_displayname\">Displayname</label> <input type=\"text\" class=\"form-control\" name=\"displayname\" id=\"field_displayname\" [(ngModel)]=\"contactTemp.displayname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.company\" for=\"field_company\">Company</label> <input type=\"text\" class=\"form-control\" name=\"company\" id=\"field_company\" [(ngModel)]=\"contactTemp.company\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.companyAdditional\" for=\"field_companyAdditional\">Company Additional</label> <input type=\"text\" class=\"form-control\" name=\"companyAdditional\" id=\"field_companyAdditional\" [(ngModel)]=\"contactTemp.companyAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.street\" for=\"field_street\">Street</label> <input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" [(ngModel)]=\"contactTemp.street\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.streetAdditional\" for=\"field_streetAdditional\">Street Additional</label> <input type=\"text\" class=\"form-control\" name=\"streetAdditional\" id=\"field_streetAdditional\" [(ngModel)]=\"contactTemp.streetAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.zipcode\" for=\"field_zipcode\">Zipcode</label> <input type=\"text\" class=\"form-control\" name=\"zipcode\" id=\"field_zipcode\" [(ngModel)]=\"contactTemp.zipcode\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.city\" for=\"field_city\">City</label> <input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" [(ngModel)]=\"contactTemp.city\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.suburb\" for=\"field_suburb\">Suburb</label> <input type=\"text\" class=\"form-control\" name=\"suburb\" id=\"field_suburb\" [(ngModel)]=\"contactTemp.suburb\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.state\" for=\"field_state\">State</label> <input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_state\" [(ngModel)]=\"contactTemp.state\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.country\" for=\"field_country\">Country</label> <input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" [(ngModel)]=\"contactTemp.country\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.phone\" for=\"field_phone\">Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" [(ngModel)]=\"contactTemp.phone\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.phoneAdditional\" for=\"field_phoneAdditional\">Phone Additional</label> <input type=\"text\" class=\"form-control\" name=\"phoneAdditional\" id=\"field_phoneAdditional\" [(ngModel)]=\"contactTemp.phoneAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.fax\" for=\"field_fax\">Fax</label> <input type=\"text\" class=\"form-control\" name=\"fax\" id=\"field_fax\" [(ngModel)]=\"contactTemp.fax\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.mobile\" for=\"field_mobile\">Mobile</label> <input type=\"text\" class=\"form-control\" name=\"mobile\" id=\"field_mobile\" [(ngModel)]=\"contactTemp.mobile\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.email\" for=\"field_email\">Email</label> <input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" [(ngModel)]=\"contactTemp.email\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.emailAdditional\" for=\"field_emailAdditional\">Email Additional</label> <input type=\"text\" class=\"form-control\" name=\"emailAdditional\" id=\"field_emailAdditional\" [(ngModel)]=\"contactTemp.emailAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.web\" for=\"field_web\">Web</label> <input type=\"text\" class=\"form-control\" name=\"web\" id=\"field_web\" [(ngModel)]=\"contactTemp.web\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.comment\" for=\"field_comment\">Comment</label> <input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" [(ngModel)]=\"contactTemp.comment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.companyGguid\" for=\"field_companyGguid\">Company Gguid</label> <input type=\"text\" class=\"form-control\" name=\"companyGguid\" id=\"field_companyGguid\" [(ngModel)]=\"contactTemp.companyGguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.casIsCompany\" for=\"field_casIsCompany\">Cas Is Company</label> <input type=\"checkbox\" class=\"form-control\" name=\"casIsCompany\" id=\"field_casIsCompany\" [(ngModel)]=\"contactTemp.casIsCompany\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.casIsContact\" for=\"field_casIsContact\">Cas Is Contact</label> <input type=\"checkbox\" class=\"form-control\" name=\"casIsContact\" id=\"field_casIsContact\" [(ngModel)]=\"contactTemp.casIsContact\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.latitude\" for=\"field_latitude\">Latitude</label> <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" [(ngModel)]=\"contactTemp.latitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.longitude\" for=\"field_longitude\">Longitude</label> <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" [(ngModel)]=\"contactTemp.longitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.boothUnit\" for=\"field_boothUnit\">Booth Unit</label> <input type=\"text\" class=\"form-control\" name=\"boothUnit\" id=\"field_boothUnit\" [(ngModel)]=\"contactTemp.boothUnit\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.boothType\" for=\"field_boothType\">Booth Type</label> <input type=\"text\" class=\"form-control\" name=\"boothType\" id=\"field_boothType\" [(ngModel)]=\"contactTemp.boothType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.radius\" for=\"field_radius\">Radius</label> <input type=\"text\" class=\"form-control\" name=\"radius\" id=\"field_radius\" [(ngModel)]=\"contactTemp.radius\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.boothWidth\" for=\"field_boothWidth\">Booth Width</label> <input type=\"number\" class=\"form-control\" name=\"boothWidth\" id=\"field_boothWidth\" [(ngModel)]=\"contactTemp.boothWidth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.boothDepth\" for=\"field_boothDepth\">Booth Depth</label> <input type=\"number\" class=\"form-control\" name=\"boothDepth\" id=\"field_boothDepth\" [(ngModel)]=\"contactTemp.boothDepth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.assortment\" for=\"field_assortment\">Assortment</label> <input type=\"text\" class=\"form-control\" name=\"assortment\" id=\"field_assortment\" [(ngModel)]=\"contactTemp.assortment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.assortmentAdditional\" for=\"field_assortmentAdditional\">Assortment Additional</label> <input type=\"text\" class=\"form-control\" name=\"assortmentAdditional\" id=\"field_assortmentAdditional\" [(ngModel)]=\"contactTemp.assortmentAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.activeMerchant\" for=\"field_activeMerchant\">Active Merchant</label> <input type=\"checkbox\" class=\"form-control\" name=\"activeMerchant\" id=\"field_activeMerchant\" [(ngModel)]=\"contactTemp.activeMerchant\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"contactTemp.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"contactTemp.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"contactTemp.gguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contactTemp.status\" for=\"field_status\">Status</label> <select class=\"form-control\" name=\"status\" [(ngModel)]=\"contactTemp.status\" id=\"field_status\"> <option value=\"New\" jhiTranslate=\"marketmanagerApp.ContactStatus.New\">New</option> <option value=\"Changed\" jhiTranslate=\"marketmanagerApp.ContactStatus.Changed\">Changed</option> <option value=\"Deleted\" jhiTranslate=\"marketmanagerApp.ContactStatus.Deleted\">Deleted</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contactTemp.superordinateContact\" for=\"field_superordinateContact\">Superordinate Contact</label> <select class=\"form-control\" id=\"field_superordinateContact\" name=\"superordinateContact\" [(ngModel)]=\"contactTemp.superordinateContact\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === contactTemp.superordinateContact?.id ? contactTemp.superordinateContact : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contactTemp.originalContact\" for=\"field_originalContact\">Original Contact</label> <select class=\"form-control\" id=\"field_originalContact\" name=\"originalContact\" [(ngModel)]=\"contactTemp.originalContact\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === contactTemp.originalContact?.id ? contactTemp.originalContact : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.contactTemp.home.title\">Contact Temps</span> <button class=\"btn btn-primary float-right create-contact-temp\" [routerLink]=\"['/', { outlets: { popup: ['contact-temp-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.contactTemp.home.createLabel\"> Create new Contact Temp </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.contactTemp.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"contactTemps\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"type\"><span jhiTranslate=\"marketmanagerApp.contactTemp.type\">Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"salutation\"><span jhiTranslate=\"marketmanagerApp.contactTemp.salutation\">Salutation</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"title\"><span jhiTranslate=\"marketmanagerApp.contactTemp.title\">Title</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"firstname\"><span jhiTranslate=\"marketmanagerApp.contactTemp.firstname\">Firstname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastname\"><span jhiTranslate=\"marketmanagerApp.contactTemp.lastname\">Lastname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"displayname\"><span jhiTranslate=\"marketmanagerApp.contactTemp.displayname\">Displayname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"company\"><span jhiTranslate=\"marketmanagerApp.contactTemp.company\">Company</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"companyAdditional\"><span jhiTranslate=\"marketmanagerApp.contactTemp.companyAdditional\">Company Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"street\"><span jhiTranslate=\"marketmanagerApp.contactTemp.street\">Street</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"streetAdditional\"><span jhiTranslate=\"marketmanagerApp.contactTemp.streetAdditional\">Street Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"zipcode\"><span jhiTranslate=\"marketmanagerApp.contactTemp.zipcode\">Zipcode</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"city\"><span jhiTranslate=\"marketmanagerApp.contactTemp.city\">City</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"suburb\"><span jhiTranslate=\"marketmanagerApp.contactTemp.suburb\">Suburb</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"state\"><span jhiTranslate=\"marketmanagerApp.contactTemp.state\">State</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"country\"><span jhiTranslate=\"marketmanagerApp.contactTemp.country\">Country</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"phone\"><span jhiTranslate=\"marketmanagerApp.contactTemp.phone\">Phone</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"phoneAdditional\"><span jhiTranslate=\"marketmanagerApp.contactTemp.phoneAdditional\">Phone Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"fax\"><span jhiTranslate=\"marketmanagerApp.contactTemp.fax\">Fax</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"mobile\"><span jhiTranslate=\"marketmanagerApp.contactTemp.mobile\">Mobile</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"email\"><span jhiTranslate=\"marketmanagerApp.contactTemp.email\">Email</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"emailAdditional\"><span jhiTranslate=\"marketmanagerApp.contactTemp.emailAdditional\">Email Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"web\"><span jhiTranslate=\"marketmanagerApp.contactTemp.web\">Web</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"comment\"><span jhiTranslate=\"marketmanagerApp.contactTemp.comment\">Comment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"companyGguid\"><span jhiTranslate=\"marketmanagerApp.contactTemp.companyGguid\">Company Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"casIsCompany\"><span jhiTranslate=\"marketmanagerApp.contactTemp.casIsCompany\">Cas Is Company</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"casIsContact\"><span jhiTranslate=\"marketmanagerApp.contactTemp.casIsContact\">Cas Is Contact</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"latitude\"><span jhiTranslate=\"marketmanagerApp.contactTemp.latitude\">Latitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"longitude\"><span jhiTranslate=\"marketmanagerApp.contactTemp.longitude\">Longitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothUnit\"><span jhiTranslate=\"marketmanagerApp.contactTemp.boothUnit\">Booth Unit</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothType\"><span jhiTranslate=\"marketmanagerApp.contactTemp.boothType\">Booth Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"radius\"><span jhiTranslate=\"marketmanagerApp.contactTemp.radius\">Radius</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothWidth\"><span jhiTranslate=\"marketmanagerApp.contactTemp.boothWidth\">Booth Width</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothDepth\"><span jhiTranslate=\"marketmanagerApp.contactTemp.boothDepth\">Booth Depth</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortment\"><span jhiTranslate=\"marketmanagerApp.contactTemp.assortment\">Assortment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortmentAdditional\"><span jhiTranslate=\"marketmanagerApp.contactTemp.assortmentAdditional\">Assortment Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"activeMerchant\"><span jhiTranslate=\"marketmanagerApp.contactTemp.activeMerchant\">Active Merchant</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.contactTemp.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.contactTemp.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.contactTemp.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"status\"><span jhiTranslate=\"marketmanagerApp.contactTemp.status\">Status</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"superordinateContact.displayname\"><span jhiTranslate=\"marketmanagerApp.contactTemp.superordinateContact\">Superordinate Contact</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"originalContact.displayname\"><span jhiTranslate=\"marketmanagerApp.contactTemp.originalContact\">Original Contact</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let contactTemp of contactTemps ;trackBy: trackId\"> <td><a [routerLink]=\"['../contact-temp', contactTemp.id ]\">{{contactTemp.id}}</a></td> <td jhiTranslate=\"{{'marketmanagerApp.ContactType.' + contactTemp.type}}\">{{contactTemp.type}}</td> <td>{{contactTemp.salutation}}</td> <td>{{contactTemp.title}}</td> <td>{{contactTemp.firstname}}</td> <td>{{contactTemp.lastname}}</td> <td>{{contactTemp.displayname}}</td> <td>{{contactTemp.company}}</td> <td>{{contactTemp.companyAdditional}}</td> <td>{{contactTemp.street}}</td> <td>{{contactTemp.streetAdditional}}</td> <td>{{contactTemp.zipcode}}</td> <td>{{contactTemp.city}}</td> <td>{{contactTemp.suburb}}</td> <td>{{contactTemp.state}}</td> <td>{{contactTemp.country}}</td> <td>{{contactTemp.phone}}</td> <td>{{contactTemp.phoneAdditional}}</td> <td>{{contactTemp.fax}}</td> <td>{{contactTemp.mobile}}</td> <td>{{contactTemp.email}}</td> <td>{{contactTemp.emailAdditional}}</td> <td>{{contactTemp.web}}</td> <td>{{contactTemp.comment}}</td> <td>{{contactTemp.companyGguid}}</td> <td>{{contactTemp.casIsCompany}}</td> <td>{{contactTemp.casIsContact}}</td> <td>{{contactTemp.latitude}}</td> <td>{{contactTemp.longitude}}</td> <td>{{contactTemp.boothUnit}}</td> <td>{{contactTemp.boothType}}</td> <td>{{contactTemp.radius}}</td> <td>{{contactTemp.boothWidth}}</td> <td>{{contactTemp.boothDepth}}</td> <td>{{contactTemp.assortment}}</td> <td>{{contactTemp.assortmentAdditional}}</td> <td>{{contactTemp.activeMerchant}}</td> <td>{{contactTemp.updated | date:'medium'}}</td> <td>{{contactTemp.created | date:'medium'}}</td> <td>{{contactTemp.gguid}}</td> <td jhiTranslate=\"{{'marketmanagerApp.ContactStatus.' + contactTemp.status}}\">{{contactTemp.status}}</td> <td> <div *ngIf=\"contactTemp.superordinateContact\"> <a [routerLink]=\"['../contact', contactTemp.superordinateContact?.id ]\">{{contactTemp.superordinateContact?.displayname}}</a> </div> </td> <td> <div *ngIf=\"contactTemp.originalContact\"> <a [routerLink]=\"['../contact', contactTemp.originalContact?.id ]\">{{contactTemp.originalContact?.displayname}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../contact-temp', contactTemp.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contact-temp/'+ contactTemp.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contact-temp/'+ contactTemp.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"contactTemps && contactTemps.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(contact.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.contact.delete.question\" translateValues=\"{id: '{{contact.id}}'}\">Are you sure you want to delete this Contact?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"contact\"> <h2><span jhiTranslate=\"marketmanagerApp.contact.detail.title\">Contact</span> {{contact.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.contact.type\">Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContactType.' + contact.type}}\">{{contact.type}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.salutation\">Salutation</span></dt> <dd> <span>{{contact.salutation}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.title\">Title</span></dt> <dd> <span>{{contact.title}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.firstname\">Firstname</span></dt> <dd> <span>{{contact.firstname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.lastname\">Lastname</span></dt> <dd> <span>{{contact.lastname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.displayname\">Displayname</span></dt> <dd> <span>{{contact.displayname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.company\">Company</span></dt> <dd> <span>{{contact.company}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.companyAdditional\">Company Additional</span></dt> <dd> <span>{{contact.companyAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.street\">Street</span></dt> <dd> <span>{{contact.street}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.streetAdditional\">Street Additional</span></dt> <dd> <span>{{contact.streetAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.zipcode\">Zipcode</span></dt> <dd> <span>{{contact.zipcode}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.city\">City</span></dt> <dd> <span>{{contact.city}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.suburb\">Suburb</span></dt> <dd> <span>{{contact.suburb}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.state\">State</span></dt> <dd> <span>{{contact.state}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.country\">Country</span></dt> <dd> <span>{{contact.country}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.phone\">Phone</span></dt> <dd> <span>{{contact.phone}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.phoneAdditional\">Phone Additional</span></dt> <dd> <span>{{contact.phoneAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.fax\">Fax</span></dt> <dd> <span>{{contact.fax}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.mobile\">Mobile</span></dt> <dd> <span>{{contact.mobile}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.email\">Email</span></dt> <dd> <span>{{contact.email}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.emailAdditional\">Email Additional</span></dt> <dd> <span>{{contact.emailAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.web\">Web</span></dt> <dd> <span>{{contact.web}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.comment\">Comment</span></dt> <dd> <span>{{contact.comment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.companyGguid\">Company Gguid</span></dt> <dd> <span>{{contact.companyGguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.casIsCompany\">Cas Is Company</span></dt> <dd> <span>{{contact.casIsCompany}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.casIsContact\">Cas Is Contact</span></dt> <dd> <span>{{contact.casIsContact}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.latitude\">Latitude</span></dt> <dd> <span>{{contact.latitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.longitude\">Longitude</span></dt> <dd> <span>{{contact.longitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.boothUnit\">Booth Unit</span></dt> <dd> <span>{{contact.boothUnit}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.boothType\">Booth Type</span></dt> <dd> <span>{{contact.boothType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.radius\">Radius</span></dt> <dd> <span>{{contact.radius}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.boothWidth\">Booth Width</span></dt> <dd> <span>{{contact.boothWidth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.boothDepth\">Booth Depth</span></dt> <dd> <span>{{contact.boothDepth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.assortment\">Assortment</span></dt> <dd> <span>{{contact.assortment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.assortmentAdditional\">Assortment Additional</span></dt> <dd> <span>{{contact.assortmentAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.activeMerchant\">Active Merchant</span></dt> <dd> <span>{{contact.activeMerchant}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.updated\">Updated</span></dt> <dd> <span>{{contact.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.created\">Created</span></dt> <dd> <span>{{contact.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.gguid\">Gguid</span></dt> <dd> <span>{{contact.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.status\">Status</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContactStatus.' + contact.status}}\">{{contact.status}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.user\">User</span></dt> <dd> {{contact.user?.login}} </dd> <dt><span jhiTranslate=\"marketmanagerApp.contact.superordinateContact\">Superordinate Contact</span></dt> <dd> <div *ngIf=\"contact.superordinateContact\"> <a [routerLink]=\"['/contact', contact.superordinateContact?.id]\">{{contact.superordinateContact?.displayname}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'contact/'+ contact.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myContactLabel\" jhiTranslate=\"marketmanagerApp.contact.home.createOrEditLabel\">Create or edit a Contact</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!contact.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"contact.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.type\" for=\"field_type\">Type</label> <select class=\"form-control\" name=\"type\" [(ngModel)]=\"contact.type\" id=\"field_type\"> <option value=\"Commune\" jhiTranslate=\"marketmanagerApp.ContactType.Commune\">Commune</option> <option value=\"Merchant\" jhiTranslate=\"marketmanagerApp.ContactType.Merchant\">Merchant</option> <option value=\"Person\" jhiTranslate=\"marketmanagerApp.ContactType.Person\">Person</option> <option value=\"Employee\" jhiTranslate=\"marketmanagerApp.ContactType.Employee\">Employee</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.salutation\" for=\"field_salutation\">Salutation</label> <input type=\"text\" class=\"form-control\" name=\"salutation\" id=\"field_salutation\" [(ngModel)]=\"contact.salutation\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.title\" for=\"field_title\">Title</label> <input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" [(ngModel)]=\"contact.title\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.firstname\" for=\"field_firstname\">Firstname</label> <input type=\"text\" class=\"form-control\" name=\"firstname\" id=\"field_firstname\" [(ngModel)]=\"contact.firstname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.lastname\" for=\"field_lastname\">Lastname</label> <input type=\"text\" class=\"form-control\" name=\"lastname\" id=\"field_lastname\" [(ngModel)]=\"contact.lastname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.displayname\" for=\"field_displayname\">Displayname</label> <input type=\"text\" class=\"form-control\" name=\"displayname\" id=\"field_displayname\" [(ngModel)]=\"contact.displayname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.company\" for=\"field_company\">Company</label> <input type=\"text\" class=\"form-control\" name=\"company\" id=\"field_company\" [(ngModel)]=\"contact.company\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.companyAdditional\" for=\"field_companyAdditional\">Company Additional</label> <input type=\"text\" class=\"form-control\" name=\"companyAdditional\" id=\"field_companyAdditional\" [(ngModel)]=\"contact.companyAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.street\" for=\"field_street\">Street</label> <input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" [(ngModel)]=\"contact.street\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.streetAdditional\" for=\"field_streetAdditional\">Street Additional</label> <input type=\"text\" class=\"form-control\" name=\"streetAdditional\" id=\"field_streetAdditional\" [(ngModel)]=\"contact.streetAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.zipcode\" for=\"field_zipcode\">Zipcode</label> <input type=\"text\" class=\"form-control\" name=\"zipcode\" id=\"field_zipcode\" [(ngModel)]=\"contact.zipcode\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.city\" for=\"field_city\">City</label> <input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" [(ngModel)]=\"contact.city\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.suburb\" for=\"field_suburb\">Suburb</label> <input type=\"text\" class=\"form-control\" name=\"suburb\" id=\"field_suburb\" [(ngModel)]=\"contact.suburb\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.state\" for=\"field_state\">State</label> <input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_state\" [(ngModel)]=\"contact.state\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.country\" for=\"field_country\">Country</label> <input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" [(ngModel)]=\"contact.country\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.phone\" for=\"field_phone\">Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" [(ngModel)]=\"contact.phone\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.phoneAdditional\" for=\"field_phoneAdditional\">Phone Additional</label> <input type=\"text\" class=\"form-control\" name=\"phoneAdditional\" id=\"field_phoneAdditional\" [(ngModel)]=\"contact.phoneAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.fax\" for=\"field_fax\">Fax</label> <input type=\"text\" class=\"form-control\" name=\"fax\" id=\"field_fax\" [(ngModel)]=\"contact.fax\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.mobile\" for=\"field_mobile\">Mobile</label> <input type=\"text\" class=\"form-control\" name=\"mobile\" id=\"field_mobile\" [(ngModel)]=\"contact.mobile\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.email\" for=\"field_email\">Email</label> <input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" [(ngModel)]=\"contact.email\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.emailAdditional\" for=\"field_emailAdditional\">Email Additional</label> <input type=\"text\" class=\"form-control\" name=\"emailAdditional\" id=\"field_emailAdditional\" [(ngModel)]=\"contact.emailAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.web\" for=\"field_web\">Web</label> <input type=\"text\" class=\"form-control\" name=\"web\" id=\"field_web\" [(ngModel)]=\"contact.web\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.comment\" for=\"field_comment\">Comment</label> <input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" [(ngModel)]=\"contact.comment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.companyGguid\" for=\"field_companyGguid\">Company Gguid</label> <input type=\"text\" class=\"form-control\" name=\"companyGguid\" id=\"field_companyGguid\" [(ngModel)]=\"contact.companyGguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.casIsCompany\" for=\"field_casIsCompany\">Cas Is Company</label> <input type=\"checkbox\" class=\"form-control\" name=\"casIsCompany\" id=\"field_casIsCompany\" [(ngModel)]=\"contact.casIsCompany\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.casIsContact\" for=\"field_casIsContact\">Cas Is Contact</label> <input type=\"checkbox\" class=\"form-control\" name=\"casIsContact\" id=\"field_casIsContact\" [(ngModel)]=\"contact.casIsContact\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.latitude\" for=\"field_latitude\">Latitude</label> <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" [(ngModel)]=\"contact.latitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.longitude\" for=\"field_longitude\">Longitude</label> <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" [(ngModel)]=\"contact.longitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.boothUnit\" for=\"field_boothUnit\">Booth Unit</label> <input type=\"text\" class=\"form-control\" name=\"boothUnit\" id=\"field_boothUnit\" [(ngModel)]=\"contact.boothUnit\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.boothType\" for=\"field_boothType\">Booth Type</label> <input type=\"text\" class=\"form-control\" name=\"boothType\" id=\"field_boothType\" [(ngModel)]=\"contact.boothType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.radius\" for=\"field_radius\">Radius</label> <input type=\"text\" class=\"form-control\" name=\"radius\" id=\"field_radius\" [(ngModel)]=\"contact.radius\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.boothWidth\" for=\"field_boothWidth\">Booth Width</label> <input type=\"number\" class=\"form-control\" name=\"boothWidth\" id=\"field_boothWidth\" [(ngModel)]=\"contact.boothWidth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.boothDepth\" for=\"field_boothDepth\">Booth Depth</label> <input type=\"number\" class=\"form-control\" name=\"boothDepth\" id=\"field_boothDepth\" [(ngModel)]=\"contact.boothDepth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.assortment\" for=\"field_assortment\">Assortment</label> <input type=\"text\" class=\"form-control\" name=\"assortment\" id=\"field_assortment\" [(ngModel)]=\"contact.assortment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.assortmentAdditional\" for=\"field_assortmentAdditional\">Assortment Additional</label> <input type=\"text\" class=\"form-control\" name=\"assortmentAdditional\" id=\"field_assortmentAdditional\" [(ngModel)]=\"contact.assortmentAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.activeMerchant\" for=\"field_activeMerchant\">Active Merchant</label> <input type=\"checkbox\" class=\"form-control\" name=\"activeMerchant\" id=\"field_activeMerchant\" [(ngModel)]=\"contact.activeMerchant\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"contact.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"contact.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"contact.gguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contact.status\" for=\"field_status\">Status</label> <select class=\"form-control\" name=\"status\" [(ngModel)]=\"contact.status\" id=\"field_status\"> <option value=\"New\" jhiTranslate=\"marketmanagerApp.ContactStatus.New\">New</option> <option value=\"Changed\" jhiTranslate=\"marketmanagerApp.ContactStatus.Changed\">Changed</option> <option value=\"Deleted\" jhiTranslate=\"marketmanagerApp.ContactStatus.Deleted\">Deleted</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contact.user\" for=\"field_user\">User</label> <select class=\"form-control\" id=\"field_user\" name=\"user\" [(ngModel)]=\"contact.user\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === contact.user?.id ? contact.user : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contact.superordinateContact\" for=\"field_superordinateContact\">Superordinate Contact</label> <select class=\"form-control\" id=\"field_superordinateContact\" name=\"superordinateContact\" [(ngModel)]=\"contact.superordinateContact\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === contact.superordinateContact?.id ? contact.superordinateContact : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.contact.home.title\">Contacts</span> <button class=\"btn btn-primary float-right create-contact\" [routerLink]=\"['/', { outlets: { popup: ['contact-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.contact.home.createLabel\"> Create new Contact </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.contact.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"contacts\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"type\"><span jhiTranslate=\"marketmanagerApp.contact.type\">Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"salutation\"><span jhiTranslate=\"marketmanagerApp.contact.salutation\">Salutation</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"title\"><span jhiTranslate=\"marketmanagerApp.contact.title\">Title</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"firstname\"><span jhiTranslate=\"marketmanagerApp.contact.firstname\">Firstname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastname\"><span jhiTranslate=\"marketmanagerApp.contact.lastname\">Lastname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"displayname\"><span jhiTranslate=\"marketmanagerApp.contact.displayname\">Displayname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"company\"><span jhiTranslate=\"marketmanagerApp.contact.company\">Company</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"companyAdditional\"><span jhiTranslate=\"marketmanagerApp.contact.companyAdditional\">Company Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"street\"><span jhiTranslate=\"marketmanagerApp.contact.street\">Street</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"streetAdditional\"><span jhiTranslate=\"marketmanagerApp.contact.streetAdditional\">Street Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"zipcode\"><span jhiTranslate=\"marketmanagerApp.contact.zipcode\">Zipcode</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"city\"><span jhiTranslate=\"marketmanagerApp.contact.city\">City</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"suburb\"><span jhiTranslate=\"marketmanagerApp.contact.suburb\">Suburb</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"state\"><span jhiTranslate=\"marketmanagerApp.contact.state\">State</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"country\"><span jhiTranslate=\"marketmanagerApp.contact.country\">Country</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"phone\"><span jhiTranslate=\"marketmanagerApp.contact.phone\">Phone</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"phoneAdditional\"><span jhiTranslate=\"marketmanagerApp.contact.phoneAdditional\">Phone Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"fax\"><span jhiTranslate=\"marketmanagerApp.contact.fax\">Fax</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"mobile\"><span jhiTranslate=\"marketmanagerApp.contact.mobile\">Mobile</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"email\"><span jhiTranslate=\"marketmanagerApp.contact.email\">Email</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"emailAdditional\"><span jhiTranslate=\"marketmanagerApp.contact.emailAdditional\">Email Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"web\"><span jhiTranslate=\"marketmanagerApp.contact.web\">Web</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"comment\"><span jhiTranslate=\"marketmanagerApp.contact.comment\">Comment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"companyGguid\"><span jhiTranslate=\"marketmanagerApp.contact.companyGguid\">Company Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"casIsCompany\"><span jhiTranslate=\"marketmanagerApp.contact.casIsCompany\">Cas Is Company</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"casIsContact\"><span jhiTranslate=\"marketmanagerApp.contact.casIsContact\">Cas Is Contact</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"latitude\"><span jhiTranslate=\"marketmanagerApp.contact.latitude\">Latitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"longitude\"><span jhiTranslate=\"marketmanagerApp.contact.longitude\">Longitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothUnit\"><span jhiTranslate=\"marketmanagerApp.contact.boothUnit\">Booth Unit</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothType\"><span jhiTranslate=\"marketmanagerApp.contact.boothType\">Booth Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"radius\"><span jhiTranslate=\"marketmanagerApp.contact.radius\">Radius</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothWidth\"><span jhiTranslate=\"marketmanagerApp.contact.boothWidth\">Booth Width</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothDepth\"><span jhiTranslate=\"marketmanagerApp.contact.boothDepth\">Booth Depth</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortment\"><span jhiTranslate=\"marketmanagerApp.contact.assortment\">Assortment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortmentAdditional\"><span jhiTranslate=\"marketmanagerApp.contact.assortmentAdditional\">Assortment Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"activeMerchant\"><span jhiTranslate=\"marketmanagerApp.contact.activeMerchant\">Active Merchant</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.contact.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.contact.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.contact.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"status\"><span jhiTranslate=\"marketmanagerApp.contact.status\">Status</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"user.login\"><span jhiTranslate=\"marketmanagerApp.contact.user\">User</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"superordinateContact.displayname\"><span jhiTranslate=\"marketmanagerApp.contact.superordinateContact\">Superordinate Contact</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let contact of contacts ;trackBy: trackId\"> <td><a [routerLink]=\"['../contact', contact.id ]\">{{contact.id}}</a></td> <td jhiTranslate=\"{{'marketmanagerApp.ContactType.' + contact.type}}\">{{contact.type}}</td> <td>{{contact.salutation}}</td> <td>{{contact.title}}</td> <td>{{contact.firstname}}</td> <td>{{contact.lastname}}</td> <td>{{contact.displayname}}</td> <td>{{contact.company}}</td> <td>{{contact.companyAdditional}}</td> <td>{{contact.street}}</td> <td>{{contact.streetAdditional}}</td> <td>{{contact.zipcode}}</td> <td>{{contact.city}}</td> <td>{{contact.suburb}}</td> <td>{{contact.state}}</td> <td>{{contact.country}}</td> <td>{{contact.phone}}</td> <td>{{contact.phoneAdditional}}</td> <td>{{contact.fax}}</td> <td>{{contact.mobile}}</td> <td>{{contact.email}}</td> <td>{{contact.emailAdditional}}</td> <td>{{contact.web}}</td> <td>{{contact.comment}}</td> <td>{{contact.companyGguid}}</td> <td>{{contact.casIsCompany}}</td> <td>{{contact.casIsContact}}</td> <td>{{contact.latitude}}</td> <td>{{contact.longitude}}</td> <td>{{contact.boothUnit}}</td> <td>{{contact.boothType}}</td> <td>{{contact.radius}}</td> <td>{{contact.boothWidth}}</td> <td>{{contact.boothDepth}}</td> <td>{{contact.assortment}}</td> <td>{{contact.assortmentAdditional}}</td> <td>{{contact.activeMerchant}}</td> <td>{{contact.updated | date:'medium'}}</td> <td>{{contact.created | date:'medium'}}</td> <td>{{contact.gguid}}</td> <td jhiTranslate=\"{{'marketmanagerApp.ContactStatus.' + contact.status}}\">{{contact.status}}</td> <td> {{contact.user?.login}} </td> <td> <div *ngIf=\"contact.superordinateContact\"> <a [routerLink]=\"['../contact', contact.superordinateContact?.id ]\">{{contact.superordinateContact?.displayname}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../contact', contact.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contact/'+ contact.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contact/'+ contact.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"contacts && contacts.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(contract.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.contract.delete.question\" translateValues=\"{id: '{{contract.id}}'}\">Are you sure you want to delete this Contract?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"contract\"> <h2><span jhiTranslate=\"marketmanagerApp.contract.detail.title\">Contract</span> {{contract.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.contract.startDate\">Start Date</span></dt> <dd> <span>{{contract.startDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.merchantNumber\">Merchant Number</span></dt> <dd> <span>{{contract.merchantNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{contract.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.marketdateNumber\">Marketdate Number</span></dt> <dd> <span>{{contract.marketdateNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.endDate\">End Date</span></dt> <dd> <span>{{contract.endDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothWidth\">Booth Width</span></dt> <dd> <span>{{contract.boothWidth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothDepth\">Booth Depth</span></dt> <dd> <span>{{contract.boothDepth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.contractNumber\">Contract Number</span></dt> <dd> <span>{{contract.contractNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothWidthAdditional\">Booth Width Additional</span></dt> <dd> <span>{{contract.boothWidthAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothDepthAdditional\">Booth Depth Additional</span></dt> <dd> <span>{{contract.boothDepthAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.specialPrice\">Special Price</span></dt> <dd> <span>{{contract.specialPrice}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.divergentEnergy\">Divergent Energy</span></dt> <dd> <span>{{contract.divergentEnergy}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.energyAdvancedPayment\">Energy Advanced Payment</span></dt> <dd> <span>{{contract.energyAdvancedPayment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.isSpecial\">Is Special</span></dt> <dd> <span>{{contract.isSpecial}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothWidthWinter\">Booth Width Winter</span></dt> <dd> <span>{{contract.boothWidthWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothDepthWinter\">Booth Depth Winter</span></dt> <dd> <span>{{contract.boothDepthWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothWidthWinterAdditional\">Booth Width Winter Additional</span></dt> <dd> <span>{{contract.boothWidthWinterAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.boothDepthWinterAdditional\">Booth Depth Winter Additional</span></dt> <dd> <span>{{contract.boothDepthWinterAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.energyType\">Energy Type</span></dt> <dd> <span>{{contract.energyType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.energyTypeWinter\">Energy Type Winter</span></dt> <dd> <span>{{contract.energyTypeWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.gguid\">Gguid</span></dt> <dd> <span>{{contract.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.marketday\">Marketday</span></dt> <dd> <div *ngIf=\"contract.marketday\"> <a [routerLink]=\"['/marketday', contract.marketday?.id]\">{{contract.marketday?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.merchant\">Merchant</span></dt> <dd> <div *ngIf=\"contract.merchant\"> <a [routerLink]=\"['/contact', contract.merchant?.id]\">{{contract.merchant?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contract.salesunit\">Salesunit</span></dt> <dd> <div *ngIf=\"contract.salesunit\"> <a [routerLink]=\"['/salesunit', contract.salesunit?.id]\">{{contract.salesunit?.identification}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'contract/'+ contract.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myContractLabel\" jhiTranslate=\"marketmanagerApp.contract.home.createOrEditLabel\">Create or edit a Contract</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!contract.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"contract.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.startDate\" for=\"field_startDate\">Start Date</label> <div class=\"d-flex\"> <input id=\"field_startDate\" type=\"datetime-local\" class=\"form-control\" name=\"startDate\" [(ngModel)]=\"contract.startDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.merchantNumber\" for=\"field_merchantNumber\">Merchant Number</label> <input type=\"number\" class=\"form-control\" name=\"merchantNumber\" id=\"field_merchantNumber\" [(ngModel)]=\"contract.merchantNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"contract.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.marketdateNumber\" for=\"field_marketdateNumber\">Marketdate Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdateNumber\" id=\"field_marketdateNumber\" [(ngModel)]=\"contract.marketdateNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.endDate\" for=\"field_endDate\">End Date</label> <div class=\"d-flex\"> <input id=\"field_endDate\" type=\"datetime-local\" class=\"form-control\" name=\"endDate\" [(ngModel)]=\"contract.endDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothWidth\" for=\"field_boothWidth\">Booth Width</label> <input type=\"number\" class=\"form-control\" name=\"boothWidth\" id=\"field_boothWidth\" [(ngModel)]=\"contract.boothWidth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothDepth\" for=\"field_boothDepth\">Booth Depth</label> <input type=\"number\" class=\"form-control\" name=\"boothDepth\" id=\"field_boothDepth\" [(ngModel)]=\"contract.boothDepth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.contractNumber\" for=\"field_contractNumber\">Contract Number</label> <input type=\"text\" class=\"form-control\" name=\"contractNumber\" id=\"field_contractNumber\" [(ngModel)]=\"contract.contractNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothWidthAdditional\" for=\"field_boothWidthAdditional\">Booth Width Additional</label> <input type=\"number\" class=\"form-control\" name=\"boothWidthAdditional\" id=\"field_boothWidthAdditional\" [(ngModel)]=\"contract.boothWidthAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothDepthAdditional\" for=\"field_boothDepthAdditional\">Booth Depth Additional</label> <input type=\"number\" class=\"form-control\" name=\"boothDepthAdditional\" id=\"field_boothDepthAdditional\" [(ngModel)]=\"contract.boothDepthAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.specialPrice\" for=\"field_specialPrice\">Special Price</label> <input type=\"number\" class=\"form-control\" name=\"specialPrice\" id=\"field_specialPrice\" [(ngModel)]=\"contract.specialPrice\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.divergentEnergy\" for=\"field_divergentEnergy\">Divergent Energy</label> <input type=\"checkbox\" class=\"form-control\" name=\"divergentEnergy\" id=\"field_divergentEnergy\" [(ngModel)]=\"contract.divergentEnergy\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.energyAdvancedPayment\" for=\"field_energyAdvancedPayment\">Energy Advanced Payment</label> <input type=\"number\" class=\"form-control\" name=\"energyAdvancedPayment\" id=\"field_energyAdvancedPayment\" [(ngModel)]=\"contract.energyAdvancedPayment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.isSpecial\" for=\"field_isSpecial\">Is Special</label> <input type=\"checkbox\" class=\"form-control\" name=\"isSpecial\" id=\"field_isSpecial\" [(ngModel)]=\"contract.isSpecial\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothWidthWinter\" for=\"field_boothWidthWinter\">Booth Width Winter</label> <input type=\"number\" class=\"form-control\" name=\"boothWidthWinter\" id=\"field_boothWidthWinter\" [(ngModel)]=\"contract.boothWidthWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothDepthWinter\" for=\"field_boothDepthWinter\">Booth Depth Winter</label> <input type=\"number\" class=\"form-control\" name=\"boothDepthWinter\" id=\"field_boothDepthWinter\" [(ngModel)]=\"contract.boothDepthWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothWidthWinterAdditional\" for=\"field_boothWidthWinterAdditional\">Booth Width Winter Additional</label> <input type=\"number\" class=\"form-control\" name=\"boothWidthWinterAdditional\" id=\"field_boothWidthWinterAdditional\" [(ngModel)]=\"contract.boothWidthWinterAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.boothDepthWinterAdditional\" for=\"field_boothDepthWinterAdditional\">Booth Depth Winter Additional</label> <input type=\"number\" class=\"form-control\" name=\"boothDepthWinterAdditional\" id=\"field_boothDepthWinterAdditional\" [(ngModel)]=\"contract.boothDepthWinterAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.energyType\" for=\"field_energyType\">Energy Type</label> <input type=\"text\" class=\"form-control\" name=\"energyType\" id=\"field_energyType\" [(ngModel)]=\"contract.energyType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.energyTypeWinter\" for=\"field_energyTypeWinter\">Energy Type Winter</label> <input type=\"text\" class=\"form-control\" name=\"energyTypeWinter\" id=\"field_energyTypeWinter\" [(ngModel)]=\"contract.energyTypeWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contract.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"contract.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contract.marketday\" for=\"field_marketday\">Marketday</label> <select class=\"form-control\" id=\"field_marketday\" name=\"marketday\" [(ngModel)]=\"contract.marketday\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdayOption.id === contract.marketday?.id ? contract.marketday : marketdayOption\" *ngFor=\"let marketdayOption of marketdays; trackBy: trackMarketdayById\">{{marketdayOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contract.merchant\" for=\"field_merchant\">Merchant</label> <select class=\"form-control\" id=\"field_merchant\" name=\"merchant\" [(ngModel)]=\"contract.merchant\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === contract.merchant?.id ? contract.merchant : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contract.salesunit\" for=\"field_salesunit\">Salesunit</label> <select class=\"form-control\" id=\"field_salesunit\" name=\"salesunit\" [(ngModel)]=\"contract.salesunit\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"salesunitOption.id === contract.salesunit?.id ? contract.salesunit : salesunitOption\" *ngFor=\"let salesunitOption of salesunits; trackBy: trackSalesunitById\">{{salesunitOption.identification}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.contract.home.title\">Contracts</span> <button class=\"btn btn-primary float-right create-contract\" [routerLink]=\"['/', { outlets: { popup: ['contract-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.contract.home.createLabel\"> Create new Contract </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.contract.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"contracts\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.startDate\">Start Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.merchantNumber\">Merchant Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.marketdayNumber\">Marketday Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.marketdateNumber\">Marketdate Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.endDate\">End Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothWidth\">Booth Width</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothDepth\">Booth Depth</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.contractNumber\">Contract Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothWidthAdditional\">Booth Width Additional</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothDepthAdditional\">Booth Depth Additional</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.specialPrice\">Special Price</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.divergentEnergy\">Divergent Energy</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.energyAdvancedPayment\">Energy Advanced Payment</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.isSpecial\">Is Special</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothWidthWinter\">Booth Width Winter</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothDepthWinter\">Booth Depth Winter</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothWidthWinterAdditional\">Booth Width Winter Additional</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.boothDepthWinterAdditional\">Booth Depth Winter Additional</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.energyType\">Energy Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.energyTypeWinter\">Energy Type Winter</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.gguid\">Gguid</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.marketday\">Marketday</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.merchant\">Merchant</span></th> <th><span jhiTranslate=\"marketmanagerApp.contract.salesunit\">Salesunit</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let contract of contracts ;trackBy: trackId\"> <td><a [routerLink]=\"['../contract', contract.id ]\">{{contract.id}}</a></td> <td>{{contract.startDate | date:'medium'}}</td> <td>{{contract.merchantNumber}}</td> <td>{{contract.marketdayNumber}}</td> <td>{{contract.marketdateNumber}}</td> <td>{{contract.endDate | date:'medium'}}</td> <td>{{contract.boothWidth}}</td> <td>{{contract.boothDepth}}</td> <td>{{contract.contractNumber}}</td> <td>{{contract.boothWidthAdditional}}</td> <td>{{contract.boothDepthAdditional}}</td> <td>{{contract.specialPrice}}</td> <td>{{contract.divergentEnergy}}</td> <td>{{contract.energyAdvancedPayment}}</td> <td>{{contract.isSpecial}}</td> <td>{{contract.boothWidthWinter}}</td> <td>{{contract.boothDepthWinter}}</td> <td>{{contract.boothWidthWinterAdditional}}</td> <td>{{contract.boothDepthWinterAdditional}}</td> <td>{{contract.energyType}}</td> <td>{{contract.energyTypeWinter}}</td> <td>{{contract.gguid}}</td> <td> <div *ngIf=\"contract.marketday\"> <a [routerLink]=\"['../marketday', contract.marketday?.id ]\">{{contract.marketday?.marketdayNumber}}</a> </div> </td> <td> <div *ngIf=\"contract.merchant\"> <a [routerLink]=\"['../contact', contract.merchant?.id ]\">{{contract.merchant?.displayname}}</a> </div> </td> <td> <div *ngIf=\"contract.salesunit\"> <a [routerLink]=\"['../salesunit', contract.salesunit?.id ]\">{{contract.salesunit?.identification}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../contract', contract.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contract/'+ contract.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contract/'+ contract.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(contractdate.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.contractdate.delete.question\" translateValues=\"{id: '{{contractdate.id}}'}\">Are you sure you want to delete this Contractdate?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"contractdate\"> <h2><span jhiTranslate=\"marketmanagerApp.contractdate.detail.title\">Contractdate</span> {{contractdate.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.contractdate.realDate\">Real Date</span></dt> <dd> <span>{{contractdate.realDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contractdate.originalDate\">Original Date</span></dt> <dd> <span>{{contractdate.originalDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contractdate.evasiveDate\">Evasive Date</span></dt> <dd> <span>{{contractdate.evasiveDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contractdate.gguid\">Gguid</span></dt> <dd> <span>{{contractdate.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.contractdate.contract\">Contract</span></dt> <dd> <div *ngIf=\"contractdate.contract\"> <a [routerLink]=\"['/contract', contractdate.contract?.id]\">{{contractdate.contract?.contractNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'contractdate/'+ contractdate.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myContractdateLabel\" jhiTranslate=\"marketmanagerApp.contractdate.home.createOrEditLabel\">Create or edit a Contractdate</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!contractdate.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"contractdate.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contractdate.realDate\" for=\"field_realDate\">Real Date</label> <div class=\"d-flex\"> <input id=\"field_realDate\" type=\"datetime-local\" class=\"form-control\" name=\"realDate\" [(ngModel)]=\"contractdate.realDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contractdate.originalDate\" for=\"field_originalDate\">Original Date</label> <div class=\"d-flex\"> <input id=\"field_originalDate\" type=\"datetime-local\" class=\"form-control\" name=\"originalDate\" [(ngModel)]=\"contractdate.originalDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contractdate.evasiveDate\" for=\"field_evasiveDate\">Evasive Date</label> <div class=\"d-flex\"> <input id=\"field_evasiveDate\" type=\"datetime-local\" class=\"form-control\" name=\"evasiveDate\" [(ngModel)]=\"contractdate.evasiveDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.contractdate.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"contractdate.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.contractdate.contract\" for=\"field_contract\">Contract</label> <select class=\"form-control\" id=\"field_contract\" name=\"contract\" [(ngModel)]=\"contractdate.contract\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contractOption.id === contractdate.contract?.id ? contractdate.contract : contractOption\" *ngFor=\"let contractOption of contracts; trackBy: trackContractById\">{{contractOption.contractNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.contractdate.home.title\">Contractdates</span> <button class=\"btn btn-primary float-right create-contractdate\" [routerLink]=\"['/', { outlets: { popup: ['contractdate-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.contractdate.home.createLabel\"> Create new Contractdate </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.contractdate.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"contractdates\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.contractdate.realDate\">Real Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.contractdate.originalDate\">Original Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.contractdate.evasiveDate\">Evasive Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.contractdate.gguid\">Gguid</span></th> <th><span jhiTranslate=\"marketmanagerApp.contractdate.contract\">Contract</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let contractdate of contractdates ;trackBy: trackId\"> <td><a [routerLink]=\"['../contractdate', contractdate.id ]\">{{contractdate.id}}</a></td> <td>{{contractdate.realDate | date:'medium'}}</td> <td>{{contractdate.originalDate | date:'medium'}}</td> <td>{{contractdate.evasiveDate | date:'medium'}}</td> <td>{{contractdate.gguid}}</td> <td> <div *ngIf=\"contractdate.contract\"> <a [routerLink]=\"['../contract', contractdate.contract?.id ]\">{{contractdate.contract?.contractNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../contractdate', contractdate.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contractdate/'+ contractdate.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'contractdate/'+ contractdate.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(electricmeter.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.electricmeter.delete.question\" translateValues=\"{id: '{{electricmeter.id}}'}\">Are you sure you want to delete this Electricmeter?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"electricmeter\"> <h2><span jhiTranslate=\"marketmanagerApp.electricmeter.detail.title\">Electricmeter</span> {{electricmeter.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.marketplaceNumber\">Marketplace Number</span></dt> <dd> <span>{{electricmeter.marketplaceNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.provider\">Provider</span></dt> <dd> <span>{{electricmeter.provider}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.count230V\">Count 230 V</span></dt> <dd> <span>{{electricmeter.count230V}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.count380V\">Count 380 V</span></dt> <dd> <span>{{electricmeter.count380V}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.owner\">Owner</span></dt> <dd> <span>{{electricmeter.owner}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.electricmeterNumber\">Electricmeter Number</span></dt> <dd> <span>{{electricmeter.electricmeterNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.location\">Location</span></dt> <dd> <span>{{electricmeter.location}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.updated\">Updated</span></dt> <dd> <span>{{electricmeter.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.created\">Created</span></dt> <dd> <span>{{electricmeter.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.gguid\">Gguid</span></dt> <dd> <span>{{electricmeter.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.lastValue\">Last Value</span></dt> <dd> <span>{{electricmeter.lastValue}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.lastValueChanged\">Last Value Changed</span></dt> <dd> <span>{{electricmeter.lastValueChanged | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.electricmeter.marketplace\">Marketplace</span></dt> <dd> <div *ngIf=\"electricmeter.marketplace\"> <a [routerLink]=\"['/marketplace', electricmeter.marketplace?.id]\">{{electricmeter.marketplace?.marketplaceNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'electricmeter/'+ electricmeter.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myElectricmeterLabel\" jhiTranslate=\"marketmanagerApp.electricmeter.home.createOrEditLabel\">Create or edit a Electricmeter</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!electricmeter.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"electricmeter.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.marketplaceNumber\" for=\"field_marketplaceNumber\">Marketplace Number</label> <input type=\"text\" class=\"form-control\" name=\"marketplaceNumber\" id=\"field_marketplaceNumber\" [(ngModel)]=\"electricmeter.marketplaceNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.provider\" for=\"field_provider\">Provider</label> <input type=\"text\" class=\"form-control\" name=\"provider\" id=\"field_provider\" [(ngModel)]=\"electricmeter.provider\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.count230V\" for=\"field_count230V\">Count 230 V</label> <input type=\"number\" class=\"form-control\" name=\"count230V\" id=\"field_count230V\" [(ngModel)]=\"electricmeter.count230V\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.count380V\" for=\"field_count380V\">Count 380 V</label> <input type=\"number\" class=\"form-control\" name=\"count380V\" id=\"field_count380V\" [(ngModel)]=\"electricmeter.count380V\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.owner\" for=\"field_owner\">Owner</label> <input type=\"text\" class=\"form-control\" name=\"owner\" id=\"field_owner\" [(ngModel)]=\"electricmeter.owner\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.electricmeterNumber\" for=\"field_electricmeterNumber\">Electricmeter Number</label> <input type=\"text\" class=\"form-control\" name=\"electricmeterNumber\" id=\"field_electricmeterNumber\" [(ngModel)]=\"electricmeter.electricmeterNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.location\" for=\"field_location\">Location</label> <input type=\"text\" class=\"form-control\" name=\"location\" id=\"field_location\" [(ngModel)]=\"electricmeter.location\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"electricmeter.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"electricmeter.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"electricmeter.gguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.lastValue\" for=\"field_lastValue\">Last Value</label> <input type=\"number\" class=\"form-control\" name=\"lastValue\" id=\"field_lastValue\" [(ngModel)]=\"electricmeter.lastValue\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.electricmeter.lastValueChanged\" for=\"field_lastValueChanged\">Last Value Changed</label> <div class=\"d-flex\"> <input id=\"field_lastValueChanged\" type=\"datetime-local\" class=\"form-control\" name=\"lastValueChanged\" [(ngModel)]=\"electricmeter.lastValueChanged\"/> </div> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.electricmeter.marketplace\" for=\"field_marketplace\">Marketplace</label> <select class=\"form-control\" id=\"field_marketplace\" name=\"marketplace\" [(ngModel)]=\"electricmeter.marketplace\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketplaceOption.id === electricmeter.marketplace?.id ? electricmeter.marketplace : marketplaceOption\" *ngFor=\"let marketplaceOption of marketplaces; trackBy: trackMarketplaceById\">{{marketplaceOption.marketplaceNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.electricmeter.home.title\">Electricmeters</span> <button class=\"btn btn-primary float-right create-electricmeter\" [routerLink]=\"['/', { outlets: { popup: ['electricmeter-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.electricmeter.home.createLabel\"> Create new Electricmeter </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.electricmeter.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"electricmeters\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.electricmeter.marketplaceNumber\">Marketplace Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"provider\"><span jhiTranslate=\"marketmanagerApp.electricmeter.provider\">Provider</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"count230V\"><span jhiTranslate=\"marketmanagerApp.electricmeter.count230V\">Count 230 V</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"count380V\"><span jhiTranslate=\"marketmanagerApp.electricmeter.count380V\">Count 380 V</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"owner\"><span jhiTranslate=\"marketmanagerApp.electricmeter.owner\">Owner</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"electricmeterNumber\"><span jhiTranslate=\"marketmanagerApp.electricmeter.electricmeterNumber\">Electricmeter Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"location\"><span jhiTranslate=\"marketmanagerApp.electricmeter.location\">Location</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.electricmeter.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.electricmeter.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.electricmeter.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastValue\"><span jhiTranslate=\"marketmanagerApp.electricmeter.lastValue\">Last Value</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"lastValueChanged\"><span jhiTranslate=\"marketmanagerApp.electricmeter.lastValueChanged\">Last Value Changed</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplace.marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.electricmeter.marketplace\">Marketplace</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let electricmeter of electricmeters ;trackBy: trackId\"> <td><a [routerLink]=\"['../electricmeter', electricmeter.id ]\">{{electricmeter.id}}</a></td> <td>{{electricmeter.marketplaceNumber}}</td> <td>{{electricmeter.provider}}</td> <td>{{electricmeter.count230V}}</td> <td>{{electricmeter.count380V}}</td> <td>{{electricmeter.owner}}</td> <td>{{electricmeter.electricmeterNumber}}</td> <td>{{electricmeter.location}}</td> <td>{{electricmeter.updated | date:'medium'}}</td> <td>{{electricmeter.created | date:'medium'}}</td> <td>{{electricmeter.gguid}}</td> <td>{{electricmeter.lastValue}}</td> <td>{{electricmeter.lastValueChanged | date:'medium'}}</td> <td> <div *ngIf=\"electricmeter.marketplace\"> <a [routerLink]=\"['../marketplace', electricmeter.marketplace?.id ]\">{{electricmeter.marketplace?.marketplaceNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../electricmeter', electricmeter.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'electricmeter/'+ electricmeter.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'electricmeter/'+ electricmeter.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"electricmeters && electricmeters.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(energyflat.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.energyflat.delete.question\" translateValues=\"{id: '{{energyflat.id}}'}\">Are you sure you want to delete this Energyflat?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"energyflat\"> <h2><span jhiTranslate=\"marketmanagerApp.energyflat.detail.title\">Energyflat</span> {{energyflat.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{energyflat.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.validFrom\">Valid From</span></dt> <dd> <span>{{energyflat.validFrom | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.priceType\">Price Type</span></dt> <dd> <span>{{energyflat.priceType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.priceLow\">Price Low</span></dt> <dd> <span>{{energyflat.priceLow}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.priceNormal\">Price Normal</span></dt> <dd> <span>{{energyflat.priceNormal}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.priceSpecial\">Price Special</span></dt> <dd> <span>{{energyflat.priceSpecial}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.updated\">Updated</span></dt> <dd> <span>{{energyflat.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.created\">Created</span></dt> <dd> <span>{{energyflat.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.gguid\">Gguid</span></dt> <dd> <span>{{energyflat.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.energyflat.marketday\">Marketday</span></dt> <dd> <div *ngIf=\"energyflat.marketday\"> <a [routerLink]=\"['/marketday', energyflat.marketday?.id]\">{{energyflat.marketday?.marketdayNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'energyflat/'+ energyflat.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myEnergyflatLabel\" jhiTranslate=\"marketmanagerApp.energyflat.home.createOrEditLabel\">Create or edit a Energyflat</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!energyflat.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"energyflat.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"energyflat.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.validFrom\" for=\"field_validFrom\">Valid From</label> <div class=\"d-flex\"> <input id=\"field_validFrom\" type=\"datetime-local\" class=\"form-control\" name=\"validFrom\" [(ngModel)]=\"energyflat.validFrom\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.priceType\" for=\"field_priceType\">Price Type</label> <input type=\"text\" class=\"form-control\" name=\"priceType\" id=\"field_priceType\" [(ngModel)]=\"energyflat.priceType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.priceLow\" for=\"field_priceLow\">Price Low</label> <input type=\"number\" class=\"form-control\" name=\"priceLow\" id=\"field_priceLow\" [(ngModel)]=\"energyflat.priceLow\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.priceNormal\" for=\"field_priceNormal\">Price Normal</label> <input type=\"number\" class=\"form-control\" name=\"priceNormal\" id=\"field_priceNormal\" [(ngModel)]=\"energyflat.priceNormal\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.priceSpecial\" for=\"field_priceSpecial\">Price Special</label> <input type=\"number\" class=\"form-control\" name=\"priceSpecial\" id=\"field_priceSpecial\" [(ngModel)]=\"energyflat.priceSpecial\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"energyflat.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"energyflat.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.energyflat.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"energyflat.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.energyflat.marketday\" for=\"field_marketday\">Marketday</label> <select class=\"form-control\" id=\"field_marketday\" name=\"marketday\" [(ngModel)]=\"energyflat.marketday\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdayOption.id === energyflat.marketday?.id ? energyflat.marketday : marketdayOption\" *ngFor=\"let marketdayOption of marketdays; trackBy: trackMarketdayById\">{{marketdayOption.marketdayNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.energyflat.home.title\">Energyflats</span> <button class=\"btn btn-primary float-right create-energyflat\" [routerLink]=\"['/', { outlets: { popup: ['energyflat-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.energyflat.home.createLabel\"> Create new Energyflat </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.energyflat.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"energyflats\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.energyflat.marketdayNumber\">Marketday Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"validFrom\"><span jhiTranslate=\"marketmanagerApp.energyflat.validFrom\">Valid From</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceType\"><span jhiTranslate=\"marketmanagerApp.energyflat.priceType\">Price Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceLow\"><span jhiTranslate=\"marketmanagerApp.energyflat.priceLow\">Price Low</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceNormal\"><span jhiTranslate=\"marketmanagerApp.energyflat.priceNormal\">Price Normal</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"priceSpecial\"><span jhiTranslate=\"marketmanagerApp.energyflat.priceSpecial\">Price Special</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.energyflat.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.energyflat.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.energyflat.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketday.marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.energyflat.marketday\">Marketday</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let energyflat of energyflats ;trackBy: trackId\"> <td><a [routerLink]=\"['../energyflat', energyflat.id ]\">{{energyflat.id}}</a></td> <td>{{energyflat.marketdayNumber}}</td> <td>{{energyflat.validFrom | date:'medium'}}</td> <td>{{energyflat.priceType}}</td> <td>{{energyflat.priceLow}}</td> <td>{{energyflat.priceNormal}}</td> <td>{{energyflat.priceSpecial}}</td> <td>{{energyflat.updated | date:'medium'}}</td> <td>{{energyflat.created | date:'medium'}}</td> <td>{{energyflat.gguid}}</td> <td> <div *ngIf=\"energyflat.marketday\"> <a [routerLink]=\"['../marketday', energyflat.marketday?.id ]\">{{energyflat.marketday?.marketdayNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../energyflat', energyflat.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'energyflat/'+ energyflat.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'energyflat/'+ energyflat.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"energyflats && energyflats.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdateBooth.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdateBooth.delete.question\" translateValues=\"{id: '{{marketdateBooth.id}}'}\">Are you sure you want to delete this Marketdate Booth?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdateBooth\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdateBooth.detail.title\">Marketdate Booth</span> {{marketdateBooth.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contractType\">Contract Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ContractType.' + marketdateBooth.contractType}}\">{{marketdateBooth.contractType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.order\">Order</span></dt> <dd> <span>{{marketdateBooth.order}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.width\">Width</span></dt> <dd> <span>{{marketdateBooth.width}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.depth\">Depth</span></dt> <dd> <span>{{marketdateBooth.depth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCost\">Sqm Cost</span></dt> <dd> <span>{{marketdateBooth.sqmCost}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCostIncludingBase\">Sqm Cost Including Base</span></dt> <dd> <span>{{marketdateBooth.sqmCostIncludingBase}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.energyPriceType\">Energy Price Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.EnergyPriceType.' + marketdateBooth.energyPriceType}}\">{{marketdateBooth.energyPriceType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceSanitary\">Price Sanitary</span></dt> <dd> <span>{{marketdateBooth.priceSanitary}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceCleaning\">Price Cleaning</span></dt> <dd> <span>{{marketdateBooth.priceCleaning}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceParking\">Price Parking</span></dt> <dd> <span>{{marketdateBooth.priceParking}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.marketingFee\">Marketing Fee</span></dt> <dd> <span>{{marketdateBooth.marketingFee}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceTotal\">Price Total</span></dt> <dd> <span>{{marketdateBooth.priceTotal}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.status\">Status</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.MarketdateBoothStatus.' + marketdateBooth.status}}\">{{marketdateBooth.status}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.correctionNotice\">Correction Notice</span></dt> <dd> <span>{{marketdateBooth.correctionNotice}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.salesunit\">Salesunit</span></dt> <dd> <div *ngIf=\"marketdateBooth.salesunit\"> <a [routerLink]=\"['/salesunit', marketdateBooth.salesunit?.id]\">{{marketdateBooth.salesunit?.salesunitNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contactPerson\">Contact Person</span></dt> <dd> <div *ngIf=\"marketdateBooth.contactPerson\"> <a [routerLink]=\"['/contact', marketdateBooth.contactPerson?.id]\">{{marketdateBooth.contactPerson?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contract\">Contract</span></dt> <dd> <div *ngIf=\"marketdateBooth.contract\"> <a [routerLink]=\"['/contract', marketdateBooth.contract?.id]\">{{marketdateBooth.contract?.startDate}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.marketdate\">Marketdate</span></dt> <dd> <div *ngIf=\"marketdateBooth.marketdate\"> <a [routerLink]=\"['/marketdate', marketdateBooth.marketdate?.id]\">{{marketdateBooth.marketdate?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.updatedBy\">Updated By</span></dt> <dd> {{marketdateBooth.updatedBy?.login}} </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateBooth.merchant\">Merchant</span></dt> <dd> <div *ngIf=\"marketdateBooth.merchant\"> <a [routerLink]=\"['/contact', marketdateBooth.merchant?.id]\">{{marketdateBooth.merchant?.displayname}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-booth/'+ marketdateBooth.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateBoothLabel\" jhiTranslate=\"marketmanagerApp.marketdateBooth.home.createOrEditLabel\">Create or edit a Marketdate Booth</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdateBooth.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdateBooth.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.contractType\" for=\"field_contractType\">Contract Type</label> <select class=\"form-control\" name=\"contractType\" [(ngModel)]=\"marketdateBooth.contractType\" id=\"field_contractType\"> <option value=\"Standard\" jhiTranslate=\"marketmanagerApp.ContractType.Standard\">Standard</option> <option value=\"None\" jhiTranslate=\"marketmanagerApp.ContractType.None\">None</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.order\" for=\"field_order\">Order</label> <input type=\"number\" class=\"form-control\" name=\"order\" id=\"field_order\" [(ngModel)]=\"marketdateBooth.order\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.width\" for=\"field_width\">Width</label> <input type=\"number\" class=\"form-control\" name=\"width\" id=\"field_width\" [(ngModel)]=\"marketdateBooth.width\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.depth\" for=\"field_depth\">Depth</label> <input type=\"number\" class=\"form-control\" name=\"depth\" id=\"field_depth\" [(ngModel)]=\"marketdateBooth.depth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCost\" for=\"field_sqmCost\">Sqm Cost</label> <input type=\"number\" class=\"form-control\" name=\"sqmCost\" id=\"field_sqmCost\" [(ngModel)]=\"marketdateBooth.sqmCost\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCostIncludingBase\" for=\"field_sqmCostIncludingBase\">Sqm Cost Including Base</label> <input type=\"number\" class=\"form-control\" name=\"sqmCostIncludingBase\" id=\"field_sqmCostIncludingBase\" [(ngModel)]=\"marketdateBooth.sqmCostIncludingBase\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.energyPriceType\" for=\"field_energyPriceType\">Energy Price Type</label> <select class=\"form-control\" name=\"energyPriceType\" [(ngModel)]=\"marketdateBooth.energyPriceType\" id=\"field_energyPriceType\"> <option value=\"Null\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.Null\">Null</option> <option value=\"ContractUnchanged\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.ContractUnchanged\">ContractUnchanged</option> <option value=\"None\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.None\">None</option> <option value=\"Low\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.Low\">Low</option> <option value=\"Normal\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.Normal\">Normal</option> <option value=\"Special\" jhiTranslate=\"marketmanagerApp.EnergyPriceType.Special\">Special</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.priceSanitary\" for=\"field_priceSanitary\">Price Sanitary</label> <input type=\"number\" class=\"form-control\" name=\"priceSanitary\" id=\"field_priceSanitary\" [(ngModel)]=\"marketdateBooth.priceSanitary\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.priceCleaning\" for=\"field_priceCleaning\">Price Cleaning</label> <input type=\"number\" class=\"form-control\" name=\"priceCleaning\" id=\"field_priceCleaning\" [(ngModel)]=\"marketdateBooth.priceCleaning\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.priceParking\" for=\"field_priceParking\">Price Parking</label> <input type=\"number\" class=\"form-control\" name=\"priceParking\" id=\"field_priceParking\" [(ngModel)]=\"marketdateBooth.priceParking\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.marketingFee\" for=\"field_marketingFee\">Marketing Fee</label> <input type=\"number\" class=\"form-control\" name=\"marketingFee\" id=\"field_marketingFee\" [(ngModel)]=\"marketdateBooth.marketingFee\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.priceTotal\" for=\"field_priceTotal\">Price Total</label> <input type=\"number\" class=\"form-control\" name=\"priceTotal\" id=\"field_priceTotal\" [(ngModel)]=\"marketdateBooth.priceTotal\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.status\" for=\"field_status\">Status</label> <select class=\"form-control\" name=\"status\" [(ngModel)]=\"marketdateBooth.status\" id=\"field_status\"> <option value=\"None\" jhiTranslate=\"marketmanagerApp.MarketdateBoothStatus.None\">None</option> <option value=\"Absent\" jhiTranslate=\"marketmanagerApp.MarketdateBoothStatus.Absent\">Absent</option> <option value=\"Completed\" jhiTranslate=\"marketmanagerApp.MarketdateBoothStatus.Completed\">Completed</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateBooth.correctionNotice\" for=\"field_correctionNotice\">Correction Notice</label> <input type=\"text\" class=\"form-control\" name=\"correctionNotice\" id=\"field_correctionNotice\" [(ngModel)]=\"marketdateBooth.correctionNotice\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.salesunit\" for=\"field_salesunit\">Salesunit</label> <select class=\"form-control\" id=\"field_salesunit\" name=\"salesunit\" [(ngModel)]=\"marketdateBooth.salesunit\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"salesunitOption.id === marketdateBooth.salesunit?.id ? marketdateBooth.salesunit : salesunitOption\" *ngFor=\"let salesunitOption of salesunits; trackBy: trackSalesunitById\">{{salesunitOption.salesunitNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.contactPerson\" for=\"field_contactPerson\">Contact Person</label> <select class=\"form-control\" id=\"field_contactPerson\" name=\"contactPerson\" [(ngModel)]=\"marketdateBooth.contactPerson\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === marketdateBooth.contactPerson?.id ? marketdateBooth.contactPerson : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.contract\" for=\"field_contract\">Contract</label> <select class=\"form-control\" id=\"field_contract\" name=\"contract\" [(ngModel)]=\"marketdateBooth.contract\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contractOption.id === marketdateBooth.contract?.id ? marketdateBooth.contract : contractOption\" *ngFor=\"let contractOption of contracts; trackBy: trackContractById\">{{contractOption.startDate}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.marketdate\" for=\"field_marketdate\">Marketdate</label> <select class=\"form-control\" id=\"field_marketdate\" name=\"marketdate\" [(ngModel)]=\"marketdateBooth.marketdate\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdateOption.id === marketdateBooth.marketdate?.id ? marketdateBooth.marketdate : marketdateOption\" *ngFor=\"let marketdateOption of marketdates; trackBy: trackMarketdateById\">{{marketdateOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.updatedBy\" for=\"field_updatedBy\">Updated By</label> <select class=\"form-control\" id=\"field_updatedBy\" name=\"updatedBy\" [(ngModel)]=\"marketdateBooth.updatedBy\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === marketdateBooth.updatedBy?.id ? marketdateBooth.updatedBy : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateBooth.merchant\" for=\"field_merchant\">Merchant</label> <select class=\"form-control\" id=\"field_merchant\" name=\"merchant\" [(ngModel)]=\"marketdateBooth.merchant\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === marketdateBooth.merchant?.id ? marketdateBooth.merchant : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdateBooth.home.title\">Marketdate Booths</span> <button class=\"btn btn-primary float-right create-marketdate-booth\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-booth-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdateBooth.home.createLabel\"> Create new Marketdate Booth </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdateBooth.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdateBooths\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contractType\">Contract Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.order\">Order</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.width\">Width</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.depth\">Depth</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCost\">Sqm Cost</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.sqmCostIncludingBase\">Sqm Cost Including Base</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.energyPriceType\">Energy Price Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceSanitary\">Price Sanitary</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceCleaning\">Price Cleaning</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceParking\">Price Parking</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.marketingFee\">Marketing Fee</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.priceTotal\">Price Total</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.status\">Status</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.correctionNotice\">Correction Notice</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.salesunit\">Salesunit</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contactPerson\">Contact Person</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.contract\">Contract</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.marketdate\">Marketdate</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.updatedBy\">Updated By</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateBooth.merchant\">Merchant</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdateBooth of marketdateBooths ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate-booth', marketdateBooth.id ]\">{{marketdateBooth.id}}</a></td> <td jhiTranslate=\"{{'marketmanagerApp.ContractType.' + marketdateBooth.contractType}}\">{{marketdateBooth.contractType}}</td> <td>{{marketdateBooth.order}}</td> <td>{{marketdateBooth.width}}</td> <td>{{marketdateBooth.depth}}</td> <td>{{marketdateBooth.sqmCost}}</td> <td>{{marketdateBooth.sqmCostIncludingBase}}</td> <td jhiTranslate=\"{{'marketmanagerApp.EnergyPriceType.' + marketdateBooth.energyPriceType}}\">{{marketdateBooth.energyPriceType}}</td> <td>{{marketdateBooth.priceSanitary}}</td> <td>{{marketdateBooth.priceCleaning}}</td> <td>{{marketdateBooth.priceParking}}</td> <td>{{marketdateBooth.marketingFee}}</td> <td>{{marketdateBooth.priceTotal}}</td> <td jhiTranslate=\"{{'marketmanagerApp.MarketdateBoothStatus.' + marketdateBooth.status}}\">{{marketdateBooth.status}}</td> <td>{{marketdateBooth.correctionNotice}}</td> <td> <div *ngIf=\"marketdateBooth.salesunit\"> <a [routerLink]=\"['../salesunit', marketdateBooth.salesunit?.id ]\">{{marketdateBooth.salesunit?.salesunitNumber}}</a> </div> </td> <td> <div *ngIf=\"marketdateBooth.contactPerson\"> <a [routerLink]=\"['../contact', marketdateBooth.contactPerson?.id ]\">{{marketdateBooth.contactPerson?.displayname}}</a> </div> </td> <td> <div *ngIf=\"marketdateBooth.contract\"> <a [routerLink]=\"['../contract', marketdateBooth.contract?.id ]\">{{marketdateBooth.contract?.startDate}}</a> </div> </td> <td> <div *ngIf=\"marketdateBooth.marketdate\"> <a [routerLink]=\"['../marketdate', marketdateBooth.marketdate?.id ]\">{{marketdateBooth.marketdate?.marketdayNumber}}</a> </div> </td> <td> {{marketdateBooth.updatedBy?.login}} </td> <td> <div *ngIf=\"marketdateBooth.merchant\"> <a [routerLink]=\"['../contact', marketdateBooth.merchant?.id ]\">{{marketdateBooth.merchant?.displayname}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate-booth', marketdateBooth.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-booth/'+ marketdateBooth.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-booth/'+ marketdateBooth.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdateComment.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdateComment.delete.question\" translateValues=\"{id: '{{marketdateComment.id}}'}\">Are you sure you want to delete this Marketdate Comment?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdateComment\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdateComment.detail.title\">Marketdate Comment</span> {{marketdateComment.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.comment\">Comment</span></dt> <dd> <span>{{marketdateComment.comment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.commentType\">Comment Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.CommentType.' + marketdateComment.commentType}}\">{{marketdateComment.commentType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.updated\">Updated</span></dt> <dd> <span>{{marketdateComment.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.created\">Created</span></dt> <dd> <span>{{marketdateComment.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.image\">Image</span></dt> <dd> <div *ngIf=\"marketdateComment.image\"> <a (click)=\"openFile(marketdateComment.imageContentType, marketdateComment.image)\"> <img [src]=\"'data:' + marketdateComment.imageContentType + ';base64,' + marketdateComment.image\" style=\"max-width: 100%\" alt=\"marketdateComment image\"/> </a> {{marketdateComment.imageContentType}}, {{byteSize(marketdateComment.image)}} </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.marketdate\">Marketdate</span></dt> <dd> <div *ngIf=\"marketdateComment.marketdate\"> <a [routerLink]=\"['/marketdate', marketdateComment.marketdate?.id]\">{{marketdateComment.marketdate?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateComment.updatedBy\">Updated By</span></dt> <dd> {{marketdateComment.updatedBy?.login}} </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-comment/'+ marketdateComment.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateCommentLabel\" jhiTranslate=\"marketmanagerApp.marketdateComment.home.createOrEditLabel\">Create or edit a Marketdate Comment</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdateComment.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdateComment.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateComment.comment\" for=\"field_comment\">Comment</label> <input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" [(ngModel)]=\"marketdateComment.comment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateComment.commentType\" for=\"field_commentType\">Comment Type</label> <select class=\"form-control\" name=\"commentType\" [(ngModel)]=\"marketdateComment.commentType\" id=\"field_commentType\"> <option value=\"None\" jhiTranslate=\"marketmanagerApp.CommentType.None\">None</option> <option value=\"Info\" jhiTranslate=\"marketmanagerApp.CommentType.Info\">Info</option> <option value=\"Warning\" jhiTranslate=\"marketmanagerApp.CommentType.Warning\">Warning</option> <option value=\"Problem\" jhiTranslate=\"marketmanagerApp.CommentType.Problem\">Problem</option> <option value=\"Success\" jhiTranslate=\"marketmanagerApp.CommentType.Success\">Success</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateComment.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketdateComment.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateComment.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketdateComment.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateComment.image\" for=\"field_image\">Image</label> <div> <img [src]=\"'data:' + marketdateComment.imageContentType + ';base64,' + marketdateComment.image\" style=\"max-height: 100px\" *ngIf=\"marketdateComment.image\" alt=\"marketdateComment image\"/> <div *ngIf=\"marketdateComment.image\" class=\"form-text text-danger clearfix\"> <span class=\"pull-left\">{{marketdateComment.imageContentType}}, {{byteSize(marketdateComment.image)}}</span> <button type=\"button\" (click)=\"clearInputImage('image', 'imageContentType', 'fileImage')\" class=\"btn btn-default btn-xs pull-right\"> <span class=\"fa fa-times\"></span> </button> </div> <input type=\"file\" id=\"fileImage\" (change)=\"setFileData($event, marketdateComment, 'image', true)\" accept=\"image/*\" jhiTranslate=\"entity.action.addimage\"/> </div> <input type=\"hidden\" class=\"form-control\" name=\"image\" id=\"field_image\" [(ngModel)]=\"marketdateComment.image\"/> <input type=\"hidden\" class=\"form-control\" name=\"imageContentType\" id=\"field_imageContentType\" [(ngModel)]=\"marketdateComment.imageContentType\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateComment.marketdate\" for=\"field_marketdate\">Marketdate</label> <select class=\"form-control\" id=\"field_marketdate\" name=\"marketdate\" [(ngModel)]=\"marketdateComment.marketdate\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdateOption.id === marketdateComment.marketdate?.id ? marketdateComment.marketdate : marketdateOption\" *ngFor=\"let marketdateOption of marketdates; trackBy: trackMarketdateById\">{{marketdateOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateComment.updatedBy\" for=\"field_updatedBy\">Updated By</label> <select class=\"form-control\" id=\"field_updatedBy\" name=\"updatedBy\" [(ngModel)]=\"marketdateComment.updatedBy\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === marketdateComment.updatedBy?.id ? marketdateComment.updatedBy : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdateComment.home.title\">Marketdate Comments</span> <button class=\"btn btn-primary float-right jh-create-entity create-marketdate-comment\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-comment-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdateComment.home.createLabel\"> Create new Marketdate Comment </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdateComment.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdateComments\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.comment\">Comment</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.commentType\">Comment Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.updated\">Updated</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.created\">Created</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.image\">Image</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.marketdate\">Marketdate</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateComment.updatedBy\">Updated By</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdateComment of marketdateComments ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate-comment', marketdateComment.id ]\">{{marketdateComment.id}}</a></td> <td>{{marketdateComment.comment}}</td> <td jhiTranslate=\"{{'marketmanagerApp.CommentType.' + marketdateComment.commentType}}\">{{marketdateComment.commentType}}</td> <td>{{marketdateComment.updated | date:'medium'}}</td> <td>{{marketdateComment.created | date:'medium'}}</td> <td> <a *ngIf=\"marketdateComment.image\" (click)=\"openFile(marketdateComment.imageContentType, marketdateComment.image)\"> <img [src]=\"'data:' + marketdateComment.imageContentType + ';base64,' + marketdateComment.image\" style=\"max-height: 30px\" alt=\"marketdateComment image\"/> </a> <span *ngIf=\"marketdateComment.image\">{{marketdateComment.imageContentType}}, {{byteSize(marketdateComment.image)}}</span> </td> <td> <div *ngIf=\"marketdateComment.marketdate\"> <a [routerLink]=\"['../marketdate', marketdateComment.marketdate?.id ]\">{{marketdateComment.marketdate?.marketdayNumber}}</a> </div> </td> <td> {{marketdateComment.updatedBy?.login}} </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate-comment', marketdateComment.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-comment/'+ marketdateComment.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-comment/'+ marketdateComment.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdateExpense.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdateExpense.delete.question\" translateValues=\"{id: '{{marketdateExpense.id}}'}\">Are you sure you want to delete this Marketdate Expense?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdateExpense\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdateExpense.detail.title\">Marketdate Expense</span> {{marketdateExpense.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.description\">Description</span></dt> <dd> <span>{{marketdateExpense.description}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.value\">Value</span></dt> <dd> <span>{{marketdateExpense.value}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.expenseType\">Expense Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.ExpenseType.' + marketdateExpense.expenseType}}\">{{marketdateExpense.expenseType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.updated\">Updated</span></dt> <dd> <span>{{marketdateExpense.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.created\">Created</span></dt> <dd> <span>{{marketdateExpense.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.image\">Image</span></dt> <dd> <div *ngIf=\"marketdateExpense.image\"> <a (click)=\"openFile(marketdateExpense.imageContentType, marketdateExpense.image)\"> <img [src]=\"'data:' + marketdateExpense.imageContentType + ';base64,' + marketdateExpense.image\" style=\"max-width: 100%\" alt=\"marketdateExpense image\"/> </a> {{marketdateExpense.imageContentType}}, {{byteSize(marketdateExpense.image)}} </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.marketdate\">Marketdate</span></dt> <dd> <div *ngIf=\"marketdateExpense.marketdate\"> <a [routerLink]=\"['/marketdate', marketdateExpense.marketdate?.id]\">{{marketdateExpense.marketdate?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateExpense.updatedBy\">Updated By</span></dt> <dd> {{marketdateExpense.updatedBy?.login}} </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-expense/'+ marketdateExpense.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateExpenseLabel\" jhiTranslate=\"marketmanagerApp.marketdateExpense.home.createOrEditLabel\">Create or edit a Marketdate Expense</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdateExpense.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdateExpense.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.description\" for=\"field_description\">Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" [(ngModel)]=\"marketdateExpense.description\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.value\" for=\"field_value\">Value</label> <input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" [(ngModel)]=\"marketdateExpense.value\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.expenseType\" for=\"field_expenseType\">Expense Type</label> <select class=\"form-control\" name=\"expenseType\" [(ngModel)]=\"marketdateExpense.expenseType\" id=\"field_expenseType\"> <option value=\"Normal\" jhiTranslate=\"marketmanagerApp.ExpenseType.Normal\">Normal</option> <option value=\"Special\" jhiTranslate=\"marketmanagerApp.ExpenseType.Special\">Special</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketdateExpense.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketdateExpense.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateExpense.image\" for=\"field_image\">Image</label> <div> <img [src]=\"'data:' + marketdateExpense.imageContentType + ';base64,' + marketdateExpense.image\" style=\"max-height: 100px\" *ngIf=\"marketdateExpense.image\" alt=\"marketdateExpense image\"/> <div *ngIf=\"marketdateExpense.image\" class=\"form-text text-danger clearfix\"> <span class=\"pull-left\">{{marketdateExpense.imageContentType}}, {{byteSize(marketdateExpense.image)}}</span> <button type=\"button\" (click)=\"marketdateExpense.image=null;marketdateExpense.imageContentType=null;\" class=\"btn btn-default btn-xs pull-right\"> <span class=\"fa fa-times\"></span> </button> </div> <input type=\"file\" (change)=\"setFileData($event, marketdateExpense, 'image', true)\" accept=\"image/*\" jhiTranslate=\"entity.action.addimage\"/> </div> <input type=\"hidden\" class=\"form-control\" name=\"image\" id=\"field_image\" [(ngModel)]=\"marketdateExpense.image\"/> <input type=\"hidden\" class=\"form-control\" name=\"imageContentType\" id=\"field_imageContentType\" [(ngModel)]=\"marketdateExpense.imageContentType\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateExpense.marketdate\" for=\"field_marketdate\">Marketdate</label> <select class=\"form-control\" id=\"field_marketdate\" name=\"marketdate\" [(ngModel)]=\"marketdateExpense.marketdate\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdateOption.id === marketdateExpense.marketdate?.id ? marketdateExpense.marketdate : marketdateOption\" *ngFor=\"let marketdateOption of marketdates; trackBy: trackMarketdateById\">{{marketdateOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateExpense.updatedBy\" for=\"field_updatedBy\">Updated By</label> <select class=\"form-control\" id=\"field_updatedBy\" name=\"updatedBy\" [(ngModel)]=\"marketdateExpense.updatedBy\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === marketdateExpense.updatedBy?.id ? marketdateExpense.updatedBy : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdateExpense.home.title\">Marketdate Expenses</span> <button class=\"btn btn-primary float-right create-marketdate-expense\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-expense-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdateExpense.home.createLabel\"> Create new Marketdate Expense </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdateExpense.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdateExpenses\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.description\">Description</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.value\">Value</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.expenseType\">Expense Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.updated\">Updated</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.created\">Created</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.image\">Image</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.marketdate\">Marketdate</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateExpense.updatedBy\">Updated By</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdateExpense of marketdateExpenses ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate-expense', marketdateExpense.id ]\">{{marketdateExpense.id}}</a></td> <td>{{marketdateExpense.description}}</td> <td>{{marketdateExpense.value}}</td> <td jhiTranslate=\"{{'marketmanagerApp.ExpenseType.' + marketdateExpense.expenseType}}\">{{marketdateExpense.expenseType}}</td> <td>{{marketdateExpense.updated | date:'medium'}}</td> <td>{{marketdateExpense.created | date:'medium'}}</td> <td> <a *ngIf=\"marketdateExpense.image\" (click)=\"openFile(marketdateExpense.imageContentType, marketdateExpense.image)\"> <img [src]=\"'data:' + marketdateExpense.imageContentType + ';base64,' + marketdateExpense.image\" style=\"max-height: 30px\" alt=\"marketdateExpense image\"/> </a> <span *ngIf=\"marketdateExpense.image\">{{marketdateExpense.imageContentType}}, {{byteSize(marketdateExpense.image)}}</span> </td> <td> <div *ngIf=\"marketdateExpense.marketdate\"> <a [routerLink]=\"['../marketdate', marketdateExpense.marketdate?.id ]\">{{marketdateExpense.marketdate?.marketdayNumber}}</a> </div> </td> <td> {{marketdateExpense.updatedBy?.login}} </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate-expense', marketdateExpense.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-expense/'+ marketdateExpense.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-expense/'+ marketdateExpense.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdateMeterreading.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdateMeterreading.delete.question\" translateValues=\"{id: '{{marketdateMeterreading.id}}'}\">Are you sure you want to delete this Marketdate Meterreading?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdateMeterreading\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.detail.title\">Marketdate Meterreading</span> {{marketdateMeterreading.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.value\">Value</span></dt> <dd> <span>{{marketdateMeterreading.value}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestampType\">Timestamp Type</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.TimestampType.' + marketdateMeterreading.timestampType}}\">{{marketdateMeterreading.timestampType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestamp\">Timestamp</span></dt> <dd> <span>{{marketdateMeterreading.timestamp | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updated\">Updated</span></dt> <dd> <span>{{marketdateMeterreading.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.created\">Created</span></dt> <dd> <span>{{marketdateMeterreading.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.marketdate\">Marketdate</span></dt> <dd> <div *ngIf=\"marketdateMeterreading.marketdate\"> <a [routerLink]=\"['/marketdate', marketdateMeterreading.marketdate?.id]\">{{marketdateMeterreading.marketdate?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updatedBy\">Updated By</span></dt> <dd> {{marketdateMeterreading.updatedBy?.login}} </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.electricmeter\">Electricmeter</span></dt> <dd> <div *ngIf=\"marketdateMeterreading.electricmeter\"> <a [routerLink]=\"['/electricmeter', marketdateMeterreading.electricmeter?.id]\">{{marketdateMeterreading.electricmeter?.electricmeterNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-meterreading/'+ marketdateMeterreading.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateMeterreadingLabel\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.home.createOrEditLabel\">Create or edit a Marketdate Meterreading</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdateMeterreading.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdateMeterreading.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.value\" for=\"field_value\">Value</label> <input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" [(ngModel)]=\"marketdateMeterreading.value\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestampType\" for=\"field_timestampType\">Timestamp Type</label> <select class=\"form-control\" name=\"timestampType\" [(ngModel)]=\"marketdateMeterreading.timestampType\" id=\"field_timestampType\"> <option value=\"Before\" jhiTranslate=\"marketmanagerApp.TimestampType.Before\">Before</option> <option value=\"After\" jhiTranslate=\"marketmanagerApp.TimestampType.After\">After</option> <option value=\"Meanwhile\" jhiTranslate=\"marketmanagerApp.TimestampType.Meanwhile\">Meanwhile</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestamp\" for=\"field_timestamp\">Timestamp</label> <div class=\"d-flex\"> <input id=\"field_timestamp\" type=\"datetime-local\" class=\"form-control\" name=\"timestamp\" [(ngModel)]=\"marketdateMeterreading.timestamp\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketdateMeterreading.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketdateMeterreading.created\"/> </div> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateMeterreading.marketdate\" for=\"field_marketdate\">Marketdate</label> <select class=\"form-control\" id=\"field_marketdate\" name=\"marketdate\" [(ngModel)]=\"marketdateMeterreading.marketdate\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdateOption.id === marketdateMeterreading.marketdate?.id ? marketdateMeterreading.marketdate : marketdateOption\" *ngFor=\"let marketdateOption of marketdates; trackBy: trackMarketdateById\">{{marketdateOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updatedBy\" for=\"field_updatedBy\">Updated By</label> <select class=\"form-control\" id=\"field_updatedBy\" name=\"updatedBy\" [(ngModel)]=\"marketdateMeterreading.updatedBy\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === marketdateMeterreading.updatedBy?.id ? marketdateMeterreading.updatedBy : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateMeterreading.electricmeter\" for=\"field_electricmeter\">Electricmeter</label> <select class=\"form-control\" id=\"field_electricmeter\" name=\"electricmeter\" [(ngModel)]=\"marketdateMeterreading.electricmeter\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"electricmeterOption.id === marketdateMeterreading.electricmeter?.id ? marketdateMeterreading.electricmeter : electricmeterOption\" *ngFor=\"let electricmeterOption of electricmeters; trackBy: trackElectricmeterById\">{{electricmeterOption.electricmeterNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.home.title\">Marketdate Meterreadings</span> <button class=\"btn btn-primary float-right create-marketdate-meterreading\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-meterreading-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdateMeterreading.home.createLabel\"> Create new Marketdate Meterreading </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdateMeterreading.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdateMeterreadings\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.value\">Value</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestampType\">Timestamp Type</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.timestamp\">Timestamp</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updated\">Updated</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.created\">Created</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.marketdate\">Marketdate</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.updatedBy\">Updated By</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateMeterreading.electricmeter\">Electricmeter</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdateMeterreading of marketdateMeterreadings ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate-meterreading', marketdateMeterreading.id ]\">{{marketdateMeterreading.id}}</a></td> <td>{{marketdateMeterreading.value}}</td> <td jhiTranslate=\"{{'marketmanagerApp.TimestampType.' + marketdateMeterreading.timestampType}}\">{{marketdateMeterreading.timestampType}}</td> <td>{{marketdateMeterreading.timestamp | date:'medium'}}</td> <td>{{marketdateMeterreading.updated | date:'medium'}}</td> <td>{{marketdateMeterreading.created | date:'medium'}}</td> <td> <div *ngIf=\"marketdateMeterreading.marketdate\"> <a [routerLink]=\"['../marketdate', marketdateMeterreading.marketdate?.id ]\">{{marketdateMeterreading.marketdate?.marketdayNumber}}</a> </div> </td> <td> {{marketdateMeterreading.updatedBy?.login}} </td> <td> <div *ngIf=\"marketdateMeterreading.electricmeter\"> <a [routerLink]=\"['../electricmeter', marketdateMeterreading.electricmeter?.id ]\">{{marketdateMeterreading.electricmeter?.electricmeterNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate-meterreading', marketdateMeterreading.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-meterreading/'+ marketdateMeterreading.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-meterreading/'+ marketdateMeterreading.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdateStatus.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdateStatus.delete.question\" translateValues=\"{id: '{{marketdateStatus.id}}'}\">Are you sure you want to delete this Marketdate Status?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdateStatus\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdateStatus.detail.title\">Marketdate Status</span> {{marketdateStatus.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{marketdateStatus.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.status\">Status</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.MarketStatus.' + marketdateStatus.status}}\">{{marketdateStatus.status}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.updated\">Updated</span></dt> <dd> <span>{{marketdateStatus.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.created\">Created</span></dt> <dd> <span>{{marketdateStatus.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdate\">Marketdate</span></dt> <dd> <div *ngIf=\"marketdateStatus.marketdate\"> <a [routerLink]=\"['/marketdate', marketdateStatus.marketdate?.id]\">{{marketdateStatus.marketdate?.marketdayNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdateStatus.updatedBy\">Updated By</span></dt> <dd> {{marketdateStatus.updatedBy?.login}} </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-status/'+ marketdateStatus.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateStatusLabel\" jhiTranslate=\"marketmanagerApp.marketdateStatus.home.createOrEditLabel\">Create or edit a Marketdate Status</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdateStatus.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdateStatus.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"marketdateStatus.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateStatus.status\" for=\"field_status\">Status</label> <select class=\"form-control\" name=\"status\" [(ngModel)]=\"marketdateStatus.status\" id=\"field_status\"> <option value=\"Unopened\" jhiTranslate=\"marketmanagerApp.MarketStatus.Unopened\">Unopened</option> <option value=\"Opened\" jhiTranslate=\"marketmanagerApp.MarketStatus.Opened\">Opened</option> <option value=\"Absent\" jhiTranslate=\"marketmanagerApp.MarketStatus.Absent\">Absent</option> <option value=\"Closed\" jhiTranslate=\"marketmanagerApp.MarketStatus.Closed\">Closed</option> <option value=\"Paused\" jhiTranslate=\"marketmanagerApp.MarketStatus.Paused\">Paused</option> <option value=\"Canceled\" jhiTranslate=\"marketmanagerApp.MarketStatus.Canceled\">Canceled</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateStatus.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketdateStatus.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdateStatus.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketdateStatus.created\"/> </div> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdate\" for=\"field_marketdate\">Marketdate</label> <select class=\"form-control\" id=\"field_marketdate\" name=\"marketdate\" [(ngModel)]=\"marketdateStatus.marketdate\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdateOption.id === marketdateStatus.marketdate?.id ? marketdateStatus.marketdate : marketdateOption\" *ngFor=\"let marketdateOption of marketdates; trackBy: trackMarketdateById\">{{marketdateOption.marketdayNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdateStatus.updatedBy\" for=\"field_updatedBy\">Updated By</label> <select class=\"form-control\" id=\"field_updatedBy\" name=\"updatedBy\" [(ngModel)]=\"marketdateStatus.updatedBy\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"userOption.id === marketdateStatus.updatedBy?.id ? marketdateStatus.updatedBy : userOption\" *ngFor=\"let userOption of users; trackBy: trackUserById\">{{userOption.login}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdateStatus.home.title\">Marketdate Statuses</span> <button class=\"btn btn-primary float-right create-marketdate-status\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-status-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdateStatus.home.createLabel\"> Create new Marketdate Status </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdateStatus.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdateStatuses\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdayNumber\">Marketday Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.status\">Status</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.updated\">Updated</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.created\">Created</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.marketdate\">Marketdate</span></th> <th><span jhiTranslate=\"marketmanagerApp.marketdateStatus.updatedBy\">Updated By</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdateStatus of marketdateStatuses ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate-status', marketdateStatus.id ]\">{{marketdateStatus.id}}</a></td> <td>{{marketdateStatus.marketdayNumber}}</td> <td jhiTranslate=\"{{'marketmanagerApp.MarketStatus.' + marketdateStatus.status}}\">{{marketdateStatus.status}}</td> <td>{{marketdateStatus.updated | date:'medium'}}</td> <td>{{marketdateStatus.created | date:'medium'}}</td> <td> <div *ngIf=\"marketdateStatus.marketdate\"> <a [routerLink]=\"['../marketdate', marketdateStatus.marketdate?.id ]\">{{marketdateStatus.marketdate?.marketdayNumber}}</a> </div> </td> <td> {{marketdateStatus.updatedBy?.login}} </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate-status', marketdateStatus.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-status/'+ marketdateStatus.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate-status/'+ marketdateStatus.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketdate.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketdate.delete.question\" translateValues=\"{id: '{{marketdate.id}}'}\">Are you sure you want to delete this Marketdate?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketdate\"> <h2><span jhiTranslate=\"marketmanagerApp.marketdate.detail.title\">Marketdate</span> {{marketdate.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{marketdate.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.originalDate\">Original Date</span></dt> <dd> <span>{{marketdate.originalDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.evasiveDate\">Evasive Date</span></dt> <dd> <span>{{marketdate.evasiveDate | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.holiday\">Holiday</span></dt> <dd> <span>{{marketdate.holiday}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.canceled\">Canceled</span></dt> <dd> <span>{{marketdate.canceled}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.comment\">Comment</span></dt> <dd> <span>{{marketdate.comment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.updated\">Updated</span></dt> <dd> <span>{{marketdate.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.created\">Created</span></dt> <dd> <span>{{marketdate.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.gguid\">Gguid</span></dt> <dd> <span>{{marketdate.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.status\">Status</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.MarketStatus.' + marketdate.status}}\">{{marketdate.status}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketdate.marketday\">Marketday</span></dt> <dd> <div *ngIf=\"marketdate.marketday\"> <a [routerLink]=\"['/marketday', marketdate.marketday?.id]\">{{marketdate.marketday?.marketdayNumber}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketdate/'+ marketdate.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdateLabel\" jhiTranslate=\"marketmanagerApp.marketdate.home.createOrEditLabel\">Create or edit a Marketdate</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketdate.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketdate.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"marketdate.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.originalDate\" for=\"field_originalDate\">Original Date</label> <div class=\"d-flex\"> <input id=\"field_originalDate\" type=\"datetime-local\" class=\"form-control\" name=\"originalDate\" [(ngModel)]=\"marketdate.originalDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.evasiveDate\" for=\"field_evasiveDate\">Evasive Date</label> <div class=\"d-flex\"> <input id=\"field_evasiveDate\" type=\"datetime-local\" class=\"form-control\" name=\"evasiveDate\" [(ngModel)]=\"marketdate.evasiveDate\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.holiday\" for=\"field_holiday\">Holiday</label> <input type=\"checkbox\" class=\"form-control\" name=\"holiday\" id=\"field_holiday\" [(ngModel)]=\"marketdate.holiday\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.canceled\" for=\"field_canceled\">Canceled</label> <input type=\"checkbox\" class=\"form-control\" name=\"canceled\" id=\"field_canceled\" [(ngModel)]=\"marketdate.canceled\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.comment\" for=\"field_comment\">Comment</label> <input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" [(ngModel)]=\"marketdate.comment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketdate.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketdate.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"marketdate.gguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketdate.status\" for=\"field_status\">Status</label> <select class=\"form-control\" name=\"status\" [(ngModel)]=\"marketdate.status\" id=\"field_status\"> <option value=\"Unopened\" jhiTranslate=\"marketmanagerApp.MarketStatus.Unopened\">Unopened</option> <option value=\"Opened\" jhiTranslate=\"marketmanagerApp.MarketStatus.Opened\">Opened</option> <option value=\"Absent\" jhiTranslate=\"marketmanagerApp.MarketStatus.Absent\">Absent</option> <option value=\"Closed\" jhiTranslate=\"marketmanagerApp.MarketStatus.Closed\">Closed</option> <option value=\"Paused\" jhiTranslate=\"marketmanagerApp.MarketStatus.Paused\">Paused</option> <option value=\"Canceled\" jhiTranslate=\"marketmanagerApp.MarketStatus.Canceled\">Canceled</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketdate.marketday\" for=\"field_marketday\">Marketday</label> <select class=\"form-control\" id=\"field_marketday\" name=\"marketday\" [(ngModel)]=\"marketdate.marketday\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketdayOption.id === marketdate.marketday?.id ? marketdate.marketday : marketdayOption\" *ngFor=\"let marketdayOption of marketdays; trackBy: trackMarketdayById\">{{marketdayOption.marketdayNumber}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketdate.home.title\">Marketdates</span> <button class=\"btn btn-primary float-right create-marketdate\" [routerLink]=\"['/', { outlets: { popup: ['marketdate-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketdate.home.createLabel\"> Create new Marketdate </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketdate.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdates\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.marketdate.marketdayNumber\">Marketday Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"originalDate\"><span jhiTranslate=\"marketmanagerApp.marketdate.originalDate\">Original Date</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"evasiveDate\"><span jhiTranslate=\"marketmanagerApp.marketdate.evasiveDate\">Evasive Date</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"holiday\"><span jhiTranslate=\"marketmanagerApp.marketdate.holiday\">Holiday</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"canceled\"><span jhiTranslate=\"marketmanagerApp.marketdate.canceled\">Canceled</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"comment\"><span jhiTranslate=\"marketmanagerApp.marketdate.comment\">Comment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.marketdate.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.marketdate.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.marketdate.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"status\"><span jhiTranslate=\"marketmanagerApp.marketdate.status\">Status</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketday.marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.marketdate.marketday\">Marketday</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketdate of marketdates ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketdate', marketdate.id ]\">{{marketdate.id}}</a></td> <td>{{marketdate.marketdayNumber}}</td> <td>{{marketdate.originalDate | date:'medium'}}</td> <td>{{marketdate.evasiveDate | date:'medium'}}</td> <td>{{marketdate.holiday}}</td> <td>{{marketdate.canceled}}</td> <td>{{marketdate.comment}}</td> <td>{{marketdate.updated | date:'medium'}}</td> <td>{{marketdate.created | date:'medium'}}</td> <td>{{marketdate.gguid}}</td> <td jhiTranslate=\"{{'marketmanagerApp.MarketStatus.' + marketdate.status}}\">{{marketdate.status}}</td> <td> <div *ngIf=\"marketdate.marketday\"> <a [routerLink]=\"['../marketday', marketdate.marketday?.id ]\">{{marketdate.marketday?.marketdayNumber}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketdate', marketdate.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate/'+ marketdate.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketdate/'+ marketdate.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"marketdates && marketdates.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketday.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketday.delete.question\" translateValues=\"{id: '{{marketday.id}}'}\">Are you sure you want to delete this Marketday?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketday\"> <h2><span jhiTranslate=\"marketmanagerApp.marketday.detail.title\">Marketday</span> {{marketday.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketdayNumber\">Marketday Number</span></dt> <dd> <span>{{marketday.marketdayNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.active\">Active</span></dt> <dd> <span>{{marketday.active}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.name\">Name</span></dt> <dd> <span>{{marketday.name}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.keyword\">Keyword</span></dt> <dd> <span>{{marketday.keyword}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketType\">Market Type</span></dt> <dd> <span>{{marketday.marketType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.assortment\">Assortment</span></dt> <dd> <span>{{marketday.assortment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.vatType\">Vat Type</span></dt> <dd> <span>{{marketday.vatType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.unit\">Unit</span></dt> <dd> <span>{{marketday.unit}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.classification\">Classification</span></dt> <dd> <span>{{marketday.classification}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.onHolidayString\">On Holiday String</span></dt> <dd> <span>{{marketday.onHolidayString}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.onHoliday\">On Holiday</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.MarketOperation.' + marketday.onHoliday}}\">{{marketday.onHoliday}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.dayString\">Day String</span></dt> <dd> <span>{{marketday.dayString}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.day\">Day</span></dt> <dd> <span jhiTranslate=\"{{'marketmanagerApp.Weekday.' + marketday.day}}\">{{marketday.day}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.startTime\">Start Time</span></dt> <dd> <span>{{marketday.startTime | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.endTime\">End Time</span></dt> <dd> <span>{{marketday.endTime | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.buildingStartTime\">Building Start Time</span></dt> <dd> <span>{{marketday.buildingStartTime | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTime\">Dismantling End Time</span></dt> <dd> <span>{{marketday.dismantlingEndTime | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.startTimeWinter\">Start Time Winter</span></dt> <dd> <span>{{marketday.startTimeWinter | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.endTimeWinter\">End Time Winter</span></dt> <dd> <span>{{marketday.endTimeWinter | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.buildingStartTimeWinter\">Building Start Time Winter</span></dt> <dd> <span>{{marketday.buildingStartTimeWinter | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTimeWinter\">Dismantling End Time Winter</span></dt> <dd> <span>{{marketday.dismantlingEndTimeWinter | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketplaceNumber\">Marketplace Number</span></dt> <dd> <span>{{marketday.marketplaceNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.branchString\">Branch String</span></dt> <dd> <span>{{marketday.branchString}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.updated\">Updated</span></dt> <dd> <span>{{marketday.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.created\">Created</span></dt> <dd> <span>{{marketday.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.gguid\">Gguid</span></dt> <dd> <span>{{marketday.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketplace\">Marketplace</span></dt> <dd> <div *ngIf=\"marketday.marketplace\"> <a [routerLink]=\"['/marketplace', marketday.marketplace?.id]\">{{marketday.marketplace?.marketplaceNumber}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster1\">Market Master 1</span></dt> <dd> <div *ngIf=\"marketday.marketMaster1\"> <a [routerLink]=\"['/contact', marketday.marketMaster1?.id]\">{{marketday.marketMaster1?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster2\">Market Master 2</span></dt> <dd> <div *ngIf=\"marketday.marketMaster2\"> <a [routerLink]=\"['/contact', marketday.marketMaster2?.id]\">{{marketday.marketMaster2?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster3\">Market Master 3</span></dt> <dd> <div *ngIf=\"marketday.marketMaster3\"> <a [routerLink]=\"['/contact', marketday.marketMaster3?.id]\">{{marketday.marketMaster3?.displayname}}</a> </div> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketday.branch\">Branch</span></dt> <dd> <div *ngIf=\"marketday.branch\"> <a [routerLink]=\"['/branch', marketday.branch?.id]\">{{marketday.branch?.name}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketday/'+ marketday.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketdayLabel\" jhiTranslate=\"marketmanagerApp.marketday.home.createOrEditLabel\">Create or edit a Marketday</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketday.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketday.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.marketdayNumber\" for=\"field_marketdayNumber\">Marketday Number</label> <input type=\"text\" class=\"form-control\" name=\"marketdayNumber\" id=\"field_marketdayNumber\" [(ngModel)]=\"marketday.marketdayNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.active\" for=\"field_active\">Active</label> <input type=\"checkbox\" class=\"form-control\" name=\"active\" id=\"field_active\" [(ngModel)]=\"marketday.active\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" [(ngModel)]=\"marketday.name\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.keyword\" for=\"field_keyword\">Keyword</label> <input type=\"text\" class=\"form-control\" name=\"keyword\" id=\"field_keyword\" [(ngModel)]=\"marketday.keyword\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.marketType\" for=\"field_marketType\">Market Type</label> <input type=\"text\" class=\"form-control\" name=\"marketType\" id=\"field_marketType\" [(ngModel)]=\"marketday.marketType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.assortment\" for=\"field_assortment\">Assortment</label> <input type=\"text\" class=\"form-control\" name=\"assortment\" id=\"field_assortment\" [(ngModel)]=\"marketday.assortment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.vatType\" for=\"field_vatType\">Vat Type</label> <input type=\"text\" class=\"form-control\" name=\"vatType\" id=\"field_vatType\" [(ngModel)]=\"marketday.vatType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.unit\" for=\"field_unit\">Unit</label> <input type=\"text\" class=\"form-control\" name=\"unit\" id=\"field_unit\" [(ngModel)]=\"marketday.unit\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.classification\" for=\"field_classification\">Classification</label> <input type=\"text\" class=\"form-control\" name=\"classification\" id=\"field_classification\" [(ngModel)]=\"marketday.classification\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.onHolidayString\" for=\"field_onHolidayString\">On Holiday String</label> <input type=\"text\" class=\"form-control\" name=\"onHolidayString\" id=\"field_onHolidayString\" [(ngModel)]=\"marketday.onHolidayString\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.onHoliday\" for=\"field_onHoliday\">On Holiday</label> <select class=\"form-control\" name=\"onHoliday\" [(ngModel)]=\"marketday.onHoliday\" id=\"field_onHoliday\"> <option value=\"Cancelled\" jhiTranslate=\"marketmanagerApp.MarketOperation.Cancelled\">Cancelled</option> <option value=\"TakesPlace\" jhiTranslate=\"marketmanagerApp.MarketOperation.TakesPlace\">TakesPlace</option> <option value=\"Before\" jhiTranslate=\"marketmanagerApp.MarketOperation.Before\">Before</option> <option value=\"After\" jhiTranslate=\"marketmanagerApp.MarketOperation.After\">After</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.dayString\" for=\"field_dayString\">Day String</label> <input type=\"text\" class=\"form-control\" name=\"dayString\" id=\"field_dayString\" [(ngModel)]=\"marketday.dayString\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.day\" for=\"field_day\">Day</label> <select class=\"form-control\" name=\"day\" [(ngModel)]=\"marketday.day\" id=\"field_day\"> <option value=\"Monday\" jhiTranslate=\"marketmanagerApp.Weekday.Monday\">Monday</option> <option value=\"Tuesday\" jhiTranslate=\"marketmanagerApp.Weekday.Tuesday\">Tuesday</option> <option value=\"Wednesday\" jhiTranslate=\"marketmanagerApp.Weekday.Wednesday\">Wednesday</option> <option value=\"Thursday\" jhiTranslate=\"marketmanagerApp.Weekday.Thursday\">Thursday</option> <option value=\"Friday\" jhiTranslate=\"marketmanagerApp.Weekday.Friday\">Friday</option> <option value=\"Saturday\" jhiTranslate=\"marketmanagerApp.Weekday.Saturday\">Saturday</option> <option value=\"Sunday\" jhiTranslate=\"marketmanagerApp.Weekday.Sunday\">Sunday</option> </select> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.startTime\" for=\"field_startTime\">Start Time</label> <div class=\"d-flex\"> <input id=\"field_startTime\" type=\"datetime-local\" class=\"form-control\" name=\"startTime\" [(ngModel)]=\"marketday.startTime\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.endTime\" for=\"field_endTime\">End Time</label> <div class=\"d-flex\"> <input id=\"field_endTime\" type=\"datetime-local\" class=\"form-control\" name=\"endTime\" [(ngModel)]=\"marketday.endTime\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.buildingStartTime\" for=\"field_buildingStartTime\">Building Start Time</label> <div class=\"d-flex\"> <input id=\"field_buildingStartTime\" type=\"datetime-local\" class=\"form-control\" name=\"buildingStartTime\" [(ngModel)]=\"marketday.buildingStartTime\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTime\" for=\"field_dismantlingEndTime\">Dismantling End Time</label> <div class=\"d-flex\"> <input id=\"field_dismantlingEndTime\" type=\"datetime-local\" class=\"form-control\" name=\"dismantlingEndTime\" [(ngModel)]=\"marketday.dismantlingEndTime\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.startTimeWinter\" for=\"field_startTimeWinter\">Start Time Winter</label> <div class=\"d-flex\"> <input id=\"field_startTimeWinter\" type=\"datetime-local\" class=\"form-control\" name=\"startTimeWinter\" [(ngModel)]=\"marketday.startTimeWinter\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.endTimeWinter\" for=\"field_endTimeWinter\">End Time Winter</label> <div class=\"d-flex\"> <input id=\"field_endTimeWinter\" type=\"datetime-local\" class=\"form-control\" name=\"endTimeWinter\" [(ngModel)]=\"marketday.endTimeWinter\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.buildingStartTimeWinter\" for=\"field_buildingStartTimeWinter\">Building Start Time Winter</label> <div class=\"d-flex\"> <input id=\"field_buildingStartTimeWinter\" type=\"datetime-local\" class=\"form-control\" name=\"buildingStartTimeWinter\" [(ngModel)]=\"marketday.buildingStartTimeWinter\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTimeWinter\" for=\"field_dismantlingEndTimeWinter\">Dismantling End Time Winter</label> <div class=\"d-flex\"> <input id=\"field_dismantlingEndTimeWinter\" type=\"datetime-local\" class=\"form-control\" name=\"dismantlingEndTimeWinter\" [(ngModel)]=\"marketday.dismantlingEndTimeWinter\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.marketplaceNumber\" for=\"field_marketplaceNumber\">Marketplace Number</label> <input type=\"text\" class=\"form-control\" name=\"marketplaceNumber\" id=\"field_marketplaceNumber\" [(ngModel)]=\"marketday.marketplaceNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.branchString\" for=\"field_branchString\">Branch String</label> <input type=\"text\" class=\"form-control\" name=\"branchString\" id=\"field_branchString\" [(ngModel)]=\"marketday.branchString\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketday.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketday.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketday.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"marketday.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketday.marketplace\" for=\"field_marketplace\">Marketplace</label> <select class=\"form-control\" id=\"field_marketplace\" name=\"marketplace\" [(ngModel)]=\"marketday.marketplace\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"marketplaceOption.id === marketday.marketplace?.id ? marketday.marketplace : marketplaceOption\" *ngFor=\"let marketplaceOption of marketplaces; trackBy: trackMarketplaceById\">{{marketplaceOption.marketplaceNumber}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketday.marketMaster1\" for=\"field_marketMaster1\">Market Master 1</label> <select class=\"form-control\" id=\"field_marketMaster1\" name=\"marketMaster1\" [(ngModel)]=\"marketday.marketMaster1\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === marketday.marketMaster1?.id ? marketday.marketMaster1 : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketday.marketMaster2\" for=\"field_marketMaster2\">Market Master 2</label> <select class=\"form-control\" id=\"field_marketMaster2\" name=\"marketMaster2\" [(ngModel)]=\"marketday.marketMaster2\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === marketday.marketMaster2?.id ? marketday.marketMaster2 : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketday.marketMaster3\" for=\"field_marketMaster3\">Market Master 3</label> <select class=\"form-control\" id=\"field_marketMaster3\" name=\"marketMaster3\" [(ngModel)]=\"marketday.marketMaster3\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === marketday.marketMaster3?.id ? marketday.marketMaster3 : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketday.branch\" for=\"field_branch\">Branch</label> <select class=\"form-control\" id=\"field_branch\" name=\"branch\" [(ngModel)]=\"marketday.branch\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"branchOption.id === marketday.branch?.id ? marketday.branch : branchOption\" *ngFor=\"let branchOption of branches; trackBy: trackBranchById\">{{branchOption.name}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketday.home.title\">Marketdays</span> <button class=\"btn btn-primary float-right create-marketday\" [routerLink]=\"['/', { outlets: { popup: ['marketday-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketday.home.createLabel\"> Create new Marketday </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketday.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketdays\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketdayNumber\"><span jhiTranslate=\"marketmanagerApp.marketday.marketdayNumber\">Marketday Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"active\"><span jhiTranslate=\"marketmanagerApp.marketday.active\">Active</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"name\"><span jhiTranslate=\"marketmanagerApp.marketday.name\">Name</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"keyword\"><span jhiTranslate=\"marketmanagerApp.marketday.keyword\">Keyword</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketType\"><span jhiTranslate=\"marketmanagerApp.marketday.marketType\">Market Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortment\"><span jhiTranslate=\"marketmanagerApp.marketday.assortment\">Assortment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"vatType\"><span jhiTranslate=\"marketmanagerApp.marketday.vatType\">Vat Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"unit\"><span jhiTranslate=\"marketmanagerApp.marketday.unit\">Unit</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"classification\"><span jhiTranslate=\"marketmanagerApp.marketday.classification\">Classification</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"onHolidayString\"><span jhiTranslate=\"marketmanagerApp.marketday.onHolidayString\">On Holiday String</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"onHoliday\"><span jhiTranslate=\"marketmanagerApp.marketday.onHoliday\">On Holiday</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"dayString\"><span jhiTranslate=\"marketmanagerApp.marketday.dayString\">Day String</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"day\"><span jhiTranslate=\"marketmanagerApp.marketday.day\">Day</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"startTime\"><span jhiTranslate=\"marketmanagerApp.marketday.startTime\">Start Time</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"endTime\"><span jhiTranslate=\"marketmanagerApp.marketday.endTime\">End Time</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"buildingStartTime\"><span jhiTranslate=\"marketmanagerApp.marketday.buildingStartTime\">Building Start Time</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"dismantlingEndTime\"><span jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTime\">Dismantling End Time</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"startTimeWinter\"><span jhiTranslate=\"marketmanagerApp.marketday.startTimeWinter\">Start Time Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"endTimeWinter\"><span jhiTranslate=\"marketmanagerApp.marketday.endTimeWinter\">End Time Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"buildingStartTimeWinter\"><span jhiTranslate=\"marketmanagerApp.marketday.buildingStartTimeWinter\">Building Start Time Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"dismantlingEndTimeWinter\"><span jhiTranslate=\"marketmanagerApp.marketday.dismantlingEndTimeWinter\">Dismantling End Time Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.marketday.marketplaceNumber\">Marketplace Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branchString\"><span jhiTranslate=\"marketmanagerApp.marketday.branchString\">Branch String</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.marketday.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.marketday.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.marketday.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplace.marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.marketday.marketplace\">Marketplace</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketMaster1.displayname\"><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster1\">Market Master 1</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketMaster2.displayname\"><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster2\">Market Master 2</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketMaster3.displayname\"><span jhiTranslate=\"marketmanagerApp.marketday.marketMaster3\">Market Master 3</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branch.name\"><span jhiTranslate=\"marketmanagerApp.marketday.branch\">Branch</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketday of marketdays ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketday', marketday.id ]\">{{marketday.id}}</a></td> <td>{{marketday.marketdayNumber}}</td> <td>{{marketday.active}}</td> <td>{{marketday.name}}</td> <td>{{marketday.keyword}}</td> <td>{{marketday.marketType}}</td> <td>{{marketday.assortment}}</td> <td>{{marketday.vatType}}</td> <td>{{marketday.unit}}</td> <td>{{marketday.classification}}</td> <td>{{marketday.onHolidayString}}</td> <td jhiTranslate=\"{{'marketmanagerApp.MarketOperation.' + marketday.onHoliday}}\">{{marketday.onHoliday}}</td> <td>{{marketday.dayString}}</td> <td jhiTranslate=\"{{'marketmanagerApp.Weekday.' + marketday.day}}\">{{marketday.day}}</td> <td>{{marketday.startTime | date:'medium'}}</td> <td>{{marketday.endTime | date:'medium'}}</td> <td>{{marketday.buildingStartTime | date:'medium'}}</td> <td>{{marketday.dismantlingEndTime | date:'medium'}}</td> <td>{{marketday.startTimeWinter | date:'medium'}}</td> <td>{{marketday.endTimeWinter | date:'medium'}}</td> <td>{{marketday.buildingStartTimeWinter | date:'medium'}}</td> <td>{{marketday.dismantlingEndTimeWinter | date:'medium'}}</td> <td>{{marketday.marketplaceNumber}}</td> <td>{{marketday.branchString}}</td> <td>{{marketday.updated | date:'medium'}}</td> <td>{{marketday.created | date:'medium'}}</td> <td>{{marketday.gguid}}</td> <td> <div *ngIf=\"marketday.marketplace\"> <a [routerLink]=\"['../marketplace', marketday.marketplace?.id ]\">{{marketday.marketplace?.marketplaceNumber}}</a> </div> </td> <td> <div *ngIf=\"marketday.marketMaster1\"> <a [routerLink]=\"['../contact', marketday.marketMaster1?.id ]\">{{marketday.marketMaster1?.displayname}}</a> </div> </td> <td> <div *ngIf=\"marketday.marketMaster2\"> <a [routerLink]=\"['../contact', marketday.marketMaster2?.id ]\">{{marketday.marketMaster2?.displayname}}</a> </div> </td> <td> <div *ngIf=\"marketday.marketMaster3\"> <a [routerLink]=\"['../contact', marketday.marketMaster3?.id ]\">{{marketday.marketMaster3?.displayname}}</a> </div> </td> <td> <div *ngIf=\"marketday.branch\"> <a [routerLink]=\"['../branch', marketday.branch?.id ]\">{{marketday.branch?.name}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketday', marketday.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketday/'+ marketday.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketday/'+ marketday.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"marketdays && marketdays.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(marketplace.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.marketplace.delete.question\" translateValues=\"{id: '{{marketplace.id}}'}\">Are you sure you want to delete this Marketplace?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"marketplace\"> <h2><span jhiTranslate=\"marketmanagerApp.marketplace.detail.title\">Marketplace</span> {{marketplace.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.marketplaceNumber\">Marketplace Number</span></dt> <dd> <span>{{marketplace.marketplaceNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.name\">Name</span></dt> <dd> <span>{{marketplace.name}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.keyword\">Keyword</span></dt> <dd> <span>{{marketplace.keyword}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.description\">Description</span></dt> <dd> <span>{{marketplace.description}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.particularities\">Particularities</span></dt> <dd> <span>{{marketplace.particularities}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.street\">Street</span></dt> <dd> <span>{{marketplace.street}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.zipcode\">Zipcode</span></dt> <dd> <span>{{marketplace.zipcode}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.city\">City</span></dt> <dd> <span>{{marketplace.city}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.place\">Place</span></dt> <dd> <span>{{marketplace.place}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.placeDescription\">Place Description</span></dt> <dd> <span>{{marketplace.placeDescription}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.alternativePlace\">Alternative Place</span></dt> <dd> <span>{{marketplace.alternativePlace}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.sanitaryLocation\">Sanitary Location</span></dt> <dd> <span>{{marketplace.sanitaryLocation}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.latitude\">Latitude</span></dt> <dd> <span>{{marketplace.latitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.longitude\">Longitude</span></dt> <dd> <span>{{marketplace.longitude}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.branchString\">Branch String</span></dt> <dd> <span>{{marketplace.branchString}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.updated\">Updated</span></dt> <dd> <span>{{marketplace.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.created\">Created</span></dt> <dd> <span>{{marketplace.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.gguid\">Gguid</span></dt> <dd> <span>{{marketplace.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.marketplace.branch\">Branch</span></dt> <dd> <div *ngIf=\"marketplace.branch\"> <a [routerLink]=\"['/branch', marketplace.branch?.id]\">{{marketplace.branch?.name}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'marketplace/'+ marketplace.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myMarketplaceLabel\" jhiTranslate=\"marketmanagerApp.marketplace.home.createOrEditLabel\">Create or edit a Marketplace</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!marketplace.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"marketplace.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.marketplaceNumber\" for=\"field_marketplaceNumber\">Marketplace Number</label> <input type=\"text\" class=\"form-control\" name=\"marketplaceNumber\" id=\"field_marketplaceNumber\" [(ngModel)]=\"marketplace.marketplaceNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" [(ngModel)]=\"marketplace.name\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.keyword\" for=\"field_keyword\">Keyword</label> <input type=\"text\" class=\"form-control\" name=\"keyword\" id=\"field_keyword\" [(ngModel)]=\"marketplace.keyword\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.description\" for=\"field_description\">Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" [(ngModel)]=\"marketplace.description\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.particularities\" for=\"field_particularities\">Particularities</label> <input type=\"text\" class=\"form-control\" name=\"particularities\" id=\"field_particularities\" [(ngModel)]=\"marketplace.particularities\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.street\" for=\"field_street\">Street</label> <input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" [(ngModel)]=\"marketplace.street\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.zipcode\" for=\"field_zipcode\">Zipcode</label> <input type=\"text\" class=\"form-control\" name=\"zipcode\" id=\"field_zipcode\" [(ngModel)]=\"marketplace.zipcode\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.city\" for=\"field_city\">City</label> <input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" [(ngModel)]=\"marketplace.city\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.place\" for=\"field_place\">Place</label> <input type=\"text\" class=\"form-control\" name=\"place\" id=\"field_place\" [(ngModel)]=\"marketplace.place\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.placeDescription\" for=\"field_placeDescription\">Place Description</label> <input type=\"text\" class=\"form-control\" name=\"placeDescription\" id=\"field_placeDescription\" [(ngModel)]=\"marketplace.placeDescription\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.alternativePlace\" for=\"field_alternativePlace\">Alternative Place</label> <input type=\"text\" class=\"form-control\" name=\"alternativePlace\" id=\"field_alternativePlace\" [(ngModel)]=\"marketplace.alternativePlace\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.sanitaryLocation\" for=\"field_sanitaryLocation\">Sanitary Location</label> <input type=\"text\" class=\"form-control\" name=\"sanitaryLocation\" id=\"field_sanitaryLocation\" [(ngModel)]=\"marketplace.sanitaryLocation\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.latitude\" for=\"field_latitude\">Latitude</label> <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" [(ngModel)]=\"marketplace.latitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.longitude\" for=\"field_longitude\">Longitude</label> <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" [(ngModel)]=\"marketplace.longitude\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.branchString\" for=\"field_branchString\">Branch String</label> <input type=\"text\" class=\"form-control\" name=\"branchString\" id=\"field_branchString\" [(ngModel)]=\"marketplace.branchString\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"marketplace.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"marketplace.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.marketplace.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"marketplace.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.marketplace.branch\" for=\"field_branch\">Branch</label> <select class=\"form-control\" id=\"field_branch\" name=\"branch\" [(ngModel)]=\"marketplace.branch\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"branchOption.id === marketplace.branch?.id ? marketplace.branch : branchOption\" *ngFor=\"let branchOption of branches; trackBy: trackBranchById\">{{branchOption.name}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.marketplace.home.title\">Marketplaces</span> <button class=\"btn btn-primary float-right create-marketplace\" [routerLink]=\"['/', { outlets: { popup: ['marketplace-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.marketplace.home.createLabel\"> Create new Marketplace </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.marketplace.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"marketplaces\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"marketplaceNumber\"><span jhiTranslate=\"marketmanagerApp.marketplace.marketplaceNumber\">Marketplace Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"name\"><span jhiTranslate=\"marketmanagerApp.marketplace.name\">Name</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"keyword\"><span jhiTranslate=\"marketmanagerApp.marketplace.keyword\">Keyword</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"description\"><span jhiTranslate=\"marketmanagerApp.marketplace.description\">Description</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"particularities\"><span jhiTranslate=\"marketmanagerApp.marketplace.particularities\">Particularities</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"street\"><span jhiTranslate=\"marketmanagerApp.marketplace.street\">Street</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"zipcode\"><span jhiTranslate=\"marketmanagerApp.marketplace.zipcode\">Zipcode</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"city\"><span jhiTranslate=\"marketmanagerApp.marketplace.city\">City</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"place\"><span jhiTranslate=\"marketmanagerApp.marketplace.place\">Place</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"placeDescription\"><span jhiTranslate=\"marketmanagerApp.marketplace.placeDescription\">Place Description</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"alternativePlace\"><span jhiTranslate=\"marketmanagerApp.marketplace.alternativePlace\">Alternative Place</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"sanitaryLocation\"><span jhiTranslate=\"marketmanagerApp.marketplace.sanitaryLocation\">Sanitary Location</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"latitude\"><span jhiTranslate=\"marketmanagerApp.marketplace.latitude\">Latitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"longitude\"><span jhiTranslate=\"marketmanagerApp.marketplace.longitude\">Longitude</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branchString\"><span jhiTranslate=\"marketmanagerApp.marketplace.branchString\">Branch String</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.marketplace.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.marketplace.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.marketplace.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"branch.name\"><span jhiTranslate=\"marketmanagerApp.marketplace.branch\">Branch</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let marketplace of marketplaces ;trackBy: trackId\"> <td><a [routerLink]=\"['../marketplace', marketplace.id ]\">{{marketplace.id}}</a></td> <td>{{marketplace.marketplaceNumber}}</td> <td>{{marketplace.name}}</td> <td>{{marketplace.keyword}}</td> <td>{{marketplace.description}}</td> <td>{{marketplace.particularities}}</td> <td>{{marketplace.street}}</td> <td>{{marketplace.zipcode}}</td> <td>{{marketplace.city}}</td> <td>{{marketplace.place}}</td> <td>{{marketplace.placeDescription}}</td> <td>{{marketplace.alternativePlace}}</td> <td>{{marketplace.sanitaryLocation}}</td> <td>{{marketplace.latitude}}</td> <td>{{marketplace.longitude}}</td> <td>{{marketplace.branchString}}</td> <td>{{marketplace.updated | date:'medium'}}</td> <td>{{marketplace.created | date:'medium'}}</td> <td>{{marketplace.gguid}}</td> <td> <div *ngIf=\"marketplace.branch\"> <a [routerLink]=\"['../branch', marketplace.branch?.id ]\">{{marketplace.branch?.name}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../marketplace', marketplace.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketplace/'+ marketplace.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'marketplace/'+ marketplace.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"marketplaces && marketplaces.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(salesunit.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.salesunit.delete.question\" translateValues=\"{id: '{{salesunit.id}}'}\">Are you sure you want to delete this Salesunit?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"salesunit\"> <h2><span jhiTranslate=\"marketmanagerApp.salesunit.detail.title\">Salesunit</span> {{salesunit.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.name\">Name</span></dt> <dd> <span>{{salesunit.name}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.salesunitNumber\">Salesunit Number</span></dt> <dd> <span>{{salesunit.salesunitNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothType\">Booth Type</span></dt> <dd> <span>{{salesunit.boothType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothWidth\">Booth Width</span></dt> <dd> <span>{{salesunit.boothWidth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothDepth\">Booth Depth</span></dt> <dd> <span>{{salesunit.boothDepth}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothSize\">Booth Size</span></dt> <dd> <span>{{salesunit.boothSize}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.energyType\">Energy Type</span></dt> <dd> <span>{{salesunit.energyType}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.identification\">Identification</span></dt> <dd> <span>{{salesunit.identification}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.assortment\">Assortment</span></dt> <dd> <span>{{salesunit.assortment}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentAdditional\">Assortment Additional</span></dt> <dd> <span>{{salesunit.assortmentAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtended\">Assortment Extended</span></dt> <dd> <span>{{salesunit.assortmentExtended}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtendedAdditional\">Assortment Extended Additional</span></dt> <dd> <span>{{salesunit.assortmentExtendedAdditional}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.contactFirstname\">Contact Firstname</span></dt> <dd> <span>{{salesunit.contactFirstname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.contactLastname\">Contact Lastname</span></dt> <dd> <span>{{salesunit.contactLastname}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.contactMobile\">Contact Mobile</span></dt> <dd> <span>{{salesunit.contactMobile}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothWidthWinter\">Booth Width Winter</span></dt> <dd> <span>{{salesunit.boothWidthWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothDepthWinter\">Booth Depth Winter</span></dt> <dd> <span>{{salesunit.boothDepthWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.boothSizeWinter\">Booth Size Winter</span></dt> <dd> <span>{{salesunit.boothSizeWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.energyTypeWinter\">Energy Type Winter</span></dt> <dd> <span>{{salesunit.energyTypeWinter}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.winterStart\">Winter Start</span></dt> <dd> <span>{{salesunit.winterStart | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.winterEnd\">Winter End</span></dt> <dd> <span>{{salesunit.winterEnd | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.merchantNumber\">Merchant Number</span></dt> <dd> <span>{{salesunit.merchantNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.merchantGguid\">Merchant Gguid</span></dt> <dd> <span>{{salesunit.merchantGguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.updated\">Updated</span></dt> <dd> <span>{{salesunit.updated | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.created\">Created</span></dt> <dd> <span>{{salesunit.created | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.gguid\">Gguid</span></dt> <dd> <span>{{salesunit.gguid}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.salesunit.merchant\">Merchant</span></dt> <dd> <div *ngIf=\"salesunit.merchant\"> <a [routerLink]=\"['/contact', salesunit.merchant?.id]\">{{salesunit.merchant?.displayname}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'salesunit/'+ salesunit.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"mySalesunitLabel\" jhiTranslate=\"marketmanagerApp.salesunit.home.createOrEditLabel\">Create or edit a Salesunit</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!salesunit.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"salesunit.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" [(ngModel)]=\"salesunit.name\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.salesunitNumber\" for=\"field_salesunitNumber\">Salesunit Number</label> <input type=\"number\" class=\"form-control\" name=\"salesunitNumber\" id=\"field_salesunitNumber\" [(ngModel)]=\"salesunit.salesunitNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothType\" for=\"field_boothType\">Booth Type</label> <input type=\"text\" class=\"form-control\" name=\"boothType\" id=\"field_boothType\" [(ngModel)]=\"salesunit.boothType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothWidth\" for=\"field_boothWidth\">Booth Width</label> <input type=\"number\" class=\"form-control\" name=\"boothWidth\" id=\"field_boothWidth\" [(ngModel)]=\"salesunit.boothWidth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothDepth\" for=\"field_boothDepth\">Booth Depth</label> <input type=\"number\" class=\"form-control\" name=\"boothDepth\" id=\"field_boothDepth\" [(ngModel)]=\"salesunit.boothDepth\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothSize\" for=\"field_boothSize\">Booth Size</label> <input type=\"number\" class=\"form-control\" name=\"boothSize\" id=\"field_boothSize\" [(ngModel)]=\"salesunit.boothSize\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.energyType\" for=\"field_energyType\">Energy Type</label> <input type=\"text\" class=\"form-control\" name=\"energyType\" id=\"field_energyType\" [(ngModel)]=\"salesunit.energyType\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.identification\" for=\"field_identification\">Identification</label> <input type=\"text\" class=\"form-control\" name=\"identification\" id=\"field_identification\" [(ngModel)]=\"salesunit.identification\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.assortment\" for=\"field_assortment\">Assortment</label> <input type=\"text\" class=\"form-control\" name=\"assortment\" id=\"field_assortment\" [(ngModel)]=\"salesunit.assortment\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.assortmentAdditional\" for=\"field_assortmentAdditional\">Assortment Additional</label> <input type=\"text\" class=\"form-control\" name=\"assortmentAdditional\" id=\"field_assortmentAdditional\" [(ngModel)]=\"salesunit.assortmentAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtended\" for=\"field_assortmentExtended\">Assortment Extended</label> <input type=\"text\" class=\"form-control\" name=\"assortmentExtended\" id=\"field_assortmentExtended\" [(ngModel)]=\"salesunit.assortmentExtended\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtendedAdditional\" for=\"field_assortmentExtendedAdditional\">Assortment Extended Additional</label> <input type=\"text\" class=\"form-control\" name=\"assortmentExtendedAdditional\" id=\"field_assortmentExtendedAdditional\" [(ngModel)]=\"salesunit.assortmentExtendedAdditional\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.contactFirstname\" for=\"field_contactFirstname\">Contact Firstname</label> <input type=\"text\" class=\"form-control\" name=\"contactFirstname\" id=\"field_contactFirstname\" [(ngModel)]=\"salesunit.contactFirstname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.contactLastname\" for=\"field_contactLastname\">Contact Lastname</label> <input type=\"text\" class=\"form-control\" name=\"contactLastname\" id=\"field_contactLastname\" [(ngModel)]=\"salesunit.contactLastname\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.contactMobile\" for=\"field_contactMobile\">Contact Mobile</label> <input type=\"text\" class=\"form-control\" name=\"contactMobile\" id=\"field_contactMobile\" [(ngModel)]=\"salesunit.contactMobile\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothWidthWinter\" for=\"field_boothWidthWinter\">Booth Width Winter</label> <input type=\"number\" class=\"form-control\" name=\"boothWidthWinter\" id=\"field_boothWidthWinter\" [(ngModel)]=\"salesunit.boothWidthWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothDepthWinter\" for=\"field_boothDepthWinter\">Booth Depth Winter</label> <input type=\"number\" class=\"form-control\" name=\"boothDepthWinter\" id=\"field_boothDepthWinter\" [(ngModel)]=\"salesunit.boothDepthWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.boothSizeWinter\" for=\"field_boothSizeWinter\">Booth Size Winter</label> <input type=\"number\" class=\"form-control\" name=\"boothSizeWinter\" id=\"field_boothSizeWinter\" [(ngModel)]=\"salesunit.boothSizeWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.energyTypeWinter\" for=\"field_energyTypeWinter\">Energy Type Winter</label> <input type=\"text\" class=\"form-control\" name=\"energyTypeWinter\" id=\"field_energyTypeWinter\" [(ngModel)]=\"salesunit.energyTypeWinter\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.winterStart\" for=\"field_winterStart\">Winter Start</label> <div class=\"d-flex\"> <input id=\"field_winterStart\" type=\"datetime-local\" class=\"form-control\" name=\"winterStart\" [(ngModel)]=\"salesunit.winterStart\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.winterEnd\" for=\"field_winterEnd\">Winter End</label> <div class=\"d-flex\"> <input id=\"field_winterEnd\" type=\"datetime-local\" class=\"form-control\" name=\"winterEnd\" [(ngModel)]=\"salesunit.winterEnd\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.merchantNumber\" for=\"field_merchantNumber\">Merchant Number</label> <input type=\"text\" class=\"form-control\" name=\"merchantNumber\" id=\"field_merchantNumber\" [(ngModel)]=\"salesunit.merchantNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.merchantGguid\" for=\"field_merchantGguid\">Merchant Gguid</label> <input type=\"text\" class=\"form-control\" name=\"merchantGguid\" id=\"field_merchantGguid\" [(ngModel)]=\"salesunit.merchantGguid\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.updated\" for=\"field_updated\">Updated</label> <div class=\"d-flex\"> <input id=\"field_updated\" type=\"datetime-local\" class=\"form-control\" name=\"updated\" [(ngModel)]=\"salesunit.updated\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.created\" for=\"field_created\">Created</label> <div class=\"d-flex\"> <input id=\"field_created\" type=\"datetime-local\" class=\"form-control\" name=\"created\" [(ngModel)]=\"salesunit.created\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.salesunit.gguid\" for=\"field_gguid\">Gguid</label> <input type=\"text\" class=\"form-control\" name=\"gguid\" id=\"field_gguid\" [(ngModel)]=\"salesunit.gguid\"/> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.salesunit.merchant\" for=\"field_merchant\">Merchant</label> <select class=\"form-control\" id=\"field_merchant\" name=\"merchant\" [(ngModel)]=\"salesunit.merchant\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === salesunit.merchant?.id ? salesunit.merchant : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.salesunit.home.title\">Salesunits</span> <button class=\"btn btn-primary float-right create-salesunit\" [routerLink]=\"['/', { outlets: { popup: ['salesunit-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.salesunit.home.createLabel\"> Create new Salesunit </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.salesunit.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"salesunits\"> <table class=\"table table-striped\"> <thead> <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\"> <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"name\"><span jhiTranslate=\"marketmanagerApp.salesunit.name\">Name</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"salesunitNumber\"><span jhiTranslate=\"marketmanagerApp.salesunit.salesunitNumber\">Salesunit Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothType\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothType\">Booth Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothWidth\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothWidth\">Booth Width</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothDepth\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothDepth\">Booth Depth</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothSize\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothSize\">Booth Size</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"energyType\"><span jhiTranslate=\"marketmanagerApp.salesunit.energyType\">Energy Type</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"identification\"><span jhiTranslate=\"marketmanagerApp.salesunit.identification\">Identification</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortment\"><span jhiTranslate=\"marketmanagerApp.salesunit.assortment\">Assortment</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortmentAdditional\"><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentAdditional\">Assortment Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortmentExtended\"><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtended\">Assortment Extended</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"assortmentExtendedAdditional\"><span jhiTranslate=\"marketmanagerApp.salesunit.assortmentExtendedAdditional\">Assortment Extended Additional</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"contactFirstname\"><span jhiTranslate=\"marketmanagerApp.salesunit.contactFirstname\">Contact Firstname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"contactLastname\"><span jhiTranslate=\"marketmanagerApp.salesunit.contactLastname\">Contact Lastname</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"contactMobile\"><span jhiTranslate=\"marketmanagerApp.salesunit.contactMobile\">Contact Mobile</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothWidthWinter\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothWidthWinter\">Booth Width Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothDepthWinter\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothDepthWinter\">Booth Depth Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"boothSizeWinter\"><span jhiTranslate=\"marketmanagerApp.salesunit.boothSizeWinter\">Booth Size Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"energyTypeWinter\"><span jhiTranslate=\"marketmanagerApp.salesunit.energyTypeWinter\">Energy Type Winter</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"winterStart\"><span jhiTranslate=\"marketmanagerApp.salesunit.winterStart\">Winter Start</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"winterEnd\"><span jhiTranslate=\"marketmanagerApp.salesunit.winterEnd\">Winter End</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"merchantNumber\"><span jhiTranslate=\"marketmanagerApp.salesunit.merchantNumber\">Merchant Number</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"merchantGguid\"><span jhiTranslate=\"marketmanagerApp.salesunit.merchantGguid\">Merchant Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"updated\"><span jhiTranslate=\"marketmanagerApp.salesunit.updated\">Updated</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"created\"><span jhiTranslate=\"marketmanagerApp.salesunit.created\">Created</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"gguid\"><span jhiTranslate=\"marketmanagerApp.salesunit.gguid\">Gguid</span> <span class=\"fa fa-sort\"></span></th> <th jhiSortBy=\"merchant.displayname\"><span jhiTranslate=\"marketmanagerApp.salesunit.merchant\">Merchant</span> <span class=\"fa fa-sort\"></span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let salesunit of salesunits ;trackBy: trackId\"> <td><a [routerLink]=\"['../salesunit', salesunit.id ]\">{{salesunit.id}}</a></td> <td>{{salesunit.name}}</td> <td>{{salesunit.salesunitNumber}}</td> <td>{{salesunit.boothType}}</td> <td>{{salesunit.boothWidth}}</td> <td>{{salesunit.boothDepth}}</td> <td>{{salesunit.boothSize}}</td> <td>{{salesunit.energyType}}</td> <td>{{salesunit.identification}}</td> <td>{{salesunit.assortment}}</td> <td>{{salesunit.assortmentAdditional}}</td> <td>{{salesunit.assortmentExtended}}</td> <td>{{salesunit.assortmentExtendedAdditional}}</td> <td>{{salesunit.contactFirstname}}</td> <td>{{salesunit.contactLastname}}</td> <td>{{salesunit.contactMobile}}</td> <td>{{salesunit.boothWidthWinter}}</td> <td>{{salesunit.boothDepthWinter}}</td> <td>{{salesunit.boothSizeWinter}}</td> <td>{{salesunit.energyTypeWinter}}</td> <td>{{salesunit.winterStart | date:'medium'}}</td> <td>{{salesunit.winterEnd | date:'medium'}}</td> <td>{{salesunit.merchantNumber}}</td> <td>{{salesunit.merchantGguid}}</td> <td>{{salesunit.updated | date:'medium'}}</td> <td>{{salesunit.created | date:'medium'}}</td> <td>{{salesunit.gguid}}</td> <td> <div *ngIf=\"salesunit.merchant\"> <a [routerLink]=\"['../contact', salesunit.merchant?.id ]\">{{salesunit.merchant?.displayname}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../salesunit', salesunit.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'salesunit/'+ salesunit.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'salesunit/'+ salesunit.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> <div *ngIf=\"salesunits && salesunits.length\"> <div class=\"row justify-content-center\"> <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count> </div> <div class=\"row justify-content-center\"> <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination> </div> </div> </div> ";

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(testentity.id)\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <p jhiTranslate=\"marketmanagerApp.testentity.delete.question\" translateValues=\"{id: '{{testentity.id}}'}\">Are you sure you want to delete this Testentity?</p> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" class=\"btn btn-danger\"> <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </form> ";

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = " <div *ngIf=\"testentity\"> <h2><span jhiTranslate=\"marketmanagerApp.testentity.detail.title\">Testentity</span> {{testentity.id}}</h2> <hr> <jhi-alert-error></jhi-alert-error> <dl class=\"row-md jh-entity-details\"> <dt><span jhiTranslate=\"marketmanagerApp.testentity.name\">Name</span></dt> <dd> <span>{{testentity.name}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.testentity.description\">Description</span></dt> <dd> <span>{{testentity.description}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.testentity.myNumber\">My Number</span></dt> <dd> <span>{{testentity.myNumber}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.testentity.myZonedDateTime\">My Zoned Date Time</span></dt> <dd> <span>{{testentity.myZonedDateTime | date:'medium'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.testentity.myLocalDate\">My Local Date</span></dt> <dd> <span>{{testentity.myLocalDate | date:'mediumDate'}}</span> </dd> <dt><span jhiTranslate=\"marketmanagerApp.testentity.contact\">Contact</span></dt> <dd> <div *ngIf=\"testentity.contact\"> <a [routerLink]=\"['/contact', testentity.contact?.id]\">{{testentity.contact?.displayname}}</a> </div> </dd> </dl> <button type=\"submit\" (click)=\"previousState()\" class=\"btn btn-info\"> <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span> </button> <button type=\"button\" [routerLink]=\"['/', { outlets: { popup: 'testentity/'+ testentity.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary\"> <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span> </button> </div> ";

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\"> <div class=\"modal-header\"> <h4 class=\"modal-title\" id=\"myTestentityLabel\" jhiTranslate=\"marketmanagerApp.testentity.home.createOrEditLabel\">Create or edit a Testentity</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"clear()\">&times;</button> </div> <div class=\"modal-body\"> <jhi-alert-error></jhi-alert-error> <div class=\"form-group\" [hidden]=\"!testentity.id\"> <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" [(ngModel)]=\"testentity.id\" readonly=\"readonly\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.testentity.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" [(ngModel)]=\"testentity.name\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.testentity.description\" for=\"field_description\">Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" [(ngModel)]=\"testentity.description\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.testentity.myNumber\" for=\"field_myNumber\">My Number</label> <input type=\"number\" class=\"form-control\" name=\"myNumber\" id=\"field_myNumber\" [(ngModel)]=\"testentity.myNumber\"/> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.testentity.myZonedDateTime\" for=\"field_myZonedDateTime\">My Zoned Date Time</label> <div class=\"d-flex\"> <input id=\"field_myZonedDateTime\" type=\"datetime-local\" class=\"form-control\" name=\"myZonedDateTime\" [(ngModel)]=\"testentity.myZonedDateTime\"/> </div> </div> <div class=\"form-group\"> <label class=\"form-control-label\" jhiTranslate=\"marketmanagerApp.testentity.myLocalDate\" for=\"field_myLocalDate\">My Local Date</label> <div class=\"input-group\"> <input id=\"field_myLocalDate\" type=\"text\" class=\"form-control\" name=\"myLocalDate\" ngbDatepicker #myLocalDateDp=\"ngbDatepicker\" [(ngModel)]=\"testentity.myLocalDate\"/> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" (click)=\"myLocalDateDp.toggle()\"><i class=\"fa fa-calendar\"></i></button> </span> </div> </div> <div class=\"form-group\"> <label jhiTranslate=\"marketmanagerApp.testentity.contact\" for=\"field_contact\">Contact</label> <select class=\"form-control\" id=\"field_contact\" name=\"contact\" [(ngModel)]=\"testentity.contact\"> <option [ngValue]=\"null\"></option> <option [ngValue]=\"contactOption.id === testentity.contact?.id ? testentity.contact : contactOption\" *ngFor=\"let contactOption of contacts; trackBy: trackContactById\">{{contactOption.displayname}}</option> </select> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\"> <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span> </button> <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\"> <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span> </button> </div> </form> ";

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "<div> <h2> <span jhiTranslate=\"marketmanagerApp.testentity.home.title\">Testentities</span> <button class=\"btn btn-primary float-right create-testentity\" [routerLink]=\"['/', { outlets: { popup: ['testentity-new'] } }]\"> <span class=\"fa fa-plus\"></span> <span class=\"hidden-sm-down\" jhiTranslate=\"marketmanagerApp.testentity.home.createLabel\"> Create new Testentity </span> </button> </h2> <jhi-alert></jhi-alert> <div class=\"row\"> <div class=\"col-sm-12 no-padding-right\"> <form name=\"searchForm\" class=\"form-inline\"> <div class=\"input-group w-100 mt-3\"> <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'marketmanagerApp.testentity.home.search' | translate }}\"> <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\"> <span class=\"fa fa-search\"></span> </button> <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\"> <span class=\"fa fa-trash-o\"></span> </button> </div> </form> </div> </div> <br/> <div class=\"table-responsive\" *ngIf=\"testentities\"> <table class=\"table table-striped\"> <thead> <tr> <th><span jhiTranslate=\"global.field.id\">ID</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.name\">Name</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.description\">Description</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.myNumber\">My Number</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.myZonedDateTime\">My Zoned Date Time</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.myLocalDate\">My Local Date</span></th> <th><span jhiTranslate=\"marketmanagerApp.testentity.contact\">Contact</span></th> <th></th> </tr> </thead> <tbody> <tr *ngFor=\"let testentity of testentities ;trackBy: trackId\"> <td><a [routerLink]=\"['../testentity', testentity.id ]\">{{testentity.id}}</a></td> <td>{{testentity.name}}</td> <td>{{testentity.description}}</td> <td>{{testentity.myNumber}}</td> <td>{{testentity.myZonedDateTime | date:'medium'}}</td> <td>{{testentity.myLocalDate | date:'mediumDate'}}</td> <td> <div *ngIf=\"testentity.contact\"> <a [routerLink]=\"['../contact', testentity.contact?.id ]\">{{testentity.contact?.displayname}}</a> </div> </td> <td class=\"text-right\"> <div class=\"btn-group flex-btn-group-container\"> <button type=\"submit\" [routerLink]=\"['../testentity', testentity.id ]\" class=\"btn btn-info btn-sm\"> <span class=\"fa fa-eye\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'testentity/'+ testentity.id + '/edit'} }]\" replaceUrl=\"true\" class=\"btn btn-primary btn-sm\"> <span class=\"fa fa-pencil\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span> </button> <button type=\"submit\" [routerLink]=\"['/', { outlets: { popup: 'testentity/'+ testentity.id + '/delete'} }]\" replaceUrl=\"true\" class=\"btn btn-danger btn-sm\"> <span class=\"fa fa-remove\"></span> <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span> </button> </div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\"> <div class=\"col-md-12\"> <h1 class=\"display-4\" jhiTranslate=\"home.title\">Welcome!</h1> <p class=\"lead\" jhiTranslate=\"home.subtitle\">This is your homepage</p> <div [ngSwitch]=\"isAuthenticated()\"> <div class=\"alert alert-success\" *ngSwitchCase=\"true\"> <span *ngIf=\"account\" jhiTranslate=\"home.logged.message\" translateValues=\"{username: '{{account.login}}'}\"> You are logged in as user \"{{account.login}}\". </span> </div> <div class=\"alert alert-warning\" *ngSwitchCase=\"false\"> <span jhiTranslate=\"global.messages.info.authenticated.prefix\">If you want to </span> <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign in</a><span jhiTranslate=\"global.messages.info.authenticated.suffix\">, you can try the default accounts:<br/>- Administrator (login=\"admin\" and password=\"admin\") <br/>- User (login=\"user\" and password=\"user\").</span> </div> <div class=\"alert alert-warning\" *ngSwitchCase=\"false\"> <span jhiTranslate=\"global.messages.info.register.noaccount\">You don't have an account yet?</span> <a class=\"alert-link\" routerLink=\"register\" jhiTranslate=\"global.messages.info.register.link\">Register a new account</a> </div> </div> </div> </div> ";

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=\"row\"> <div class=\"col-md-4\"> <span class=\"hipster img-fluid img-rounded\"></span> </div> <div class=\"col-md-8\"> <h1 jhiTranslate=\"error.title\">Error Page!</h1> <div [hidden]=\"!errorMessage\"> <div class=\"alert alert-danger\">{{errorMessage}} </div> </div> <div [hidden]=\"!error403\" class=\"alert alert-danger\" jhiTranslate=\"error.403\">You are not authorized to access the page. </div> </div> </div> </div> ";

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer\"> <p jhiTranslate=\"footer\">Deutsche Marktgilde</p> </div> ";

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<jhi-page-ribbon></jhi-page-ribbon> <div> <router-outlet name=\"navbar\"></router-outlet> </div> <div class=\"container-fluid\"> <div class=\"card jh-card\"> <router-outlet></router-outlet> <router-outlet name=\"popup\"></router-outlet> </div> <jhi-footer></jhi-footer> </div> ";

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-inverse navbar-toggleable-md jh-navbar\"> <div class=\"jh-logo-container float-left\"> <a *ngIf=\"navbarService.visible\" class=\"jh-navbar-toggler hidden-lg-up float-right\" href=\"javascript:void(0);\" data-toggle=\"collapse\" data-target=\"#navbarResponsive\" aria-controls=\"navbarResponsive\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" (click)=\"toggleNavbar()\"> <i class=\"fa fa-bars\"></i> </a> <a class=\"navbar-brand logo float-left\" routerLink=\"/\" (click)=\"collapseNavbar()\"> <span jhiTranslate=\"global.title\" class=\"navbar-title\">Marketmanager</span> <span class=\"navbar-version\">{{version}}</span> </a> </div> <div class=\"navbar-collapse collapse\" id=\"navbarResponsive\" [ngbCollapse]=\"isNavbarCollapsed\" [ngSwitch]=\"isAuthenticated()\" *ngIf=\"navbarService.visible\"> <ul class=\"navbar-nav ml-auto\"> <li class=\"nav-item\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact: true}\"> <a class=\"nav-link\" routerLink=\"/\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-home\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.home\">Home</span> </a> </li> <li *ngSwitchCase=\"true\" ngbDropdown class=\"nav-item dropdown pointer\"> <a class=\"nav-link dropdown-toggle\" routerLinkActive=\"active\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"entity-menu\"> <span> <i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.main\"> Entities </span> <b class=\"caret\"></b> </span> </a> <ul class=\"dropdown-menu\" ngbDropdownMenu> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"contact\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.contact\">Contact</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"branch\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.branch\">Branch</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketplace\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketplace\">Marketplace</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketday\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketday\">Marketday</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdate\">Marketdate</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"electricmeter\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.electricmeter\">Electricmeter</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"boothfee\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.boothfee\">Boothfee</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"energyflat\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.energyflat\">Energyflat</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"additionalflat\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.additionalflat\">Additionalflat</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"salesunit\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.salesunit\">Salesunit</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"testentity\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.testentity\">Testentity</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-status\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateStatus\">Marketdate Status</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-meterreading\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateMeterreading\">Marketdate Meterreading</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-comment\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateComment\">Marketdate Comment</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"contact-temp\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.contactTemp\">Contact Temp</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-meterreading\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateMeterreading\">Marketdate Meterreading</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-expense\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateExpense\">Marketdate Expense</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"booth\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.booth\">Booth</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"contract\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.contract\">Contract</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"marketdate-booth\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateBooth\">Marketdate Booth</span> </a> </li> <li uiSrefActive=\"active\"> <a class=\"dropdown-item\" routerLink=\"contractdate\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.contractdate\">Contractdate</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"marketdate-booth\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.marketdateBooth\">Marketdate Booth</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"branch\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.entities.branch\">Branch</span> </a> </li> </ul> </li> <li *jhiHasAnyAuthority=\"'ROLE_ADMIN'\" ngbDropdown class=\"nav-item dropdown pointer\"> <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"admin-menu\"> <span> <i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b> </span> </a> <ul class=\"dropdown-menu\" ngbDropdownMenu> <li> <a class=\"dropdown-item\" routerLink=\"user-management\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-user\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.userManagement\">User management</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"jhi-tracker\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-eye\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.tracker\">User tracker</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"jhi-metrics\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-tachometer\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.metrics\">Metrics</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"jhi-health\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-heart\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.health\">Health</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"jhi-configuration\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-list\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.configuration\">Configuration</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"audits\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-bell\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.audits\">Audits</span> </a> </li> <li> <a class=\"dropdown-item\" routerLink=\"logs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-tasks\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.logs\">Logs</span> </a> </li> <li *ngIf=\"swaggerEnabled\"> <a class=\"dropdown-item\" routerLink=\"docs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-book\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.admin.apidocs\">API</span> </a> </li> </ul> </li> <li ngbDropdown class=\"nav-item dropdown pointer\" *ngIf=\"languages\"> <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"languagesnavBarDropdown\" *ngIf=\"languages.length > 1\"> <span> <i class=\"fa fa-flag\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.language\">Language</span> <b class=\"caret\"></b> </span> </a> <ul class=\"dropdown-menu\" ngbDropdownMenu *ngIf=\"languages.length > 1\"> <li *ngFor=\"let language of languages\"> <a class=\"dropdown-item\" [jhiActiveMenu]=\"language\" href=\"javascript:void(0);\" (click)=\"changeLanguage(language);collapseNavbar();\">{{language | findLanguageFromKey}}</a> </li> </ul> </li> <li ngbDropdown class=\"nav-item dropdown pointer\"> <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"account-menu\"> <span *ngIf=\"!getImageUrl()\"> <i class=\"fa fa-user\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.main\"> Account </span> <b class=\"caret\"></b> </span> <span *ngIf=\"getImageUrl()\"> <img [src]=\"getImageUrl()\" class=\"profile-image img-circle\" alt=\"Avatar\"> </span> </a> <ul class=\"dropdown-menu dropdown-menu-right\" ngbDropdownMenu> <li *ngSwitchCase=\"true\"> <a class=\"dropdown-item\" routerLink=\"settings\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-wrench\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.settings\">Settings</span> </a> </li> <li *ngSwitchCase=\"true\"> <a class=\"dropdown-item\" routerLink=\"password\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-clock-o\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.password\">Password</span> </a> </li> <li *ngSwitchCase=\"true\"> <a class=\"dropdown-item\" (click)=\"logout()\" id=\"logout\"> <i class=\"fa fa-fw fa-sign-out\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.logout\">Sign out</span> </a> </li> <li *ngSwitchCase=\"false\"> <a class=\"dropdown-item\" (click)=\"login()\" id=\"login\"> <i class=\"fa fa-fw fa-sign-in\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.login\">Sign in</span> </a> </li> <li *ngSwitchCase=\"false\"> <a class=\"dropdown-item\" routerLink=\"register\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\"> <i class=\"fa fa-fw fa-registered\" aria-hidden=\"true\"></i> <span jhiTranslate=\"global.menu.account.register\">Register</span> </a> </li> </ul> </li> </ul> </div> </nav> ";

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"> <h4 class=\"modal-title\" jhiTranslate=\"login.title\">Sign in</h4> <button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('closed')\"><span aria-hidden=\"true\">x</span> </button> </div> <div class=\"modal-body\"> <div class=\"row\"> <div class=\"col-md-4 offset-md-4\"> <h1 jhiTranslate=\"login.title\">Sign in</h1> </div> <div class=\"col-md-8 offset-md-2\"> <div class=\"alert alert-danger\" *ngIf=\"authenticationError\" jhiTranslate=\"login.messages.error.authentication\"> <strong>Failed to sign in!</strong> Please check your credentials and try again. </div> </div> <div class=\"col-md-8 offset-md-2\"> <form class=\"form\" role=\"form\" (ngSubmit)=\"login()\"> <div class=\"form-group\"> <label for=\"username\" jhiTranslate=\"global.form.username\">Login</label> <input type=\"text\" class=\"form-control\" name=\"username\" id=\"username\" placeholder=\"{{'global.form.username.placeholder' | translate}}\" [(ngModel)]=\"username\"> </div> <div class=\"form-group\"> <label for=\"password\" jhiTranslate=\"login.form.password\">Password</label> <input type=\"password\" class=\"form-control\" name=\"password\" id=\"password\" placeholder=\"{{'login.form.password.placeholder' | translate}}\" [(ngModel)]=\"password\"> </div> <div class=\"form-check\"> <label class=\"form-check-label\" for=\"rememberMe\"> <input class=\"form-check-input\" type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe\" [(ngModel)]=\"rememberMe\" checked=\"checked\"> <span jhiTranslate=\"login.form.rememberme\">Remember me</span> </label> </div> <button type=\"submit\" class=\"btn btn-primary\" jhiTranslate=\"login.form.button\">Sign in</button> </form> <p></p> <div class=\"alert alert-warning\"> <a class=\"alert-link\" (click)=\"requestResetPassword()\" jhiTranslate=\"login.password.forgot\">Did you forget your password?</a> </div> <div class=\"alert alert-warning\"> <span jhiTranslate=\"global.messages.info.register.noaccount\">You don't have an account yet?</span> <a class=\"alert-link\" (click)=\"register()\" jhiTranslate=\"global.messages.info.register.link\">Register a new account</a> </div> </div> </div> </div> ";

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(43);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "translateLoaderFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["translateLoaderFactory"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateModule", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateModule"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslatePipe"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["MissingTranslationHandler"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateStaticLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateStaticLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateService"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DefaultTranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["DefaultTranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateDirective"]; });



/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(329);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(330);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(331);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(332);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(17);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(235);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(236);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(240);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(241);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(242);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(246);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(7);

/***/ })
],[246]);


// WEBPACK FOOTER //
// 616c421c19bf0fdb9550.main.bundle.js